import _defineProperty from '@babel/runtime/helpers/defineProperty';

var basic = {
	card: {
		from: "来自",
		people: "人"
	},
	search: {
		clear: "清空",
		holder: "搜索"
	},
	inviteNotify: {
		title: "已邀请对方加入协作",
		subTitle: "你可以提醒对方登录金山文档，在「首页-消息」中查看你的邀请",
		confirmText: "我知道了"
	},
	linkCreate: {
		title: "分享链接权限",
		cancelTxt: "取消",
		confirmTxt: "创建并分享"
	},
	memberItem: {
		more: "更多信息"
	},
	deleteContent: {
		cancelDel: "请确认删除",
		delDesc: "删除联系人后，该用户将不出现在我的联系人列表",
		confirmDel: "请确认删除",
		files: "文件、文件夹",
		delNopower: "删除后，团队成员将无法访问该团队",
		members: "位成员",
		confirmOut: "请确认退出",
		outNopower: "退出后你将无法访问该团队",
		cancel: "取消",
		confirm: "确定"
	},
	noticeCard: {
		markWait: "标记为稍后处理",
		markDeal: "标记为已处理",
		title: "未知类型通知"
	},
	scroll: {
		loadingText: "加载中..."
	},
	voice: {
		errorText: "播放失败"
	},
	clinkCreate: {
		txt0: "公开分享",
		txt1: "任何人可查看",
		txt2: "适用于文件公开分享",
		txt3: "任何人可编辑",
		txt4: "适用于多人协作，编辑内容实时更新",
		txt5: "指定范围分享",
		txt6: "本企业成员可查看",
		txt7: "本企业成员可编辑",
		txt8: "仅指定人可查看/编辑",
		txt9: "仅指定人可查看",
		txt10: "适用于隐私文件，可指定查看/编辑权限",
		txt11: "适用于隐私文件，可指定查看权限",
		txt12: "取消",
		txt13: "创建并分享",
		company_admin: "企业管理员",
		group_admin: "团队管理员",
		txt14: "已禁止文件分享到企业外",
		txt15: "已禁止文件分享到团队外",
		txt16: "快速了解链接分享功能",
		securetip_head: "该文档为加密保护文档",
		securetip_txt1: "分享权限控制为仅指定人可查看/编辑",
		securetip_txt2: "在文档内进行授权的成员，可自动获得链接访问权限",
		txt17: "企业版专属",
		anyone_comment: "任何人可评论",
		anyone_comment_tip: "适用于文件公开分享，允许他人评论",
		company_comment: "本企业成员可评论",
		someoneAllPerm: "仅指定人可查看/评论/编辑",
		someoneAllPermSubTitle: "适用于隐私文件，可指定查看/评论/编辑权限",
		someoneAllPermsShowMore: "任何人可查看/评论/编辑"
	},
	batchClinkCreate: {
		txt0: "公开分享",
		txt1: "任何人可查看",
		txt3: "任何人可编辑",
		txt5: "指定范围分享",
		txt6: "本企业成员可查看",
		txt7: "本企业成员可编辑",
		txt8: "仅指定人可查看",
		txt9: "/编辑",
		cancel: "取消",
		confirm: "确认",
		company_admin: "企业管理员",
		group_admin: "团队管理员",
		txt14: "已禁止文件分享到企业外",
		txt15: "已禁止文件分享到团队外",
		txt16: "快速了解链接分享功能",
		include_folder: "勾选的文件中包含“文件夹”",
		ignore_folder: "忽略文件夹",
		include_other: "勾选的文件中包含“图片、视频、压缩包” 等",
		ignore_other: "忽略这部分文件",
		modify_success: "修改成功",
		txt17: "授权范围",
		txt18: "权限类型",
		txt19: "任何人",
		txt20: "本企业成员",
		txt21: "仅指定用户可访问",
		txt22: "企业管理员已禁止文件分享到企业外",
		txt23: "团队管理员已禁止文件分享到团队外",
		txt24: "勾选的文件为加密保护文档，不支持通过链接分享",
		txt25: "勾选的文件中包含加密保护文档，不支持通过链接分享",
		txt26: "勾选的文件中包含思维导图，流程图或轻维表",
		txt27: "勾选的文件中包含图片，视频，压缩包等",
		txt28: "勾选的文件中包含思维导图，流程图，图片等"
	},
	shareGuide: {
		txt0: "这里是已加入分享的人，可以对其进行权限管理",
		txt1: "下一步",
		txt2: "点击获取免登录链接，访问者免登录打开文件",
		txt3: "我知道了"
	},
	certification: {
		desc: "账号需绑定手机才能进行下一步操作",
		descCertification: "账号完成实名制才能进行下一步操作",
		cancel: "取消",
		bind: "去绑定",
		cert: "去实名",
		bindSuccess: "手机绑定成功",
		certificationSuccess: "实名认证成功",
		forbiddenTitle: "账号已被暂停分享",
		forbiddenDesc: "解封请发送邮件至WPS@WPS.cn联系客服，邮件标题备注【账号已被暂停分享问题咨询】",
		forbiddenReasonTemAttemp: "请您于 {time} 后尝试",
		forbiddenReasonPer: "因技术原因服务暂不可用",
		forbiddenText: "您可下载/导出/另存到本地后进行其他操作",
		forbiddenSuggestion: "如有疑问可咨询客服400-677-5005，工作人员会及时核查跟进",
		downloadBtn: "下载/导出到本地查看"
	},
	CancelSyncFolderConfirm: {
		desc: "当前文件夹已被「{0}」设置为同步文件夹，",
		subDesc: "{0}将会导致同步文件夹被取消，变为普通的文件夹。",
		confirm: "确定",
		cancel: "取消"
	}
};
var basic$1 = {
	basic: basic
};

var combine = {
	dialog: {
		cancel: "取 消",
		confirm: "确 定",
		memberSeletor: "选择成员"
	},
	finder: {
		cancel: "取消",
		newBuilt: "新建文件夹",
		selected: "已选",
		selectedUnit: "项",
		notGroupMember: "你的权限已被作者收回",
		expired: "你没有该文件的操作权限",
		permissionDenied: "你没有该文件的操作权限",
		okText: "确定",
		move: "移动",
		copy: "复制",
		saveas: "另存",
		confirm: "确定",
		messageErr: "该文件格式不支持发起会议",
		docs: "我的文档",
		copy1: "副本"
	},
	aside: {
		latest: "最近",
		star: "星标",
		alls: "我的文档",
		myTeams: "我的团队",
		share1: "共享",
		localfile: "本地文件",
		receive: "我收到的"
	},
	main: {
		holder1: "输入文件名称",
		holder2: "输入文件夹名称",
		clear: "清空",
		compFile: "企业文档",
		share: "与我共享",
		receive: "我收到的",
		myTeams: "我的团队",
		"private": "私人空间",
		cloudFile: "我的云文档",
		myFile: "我的文档",
		autoUpload: "自动上传文档",
		myDevice: "我的设备",
		latestOpen: "最近打开",
		latest: "最近",
		recBin: "回收站",
		teamDocs: "团队文档",
		search: "搜索结果",
		privateFile: "私密文件夹",
		team: "团队",
		appDriveTitle: "WPS 云文档 - 随时随地编辑你的办公文档",
		appAccountTitle: "个人中心",
		appDriveTitleSimple: "金山文档",
		appDriveForgetTitle: "金山文档 - 找回私密文件夹密码",
		starredFile: "星标文件",
		stared: "星标",
		cooperation: "最近的协作",
		shareCom: "共享",
		roles1: "企业拥有者",
		roles2: "企业管理员",
		roles3: "成员",
		newFile: "新建文件夹",
		newFileErr: "创建文件夹失败"
	},
	mainEmp: {
		groupNumLimit: "你的3个免费团队数量已用完，升级会员即可拥有创建50个团队和100G 云空间特权。",
		groupLengthTooShort: "团队名至少2个汉字或4个字母",
		illegalGroupName: "团队名不能包含下列字符： \\/;:*?\"<>|%&",
		groupLengthTooLong: "团队名不能超过240个字符",
		userNotLogin: "账号已退出，请重新登录",
		InvalidArgument: "提交的参数无效",
		errServerException: "服务器忙请稍后再试",
		ServerError: "服务器错误",
		LicenseNotFound: "账号未授权",
		LicenseExpired: "账号已过期",
		permissionDenied: "你的操作权限不足",
		DomainExist: "域名已存在",
		CompanymMemberNotExist: "公司不存在",
		InvalidCompanyName: "公司名无效",
		CompanyNameTooLong: "公司名太长",
		UserAlreadyExists: "用户已存在",
		DeptNotEmpty: "部门非空",
		GroupMemberExists: "团队已存在此成员",
		GroupMemberLimit: "团队人数已达上限",
		InvalidAccount: "请输入一个正确的邮箱/手机号",
		groupNotExist: "团队已不存在",
		teamLinkNotExist: "团队链接已不存在",
		notPersonalUser: "不能添加企业账号",
		UserNotExists: "用户不存在",
		fileNameLengthExceed: "文件名不能超过100个字符",
		fileNameConflict: "存在同名文件",
		fileNotExists: "文件(夹)不存在",
		notGroupMember: "你已不是该团队成员",
		illegalFname: "名字不能包含非法字符和特殊符号\\/:*?\"<>|",
		illegalLinkFolderName: "名字不能包含非法字符和特殊符号： \\/;:*?\"<>|%&",
		fileNameEmpty: "文件名不能为空",
		moveFilePermission: "普通成员只能移动自己的文件",
		moveFileSelfPermission: "文件移动位置不变",
		lightLinkExist: "链接已存在",
		lightLinkNotExist: "链接不存在或已被重置",
		SecretGroupPermissionDenied: "私密文件夹特权已过期",
		checkPerFail: "权限校验失败，请刷新重试",
		noFolderOperatePermission: "没有当前目录的操作权限,请联系管理员",
		noNewFilePermission: "没有当前目录的新建权限",
		MustHasOneBind: "请保留邮箱或手机其中一种登录方式",
		apiRateLimitExceede: "你的操作频率过快，请稍后重试",
		SMSLimitReached: "该手机申请验证码次数已超上限，请明天再试",
		InvalidPhone: "手机格式不正确",
		PhoneAlreadyInUsed: "该手机已绑定其它账号",
		CellPhoneAlreadyInUsed: "该手机已绑定其它账号",
		InvalidEmail: "请输入正确格式的邮箱",
		EmailAlreadyInUsed: "该邮箱已绑定其它账号，请换一个",
		InvalidBindCode: "验证码错误",
		EmailAlreadyExists: "该邮箱已绑定其它账号，请换一个",
		hasEmailAccount: "无法解绑，至少要有一个邮箱或手机账号，请先绑定邮箱再解绑手机",
		invalidVerifyCode: "验证码错误",
		PasswordWeak: "密码为8-16位，大小写字母、数字或符号3种组合",
		UserHasBindedPhone: "你已绑定了手机",
		CellPhoneBind: "该手机已绑定其它账号",
		codeNotEmpty: "验证码不能为空",
		InvalidEmailCode: "验证码不正确,请重新输入",
		InvalidSMSCode: "验证码不正确,请重新输入",
		UserHasBindedEmail: "你已绑定了邮箱",
		EmailNotExists: "邮箱不存在",
		InvalidToken: "不合法的操作",
		InvalidNickname: "不能包含字符!@#$^*<>?",
		wrongPassword: "密码错误",
		chkCodeReset: "打开文件失败，轻地址密码已变更。",
		commentLengthTooLong: "评论内容超过了255个字符",
		shareFail: "分享失败",
		commentTooLong: "评论不能超过255个字",
		moveFilesFail: "移动文件失败",
		linkClosed: "链接已关闭",
		FileNoExists: "文件不存在",
		IPCError: "内部错误",
		IOError: "文件内容读取错误",
		batchDownloadTooDeep: "文件夹层级过多，请重新选择",
		batchDownloadFailed: "下载失败，所选文件格式不支持下载",
		batchDownloadEmptyFolder: "下载失败，不支持下载空文件夹",
		batchDownloadEmpty: "你未选中任何实体文件，请确认文件是否存在",
		fileSearchNoPermission: "没有文件搜索功能权限",
		copyFileFail: "不支持复制到子文件夹，请重新选择",
		noCopyMultiFolders: "不支持复制带有子文件夹的目录，请重新选择",
		copyTooDeep: "不支持复制带有子文件夹的目录，请重新选择",
		fileTaskFailed: "文件批量操作任务失败",
		fileTaskNumLimit: "不支持操作5000个以上的文件，请重新选择",
		fileTaskNotExist: "文件批量操作任务不存在",
		fileTaskDuplicated: "正在执行文件操作，请稍候重试",
		NicknameTooLong: "名字太长",
		InvalidSsid: "无效ssid",
		userContracted: "用户已经签约",
		fileImportSameAccount: "不可导入同一账号的数据",
		HaveNotVerify: "验证结果已过期",
		InvalidVerifyCode: "验证码不正确，请重新输入",
		SsidIsMissing: "参数缺失ssid",
		SsidParamError: "ssid参数错误",
		GetAccountMergeUserInfoFailed: "获取被合并账号用户信息失败",
		ReportAccountMergeFailed: "报告合并完成失败",
		CanNotMergeUsersFromDiffrentCompany: "不能合并不同公司的账号",
		CanNotMergerUsersFromThisCompany: "此公司的用户不能合并账号",
		QueryPermittedDocumentFaild: "获取用户授权的安全文档失败",
		CanNotGetLoginUserInfo: "无法获取登录用户的信息",
		InconsistentAccount: "验证信息与所绑定的账号不一致",
		IrregularOauthBinded: "绑定时间过短",
		ErrLinkShareGroupNotFound: "该协作已被解散",
		ErrGroupCountExceedLimit: "超过团队数量限制",
		ErrLinkShareGroupMemberNotFound: "你已不是该协作组成员",
		searching: "正在搜索...",
		latestHere: "最近移动、复制和搜索过的位置将显示在这里",
		noFindContain: "未找到文件名包含",
		de: "的",
		pitera: "这里暂无",
		file: "文件",
		finder: "文件夹"
	},
	mainList: {
		finder: "文件夹",
		nickname: "昵称",
		deptName: "部门",
		email: "邮箱",
		phone: "手机号",
		markname: "备注名",
		holder: "添加备注名",
		addContact: "添加到我的联系人",
		sendWoaMessage: "聊天",
		nickDesc: "使用真实头像昵称，让工作伙伴认识你",
		toSet: "去设置",
		location: "IP属地"
	},
	memSelector: {
		myContact: "我的联系人",
		addBook: "企业通讯录",
		emptyInfo: "暂无可选成员",
		emptySearchInfo: "未搜索到匹配的用户",
		emptySearchInfo2: "未搜索到匹配的数据",
		errorInfo: "获取成员失败，请重试",
		deptEmpty: "部门为空",
		empSearchInfo: "未搜索到匹配的联系人",
		empInfo: "暂无联系人可选",
		noGroup: "暂无分组",
		latestMember: "最近选择的用户将出现在这里",
		canEdit: "可编辑",
		canRead: "可查看",
		canComment: "可评论",
		contactor: "联系人",
		docsRelated: "文档协作",
		recent: "最近",
		formCollect: "表单收集群",
		rightTitle: "请选择需要添加的成员",
		addContactor: "添加联系人",
		addTips: "你可从这添加最近与你有文件来往的人",
		lookUser: "查找该手机号用户：",
		choose: "已选择",
		cancel: "取消",
		confirm: "确定",
		myGroup: "我的分组",
		newGroup: "新增分组选择功能",
		defaultGroup: "默认展示我加入的表单群",
		checkAll: "一键勾选全组，选人更方便",
		position: "职务",
		teamMember: "团队成员",
		tagsTeam: "自定义组",
		tagsTeamManage: "自定义组管理",
		deptAndPosition: "按部门/职务",
		accordDept: "按部门",
		accordPosition: "按职务",
		noSubDept: "该部门没有子部门，不能按部门授权",
		noPosition: "成员的职务在【管理后台/通讯录】中未填写，不能按职务授权",
		noMember: "暂无成员",
		teamNoTags: "团队成员暂无自定义分组",
		newTags: "新建自定义组",
		notInTeam: "以下成员未加入团队，需添加为团队成员再授权",
		hasNoSubDept: "暂无子部门",
		externalStaff: "外部人员",
		myTeams: "我的团队",
		noMyTeams: "暂无团队",
		myGroups: "我的群组",
		noMyGroups: "暂无群组",
		corpTeams: "企业团队",
		personalTeams: "个人团队",
		noPermission: "没有权限，请联系团队管理员"
	},
	phone: {
		title: "绑定手机，开启登录两步验证，账号更安全。",
		phoneHolder: "手机号码",
		codeHolder: "手机验证码",
		repeat: "重发",
		getCode: "获取验证码",
		immeBind: "立即绑定",
		smsCodeErr: "短信验证码错误",
		freqAction: "你的操作频率过快，请稍后重试",
		bindAlready: "你已经绑定了手机，请勿重复绑定",
		importTel: "请输入手机号",
		currentTel: "请输入正确的手机号码",
		importSms: "请入短信验证码",
		needBind: "账号需绑定手机才能进行下一步操作",
		needCertification: "账号需先完成手机验证才能进行下一步操作",
		cancel: "取消",
		bind: "去绑定",
		certification: "立即验证"
	},
	recentSelector: {
		relatedContact: "相关联系人",
		wordCoop: "文档协作者",
		latestContact: "最近联系人",
		msgOther: "消息提醒对方",
		empty: "暂无",
		selectList: "从联系人列表选择",
		msgTip: "5分钟后你选中的人将收到消息提醒",
		coop: "协作成员、我的联系人等",
		book: "从通讯录选择",
		endTips: "已经到底啦",
		mention: "你可能想提及",
		search: "搜索"
	},
	NotLoginInfoCard: {
		txt0: "系统给未登录用户临时分配的昵称",
		txt1: "登录使用更多功能",
		txt2: "登录",
		txt3: "邀请对方登录验证身份",
		txt4: "邀请",
		txt5: "已邀请，等待对方登录验证身份",
		txt6: "（我）",
		txt7: "（未登录）"
	},
	ThumbnailViewer: {
		txt0: "图片预览获取失败",
		txt1: "你没有访问权限",
		txt2: "图片大小超限，无法预览",
		txt3: "预览图获取失败",
		txt4: "请点击文件名查看原图",
		txt5: "预览图加载中",
		txt6: "缩略图"
	},
	TeamInfo: {
		"0": "当前文件夹以下团队可见",
		"1": "当前文件夹仅你可见",
		"2": "升级为团队",
		"3": "点击进入团队"
	},
	upgradePrivilege: {
		upgradeNow: "立即升级",
		purchaseNow: "立即购买",
		confirm: "确定"
	},
	externalLinkTip: {
		desc: "由于小程序限制，请复制链接后使用浏览器访问",
		btnTxt: "复制链接",
		tipSucc: "复制成功",
		tipFail: "复制失败"
	},
	memberInfo: {
		companyLabel: "企业"
	},
	LimitMode: {
		userChatPrivilegesPermissionText: "该人员受聊天权限管控",
		groupChatDenyToast: "当前群聊内存在受聊天权限管控的人员，无法选择发送"
	},
	commonUserCard: {
		sendMsgTips: "请使用 WPS协作 查看或发送消息"
	}
};
var combine$1 = {
	combine: combine
};

var mCombine = {
	file: {
		emptyTxt: "这里暂无文件",
		noMore: "无更多文档",
		recent: "最近",
		myDocs: "我的文档",
		noTeam: "暂无团队",
		noMoreTeam: "无更多团队",
		title: "金山文档",
		errTry: "发生错误，请点击此处重试",
		share: "共享给我"
	}
};
var miCombine = {
	mCombine: mCombine
};

var inputSearch = "请输入手机号/邮箱";
var searchRes = "搜索结果";
var searchCon = "以下用户最近与你分享文件";
var noFind = "找不到相关用户";
var copyAdd = "你可以复制链接发送好友添加";
var searchInvite = "输入「手机号」搜索";
var searchInvite1 = "或";
var searchInvite2 = "发送邀请链接，可添加联系人";
var inviteAdd$2 = "使用链接添加";
var validLink = "该链接";
var validLink1 = "有效，对方同时加入协作「";
var validLink2 = "」";
var inviteRoad$1 = "通过邀请链接添加QQ、微信等好友";
var copyLink$6 = "复制链接";
var inviteEdit = "邀请你一起编辑「";
var applyContact = "对方申请添加你为联系人，点击查看";
var inner = "内";
var seInner = "7天内";
var validContac = "对方已加入协作，你可以发送验证将其加为联系人，并等待对方通过";
var inviteFail = "开启邀请失败";
var correctMsg = "请正确填写手机号、邮箱地址";
var me$4 = "我";
var add$2 = "已添加";
var send$2 = "已发送";
var invite$2 = "添加";
var copySucc = "复制成功";
var copyFail$1 = "复制失败，请重试";
var getLink = "获得链接的人可加入此文档协作，链接有效期";
var txt0$3c = "你需要发送验证消息，等待对方通过";
var member_selector_tab_title_address = "联系人";
var member_selector_tab_title_secret_invite = "微信私密邀请";
var member_selector_tab_title_secret_invite_tip = "只有你分享的好友/群成员可访问，其他人转发无效";
var member_selector_quick_add = "快捷添加";
var member_selector_copy_link = "复制链接";
var member_selector_qrcode_title = "二维码";
var member_selector_qr_code_subtitle = "使用微信扫码，向好友发送协作邀请";
var member_selector_qr_code_alt = "小程序码";
var AddRecommendContact = {
	inputSearch: inputSearch,
	searchRes: searchRes,
	searchCon: searchCon,
	noFind: noFind,
	copyAdd: copyAdd,
	searchInvite: searchInvite,
	searchInvite1: searchInvite1,
	searchInvite2: searchInvite2,
	inviteAdd: inviteAdd$2,
	validLink: validLink,
	validLink1: validLink1,
	validLink2: validLink2,
	inviteRoad: inviteRoad$1,
	copyLink: copyLink$6,
	inviteEdit: inviteEdit,
	applyContact: applyContact,
	inner: inner,
	seInner: seInner,
	validContac: validContac,
	inviteFail: inviteFail,
	correctMsg: correctMsg,
	me: me$4,
	add: add$2,
	send: send$2,
	invite: invite$2,
	copySucc: copySucc,
	copyFail: copyFail$1,
	getLink: getLink,
	txt0: txt0$3c,
	member_selector_tab_title_address: member_selector_tab_title_address,
	member_selector_tab_title_secret_invite: member_selector_tab_title_secret_invite,
	member_selector_tab_title_secret_invite_tip: member_selector_tab_title_secret_invite_tip,
	member_selector_quick_add: member_selector_quick_add,
	member_selector_copy_link: member_selector_copy_link,
	member_selector_qrcode_title: member_selector_qrcode_title,
	member_selector_qr_code_subtitle: member_selector_qr_code_subtitle,
	member_selector_qr_code_alt: member_selector_qr_code_alt
};

var txt0$3b = "通讯录";
var txt1$2T = "添加联系人";
var txt2$2D = "我的联系人";
var txt3$2n = "企业联系人";
var txt4$22 = "查找该手机号用户：";
var txt5$1S = "暂无成员";
var txt6$1F = "你可以添加常用的联系人";
var txt7$1t = "指定对方参与协作";
var txt8$1n = "去添加";
var txt9$1f = "未搜索到匹配的联系人";
var txt10$18 = "暂无联系人";
var txt11$10 = "部门为空";
var txt12$X = "仅管理员可邀请同事加入企业";
var txt13$X = "删除联系人";
var txt14$N = "，";
var txt15$I = "你将无法与该联系人协作，确定删除？";
var txt16$G = "仅删除当前联系人";
var txt17$B = "解除与该企业的协作关系，并删除该企业的所有联系人";
var txt18$A = "确定";
var txt19$y = "取消";
var txt20$v = "删除成功";
var txt21$r = "删除失败";
var txt22$o = "无（个人用户）";
var txt23$l = "你与该联系人所在企业【{compName}】建立了协作关系，并与该企业成员：{nameTexts}{total}是协作关系，请选择：";
var txt24$h = "等{total}人";
var txt25$g = "企业";
var txt26$g = "个人";
var txt27$e = "外部联系人";
var txt28$d = "企业联系人";
var txt29$9 = "添加外部联系人";
var txt30$8 = "将链接发给对方，对方打开链接后发起添加申请：";
var txt31$9 = "复制链接";
var txt32$7 = "链接有效期至";
var txt33$6 = "重置链接";
var txt34$6 = "提示";
var txt35$6 = "重置后，之前已分享的链接将失效，确定重置？";
var txt36$6 = "确认重置";
var txt37$6 = "重置成功";
var txt38$6 = "邀请你成为「{compName}」 的外部联系人，方便跨组织协作，点击链接去处理（{month}月{day}日{time}前有效）";
var txt39$6 = "你的操作权限不足";
var txt40$6 = "搜索";
var txt41$6 = "搜索结果";
var txt42$6 = "组织架构";
var txt43$6 = "删除我的联系人";
var txt44$6 = "删除外部联系人";
var txt45$6 = "删除企业联系人";
var txt46$6 = "复制成功";
var txt47$6 = "复制失败";
var txt48$6 = "暂无数据";
var txt49$6 = "邀请加入";
var AddressBook = {
	txt0: txt0$3b,
	txt1: txt1$2T,
	txt2: txt2$2D,
	txt3: txt3$2n,
	txt4: txt4$22,
	txt5: txt5$1S,
	txt6: txt6$1F,
	txt7: txt7$1t,
	txt8: txt8$1n,
	txt9: txt9$1f,
	txt10: txt10$18,
	txt11: txt11$10,
	txt12: txt12$X,
	txt13: txt13$X,
	txt14: txt14$N,
	txt15: txt15$I,
	txt16: txt16$G,
	txt17: txt17$B,
	txt18: txt18$A,
	txt19: txt19$y,
	txt20: txt20$v,
	txt21: txt21$r,
	txt22: txt22$o,
	txt23: txt23$l,
	txt24: txt24$h,
	txt25: txt25$g,
	txt26: txt26$g,
	txt27: txt27$e,
	txt28: txt28$d,
	txt29: txt29$9,
	txt30: txt30$8,
	txt31: txt31$9,
	txt32: txt32$7,
	txt33: txt33$6,
	txt34: txt34$6,
	txt35: txt35$6,
	txt36: txt36$6,
	txt37: txt37$6,
	txt38: txt38$6,
	txt39: txt39$6,
	txt40: txt40$6,
	txt41: txt41$6,
	txt42: txt42$6,
	txt43: txt43$6,
	txt44: txt44$6,
	txt45: txt45$6,
	txt46: txt46$6,
	txt47: txt47$6,
	txt48: txt48$6,
	txt49: txt49$6
};

var txt0$3a = "对方还不是你的联系人，你可发送消息邀请对方加入协作并添加为联系人。";
var txt1$2S = "取消";
var txt2$2C = "发送";
var AddToCoop = {
	txt0: txt0$3a,
	txt1: txt1$2S,
	txt2: txt2$2C
};

var create = "创作";
var more$1 = "更多";
var placeholder$3 = "输入主题，让 WPS AI 帮你创作，例如：工作周报";
var command = "工作周报";
var search$2 = "你可能需要：";
var AInewfileRecommend = {
	create: create,
	more: more$1,
	placeholder: placeholder$3,
	command: command,
	search: search$2
};

var bottomAgree = "知悉并同意";
var bottomReject = "退出";
var content$1 = "欢迎您选择使用由金山办公提供的WPS AI服务！\n     为保护您的相关权益并帮助您简单了解WPS AI服务，我们制定了$protocol$，向您简单介绍了WPS AI服务，并且约定了我们向您提供本服务的免责条款及使用限制，以及我们将如何依法保护并处理您的个人信息，请您及时查看并阅读，在您确认同意协议条款后方可使用本服务。";
var title$t = "WPS AI 使用须知";
var linkCopy = "《WPS AI服务协议》";
var linkCopy2 = "《WPS AI隐私协议》";
var AiProtocol = {
	bottomAgree: bottomAgree,
	bottomReject: bottomReject,
	content: content$1,
	title: title$t,
	linkCopy: linkCopy,
	linkCopy2: linkCopy2
};

var txt0$39 = "下载客户端";
var txt1$2R = "下载APP";
var txt2$2B = "Windows版本";
var txt3$2m = "Mac版本";
var txt4$21 = "APP扫码下载";
var txt5$1R = "手机扫码下载";
var txt6$1E = "支持Android / iOS";
var txt7$1s = "小程序扫码使用";
var txt8$1m = "文档装进小程序";
var txt9$1e = "打开微信扫码使用";
var webPageCollectionPlugin = "网页收藏插件";
var AppDownload = {
	txt0: txt0$39,
	txt1: txt1$2R,
	txt2: txt2$2B,
	txt3: txt3$2m,
	txt4: txt4$21,
	txt5: txt5$1R,
	txt6: txt6$1E,
	txt7: txt7$1s,
	txt8: txt8$1m,
	txt9: txt9$1e,
	webPageCollectionPlugin: webPageCollectionPlugin
};

var components_dialog_appeal_index0 = "反馈原因";
var components_dialog_appeal_index1 = "(请输入5~50字)";
var components_dialog_appeal_index2 = "请详细描述反馈原因，可加快反馈进度";
var components_dialog_appeal_index3 = "提交";
var components_dialog_appeal_index4 = "反馈";
var components_dialog_appeal_index5 = "请输入{0}~{1}以内字数";
var components_dialog_appeal_index6 = "反馈恢复分享";
var components_dialog_appeal_index7 = "此文件违反";
var components_dialog_appeal_index8 = "用户行为规范";
var components_dialog_appeal_index9 = "已停止访问";
var components_dialog_appeal_index10 = "反馈处理中";
var components_dialog_appeal_index11 = "反馈失败";
var components_dialog_appeal_index12 = "请联系文件所有者";
var components_dialog_appeal_index13 = "下载到本地";
var components_dialog_appeal_index14 = "网络异常，下载失败";
var components_dialog_appeal_index15 = "正在下载";
var components_dialog_appeal_index16 = "取消";
var components_dialog_appeal_index17 = "反馈";
var components_dialog_appeal_index18 = "反馈原因";
var components_dialog_appeal_index19 = "请详细描述反馈原因，可加快反馈进度";
var components_dialog_appeal_index20 = "反馈处理中";
var components_dialog_appeal_index21 = "反馈失败";
var components_dialog_appeal_index22 = "反馈恢复分享";
var AppealIllegalFile = {
	components_dialog_appeal_index0: components_dialog_appeal_index0,
	components_dialog_appeal_index1: components_dialog_appeal_index1,
	components_dialog_appeal_index2: components_dialog_appeal_index2,
	components_dialog_appeal_index3: components_dialog_appeal_index3,
	components_dialog_appeal_index4: components_dialog_appeal_index4,
	components_dialog_appeal_index5: components_dialog_appeal_index5,
	components_dialog_appeal_index6: components_dialog_appeal_index6,
	components_dialog_appeal_index7: components_dialog_appeal_index7,
	components_dialog_appeal_index8: components_dialog_appeal_index8,
	components_dialog_appeal_index9: components_dialog_appeal_index9,
	components_dialog_appeal_index10: components_dialog_appeal_index10,
	components_dialog_appeal_index11: components_dialog_appeal_index11,
	components_dialog_appeal_index12: components_dialog_appeal_index12,
	components_dialog_appeal_index13: components_dialog_appeal_index13,
	components_dialog_appeal_index14: components_dialog_appeal_index14,
	components_dialog_appeal_index15: components_dialog_appeal_index15,
	components_dialog_appeal_index16: components_dialog_appeal_index16,
	components_dialog_appeal_index17: components_dialog_appeal_index17,
	components_dialog_appeal_index18: components_dialog_appeal_index18,
	components_dialog_appeal_index19: components_dialog_appeal_index19,
	components_dialog_appeal_index20: components_dialog_appeal_index20,
	components_dialog_appeal_index21: components_dialog_appeal_index21,
	components_dialog_appeal_index22: components_dialog_appeal_index22
};

var txt0$38 = "已加入分享的人";
var txt1$2Q = "复制成功";
var txt2$2A = "仅指定人可查看";
var txt3$2l = "仅指定人可查看/编辑";
var someoneAllPerm = "仅指定人可查看/评论/编辑";
var txt4$20 = "打开链接的人";
var txt5$1Q = "仅自己 可查看或编辑";
var txt6$1D = "任何人";
var txt7$1r = "复制成功，";
var txt8$1l = "复制失败";
var txt9$1d = "你的浏览器不支持自动复制请按";
var txt10$17 = "复制下面输入框的内容";
var txt11$$ = "分享功能升级维护中";
var txt12$W = "如何划分可编辑区域，防止数据被他人误改";
var txt13$W = "已选择";
var txt14$M = "批量操作";
var txt15$H = "设为 可编辑";
var txt16$F = "设为 可查看";
var txt17$A = "批量移除";
var txt18$z = "部分修改失败";
var txt19$x = "修改失败";
var txt20$u = "部分移除失败";
var txt21$q = "移除失败";
var txt22$n = "请确认移除指定的{0}个成员";
var txt23$k = "批量删除";
var txt24$g = "修改成功";
var txt25$f = "移除成功";
var txt26$f = "开启后，仅具有查看权限的人将无法下载、打印、另存和复制内容";
var setComment = "设为 可评论";
var advanceSettingTxt$1 = "高级设置";
var fileBan = "文件分享已停止";
var linkNotExist = "你访问的链接不存在或者已移除";
var serverError$1 = "服务器错误";
var ClinkCoopBox = {
	txt0: txt0$38,
	txt1: txt1$2Q,
	txt2: txt2$2A,
	txt3: txt3$2l,
	someoneAllPerm: someoneAllPerm,
	txt4: txt4$20,
	txt5: txt5$1Q,
	txt6: txt6$1D,
	txt7: txt7$1r,
	txt8: txt8$1l,
	txt9: txt9$1d,
	txt10: txt10$17,
	txt11: txt11$$,
	txt12: txt12$W,
	txt13: txt13$W,
	txt14: txt14$M,
	txt15: txt15$H,
	txt16: txt16$F,
	txt17: txt17$A,
	txt18: txt18$z,
	txt19: txt19$x,
	txt20: txt20$u,
	txt21: txt21$q,
	txt22: txt22$n,
	txt23: txt23$k,
	txt24: txt24$g,
	txt25: txt25$f,
	txt26: txt26$f,
	setComment: setComment,
	advanceSettingTxt: advanceSettingTxt$1,
	fileBan: fileBan,
	linkNotExist: linkNotExist,
	serverError: serverError$1
};

var txt0$37 = "文件分享链接已过期";
var txt1$2P = "链接已重置";
var txt2$2z = "分享功能升级维护中";
var ClinkPerm = {
	txt0: txt0$37,
	txt1: txt1$2P,
	txt2: txt2$2z
};

var txt0$36 = "文件";
var txt1$2O = "夹";
var txt2$2y = "由";
var txt3$2k = "「";
var txt4$1$ = "」管理员已设置权限";
var txt5$1P = "取不到名字";
var txt5_1 = "分享者已设置权限";
var txt6$1C = "分享，对方";
var txt6_1 = "已设置权限";
var txt6_2 = "分享者";
var txt7$1q = "分享已取消";
var txt8$1k = "邀请他人加入分享";
var txt9$1c = "获取免登录链接";
var txt10$16 = "文件分享链接已过期";
var txt11$_ = "分享链接未创建";
var txt12$V = "立即开启";
var txt13$V = "创建链接";
var txt14$L = "获取免登录链接";
var txt15$G = "开启链接";
var txt16$E = "复制链接";
var txt17$z = "点击获取免登录链接，访问者可免登录打开文件";
var txt18$y = "分享权限为本企业成员才可访问，不支持免登录";
var txt19$w = "分享权限为仅指定成员才可访问，不支持免登录";
var txt20$t = "开启链接成功";
var txt21$p = "金山文档 | WPS云文档";
var txt22$m = "扫码发给好友";
var txt23$j = "免登录链接未关闭，且任何人可访问";
var secure_title = "分享加密文件，仅指定人可访问";
var sendIMLoading = "正在发送...";
var sendIMSuccess = "发送成功";
var sendIMFail = "发送失败";
var overMaxCountTxt = "最多只能选择{0}个聊天";
var sendWOAMsgFail1 = "发送至「{0}」失败";
var sendWOAMsgFail2 = "发送至「{0}」等{1}个会话失败";
var sendWOAMsgFail3 = "安全文档不支持发送到企业外";
var ClinkSettingBox = {
	txt0: txt0$36,
	txt1: txt1$2O,
	txt2: txt2$2y,
	txt3: txt3$2k,
	txt4: txt4$1$,
	txt5: txt5$1P,
	txt5_1: txt5_1,
	txt6: txt6$1C,
	txt6_1: txt6_1,
	txt6_2: txt6_2,
	txt7: txt7$1q,
	txt8: txt8$1k,
	txt9: txt9$1c,
	txt10: txt10$16,
	txt11: txt11$_,
	txt12: txt12$V,
	txt13: txt13$V,
	txt14: txt14$L,
	txt15: txt15$G,
	txt16: txt16$E,
	txt17: txt17$z,
	txt18: txt18$y,
	txt19: txt19$w,
	txt20: txt20$t,
	txt21: txt21$p,
	txt22: txt22$m,
	txt23: txt23$j,
	secure_title: secure_title,
	sendIMLoading: sendIMLoading,
	sendIMSuccess: sendIMSuccess,
	sendIMFail: sendIMFail,
	overMaxCountTxt: overMaxCountTxt,
	sendWOAMsgFail1: sendWOAMsgFail1,
	sendWOAMsgFail2: sendWOAMsgFail2,
	sendWOAMsgFail3: sendWOAMsgFail3
};

var txt0$35 = "永久有效";
var txt1$2N = "有效";
var txt2$2x = "链接有效期";
var txt3$2j = "天有效";
var setSucc = "链接有效期设置成功";
var diyDate = "自定义有效期";
var timeSuffix = "前有效";
var timeFront = "前";
var selectTimeTxt = "选择有效期";
var expired = "已过期";
var ClinkTime = {
	txt0: txt0$35,
	txt1: txt1$2N,
	txt2: txt2$2x,
	txt3: txt3$2j,
	setSucc: setSucc,
	diyDate: diyDate,
	timeSuffix: timeSuffix,
	timeFront: timeFront,
	selectTimeTxt: selectTimeTxt,
	expired: expired
};

var txt0$34 = "参数不能为空";
var txt1$2M = "参数类型错误，正确应该是：";
var txt2$2w = "没有传入元素";
var txt3$2i = "没有传入正确的元素";
var txt4$1_ = "传参不能为空";
var txt5$1O = "快速了解如何解决办公困扰，与同事一起高效协作";
var txt6$1B = "你是否在工作中存在以下困扰：";
var txt7$1p = "工作资料散落各处，经常反复传输";
var txt8$1j = "文档意外丢失或误改无法找回和恢复";
var txt9$1b = "多人编写的文档需多次汇总整理，效率低";
var txt10$15 = "在家/出差等情况无法随时访问文档";
var txt11$Z = "立即了解";
var txt12$U = "直接使用";
var txt13$U = "已完成企业探索之旅！";
var txt14$K = "现在，你可以在团队中共享文档，进行协作办公";
var txt15$F = "立即前往";
var txt16$D = "或者也可以选择查看以下内容";
var txt17$y = "行业案例";
var txt18$x = "了解不同行业如何使用WPS+协同办公";
var txt19$v = "帮助中心";
var txt20$s = "所有功能的使用方法都在这里";
var txt21$o = "操作技巧";
var txt22$l = "可提升工作效率的小技巧，干货满满";
var txt23$i = "1.组建工作团队";
var txt24$f = "联系管理员邀请你加入工作团队；也可按需创建一个团队，邀请同事进入";
var txt25$e = "下一步";
var txt26$e = "2.共享办公资料";
var txt27$d = "文档在团队共享，形成办公资料库，避免文档散落各处与反复传输；历史版本防误改防丢失";
var txt28$c = "3.高效协同编辑";
var txt29$8 = "团队文档支持多人同时编辑，内容实时更新同步，避免分开填写再汇总的麻烦，提高协作效率";
var txt30$7 = "4.便捷分享文件";
var txt31$8 = "用分享功能方便快捷地将文件（夹）发送给同事，同事无需安装软件，点击链接即可查看，提高沟通效率";
var txt32$6 = "5.文档多端同步";
var txt33$5 = "工作文档在电脑手机等多端同步，无论是出差还是在家，随时随地移动办公";
var txt34$5 = "完成";
var txt35$5 = "欢迎加入";
var txt36$5 = "的企业云办公";
var txt37$5 = "与你的同事一起协同办公";
var txt38$5 = "马上了解";
var txt39$5 = "直接使用";
var txt40$5 = "已完成企业探索之旅！";
var txt41$5 = "现在，你可以在团队中共享文档，进行协作办公";
var txt42$5 = "立即前往";
var txt43$5 = "或者也可以选择查看以下内容";
var txt44$5 = "行业案例";
var txt45$5 = "了解不同行业如何使用WPS+协同办公";
var txt46$5 = "帮助中心";
var txt47$5 = "所有功能的使用方法都在这里";
var txt48$5 = "操作技巧";
var txt49$5 = "可提升工作效率的小技巧，干货满满";
var txt50$5 = "首先，";
var txt51$3 = "建立属于你的工作团队";
var txt52$3 = "可根据你所在的部门来创建，例如财务部、运营部等...";
var txt53$3 = "现在，";
var txt54$3 = "可以开始协作办公了";
var txt55$2 = "然后，";
var txt56$2 = "邀请进行协作的成员加入";
var txt57$2 = "成员可在团队中查看或编辑文档";
var txt58$2 = "同一份文档，团队成员可同时进行编辑";
var txt59$2 = "已完成企业探索之旅！";
var txt60$2 = "现在，你可以在团队中共享文档，进行协作办公";
var txt61$2 = "立即前往";
var txt62$2 = "或者也可以选择查看以下内容";
var txt63$2 = "行业案例";
var txt64$1 = "了解不同行业如何使用WPS+协同办公";
var txt65$1 = "帮助中心";
var txt66$1 = "所有功能的使用方法都在这里";
var txt67$1 = "操作技巧";
var txt68$1 = "可提升工作效率的小技巧，干货满满";
var txt69$1 = "可在这里邀请同事加入你的企业，加入后共享团队文档无需反复传输";
var txt70$1 = "立即邀请";
var txt71$1 = "创建例如财务部/运营部或项目组等需要 进行文档协作等工作团队";
var txt72 = "立即新建";
var txt73 = "可在这里重新进入操作指南";
var txt74 = "欢迎开启";
var txt75 = "的企业云办公";
var txt76 = "只需几步，可提升企业办公效率";
var txt77 = "了解企业团队的应用场景";
var txt78 = "以后再说";
var txt79 = "成功创建企业";
var txt80 = "邀请同事加入";
var txt81 = "建立工作团队";
var txt82 = "已创建企业";
var CompanyGuidePanel = {
	txt0: txt0$34,
	txt1: txt1$2M,
	txt2: txt2$2w,
	txt3: txt3$2i,
	txt4: txt4$1_,
	txt5: txt5$1O,
	txt6: txt6$1B,
	txt7: txt7$1p,
	txt8: txt8$1j,
	txt9: txt9$1b,
	txt10: txt10$15,
	txt11: txt11$Z,
	txt12: txt12$U,
	txt13: txt13$U,
	txt14: txt14$K,
	txt15: txt15$F,
	txt16: txt16$D,
	txt17: txt17$y,
	txt18: txt18$x,
	txt19: txt19$v,
	txt20: txt20$s,
	txt21: txt21$o,
	txt22: txt22$l,
	txt23: txt23$i,
	txt24: txt24$f,
	txt25: txt25$e,
	txt26: txt26$e,
	txt27: txt27$d,
	txt28: txt28$c,
	txt29: txt29$8,
	txt30: txt30$7,
	txt31: txt31$8,
	txt32: txt32$6,
	txt33: txt33$5,
	txt34: txt34$5,
	txt35: txt35$5,
	txt36: txt36$5,
	txt37: txt37$5,
	txt38: txt38$5,
	txt39: txt39$5,
	txt40: txt40$5,
	txt41: txt41$5,
	txt42: txt42$5,
	txt43: txt43$5,
	txt44: txt44$5,
	txt45: txt45$5,
	txt46: txt46$5,
	txt47: txt47$5,
	txt48: txt48$5,
	txt49: txt49$5,
	txt50: txt50$5,
	txt51: txt51$3,
	txt52: txt52$3,
	txt53: txt53$3,
	txt54: txt54$3,
	txt55: txt55$2,
	txt56: txt56$2,
	txt57: txt57$2,
	txt58: txt58$2,
	txt59: txt59$2,
	txt60: txt60$2,
	txt61: txt61$2,
	txt62: txt62$2,
	txt63: txt63$2,
	txt64: txt64$1,
	txt65: txt65$1,
	txt66: txt66$1,
	txt67: txt67$1,
	txt68: txt68$1,
	txt69: txt69$1,
	txt70: txt70$1,
	txt71: txt71$1,
	txt72: txt72,
	txt73: txt73,
	txt74: txt74,
	txt75: txt75,
	txt76: txt76,
	txt77: txt77,
	txt78: txt78,
	txt79: txt79,
	txt80: txt80,
	txt81: txt81,
	txt82: txt82
};

var txt0$33 = "已";
var txt1$2L = "发送验证消息";
var txt2$2v = "你可以提醒对方登录金山文档，在「首页-消息」中同意你的申请";
var txt3$2h = "我知道了";
var txt4$1Z = "邀请发送成功";
var ContactInvitationPanel = {
	txt0: txt0$33,
	txt1: txt1$2L,
	txt2: txt2$2v,
	txt3: txt3$2h,
	txt4: txt4$1Z
};

var txt0$32 = "人可编辑";
var txt1$2K = "人可查看，其中";
var txt2$2u = "人可查看";
var txt3$2g = "管理员已设置查看和编辑成员";
var txt4$1Y = "暂无协作者加入，你可以先添加协作者";
var txt5$1N = "你可以另外添加协作者，并指定查看/编辑权限";
var txt6$1A = "你没有权限访问文件";
var txt7$1o = "谁可以访问";
var txt8$1i = "文件已开启协作，你";
var txt9$1a = "仅可查看";
var txt10$14 = "可与他人一起编辑";
var txt11$Y = "创建者";
var txt12$T = "可查看";
var txt13$T = "可编辑";
var txt14$J = "只能查看，不能评论和编辑文件";
var txt15$E = "可以查看、评论和编辑文件";
var txt16$C = "移除";
var txt17$x = "已邀请";
var CoopMember = {
	txt0: txt0$32,
	txt1: txt1$2K,
	txt2: txt2$2u,
	txt3: txt3$2g,
	txt4: txt4$1Y,
	txt5: txt5$1N,
	txt6: txt6$1A,
	txt7: txt7$1o,
	txt8: txt8$1i,
	txt9: txt9$1a,
	txt10: txt10$14,
	txt11: txt11$Y,
	txt12: txt12$T,
	txt13: txt13$T,
	txt14: txt14$J,
	txt15: txt15$E,
	txt16: txt16$C,
	txt17: txt17$x
};

var txt0$31 = "文档所属团队";
var txt1$2J = "人可编辑";
var txt2$2t = "人可查看，其中";
var txt3$2f = "人可编辑";
var txt4$1X = "人可查看";
var txt5$1M = "管理员已设置查看和编辑成员";
var txt6$1z = "创建者";
var txt7$1n = "可查看";
var txt8$1h = "可编辑";
var txt9$19 = "只能查看，不能评论和编辑文件";
var txt10$13 = "可以查看、评论和编辑文件";
var txt11$X = "移除";
var txt12$S = "仅团队管理员可设置团队成员权限";
var txt13$S = "文件创建者";
var txt14$I = "通过链接加入";
var txt15$D = "直接指定添加";
var txt16$B = "查看成员授权";
var encryptertxt = "加密者";
var transferOwner$1 = "转让文档所有权";
var transferOwnerTips = "你是文档的创建者，拥有文档的所有权";
var chooseNewOwner = "请选择新的拥有者";
var transferOwnerDisableForSecret$1 = "加密文档暂不支持转让";
var transferOwnerDisableForPrivate = "无法转让，分享未开启，请先开启分享";
var transferOwnerTipForTeam = "该文档为团队文档，仅支持转让给团队成员";
var transferOwnerTipForShareFolder = "该文档为共享文件夹文档，仅支持转让给共享文件夹成员";
var transferOwnerTipForCorp = "该文档为企业文档，仅支持转让给本企业成员";
var comment$8 = "可评论";
var removeMember = "移出协作";
var removeMemberAndClear = "取消授权";
var canNotChangeGroupMemberPerm$1 = "暂不支持调整团队中的单个成员权限";
var canNotRemoveGroupMemberPerm = "当前用户是团队/共享文件夹成员，暂不支持取消授权";
var CoopMemberList = {
	txt0: txt0$31,
	txt1: txt1$2J,
	txt2: txt2$2t,
	txt3: txt3$2f,
	txt4: txt4$1X,
	txt5: txt5$1M,
	txt6: txt6$1z,
	txt7: txt7$1n,
	txt8: txt8$1h,
	txt9: txt9$19,
	txt10: txt10$13,
	txt11: txt11$X,
	txt12: txt12$S,
	txt13: txt13$S,
	txt14: txt14$I,
	txt15: txt15$D,
	txt16: txt16$B,
	encryptertxt: encryptertxt,
	transferOwner: transferOwner$1,
	transferOwnerTips: transferOwnerTips,
	chooseNewOwner: chooseNewOwner,
	transferOwnerDisableForSecret: transferOwnerDisableForSecret$1,
	transferOwnerDisableForPrivate: transferOwnerDisableForPrivate,
	transferOwnerTipForTeam: transferOwnerTipForTeam,
	transferOwnerTipForShareFolder: transferOwnerTipForShareFolder,
	transferOwnerTipForCorp: transferOwnerTipForCorp,
	comment: comment$8,
	removeMember: removeMember,
	removeMemberAndClear: removeMemberAndClear,
	canNotChangeGroupMemberPerm: canNotChangeGroupMemberPerm$1,
	canNotRemoveGroupMemberPerm: canNotRemoveGroupMemberPerm
};

var txt0$30 = "搜索用户名称、手机号，添加协作者";
var txt1$2I = "找不到对应的用户";
var txt2$2s = "你可以直接复制链接发送";
var txt3$2e = "可查看";
var txt4$1W = "只能查看，不能评论和编辑文件";
var txt5$1L = "可编辑";
var txt6$1y = "可以查看、评论和编辑文件";
var txt7$1m = "通讯录";
var txt8$1g = "已发送";
var txt9$18 = "已添加";
var txt10$12 = "添加";
var txt11$W = "邀请发送成功";
var txt12$R = "我";
var txt13$R = "添加失败，";
var sendToWoa = "将文件发送至聊天";
var comment$7 = "可评论";
var sendRemind = "消息提醒对方";
var noAddListTxt = "未添加";
var addListTxt = "已添加";
var fileCreator$2 = "创建者";
var sendToWoaFail = "发送失败";
var department = "部门";
var groupChat$2 = "群聊";
var team$2 = "团队";
var CoopMemberSearch = {
	txt0: txt0$30,
	txt1: txt1$2I,
	txt2: txt2$2s,
	txt3: txt3$2e,
	txt4: txt4$1W,
	txt5: txt5$1L,
	txt6: txt6$1y,
	txt7: txt7$1m,
	txt8: txt8$1g,
	txt9: txt9$18,
	txt10: txt10$12,
	txt11: txt11$W,
	txt12: txt12$R,
	txt13: txt13$R,
	sendToWoa: sendToWoa,
	comment: comment$7,
	sendRemind: sendRemind,
	noAddListTxt: noAddListTxt,
	addListTxt: addListTxt,
	fileCreator: fileCreator$2,
	sendToWoaFail: sendToWoaFail,
	department: department,
	groupChat: groupChat$2,
	team: team$2
};

var txt0$2$ = "搜索联系人名称、手机号，添加协作者";
var txt1$2H = "找不到对应的用户";
var txt2$2r = "你可以通过链接邀请好友";
var txt3$2d = "从通讯录中选择";
var txt4$1V = "我";
var txt5$1K = "已发送";
var txt6$1x = "已添加";
var txt7$1l = "添加";
var CoopMemberSearcher = {
	txt0: txt0$2$,
	txt1: txt1$2H,
	txt2: txt2$2r,
	txt3: txt3$2d,
	txt4: txt4$1V,
	txt5: txt5$1K,
	txt6: txt6$1x,
	txt7: txt7$1l
};

var txt0$2_ = "其他添加方式：";
var txt1$2G = "扫一扫发送给好友";
var txt2$2q = "内有效，加入后可协作";
var txt3$2c = "该邀请链接";
var txt4$1U = "内有效，加入后可协作「";
var txt5$1J = "」";
var txt6$1w = "复制链接";
var txt7$1k = "邀请你一起编辑「";
var txt8$1f = "」";
var txt9$17 = "天";
var txt10$11 = "开启邀请失败";
var CopyEditLink = {
	txt0: txt0$2_,
	txt1: txt1$2G,
	txt2: txt2$2q,
	txt3: txt3$2c,
	txt4: txt4$1U,
	txt5: txt5$1J,
	txt6: txt6$1w,
	txt7: txt7$1k,
	txt8: txt8$1f,
	txt9: txt9$17,
	txt10: txt10$11
};

var txt0$2Z = "由于小程序限制，请复制链接后使用浏览器访问";
var txt1$2F = "复制链接";
var txt2$2p = "复制成功";
var txt3$2b = "复制失败";
var txt4$1T = "下载提示";
var CopyLink = {
	txt0: txt0$2Z,
	txt1: txt1$2F,
	txt2: txt2$2p,
	txt3: txt3$2b,
	txt4: txt4$1T
};

var txt0$2Y = "企业空间容量已满，升级企业套餐可扩容企业空间";
var txt1$2E = "升级套餐";
var txt2$2o = "企业空间容量已满，请通知超级管理员";
var txt3$2a = "，升级企业套餐。";
var txt4$1S = "取消";
var CorpSpaceFull = {
	txt0: txt0$2Y,
	txt1: txt1$2E,
	txt2: txt2$2o,
	txt3: txt3$2a,
	txt4: txt4$1S
};

var txt0$2X = "团队名";
var txt0_beemwork$3 = "团队名";
var txt1$2D = "（开启加密保护";
var txt2$2n = "团队文档自动加密，非团队成员不可查看";
var txt3$29 = "团队成员";
var txt3_beemwork = "团队成员";
var txt4$1R = "名成员";
var txt5$1I = "从共享文件夹移入";
var txt6$1v = "取消";
var txt7$1j = "确定";
var txt8$1e = "的团队";
var txt9$16 = "申请";
var placeholder$2 = "请填写团队名";
var teamsettings = {
	txt1: "团队设置",
	txt2: "开启“团队文档水印”",
	txt3: "设置“文档对外分享范围”为",
	txt4: "可以禁止团队文件分享到企业外/团队外",
	txt5: "开启“团队智能问答服务”",
	txt6: "可通过对话形式获取团队内的文档信息",
	publishMenu: "发布设置"
};
var presetFail = {
	txt1: "以下团队设置由于权益不足修改失败，您可以直接进入团队或者购买套餐，购买套餐后，可以开启团队文档水印并管控文档分享范围。",
	txt2: "团队文档水印",
	txt3: "文档对外分享范围",
	txt4: "购买套餐",
	txt5: "进入团队"
};
var presetSucc = {
	txt1: "如需调整，可到“团队设置-文档设置”，进行修改。",
	txt2: "进入团队"
};
var noMemberToSelect$1 = "暂无可选成员";
var CreateTeam = {
	txt0: txt0$2X,
	txt0_beemwork: txt0_beemwork$3,
	txt1: txt1$2D,
	txt2: txt2$2n,
	txt3: txt3$29,
	txt3_beemwork: txt3_beemwork,
	txt4: txt4$1R,
	txt5: txt5$1I,
	txt6: txt6$1v,
	txt7: txt7$1j,
	txt8: txt8$1e,
	txt9: txt9$16,
	placeholder: placeholder$2,
	teamsettings: teamsettings,
	presetFail: presetFail,
	presetSucc: presetSucc,
	noMemberToSelect: noMemberToSelect$1
};

var txt0$2W = "选择文件/文件夹可以查看详情";
var txt1$2C = "没有访问权限";
var txt2$2m = "请联系作者开启访问权限";
var txt3$28 = "分享设置";
var txt4$1Q = "未分享";
var txt5$1H = "设置分享权限";
var txt6$1u = "分享";
var txt7$1i = "共享后可共同查看、编辑文件";
var txt8$1d = "共享文件可多人编辑、实时同步";
var txt9$15 = "邀请成员加入";
var txt10$10 = "共享文件可多人编辑、实时同步";
var txt11$V = "历史版本";
var txt12$Q = "查看全部";
var txt13$Q = "一键恢复文件/文档到任意版本";
var txt14$H = "修改";
var txt15$C = "预览";
var txt16$A = "更多信息";
var txt17$w = "所有者";
var txt18$w = "上次修改";
var txt19$u = "创建时间";
var txt20$r = "已过期";
var txt21$n = "邀请成员";
var cooperation = "协同办公";
var addSchedule = "添加日程";
var clickToSeeMember = "点击查看参与者";
var scheduleEmpty = "暂无事项";
var scheduleEmptyTips = "把文件作添加为日程，按时提醒并归档记录";
var label = {
	title: "标签",
	favor: "常用",
	watch_all: "查看全部标签",
	add: "添加标签"
};
var fileSize = "文件大小";
var onlineFileSize = "不占云空间";
var fileType = "文件类型";
var filePath = "文件位置";
var myDocs = "我的文档";
var myCloudDocs = "我的云文档";
var share$1 = "共享";
var sharewithme = "与我共享";
var share2me = "共享给我";
var path_received = "我收到的轻地址";
var formatFileType = {
	otl: "智能文档",
	ksheet: "智能表格",
	dbt: "多维表格",
	form: "智能表单",
	pof: "思维导图",
	pom: "流程图",
	kw: "白板",
	wpsnote: "便签",
	ckt: "海报",
	ofd: "样张",
	resh: "简历"
};
var me$3 = "我";
var docInfo_today = "今天";
var docInfo_yesterday = "昨天";
var docInfo_month_day = "m月d日";
var docInfo_year_month_day = "Y年m月d日";
var DocInfo = {
	txt0: txt0$2W,
	txt1: txt1$2C,
	txt2: txt2$2m,
	txt3: txt3$28,
	txt4: txt4$1Q,
	txt5: txt5$1H,
	txt6: txt6$1u,
	txt7: txt7$1i,
	txt8: txt8$1d,
	txt9: txt9$15,
	txt10: txt10$10,
	txt11: txt11$V,
	txt12: txt12$Q,
	txt13: txt13$Q,
	txt14: txt14$H,
	txt15: txt15$C,
	txt16: txt16$A,
	txt17: txt17$w,
	txt18: txt18$w,
	txt19: txt19$u,
	txt20: txt20$r,
	txt21: txt21$n,
	cooperation: cooperation,
	addSchedule: addSchedule,
	clickToSeeMember: clickToSeeMember,
	scheduleEmpty: scheduleEmpty,
	scheduleEmptyTips: scheduleEmptyTips,
	label: label,
	fileSize: fileSize,
	onlineFileSize: onlineFileSize,
	fileType: fileType,
	filePath: filePath,
	myDocs: myDocs,
	myCloudDocs: myCloudDocs,
	share: share$1,
	sharewithme: sharewithme,
	share2me: share2me,
	path_received: path_received,
	formatFileType: formatFileType,
	me: me$3,
	docInfo_today: docInfo_today,
	docInfo_yesterday: docInfo_yesterday,
	docInfo_month_day: docInfo_month_day,
	docInfo_year_month_day: docInfo_year_month_day
};

var txt0$2V = "请确认删除";
var txt1$2B = "删除联系人后，该用户将不出现在我的联系人列表";
var txt2$2l = "取消";
var txt3$27 = "删除";
var DeleteContact = {
	txt0: txt0$2V,
	txt1: txt1$2B,
	txt2: txt2$2l,
	txt3: txt3$27
};

var txt0$2U = "云空间已满";
var DialogCorpSpaceFull = {
	txt0: txt0$2U
};

var txt0$2T = "新建团队";
var txt0_beemwork$2 = "新建团队";
var txt1$2A = "添加联系人";
var txt2$2k = "删除联系人";
var txt3$26 = "新建团队申请";
var txt4$1P = "团队类型";
var txt5$1G = "新建普通团队";
var txt6$1t = "预览";
var txt7$1h = "使用";
var txt8$1c = "加载中";
var txt9$14 = "重新加载";
var txt10$$ = "初始化场景失败";
var txt11$U = "应用开通失败";
var txt12$P = "部分应用开通失败";
var txt13$P = "自建应用开通失败";
var txt14$G = "团队创建成功且设置已生效";
var txt15$B = "团队创建成功但设置未生效";
var docTemplateError = {
	"40000105": "空间已满，模板创建失败",
	"40000201": "模板创建失败，请重新创建"
};
var upToMyTeam = "升级为个人团队";
var selectGroup = "选择升级为团队的共享文件夹";
var upToGuide = "移入说明";
var oem = {
	normal: {
		title: "普通团队",
		subtitle: "按需邀请成员上传文件，共享协作"
	},
	secure: {
		title: "加密团队",
		subtitle: "所有文件自动加密仅本团队成员可见"
	}
};
var defaulScenarios = {
	scenariosTitle: "基础使用场景",
	general: {
		title: "普通团队",
		subtitle: "按需邀请成员<br/>上传文件，共享协作"
	},
	secure: {
		title: "加密团队",
		subtitle: "所有文件自动加密<br/>仅本团队成员可见"
	}
};
var DialogCreateTeam = {
	txt0: txt0$2T,
	txt0_beemwork: txt0_beemwork$2,
	txt1: txt1$2A,
	txt2: txt2$2k,
	txt3: txt3$26,
	txt4: txt4$1P,
	txt5: txt5$1G,
	txt6: txt6$1t,
	txt7: txt7$1h,
	txt8: txt8$1c,
	txt9: txt9$14,
	txt10: txt10$$,
	txt11: txt11$U,
	txt12: txt12$P,
	txt13: txt13$P,
	txt14: txt14$G,
	txt15: txt15$B,
	docTemplateError: docTemplateError,
	upToMyTeam: upToMyTeam,
	selectGroup: selectGroup,
	upToGuide: upToGuide,
	oem: oem,
	defaulScenarios: defaulScenarios
};

var txt0$2S = "不是改企业成员";
var txt1$2z = "企业id为必选参数";
var DialogEntCardsGuide = {
	txt0: txt0$2S,
	txt1: txt1$2z
};

var txt0$2R = "置顶内容功能示例";
var DialogEntDemo = {
	txt0: txt0$2R
};

var txt0$2Q = "免费升级WPS+协作版";
var DialogEntGetCooper = {
	txt0: txt0$2Q
};

var txt0$2P = "企业id为必选参数";
var DialogEntGuide = {
	txt0: txt0$2P
};

var txt0$2O = "即将跳转至第三方网站，建议确认该网站安全后前往。是否继续跳转？";
var txt1$2y = "取消";
var txt2$2j = "继续";
var txt3$25 = "跳转提示";
var DialogLinkJumpTip = {
	txt0: txt0$2O,
	txt1: txt1$2y,
	txt2: txt2$2j,
	txt3: txt3$25
};

var txt0$2N = "文件夹权限设置";
var txt1$2x = "文档权限设置";
var DialogModifyFilePermission = {
	txt0: txt0$2N,
	txt1: txt1$2x
};

var txt0$2M = "文档权限设置";
var DialogModifyFilePerSetting = {
	txt0: txt0$2M
};

var txt0$2L = "已准备好了「疫情防控知识与员工情况收集」团队，方便统计";
var txt1$2w = "员工情况和下发通知等。包含以下文档，是否创建该团队？";
var txt2$2i = "立即创建";
var txt3$24 = "不用了";
var Ent2019nCovGuide = {
	txt0: txt0$2L,
	txt1: txt1$2w,
	txt2: txt2$2i,
	txt3: txt3$24
};

var txt0$2K = "高效安全、多人协作的办公服务";
var txt1$2v = "以下技巧可帮助您快速上手";
var txt2$2h = "跳过引导，开始使用";
var EntCardsGuide = {
	txt0: txt0$2K,
	txt1: txt1$2v,
	txt2: txt2$2h
};

var txt0$2J = "查看详细的图文教程";
var EntCardsGuideVideo = {
	txt0: txt0$2J
};

var txt0$2I = "你已获得以下权限";
var txt1$2u = "WPS+协作版权益";
var txt2$2g = "若需更多权益，可";
var txt3$23 = "填表申请";
var txt4$1O = "我知道了";
var txt5$1F = "人";
var txt6$1s = "更大空间，企业文档集中管理";
var txt7$1g = "支持超大文件上传，无障碍共享";
var txt8$1b = "远程办公高效协作";
var txt9$13 = "语音会议，表单统计，协同编辑";
var txt10$_ = "企业文件安全保护";
var txt11$T = "重要文件控制可见范围，防止外泄";
var txt12$O = "WPS+协作版权益";
var txt13$O = "恭喜你，你已成功领取6个月WPS+协作版";
var txt14$F = "开启数字化办公";
var txt15$A = "提供一站式解决方案";
var txt16$z = "从即日起至2020年6月21日，企业成员激活达到";
var txt17$v = "当前";
var txt18$v = "邀请成员";
var txt19$t = "即可领取6个月WPS+协作版";
var txt20$q = "仅企业管理员可领取权益，可通知";
var txt21$m = "来领取";
var txt22$k = "立即领取";
var txt23$h = "服务器开小差，请稍后再试";
var EntGetCooper = {
	txt0: txt0$2I,
	txt1: txt1$2u,
	txt2: txt2$2g,
	txt3: txt3$23,
	txt4: txt4$1O,
	txt5: txt5$1F,
	txt6: txt6$1s,
	txt7: txt7$1g,
	txt8: txt8$1b,
	txt9: txt9$13,
	txt10: txt10$_,
	txt11: txt11$T,
	txt12: txt12$O,
	txt13: txt13$O,
	txt14: txt14$F,
	txt15: txt15$A,
	txt16: txt16$z,
	txt17: txt17$v,
	txt18: txt18$v,
	txt19: txt19$t,
	txt20: txt20$q,
	txt21: txt21$m,
	txt22: txt22$k,
	txt23: txt23$h
};

var txt0$2H = "查看WPS+使用指南，更好助力企业复工";
var txt1$2t = "查看使用指南 >";
var txt2$2f = "收起引导";
var txt3$22 = "「帮助中心」";
var txt4$1N = "查看";
var txt5$1E = "更多远程办公指南与行业使用案例，去";
var txt6$1r = "可在这里进入远程办公引导";
var txt7$1f = "用表单便捷收集与高效汇总信息";
var txt8$1a = "适用于客户需求收集、销售统计、防疫物资统计等多种场景";
var txt9$12 = "将表格转成表单发送给相关人员填写，可自动汇总至表格，方便高效";
var txt10$Z = "用企业团队实现办公资料共享";
var txt11$S = "文档在团队共享，形成办公资料库，避免散落各处与反复传输";
var txt12$N = "按需控制员工读写权限，重要文件防误改，不泄密";
var txt13$N = "支持多人同步编辑，避免分开填写再汇总的麻烦";
var txt14$E = "用文档开启远程会议";
var txt15$z = "使用「远程会议」功能，避免人员聚集，不受场地限制";
var txt16$y = "多人同时查看文档，文档自动跟随主讲人翻页，与当面沟通一样高效";
var txt17$u = "用WPS日历安排办公日程";
var txt18$u = "办公日程全员同步，节点清晰，一目了然";
var txt19$s = "日程到期自动提醒，重要工作不耽误";
var EntRemoteWorkGuide = {
	txt0: txt0$2H,
	txt1: txt1$2t,
	txt2: txt2$2f,
	txt3: txt3$22,
	txt4: txt4$1N,
	txt5: txt5$1E,
	txt6: txt6$1r,
	txt7: txt7$1f,
	txt8: txt8$1a,
	txt9: txt9$12,
	txt10: txt10$Z,
	txt11: txt11$S,
	txt12: txt12$N,
	txt13: txt13$N,
	txt14: txt14$E,
	txt15: txt15$z,
	txt16: txt16$y,
	txt17: txt17$u,
	txt18: txt18$u,
	txt19: txt19$s
};

var txt0$2G = "添加置顶公告";
var txt1$2s = "设置团队目标或新人入职说明";
var txt2$2e = "添加置顶文件";
var txt3$21 = "让成员关注团队重要文件";
var txt4$1M = "点击";
var txt5$1D = "添加";
var txt6$1q = "团队置顶公告";
var txt7$1e = "本季度销售量同比增长30%!";
var txt8$19 = "客户信息登记表.xlsx";
var txt9$11 = "固定至团队置顶";
var txt10$Y = "置顶内容";
var txt11$R = "团队文档";
var txt12$M = "业务部";
var EntTeamtopDemo = {
	txt0: txt0$2G,
	txt1: txt1$2s,
	txt2: txt2$2e,
	txt3: txt3$21,
	txt4: txt4$1M,
	txt5: txt5$1D,
	txt6: txt6$1q,
	txt7: txt7$1e,
	txt8: txt8$19,
	txt9: txt9$11,
	txt10: txt10$Y,
	txt11: txt11$R,
	txt12: txt12$M
};

var txt0$2F = "链接分享";
var txt1$2r = "文件已设置权限";
var txt2$2d = "分享给指定用户";
var txt3$20 = "我所在的群组";
var txt4$1L = "我的权限";
var txt6$1p = "从通讯录选择";
var txt7$1d = "分享给用户和群组";
var txt8$18 = "我所在的群组";
var txt9$10 = "父目录已开启分享，权限为「{0}」";
var txt10$X = "文件夹未开启分享";
var txt11$Q = "已继承父目录权限";
var txt12$L = "（继承上级文件夹分享设定）";
var cancel$e = "取消";
var confirm$4 = "确定";
var openLink$1 = "开启链接";
var openShare = "开启分享";
var copyLink$5 = "复制链接";
var modify$2 = "修改";
var shareTo = "分享到";
var moreShareWay = "更多分享方式";
var unopened = "未开启";
var advanceSetting = "高级设置";
var permsSetting = "权限设置";
var someoneTip1 = "仅指定用户和群组可通过链接打开";
var someoneTip2 = "仅下方用户可访问";
var someoneTip3 = "指定人";
var someoneTip4 = "仅指定用户可访问";
var someoneTip5 = "仅创建者指定用户可访问";
var inheritFirstDir = "继承上级文件夹分享设定";
var unopenedFolderLink = "文件夹未开启链接";
var someone$1 = "仅下方用户";
var someone1 = "仅指定用户";
var anyone$3 = "任何人";
var company$1 = "本企业成员";
var noRangePerm = "未设置分享范围和权限";
var linkNotOpenShare = "文件未开启分享";
var linkExpired = "文件分享链接已过期";
var closeShareLink = "关闭链接分享";
var cancelShare = "取消分享";
var stopCoop = "停止协作";
var remove$1 = "移除";
var getOut = "移出";
var read$8 = "可查看";
var write$7 = "可编辑";
var notFound = "找不到对应的用户、群组或部门";
var openPublicShare = "开启对外分享";
var canManage = "可管理";
var shareGuideTip = "想要分享给指定人？试试重新创建分享吧。";
var entEmpowerPermConfirm_txt0 = "请确认开启分享「{0}」";
var entEmpowerPermConfirm_txt1 = "当前文件未开启对外分享，无法添加团队外成员";
var entEmpowerPermConfirm_txt2 = "{0}位成员";
var yourself = "你自己";
var teamMember = "团队成员";
var cancelShareConfirmTitle = "请确认取消分享「{0}」";
var cancelShareConfirmSubTitle = "取消后仅{name}可访问，以下成员将无法继续访问";
var linkCopied = "链接已复制";
var copySuccess$2 = "复制成功";
var copyFail = "复制失败";
var noPermission$2 = "没有访问权限";
var directToAdd = "直接指定添加";
var linkToAdd = "通过链接加入";
var fileBelongToTeam = "文档所属团队";
var wpsDoc = "金山文档 | WPS云文档";
var manualCopyTips = "你的浏览器不支持自动复制请按{0} + C 复制下面输入框的内容";
var openShareSuccess = "开启分享成功";
var openLinkSuccess$1 = "开启链接成功";
var inputTip = "搜索用户名、群组或部门";
var cancelShareSuccess = "取消分享成功";
var stopCoopSuccess = "停止协作成功";
var cancelShareFail = "取消分享失败";
var updateSuccess = "修改成功";
var updateFail = "修改失败";
var addSuccess = "添加成功";
var shareChargeInCompany = "{role}已禁止文件分享到企业外";
var shareChargeInTeam = "{role}已禁止文件分享到团队外";
var teamAdmin = "团队管理员";
var entAdmin = "企业管理员";
var failTryAgain = "失败，请重试";
var linkPerm = "链接权限";
var manageCorpMembers = "管理协作者";
var addCorpMembers = "添加协作者";
var corp = "协作";
var send$1 = "发送";
var shareRange$2 = "分享范围";
var sharePerms = "分享权限";
var multiCompoundPerms = "组合权限";
var condition1 = "已搜索出{0}位用户";
var condition2 = "，其中{0}位用户已有权限";
var selectDate = "选择日期";
var selectTime = "选择时间";
var requestShareOutside$2 = "申请外发";
var EntSharePanel = {
	txt0: txt0$2F,
	txt1: txt1$2r,
	txt2: txt2$2d,
	txt3: txt3$20,
	txt4: txt4$1L,
	txt6: txt6$1p,
	txt7: txt7$1d,
	txt8: txt8$18,
	txt9: txt9$10,
	txt10: txt10$X,
	txt11: txt11$Q,
	txt12: txt12$L,
	cancel: cancel$e,
	confirm: confirm$4,
	openLink: openLink$1,
	openShare: openShare,
	copyLink: copyLink$5,
	modify: modify$2,
	shareTo: shareTo,
	moreShareWay: moreShareWay,
	unopened: unopened,
	advanceSetting: advanceSetting,
	permsSetting: permsSetting,
	someoneTip1: someoneTip1,
	someoneTip2: someoneTip2,
	someoneTip3: someoneTip3,
	someoneTip4: someoneTip4,
	someoneTip5: someoneTip5,
	inheritFirstDir: inheritFirstDir,
	unopenedFolderLink: unopenedFolderLink,
	someone: someone$1,
	someone1: someone1,
	anyone: anyone$3,
	company: company$1,
	noRangePerm: noRangePerm,
	linkNotOpenShare: linkNotOpenShare,
	linkExpired: linkExpired,
	closeShareLink: closeShareLink,
	cancelShare: cancelShare,
	stopCoop: stopCoop,
	remove: remove$1,
	getOut: getOut,
	read: read$8,
	write: write$7,
	notFound: notFound,
	openPublicShare: openPublicShare,
	canManage: canManage,
	shareGuideTip: shareGuideTip,
	entEmpowerPermConfirm_txt0: entEmpowerPermConfirm_txt0,
	entEmpowerPermConfirm_txt1: entEmpowerPermConfirm_txt1,
	entEmpowerPermConfirm_txt2: entEmpowerPermConfirm_txt2,
	yourself: yourself,
	teamMember: teamMember,
	cancelShareConfirmTitle: cancelShareConfirmTitle,
	cancelShareConfirmSubTitle: cancelShareConfirmSubTitle,
	linkCopied: linkCopied,
	copySuccess: copySuccess$2,
	copyFail: copyFail,
	noPermission: noPermission$2,
	directToAdd: directToAdd,
	linkToAdd: linkToAdd,
	fileBelongToTeam: fileBelongToTeam,
	wpsDoc: wpsDoc,
	manualCopyTips: manualCopyTips,
	openShareSuccess: openShareSuccess,
	openLinkSuccess: openLinkSuccess$1,
	inputTip: inputTip,
	cancelShareSuccess: cancelShareSuccess,
	stopCoopSuccess: stopCoopSuccess,
	cancelShareFail: cancelShareFail,
	updateSuccess: updateSuccess,
	updateFail: updateFail,
	addSuccess: addSuccess,
	shareChargeInCompany: shareChargeInCompany,
	shareChargeInTeam: shareChargeInTeam,
	teamAdmin: teamAdmin,
	entAdmin: entAdmin,
	failTryAgain: failTryAgain,
	linkPerm: linkPerm,
	manageCorpMembers: manageCorpMembers,
	addCorpMembers: addCorpMembers,
	corp: corp,
	send: send$1,
	shareRange: shareRange$2,
	sharePerms: sharePerms,
	multiCompoundPerms: multiCompoundPerms,
	condition1: condition1,
	condition2: condition2,
	selectDate: selectDate,
	selectTime: selectTime,
	requestShareOutside: requestShareOutside$2
};

var txt0$2E = "文档标签";
var txt1$2q = "输入标签，按回车添加";
var txt2$2c = "标签文字过长";
var txt3$1$ = "推荐标签";
var txt4$1K = "标签太多不利于管理哦";
var txt5$1C = "标签已存在";
var txt6$1o = "取消";
var txt7$1c = "确定";
var companyLabel = "企业标签";
var groupLabel = "团队标签";
var groupLabelInfo = "（所有成员可见）";
var companyOrGroupLabel = "企业/团队标签";
var myLabel = "我的标签";
var noCreateGroupPermission = "无权创建团队标签，请从下拉菜单中选择";
var inputKeywordWarning = "输入框内还有未添加的标签";
var createLabelFailed = "添加失败";
var EditLabel = {
	txt0: txt0$2E,
	txt1: txt1$2q,
	txt2: txt2$2c,
	txt3: txt3$1$,
	txt4: txt4$1K,
	txt5: txt5$1C,
	txt6: txt6$1o,
	txt7: txt7$1c,
	companyLabel: companyLabel,
	groupLabel: groupLabel,
	groupLabelInfo: groupLabelInfo,
	companyOrGroupLabel: companyOrGroupLabel,
	myLabel: myLabel,
	noCreateGroupPermission: noCreateGroupPermission,
	inputKeywordWarning: inputKeywordWarning,
	createLabelFailed: createLabelFailed
};

var txt0$2D = "另存";
var txt1$2p = "复制";
var txt2$2b = "已选";
var txt3$1_ = "项";
var txt4$1J = "复制文件成功";
var txt5$1B = "粘贴";
var txt6$1n = "复制到";
var txt7$1b = "您不是加密者,无权限解密,可联系{0}(文档加密者)解密";
var FileCopy = {
	txt0: txt0$2D,
	txt1: txt1$2p,
	txt2: txt2$2b,
	txt3: txt3$1_,
	txt4: txt4$1J,
	txt5: txt5$1B,
	txt6: txt6$1n,
	txt7: txt7$1b
};

var txt0$2C = "请登录后，下载指定文件";
var txt1$2o = "获取团队失败";
var txt2$2a = "获取文件下载地址失败";
var txt3$1Z = "未能完整下载指定的文件列表";
var txt4$1I = "{0}下载失败，该文件格式不支持下载";
var txt5$1A = "{0}等{1}个文件下载失败，该文件格式不支持下载";
var txt6$1m = "文件导出中，请稍候...";
var txt7$1a = "批量下载文件不能超过300个，请重新选择";
var txt8$17 = "批量下载文件不能超过100个，";
var txt9$$ = "升级超级会员可提高上限";
var txt10$W = "批量下载文件大小不能超过500M，请重新选择";
var txt11$P = "批量下载文件大小不能超过200M，";
var txt12$K = "升级超级会员可提高上限";
var txt13$M = "客户端不支持的接口";
var tooManyRequests = "目前无法完成此请求，请稍后重试";
var imageResourcesTooLarge = "当前文档内图片体积超出 2GB，暂不支持导出";
var fail$1 = "导出失败，请稍后重试";
var VisiblePermissionDenied = "文档中包含不可见区域，不支持此操作";
var permissionDenied$1 = "你没有该文件的下载权限";
var FileDownload = {
	txt0: txt0$2C,
	txt1: txt1$2o,
	txt2: txt2$2a,
	txt3: txt3$1Z,
	txt4: txt4$1I,
	txt5: txt5$1A,
	txt6: txt6$1m,
	txt7: txt7$1a,
	txt8: txt8$17,
	txt9: txt9$$,
	txt10: txt10$W,
	txt11: txt11$P,
	txt12: txt12$K,
	txt13: txt13$M,
	tooManyRequests: tooManyRequests,
	imageResourcesTooLarge: imageResourcesTooLarge,
	fail: fail$1,
	VisiblePermissionDenied: VisiblePermissionDenied,
	permissionDenied: permissionDenied$1
};

var txt0$2B = "移动";
var txt1$2n = "已选";
var txt2$29 = "项";
var txt3$1Y = "移动文件成功";
var txt4$1H = "移动到";
var FileMove = {
	txt0: txt0$2B,
	txt1: txt1$2n,
	txt2: txt2$29,
	txt3: txt3$1Y,
	txt4: txt4$1H
};

var title$s = "文档信息";
var view_t1 = "访问数据";
var view_t2 = "编辑数据从2022年4月28日开始统计";
var view_today = "今日";
var view_pv = "查看次数";
var view_dv = "查看人数";
var view_ev = "编辑人数";
var view_pv_desc = "成功打开文档的总次数";
var view_dv_desc = "成功打开文档的总人数";
var view_ev_desc = "编辑文档内容的总人数";
var export_btn = "详细记录";
var filename = "文件名";
var creator$1 = "所有者";
var createtime = "创建时间";
var filetype = "类型";
var filesize = "大小";
var filepath = "位置";
var otl = "智能文档";
var dbt = "多维表格";
var pof = "思维导图";
var pom = "流程图";
var form = "智能表单";
var kw = "白板";
var wpsnote = "便签";
var ckt = "海报";
var ofd = "ofd";
var ksheet = "智能表格";
var size_text = "-";
var myfile = "我收到的文件";
var netError_desc = "网络异常，加载失败";
var netError_btn = "重新加载";
var export_title = "导出访问数据";
var export_desc = "仅支持导出近30天数据";
var export_btn_cancel = "取消";
var export_btn_error = "导出失败";
var export_btn_retry = "重试";
var export_btn_open = "打开文档";
var export_path = "存储至";
var count_title = "基本信息";
var count_total = "总字数";
var count_char1 = "字符数:计空格";
var count_char2 = "字符数:不计空格";
var group_viewer_title = "群访问人数";
var group_viewer_btn = "查看微信群访问人数";
var group_viewer_tip = "使用手机微信“扫一扫”，查看微信群访问人数";
var group_viewer_bottom_btn = "去查看";
var FileInfo = {
	title: title$s,
	view_t1: view_t1,
	view_t2: view_t2,
	view_today: view_today,
	view_pv: view_pv,
	view_dv: view_dv,
	view_ev: view_ev,
	view_pv_desc: view_pv_desc,
	view_dv_desc: view_dv_desc,
	view_ev_desc: view_ev_desc,
	export_btn: export_btn,
	filename: filename,
	creator: creator$1,
	createtime: createtime,
	filetype: filetype,
	filesize: filesize,
	filepath: filepath,
	otl: otl,
	dbt: dbt,
	pof: pof,
	pom: pom,
	form: form,
	kw: kw,
	wpsnote: wpsnote,
	ckt: ckt,
	ofd: ofd,
	ksheet: ksheet,
	size_text: size_text,
	myfile: myfile,
	netError_desc: netError_desc,
	netError_btn: netError_btn,
	export_title: export_title,
	export_desc: export_desc,
	export_btn_cancel: export_btn_cancel,
	export_btn_error: export_btn_error,
	export_btn_retry: export_btn_retry,
	export_btn_open: export_btn_open,
	export_path: export_path,
	count_title: count_title,
	count_total: count_total,
	count_char1: count_char1,
	count_char2: count_char2,
	group_viewer_title: group_viewer_title,
	group_viewer_btn: group_viewer_btn,
	group_viewer_tip: group_viewer_tip,
	group_viewer_bottom_btn: group_viewer_bottom_btn
};

var decryptFiles = "解密文件";
var confirm$3 = "解密并继续";
var cancel$d = "取消";
var txt1$2m = "当前团队已开启文档加密保护，请阅读并勾选以下选项";
var txt2$28 = "移出团队的文档需先被解密，解密后的文档可被分享给任何人查看";
var txt3$1X = "如需对所选文件（夹）再次加密，请到文件（夹）所在团队的【团队设置】中开启文档加密保护";
var cryptDocs = "{action}加密文档";
var operationTip = "加密文档{action}到安全团队「{team}」后，该文档仅「{team}」成员可访问，且文档加密者变更为该团队拥有者，是否继续？";
var actConfirm = "确定{action}";
var noMoreRemind = "以后不再提醒";
var checkPermTip = "您不是加密者，无权操作，可联系{name}（文档加密者）操作";
var copy$1 = "复制";
var move = "移动";
var saveAs$1 = "另存";
var SecureTeamConfirm = {
	decryptFiles: decryptFiles,
	confirm: confirm$3,
	cancel: cancel$d,
	txt1: txt1$2m,
	txt2: txt2$28,
	txt3: txt3$1X,
	cryptDocs: cryptDocs,
	operationTip: operationTip,
	actConfirm: actConfirm,
	noMoreRemind: noMoreRemind,
	checkPermTip: checkPermTip,
	copy: copy$1,
	move: move,
	saveAs: saveAs$1
};

var txt0$2A = "恭喜你，你的企业已加入中小企业成长计划！";
var txt1$2l = "已获得以下权益，权益有效期30天";
var txt2$27 = "人";
var txt3$1W = "存储空间";
var txt4$1G = "上传文档大小";
var txt5$1z = "企业人数扩容";
var txt6$1l = "使用培训指导";
var txt7$19 = "如需企业人数扩容和培训指导，可加入QQ群：695850612 申请";
var txt8$16 = "我知道了";
var txt9$_ = "恭喜你，已领取成长计划{name}权益";
var txt10$V = "获取更多高级权益";
var FinishCompPrivilege = {
	txt0: txt0$2A,
	txt1: txt1$2l,
	txt2: txt2$27,
	txt3: txt3$1W,
	txt4: txt4$1G,
	txt5: txt5$1z,
	txt6: txt6$1l,
	txt7: txt7$19,
	txt8: txt8$16,
	txt9: txt9$_,
	txt10: txt10$V
};

var txt0$2z = "在企业内，";
var txt1$2k = "可以更安全高效地完成如下工作";
var txt2$26 = "跳过引导，开始使用";
var txt3$1V = "使用模板团队实现";
var txt5$1y = "立即了解";
var GroupTemplateGuide = {
	txt0: txt0$2z,
	txt1: txt1$2k,
	txt2: txt2$26,
	txt3: txt3$1V,
	txt5: txt5$1y
};

var txt0$2y = "创建「";
var txt1$2j = "」团队";
var txt2$25 = "创建团队失败，请稍后重试";
var GroupTplVideo = {
	txt0: txt0$2y,
	txt1: txt1$2j,
	txt2: txt2$25
};

var txt0$2x = "邀请同事";
var txt1$2i = "下次可点击这里邀请同事加入企业";
var txt2$24 = "去邀请";
var txt3$1U = "1/2上传文件";
var txt4$1F = "下次可点击这里上传文档至团队";
var txt5$1x = "下一步";
var txt6$1k = "2/2分享文件";
var txt7$18 = "点击“分享”功能，设置分享权限，创建分享链接，即可分享给同事";
var txt8$15 = "去分享";
var txt9$Z = "申请加入「企业成长计划」领取企业权益";
var txt10$U = "邀请{0}人以上加入即可升级企业权益";
var txt11$O = "邀请2人以上加入即可升级企业权益";
var txt12$J = "申请加入企业成长计划";
var txt13$L = "邀请同事加入";
var txt14$D = "人";
var GuideReminder = {
	txt0: txt0$2x,
	txt1: txt1$2i,
	txt2: txt2$24,
	txt3: txt3$1U,
	txt4: txt4$1F,
	txt5: txt5$1x,
	txt6: txt6$1k,
	txt7: txt7$18,
	txt8: txt8$15,
	txt9: txt9$Z,
	txt10: txt10$U,
	txt11: txt11$O,
	txt12: txt12$J,
	txt13: txt13$L,
	txt14: txt14$D
};

var txt0$2w = "下次可在此创建更多团队模板";
var GuideSingleTip = {
	txt0: txt0$2w
};

var txt0$2v = "可在此处邀请企业管理人员/HR等相关同事加入团队，方便查阅员工信息和信息同步";
var txt1$2h = "立即邀请";
var txt2$23 = "将统计表生成表单，分享给员工，员工填写后可自动生成汇总表格，方便高效，省时省力";
var txt3$1T = "查看操作指南";
var txt4$1E = "了解更多「如何使用WPS+进行远程办公」，请查看文档";
var txt5$1w = "立即查看";
var txt6$1j = "参数不能为空";
var txt7$17 = "参数类型错误，正确应该是：";
var GuideStepTips = {
	txt0: txt0$2v,
	txt1: txt1$2h,
	txt2: txt2$23,
	txt3: txt3$1T,
	txt4: txt4$1E,
	txt5: txt5$1w,
	txt6: txt6$1j,
	txt7: txt7$17
};

var txt0$2u = "导入说明";
var txt1$2g = "快速加入企业";
var txt2$22 = "我们将向文件夹协作成员发送";
var txt3$1S = "邀请通知，接受后直接加入";
var txt4$1D = "平滑迁移";
var txt5$1v = "原成员权限、文件夹目录权限、";
var txt6$1i = "分享链接和协作成员不变";
var txt7$16 = "企业高级功能";
var txt8$14 = "获取企业团队文档";
var txt9$Y = "加密等高级功能";
var txt10$T = "选择共享文件夹";
var txt11$N = "选择你要导入企业的共享文件夹";
var txt12$I = "个人共享文件夹";
var txt13$K = "暂无共享文件夹";
var txt14$C = "位成员·";
var txt15$y = "企业团队";
var txt16$x = "点击左侧共享文件夹";
var txt17$t = "将文件及成员导入至企业";
var txt18$t = "导入共享文件夹成功";
var txt19$r = "以下成员需接受邀请加入企业后即可正常访问团队";
var txt20$p = "我知道了";
var txt21$l = "已导入成功,";
var txt22$j = "导入失败,";
var txt23$g = "失败原因：企业团队数达到上限";
var txt24$e = "请尝试重新导入";
var txt25$d = "稍后再说";
var txt26$d = "确定";
var txt27$c = "重试";
var ImportPersonalFolder = {
	txt0: txt0$2u,
	txt1: txt1$2g,
	txt2: txt2$22,
	txt3: txt3$1S,
	txt4: txt4$1D,
	txt5: txt5$1v,
	txt6: txt6$1i,
	txt7: txt7$16,
	txt8: txt8$14,
	txt9: txt9$Y,
	txt10: txt10$T,
	txt11: txt11$N,
	txt12: txt12$I,
	txt13: txt13$K,
	txt14: txt14$C,
	txt15: txt15$y,
	txt16: txt16$x,
	txt17: txt17$t,
	txt18: txt18$t,
	txt19: txt19$r,
	txt20: txt20$p,
	txt21: txt21$l,
	txt22: txt22$j,
	txt23: txt23$g,
	txt24: txt24$e,
	txt25: txt25$d,
	txt26: txt26$d,
	txt27: txt27$c
};

var txt0$2t = "移入说明";
var txt1$2f = "将选中文件（夹）进行移动";
var DialogImportFromSpecail = {
	txt0: txt0$2t,
	txt1: txt1$2f
};

var txt0$2s = "企业管理员已禁止企业文件转移到企业外，从个人文档移入后，文件即归属企业管控，";
var txt1$2e = "不允许再移动复制到企业外";
var txt2$21 = "去移入";
var txt3$1R = "取消";
var ImportFromSpecailTips = {
	txt0: txt0$2s,
	txt1: txt1$2e,
	txt2: txt2$21,
	txt3: txt3$1R
};

var txt0$2r = "共享文件夹无法移动到我的企业文档，请升级为团队";
var txt1$2d = "移动文件成功";
var txt2$20 = "移动";
var ImportFromSpecail = {
	txt0: txt0$2r,
	txt1: txt1$2d,
	txt2: txt2$20
};

var txt0$2q = "快速加入企业";
var txt1$2c = "我们将向文件夹协作成员发送";
var txt2$1$ = "邀请通知，接受后直接加入";
var txt3$1Q = "平滑迁移";
var txt4$1C = "原成员权限、文件夹目录权限、";
var txt5$1u = "分享链接和协作成员不变";
var txt6$1h = "企业高级功能";
var txt7$15 = "获取企业团队文档";
var txt8$13 = "加密等高级功能";
var txt9$X = "选择共享文件夹";
var txt10$S = "选择你要移入企业的共享文件夹";
var txt11$M = "个人共享文件夹";
var txt12$H = "暂无共享文件夹";
var txt13$J = "位成员·";
var txt14$B = "企业团队";
var txt15$x = "点击左侧共享文件夹";
var txt16$w = "将文件及成员移入至企业";
var txt17$s = "立即移入";
var txt18$s = "移入共享文件夹成功";
var txt19$q = "以下成员需接受邀请加入企业后即可正常访问团队";
var txt20$o = "我知道了";
var txt21$k = "已移入成功,";
var txt22$i = "移入失败,";
var txt23$f = "失败原因：企业团队数达到上限";
var txt24$d = "请尝试重新移入";
var txt25$c = "稍后再说";
var txt26$c = "确定";
var txt27$b = "重试";
var txt28$b = "最多支持移入20个共享文件夹";
var txt29$7 = "移入说明";
var txt30$6 = "申请移入";
var txt31$7 = "共享文件夹";
var ImportPersonalFolderPlus = {
	txt0: txt0$2q,
	txt1: txt1$2c,
	txt2: txt2$1$,
	txt3: txt3$1Q,
	txt4: txt4$1C,
	txt5: txt5$1u,
	txt6: txt6$1h,
	txt7: txt7$15,
	txt8: txt8$13,
	txt9: txt9$X,
	txt10: txt10$S,
	txt11: txt11$M,
	txt12: txt12$H,
	txt13: txt13$J,
	txt14: txt14$B,
	txt15: txt15$x,
	txt16: txt16$w,
	txt17: txt17$s,
	txt18: txt18$s,
	txt19: txt19$q,
	txt20: txt20$o,
	txt21: txt21$k,
	txt22: txt22$i,
	txt23: txt23$f,
	txt24: txt24$d,
	txt25: txt25$c,
	txt26: txt26$c,
	txt27: txt27$b,
	txt28: txt28$b,
	txt29: txt29$7,
	txt30: txt30$6,
	txt31: txt31$7
};

var txt0$2p = "邀请已发送";
var txt1$2b = "成员接受后即可加入企业";
var txt2$1_ = "发送链接给同事，同事点击即可申请加入企业";
var txt3$1P = "扫码发送邀请给同事";
var txt4$1B = "复制链接";
var txt5$1t = "我的联系人";
var txt6$1g = "取消";
var txt7$14 = "确定";
var txt8$12 = "复制失败";
var txt9$W = "复制成功";
var InviteColleague = {
	txt0: txt0$2p,
	txt1: txt1$2b,
	txt2: txt2$1_,
	txt3: txt3$1P,
	txt4: txt4$1B,
	txt5: txt5$1t,
	txt6: txt6$1g,
	txt7: txt7$14,
	txt8: txt8$12,
	txt9: txt9$W
};

var txt0$2o = "邀请同事加入";
var txt1$2a = "提升企业指数";
var txt2$1Z = "非超管用户";
var txt3$1O = "非企业基础班用户";
var txt4$1A = "重复领取";
var txt5$1s = "跨级领取";
var txt6$1f = "任务未完成";
var txt7$13 = "已领取";
var txt8$11 = "立即领取";
var txt9$V = "付费套餐";
var txt10$R = "当前";
var txt11$L = "如需更高权益，可了解";
var txt12$G = "当前维度还有";
var txt13$I = "分提升空间";
var txt14$A = "已完成";
var txt15$w = "查看企业指数";
var txt16$v = "仅超级管理员可领取";
var txt17$r = "请在团队内上传文件";
var txt18$r = "达成目标领取企业成长计划权益";
var txt19$p = "企业成长计划权益";
var expansionDesc = "企业人员扩容申请";
var expansionJumpDesc = "立即申请";
var awardsDescLink = "2023年成长计划权益调整说明";
var JoinCompPrivilege = {
	txt0: txt0$2o,
	txt1: txt1$2a,
	txt2: txt2$1Z,
	txt3: txt3$1O,
	txt4: txt4$1A,
	txt5: txt5$1s,
	txt6: txt6$1f,
	txt7: txt7$13,
	txt8: txt8$11,
	txt9: txt9$V,
	txt10: txt10$R,
	txt11: txt11$L,
	txt12: txt12$G,
	txt13: txt13$I,
	txt14: txt14$A,
	txt15: txt15$w,
	txt16: txt16$v,
	txt17: txt17$r,
	txt18: txt18$r,
	txt19: txt19$p,
	expansionDesc: expansionDesc,
	expansionJumpDesc: expansionJumpDesc,
	awardsDescLink: awardsDescLink
};

var txt0$2n = "协作";
var txt1$29 = "公开分享";
var txt2$1Y = "分享";
var txt3$1N = "私密分享";
var txt4$1z = "复制成功";
var txt5$1r = "复制失败";
var txt6$1e = "复制成功，";
var txt7$12 = "打开链接的人";
var txt8$10 = "仅自己 可查看或编辑";
var txt9$U = "你的浏览器不支持自动复制请按";
var txt10$Q = "复制下面输入框的内容";
var txt11$K = "分享功能升级维护中";
var txt12$F = "所有成员";
var LinkCoopBox = {
	txt0: txt0$2n,
	txt1: txt1$29,
	txt2: txt2$1Y,
	txt3: txt3$1N,
	txt4: txt4$1z,
	txt5: txt5$1r,
	txt6: txt6$1e,
	txt7: txt7$12,
	txt8: txt8$10,
	txt9: txt9$U,
	txt10: txt10$Q,
	txt11: txt11$K,
	txt12: txt12$F
};

var txt0$2m = "禁止查看者下载、打印、另存和复制内容";
var ksheetForbid$2 = "禁止查看者导出、打印、另存和复制内容";
var txt1$28 = "开启后，仅具有查看权限的人将无法下载、打印、另存和复制内容";
var txt2$1X = "适用于禁止查看者复用的文档";
var ksheetPopText$1 = "开启后，仅具有查看权限的人将无法导出、打印、另存和复制内容";
var openComment$2 = "允许加入分享的人查看、发表全文评论";
var showFullComment = "显示全文评论";
var openCommentTips$1 = "开启后，他人打开文档可发表全文评论及查看全文评论";
var kdbtForbid$1 = "禁止查看者导出、另存和复制内容";
var kfpForbid$1 = "禁止查看者导出和另存";
var kdbtPopText$1 = "开启后，仅具有查看权限的人将无法导出、另存和复制内容";
var kfpPopText$1 = "开启后，仅具有查看权限的人将无法导出和另存";
var kprocessonForbid$1 = "禁止查看者导出和另存";
var kprocessonPopText$1 = "开启后，仅具有查看权限的人将无法导出、另存";
var kimgForbid$1 = "禁止查看者下载和另存";
var kimgPopText$1 = "开启后，仅具有查看权限的人将无法下载、另存";
var LinkDownloadPerm = {
	txt0: txt0$2m,
	ksheetForbid: ksheetForbid$2,
	txt1: txt1$28,
	txt2: txt2$1X,
	ksheetPopText: ksheetPopText$1,
	openComment: openComment$2,
	showFullComment: showFullComment,
	openCommentTips: openCommentTips$1,
	kdbtForbid: kdbtForbid$1,
	kfpForbid: kfpForbid$1,
	kdbtPopText: kdbtPopText$1,
	kfpPopText: kfpPopText$1,
	kprocessonForbid: kprocessonForbid$1,
	kprocessonPopText: kprocessonPopText$1,
	kimgForbid: kimgForbid$1,
	kimgPopText: kimgPopText$1
};

var ksheetForbid$1 = "禁止查看者导出、打印、另存和复制内容";
var ksheetRenameForbid$1 = "禁止添加、删除工作表";
var ksheetRenameForbidDesc = "适用于多人填写的信息收集表";
var ksheetRenameForbidPop$1 = "开启后，禁止协作者删除、新建、移动、重命名工作表";
var permissionDenied = "您的操作权限不足";
var noNetwork = "网络故障，请稍后重试";
var serverError = "服务器故障，请稍后重试";
var error$4 = "操作失败，请稍后重试";
var LinkRenamePerm = {
	ksheetForbid: ksheetForbid$1,
	ksheetRenameForbid: ksheetRenameForbid$1,
	ksheetRenameForbidDesc: ksheetRenameForbidDesc,
	ksheetRenameForbidPop: ksheetRenameForbidPop$1,
	permissionDenied: permissionDenied,
	noNetwork: noNetwork,
	serverError: serverError,
	error: error$4
};

var txt0$2l = "「";
var txt1$27 = "」管理员已设置权限";
var txt2$1W = "文件";
var txt3$1M = "夹";
var txt4$1y = "由";
var txt5$1q = "分享，对方已设置权限";
var txt6$1d = "分享已取消";
var txt7$11 = "文件分享链接已过期";
var txt8$$ = "分享链接未创建";
var txt9$T = "立即开启";
var txt10$P = "创建链接";
var txt11$J = "复制链接";
var txt12$E = "【金山文档 | WPS云文档】";
var txt13$H = "开启链接成功";
var LinkSettingBox = {
	txt0: txt0$2l,
	txt1: txt1$27,
	txt2: txt2$1W,
	txt3: txt3$1M,
	txt4: txt4$1y,
	txt5: txt5$1q,
	txt6: txt6$1d,
	txt7: txt7$11,
	txt8: txt8$$,
	txt9: txt9$T,
	txt10: txt10$P,
	txt11: txt11$J,
	txt12: txt12$E,
	txt13: txt13$H
};

var txt0$2k = "永久";
var txt1$26 = "链接有效期";
var txt2$1V = "天";
var txt13$G = "有效";
var txt14$z = "链接有效期设置成功";
var LinkTime = {
	txt0: txt0$2k,
	txt1: txt1$26,
	txt2: txt2$1V,
	txt13: txt13$G,
	txt14: txt14$z
};

var txt0$2j = "和 ";
var txt1$25 = "等外部协作成员";
var txt2$1U = "去添加";
var txt3$1L = "谁可以编辑：";
var txt5$1p = "仅可查看 ";
var txt6$1c = "指定人：";
var txt7$10 = "谁可以编辑：仅你自己";
var LinkToCoop = {
	txt0: txt0$2j,
	txt1: txt1$25,
	txt2: txt2$1U,
	txt3: txt3$1L,
	txt5: txt5$1p,
	txt6: txt6$1c,
	txt7: txt7$10
};

var txt0$2i = "发送成功";
var txt1$24 = "删除成功";
var txt2$1T = "已选择";
var txt3$1K = "个用户";
var MemberSelectorPlus = {
	txt0: txt0$2i,
	txt1: txt1$24,
	txt2: txt2$1T,
	txt3: txt3$1K
};

var txt0$2h = "谁可以查看";
var txt1$23 = "禁止";
var txt2$1S = "允许";
var txt3$1J = "下载";
var txt4$1x = "设置";
var txt5$1o = "见";
var txt6$1b = "添加";
var txt7$$ = "谁可以编辑";
var txt8$_ = "修改";
var txt9$S = "文档权限设置";
var txt10$O = "选择成员";
var txt11$I = "文件夹权限";
var txt12$D = "不可更改管理员权限";
var txt13$F = "文件夹权限设置";
var txt14$y = "设置成功";
var txt15$v = "设置成功，已同步更新该文件夹下所有文件（夹）的权限";
var txt16$u = "所有人";
var txt17$q = "所有成员可";
var txt18$q = "仅部分人";
var txt19$o = "选择的成员可";
var txt20$n = "文件权限";
var ModifyFilePermission = {
	txt0: txt0$2h,
	txt1: txt1$23,
	txt2: txt2$1S,
	txt3: txt3$1J,
	txt4: txt4$1x,
	txt5: txt5$1o,
	txt6: txt6$1b,
	txt7: txt7$$,
	txt8: txt8$_,
	txt9: txt9$S,
	txt10: txt10$O,
	txt11: txt11$I,
	txt12: txt12$D,
	txt13: txt13$F,
	txt14: txt14$y,
	txt15: txt15$v,
	txt16: txt16$u,
	txt17: txt17$q,
	txt18: txt18$q,
	txt19: txt19$o,
	txt20: txt20$n
};

var txt0$2g = "以下为团队成员文档操作权限设置，对团队内所有文件生效";
var txt1$22 = "下载设置";
var txt2$1R = "拥有文件查看权限的人禁止下载、打印和另存文件";
var txt3$1I = "分享设置";
var txt4$1w = "禁止团队成员创建分享链接和更改分享链接权限";
var txt5$1n = "删除设置";
var txt6$1a = "禁止团队成员删除他自己创建的文件";
var ModifyFilePerSetting = {
	txt0: txt0$2g,
	txt1: txt1$22,
	txt2: txt2$1R,
	txt3: txt3$1I,
	txt4: txt4$1w,
	txt5: txt5$1n,
	txt6: txt6$1a
};

var txt0$2f = "谁可以查看";
var txt1$21 = "见";
var txt2$1Q = "添加";
var txt3$1H = "谁可以编辑";
var txt4$1v = "修改";
var txt5$1m = "所有人";
var txt6$19 = "所有成员可";
var txt7$_ = "仅部分人";
var txt8$Z = "选择的成员可";
var txt9$R = "选择成员";
var txt10$N = "文件权限";
var txt11$H = "不可更改管理员权限";
var txt12$C = "设置成功";
var ModifyPermission = {
	txt0: txt0$2f,
	txt1: txt1$21,
	txt2: txt2$1Q,
	txt3: txt3$1H,
	txt4: txt4$1v,
	txt5: txt5$1m,
	txt6: txt6$19,
	txt7: txt7$_,
	txt8: txt8$Z,
	txt9: txt9$R,
	txt10: txt10$N,
	txt11: txt11$H,
	txt12: txt12$C
};

var txt3$1G = "以下";
var txt4$1u = "个子文件(夹)单独设置过权限，确认同步修改为「所有人可";
var txt5$1l = "个子文件(夹)单独设置过权限，确认同步「增加";
var txt6$18 = "可";
var txt7$Z = "查看";
var txt8$Y = "编辑";
var txt10$M = "等";
var txt11$G = "人";
var txt13$E = "」?";
var ModifyPermissionInfoSub = {
	txt3: txt3$1G,
	txt4: txt4$1u,
	txt5: txt5$1l,
	txt6: txt6$18,
	txt7: txt7$Z,
	txt8: txt8$Y,
	txt10: txt10$M,
	txt11: txt11$G,
	txt13: txt13$E
};

var yes = "是";
var no = "否";
var add$1 = "增加";
var modify$1 = "修改";
var base = "以下{num}个子文件(夹)单独设置过权限，";
var none = "是否同步【{action}】为【{perm}】？";
var single = "是否同步【{action}】{name}为【{perm}】？";
var mutilate = "是否同步【{action}】{name}等{count}项为【{perm}】？";
var cancel$c = "是否同步【取消分享】？";
var timeoutBase = "可能存在单独设置过权限的子文件，";
var ModifyPermissionInfoTip = {
	yes: yes,
	no: no,
	add: add$1,
	modify: modify$1,
	base: base,
	none: none,
	single: single,
	mutilate: mutilate,
	cancel: cancel$c,
	timeoutBase: timeoutBase
};

var anyone$2 = "任何人";
var txt0$2e = "免登录链接已关闭";
var txt1$20 = "开启链接";
var txt2$1P = "复制链接";
var txt3$1F = "【金山文档 | WPS云文档】";
var txt4$1t = "可查看";
var txt5$1k = "可编辑";
var txt6$17 = "关闭免登录链接";
var txt7$Y = "已生成免登录链接，请重新复制发送";
var txt8$X = "复制成功，任何人可查看";
var txt9$Q = "复制成功，任何人可编辑";
var txt10$L = "你的浏览器不支持自动复制请按";
var txt11$F = "复制下面输入框的内容";
var txt12$B = "分享功能升级维护中";
var txt13$D = "已生成免登录链接，请重新复制发送";
var txt14$x = "免登录链接已关闭";
var txt15$u = "复制失败";
var txt16$t = "点击「开启」可重新获取免登录链接";
var secureCopy_txt = "复制成功，仅指定人可查看/编辑";
var OpenShare = {
	anyone: anyone$2,
	txt0: txt0$2e,
	txt1: txt1$20,
	txt2: txt2$1P,
	txt3: txt3$1F,
	txt4: txt4$1t,
	txt5: txt5$1k,
	txt6: txt6$17,
	txt7: txt7$Y,
	txt8: txt8$X,
	txt9: txt9$Q,
	txt10: txt10$L,
	txt11: txt11$F,
	txt12: txt12$B,
	txt13: txt13$D,
	txt14: txt14$x,
	txt15: txt15$u,
	txt16: txt16$t,
	secureCopy_txt: secureCopy_txt
};

var txt0$2d = "提示";
var txt1$1$ = "不尝试调用客户端的接口";
var txt2$1O = "客户端不支持的接口";
var txt3$1E = "特殊文件（wdoc,wxls,wppt,pom,h5）客户端打开失败";
var OpenClient = {
	txt0: txt0$2d,
	txt1: txt1$1$,
	txt2: txt2$1O,
	txt3: txt3$1E
};

var author = "作者";
var mbLink = "模板链接";
var copy_link = "复制链接";
var title_template = "生成模板链接";
var mobile = "手机版";
var pc = "电脑版";
var save_as_template = "保存为我的模板";
var save_as_fail = "保存失败";
var save_as_success = "保存成功";
var wechat$1 = "微信";
var moment = "朋友圈";
var qrcode = "二维码";
var update_template = "文档内容有变，是否更新模板链接";
var update$1 = "更新";
var updated = "更新成功";
var load_error = "加载失败, 请稍后重试";
var del_publish_template = "停用链接";
var loading$3 = "模板加载中...";
var docSave = "文档已保存为模板";
var useDesc = "模板保存成功，可在 [模板库-我的模板] 中查看并使用模板";
var useBtn = "使用模板";
var cancelBtn = "取消";
var copy_text = "【金山文档】";
var title$r = "发布文件";
var shareTitle$1 = "分享";
var copy_success$1 = "复制成功，去发送给好友";
var copy_fail$1 = "复制失败";
var published = "已发布";
var del_publish = "取消发布";
var del_published = "已取消发布";
var review = "请确认取消对";
var publish = "的发布";
var result = "取消后，所有人将无法访问发布的链接";
var copy_text_template = "【金山文档｜模板】";
var review_template = "请确认停用对";
var publish_template = "创建的模板链接";
var result_template = "停用后，所有人将无法通过链接访问模板文件";
var del_published_template = "已停用模板";
var guide_desc1 = "你可以使用发布功能生成一条公开链接，任何人无需登录即可查看当前文档内容。";
var guide_desc2 = "如需更新链接内容，编辑文档后再次发布即可。";
var guide_desc3 = "可以用发布来做什么？";
var guide_go_publish = "去发布文件";
var preview = "预览模板";
var title_review_error = "操作失败，请修改标题后重试";
var PublishFile = {
	author: author,
	mbLink: mbLink,
	copy_link: copy_link,
	"share-to-tip": "分享到",
	title_template: title_template,
	mobile: mobile,
	pc: pc,
	save_as_template: save_as_template,
	save_as_fail: save_as_fail,
	save_as_success: save_as_success,
	wechat: wechat$1,
	moment: moment,
	qrcode: qrcode,
	update_template: update_template,
	update: update$1,
	updated: updated,
	load_error: load_error,
	del_publish_template: del_publish_template,
	loading: loading$3,
	docSave: docSave,
	useDesc: useDesc,
	useBtn: useBtn,
	cancelBtn: cancelBtn,
	copy_text: copy_text,
	title: title$r,
	shareTitle: shareTitle$1,
	copy_success: copy_success$1,
	copy_fail: copy_fail$1,
	published: published,
	del_publish: del_publish,
	del_published: del_published,
	review: review,
	publish: publish,
	result: result,
	copy_text_template: copy_text_template,
	review_template: review_template,
	publish_template: publish_template,
	result_template: result_template,
	del_published_template: del_published_template,
	guide_desc1: guide_desc1,
	guide_desc2: guide_desc2,
	guide_desc3: guide_desc3,
	guide_go_publish: guide_go_publish,
	preview: preview,
	title_review_error: title_review_error
};

var txt0$2c = "提交成功";
var txt1$1_ = "提交失败";
var txt2$1N = "客户案例";
var txt3$1D = "举报「";
var txt31$6 = "」";
var txt4$1s = "请稍后重试";
var txt5$1j = "操作成功";
var txt6$16 = "操作失败，请稍后重试";
var txt7$X = "为什么举报这个文件";
var txt8$W = "违反国家法律法规";
var txt9$P = "盗版，未获得权利人的合法授权";
var txt10$K = "泄露商业机密";
var txt11$E = "侵犯个人隐私";
var txt12$A = "垃圾信息骚扰";
var txt13$C = "涉及未成年人有害信息";
var txt14$w = "涉及未成年人有害信息举报专区";
var txt15$t = "举报文件";
var txt16$s = "打开外部链接";
var txt17$p = "举报说明（必填）";
var txt18$p = "请描述举报原因（5-200字）";
var txt19$n = "（必选）";
var label10 = "政治敏感";
var label20 = "色情低俗";
var label40 = "违法违规";
var txt20$m = "字";
var txt21$j = "举报电话：400-677-5005";
var txt22$h = "为什么举报这个评论";
var public_Report_submit = "提交";
var text23 = "选择举报原因(单选)";
var text24 = "同意获取会话信息以辅助判断";
var Report = {
	txt0: txt0$2c,
	txt1: txt1$1_,
	txt2: txt2$1N,
	txt3: txt3$1D,
	txt31: txt31$6,
	txt4: txt4$1s,
	txt5: txt5$1j,
	txt6: txt6$16,
	txt7: txt7$X,
	txt8: txt8$W,
	txt9: txt9$P,
	txt10: txt10$K,
	txt11: txt11$E,
	txt12: txt12$A,
	txt13: txt13$C,
	txt14: txt14$w,
	txt15: txt15$t,
	txt16: txt16$s,
	txt17: txt17$p,
	txt18: txt18$p,
	txt19: txt19$n,
	label10: label10,
	label20: label20,
	label40: label40,
	txt20: txt20$m,
	txt21: txt21$j,
	txt22: txt22$h,
	public_Report_submit: public_Report_submit,
	text23: text23,
	text24: text24
};

var requestShareOutside$1 = "申请外发";
var tips$3 = "企业禁止分享文档到企业外，你可申请将当前文档分享到企业外。";
var shareRange$1 = "分享范围";
var rangeAnyone = "任何人";
var rangeSelect = "仅指定企业外用户";
var reason = "理由";
var placeholder$1 = "请输入申请理由";
var pleaseInputReason = "请输入申请理由";
var cancel$b = "取消";
var submit$3 = "发送申请";
var submitSuccess$1 = "已发送申请";
var submitFail = "网络异常，请重试";
var RequestShareOutside = {
	requestShareOutside: requestShareOutside$1,
	tips: tips$3,
	shareRange: shareRange$1,
	rangeAnyone: rangeAnyone,
	rangeSelect: rangeSelect,
	reason: reason,
	placeholder: placeholder$1,
	pleaseInputReason: pleaseInputReason,
	cancel: cancel$b,
	submit: submit$3,
	submitSuccess: submitSuccess$1,
	submitFail: submitFail
};

var txt0$2b = "开通WPS会员后即可使用批量下载功能。";
var txt1$1Z = "查看更多会员特权";
var txt2$1M = "注：协作文档、流程图等在线文件暂不支持批量下载";
var txt3$1C = "取消";
var txt4$1r = "开通会员";
var txt5$1i = "开通会员";
var DriveRegisterVip = {
	txt0: txt0$2b,
	txt1: txt1$1Z,
	txt2: txt2$1M,
	txt3: txt3$1C,
	txt4: txt4$1r,
	txt5: txt5$1i
};

var txt0$2a = "你需要发送验证消息，等待对方通过";
var txt1$1Y = "由于验证消息发送频繁，请到";
var txt2$1L = "客户案例";
var ucenter = "个人中心";
var txt3$1B = "绑定手机号后重试";
var cancel$a = "取消";
var send = "发送";
var SendVerfiyMessage = {
	txt0: txt0$2a,
	txt1: txt1$1Y,
	txt2: txt2$1L,
	ucenter: ucenter,
	txt3: txt3$1B,
	cancel: cancel$a,
	send: send
};

var name0 = "邀请同事加入企业";
var name1 = "成员填写加入申请";
var name2 = "审批同事的申请";
var name3 = "建立工作团队";
var name4 = "在团队中添加相应同事";
var err0$1 = "没有传入元素";
var err1$1 = "没有传入正确的元素";
var err2$1 = "参数不能为空";
var err3$1 = "参数类型错误，正确应该是：";
var guide = "使用指南";
var more = "更多";
var txt0$29 = "填写反馈";
var txt1$1X = "使用手册";
var txt2$1K = "客户案例";
var txt3$1A = "目录";
var SlideHelper = {
	name0: name0,
	name1: name1,
	name2: name2,
	name3: name3,
	name4: name4,
	err0: err0$1,
	err1: err1$1,
	err2: err2$1,
	err3: err3$1,
	guide: guide,
	more: more,
	txt0: txt0$29,
	txt1: txt1$1X,
	txt2: txt2$1K,
	txt3: txt3$1A
};

var txt0$28 = "你可能需要";
var txt1$1W = "查看视频简介";
var txt2$1J = "立即使用";
var txt3$1z = "对团队模板有建议或疑问？";
var txt4$1q = "联系我们";
var txt5$1h = "初始化场景失败";
var txt6$15 = "「";
var txt8$V = "仅超管可创建，请联系「";
var txt9$O = "」创建";
var txt10$J = "」视频简介";
var txt11$D = "创建普通团队";
var txt12$z = "立即";
var txt13$B = "开启文档加密保护";
var txt14$v = "企业套餐";
var txt15$s = "升级套餐";
var txt16$r = "WPS项目经理";
var txt17$o = "超级管理员";
var txt18$o = "进行授权升级处理";
var txt19$m = "您企业采购的功能服务已超出支持的最大数量，请您联系";
var txt20$l = "购买";
var txt21$i = "升级";
var error$3 = {
	"40000105": "空间已满，模板创建失败",
	"40000201": "模板创建失败，请重新创建",
	"40020010": "企业禁止当前IP保存文件到「{0}」",
	"40020011": "当前IP只允许文件保存到企业空间",
	network: "网络异常"
};
var txt22$g = "普通团队";
var txt23$e = "上传文件，共享协作";
var txt24$c = "创建";
var txt25$b = "导入团队";
var txt26$b = "批量导入个人团队";
var txt27$a = "导入";
var txt28$a = "精选团队模板";
var TeamSceneSelector = {
	txt0: txt0$28,
	txt1: txt1$1W,
	txt2: txt2$1J,
	txt3: txt3$1z,
	txt4: txt4$1q,
	txt5: txt5$1h,
	txt6: txt6$15,
	txt8: txt8$V,
	txt9: txt9$O,
	txt10: txt10$J,
	txt11: txt11$D,
	txt12: txt12$z,
	txt13: txt13$B,
	txt14: txt14$v,
	txt15: txt15$s,
	txt16: txt16$r,
	txt17: txt17$o,
	txt18: txt18$o,
	txt19: txt19$m,
	txt20: txt20$l,
	txt21: txt21$i,
	error: error$3,
	txt22: txt22$g,
	txt23: txt23$e,
	txt24: txt24$c,
	txt25: txt25$b,
	txt26: txt26$b,
	txt27: txt27$a,
	txt28: txt28$a
};

var txt0$27 = "创建「";
var txt1$1V = "」团队";
var txt2$1I = "团队仅企业超管";
var txt3$1y = "可创建，并授权企业财务/HR等使用。可通过视频了解详细后";
var txt4$1p = "通知「";
var txt5$1g = "」创建";
var txt6$14 = "我知道了";
var TeamSceneVideo = {
	txt0: txt0$27,
	txt1: txt1$1V,
	txt2: txt2$1I,
	txt3: txt3$1y,
	txt4: txt4$1p,
	txt5: txt5$1g,
	txt6: txt6$14
};

var click = "点击";
var add = "添加";
var txt0$26 = "团队置顶公告或置顶文件让成员关注";
var txt1$1U = "功能示例";
var placeHolder = "添加团队置顶信息，所有成员都可以查看";
var newPlaceHolder = "添加团队公告，所有成员都可以查看";
var cancel$9 = "取消";
var ok$4 = "确定";
var maxLengthError = "最多支持{0}个字符";
var tips$2 = "发布公告或将文件置顶，让成员关注";
var TeamTopAreaNotice = {
	click: click,
	add: add,
	txt0: txt0$26,
	txt1: txt1$1U,
	placeHolder: placeHolder,
	newPlaceHolder: newPlaceHolder,
	cancel: cancel$9,
	ok: ok$4,
	maxLengthError: maxLengthError,
	tips: tips$2
};

var label_panel_txt0 = "这是";
var label_panel_txt1 = "的搜索结果";
var table_header_txt0 = "文件";
var table_header_txt1 = "最后修改";
var table_header_txt2 = "大小";
var TeamTagPanel = {
	label_panel_txt0: label_panel_txt0,
	label_panel_txt1: label_panel_txt1,
	table_header_txt0: table_header_txt0,
	table_header_txt1: table_header_txt1,
	table_header_txt2: table_header_txt2
};

var open$2 = "打开文件";
var upload = "上传";
var complete = "完成";
var txt0$25 = "项失败";
var txt1$1T = "正在";
var file = "文件";
var err1 = "你的云空间已满";
var err2 = "拥有者的云空间已满";
var err3 = "文件超过1GB，无法上传";
var confirm$2 = "上传正在进行，关闭将取消正在上传的文件，是否关闭？";
var tips$1 = "提示";
var close$4 = "关闭";
var cancel$8 = "取消";
var err0 = "云空间已满";
var err4 = "文件大小超过限制";
var opening = "正在打开文件，请稍候...";
var uploadFile = "上传文件";
var uploadFail = "上传失败";
var err5 = "你的会员已过期，无法使用私密文件夹功能，请续费后使用";
var err6 = "没有当前目录的操作权限,请联系管理员";
var err7 = "未知错误";
var err8 = "你上传的文件类型与当前文件不一致";
var err9 = "不能上传空文件";
var err10 = "文件大小超过限制";
var canceled$2 = "已取消";
var Upload = {
	open: open$2,
	upload: upload,
	complete: complete,
	txt0: txt0$25,
	txt1: txt1$1T,
	file: file,
	err1: err1,
	err2: err2,
	err3: err3,
	confirm: confirm$2,
	tips: tips$1,
	close: close$4,
	cancel: cancel$8,
	err0: err0,
	err4: err4,
	opening: opening,
	uploadFile: uploadFile,
	uploadFail: uploadFail,
	err5: err5,
	err6: err6,
	err7: err7,
	err8: err8,
	err9: err9,
	err10: err10,
	canceled: canceled$2
};

var title$q = "为什么要升级企业团队？";
var content0$1 = "更安全的企业文件";
var content1$1 = "企业文件与个人文件隔";
var content2 = "离不惧怕人员变动带来";
var content3 = "的隐私泄露";
var content4 = "企业通讯录";
var content5 = "一键申请加入，成员统一";
var content6 = "管理不用加好友也能直接";
var content7 = "分享文件";
var content8 = "更丰富的团队权限";
var content9 = "支持团队文档加密";
var content10 = "团队操作日志管理";
var upgrade$1 = "立即升级";
var txt0$24 = "升级为企业团队";
var txt1$1S = "请选择将共享文件夹升级至";
var txt2$1H = "升级企业团队";
var txt3$1x = "请确定将";
var txt4$1o = "升级为";
var txt5$1f = "的企业团队？";
var cancel$7 = "取消";
var txt7$W = "升级企业团队成功";
var txt8$U = "以下成员需接受邀请加入企业后即可正常访问团队";
var txt9$N = "我知道了";
var close$3 = "关闭";
var check$1 = "查看";
var txt10$I = "已导入成功,";
var txt11$C = "导入失败,";
var txt12$y = "失败原因：企业团队数达到上限";
var txt13$A = "请尝试重新导入";
var txt14$u = "稍后再说";
var ok$3 = "确定";
var retry$1 = "重试";
var applyUpgrade = "申请升级";
var defaultReason = "成员暂未填写团队创建用途";
var txt15$r = "共享文件夹";
var UpToCorpTeam = {
	title: title$q,
	content0: content0$1,
	content1: content1$1,
	content2: content2,
	content3: content3,
	content4: content4,
	content5: content5,
	content6: content6,
	content7: content7,
	content8: content8,
	content9: content9,
	content10: content10,
	upgrade: upgrade$1,
	txt0: txt0$24,
	txt1: txt1$1S,
	txt2: txt2$1H,
	txt3: txt3$1x,
	txt4: txt4$1o,
	txt5: txt5$1f,
	cancel: cancel$7,
	txt7: txt7$W,
	txt8: txt8$U,
	txt9: txt9$N,
	close: close$3,
	check: check$1,
	txt10: txt10$I,
	txt11: txt11$C,
	txt12: txt12$y,
	txt13: txt13$A,
	txt14: txt14$u,
	ok: ok$3,
	retry: retry$1,
	applyUpgrade: applyUpgrade,
	defaultReason: defaultReason,
	txt15: txt15$r
};

var txt0$23 = "请确定将";
var txt1$1R = "升级为个人团队？";
var txt2$1G = "立即升级";
var txt3$1w = "取消";
var UpToPersonalTeam = {
	txt0: txt0$23,
	txt1: txt1$1R,
	txt2: txt2$1G,
	txt3: txt3$1w
};

var title$p = "升级说明";
var content0 = "团队协作空间";
var content1 = "平滑迁移";
var description1 = "使用任务、项目管理库等应用";
var description2 = "更好地进行团队协作";
var description3 = "原成员权限、文件夹目录权限";
var description4 = "分享链接和协作成员不变";
var upgrade = "立即升级";
var select = "选择共享文件夹";
var UpToPersonalTeamGuide = {
	title: title$p,
	content0: content0,
	content1: content1,
	description1: description1,
	description2: description2,
	description3: description3,
	description4: description4,
	upgrade: upgrade,
	select: select
};

var txt0$22 = "位成员·";
var txt1$1Q = "取消";
var txt2$1F = "确认";
var UpToPersonalTeamSelect = {
	txt0: txt0$22,
	txt1: txt1$1Q,
	txt2: txt2$1F
};

var tips_title = "升级说明";
var title$o = "升级为个人团队";
var select_title = "选择升级为团队的共享文件夹";
var DialogUpToPersonalTeam = {
	tips_title: tips_title,
	title: title$o,
	select_title: select_title
};

var txt0$21 = "使用指南";
var txt1$1P = "没有搜索到相关内容";
var txt2$1E = "可扫码联系客服";
var txt3$1v = "暂无内容";
var txt4$1n = "输入你的问题，如\"新建团队\"";
var searchTitle = "请问需要什么帮助？";
var recommendTitle = "推荐阅读";
var moreHelpTitle = "更多内容";
var open$1 = "展开";
var close$2 = "收起";
var subscribe = {
	all: "开启通知",
	text: "接收通知"
};
var CompanyHelpContent = {
	txt0: txt0$21,
	txt1: txt1$1P,
	txt2: txt2$1E,
	txt3: txt3$1v,
	txt4: txt4$1n,
	searchTitle: searchTitle,
	recommendTitle: recommendTitle,
	moreHelpTitle: moreHelpTitle,
	open: open$1,
	close: close$2,
	subscribe: subscribe
};

var txt0$20 = "暂无可选成员";
var txt1$1O = "请选择新的拥有者";
var TransferTeamMembers = {
	txt0: txt0$20,
	txt1: txt1$1O
};

var currentFileOwner = "当前文档所有者";
var transferOwner = "转让文档所有权";
var willTransferTo = "请确认将文档所有权转让给";
var tipsAfterTransfer = "转让后，你将成为该文档可编辑权限成员";
var afterTransfer = "转让后，";
var willReceiveMessage = "将收到消息通知";
var confirm$1 = "确定";
var cancel$6 = "取消";
var me$2 = "我";
var transferSuccess$1 = "转让成功";
var transfer_file_only = "该文档仅支持转让给已加入协作的人";
var iknow = "我已知悉";
var transfer = "转让";
var TransferOwnerConfirm = {
	currentFileOwner: currentFileOwner,
	transferOwner: transferOwner,
	willTransferTo: willTransferTo,
	tipsAfterTransfer: tipsAfterTransfer,
	afterTransfer: afterTransfer,
	willReceiveMessage: willReceiveMessage,
	confirm: confirm$1,
	cancel: cancel$6,
	me: me$2,
	transferSuccess: transferSuccess$1,
	transfer_file_only: transfer_file_only,
	iknow: iknow,
	transfer: transfer
};

var txt0$1$ = "请确认将团队转让给";
var txt1$1N = "转让后，你将转变为团队成员";
var txt2$1D = "取消";
var txt3$1u = "转让团队";
var txt4$1m = "转让团队成功";
var txt5$1e = "转让失败，不是该团队成员";
var txt6$13 = "不能转让团队给待接受的成员";
var txt7$V = "转让后：";
var txt8$T = "你将转变为团队成员";
var txt9$M = "已采购的会员将由团队拥有者和管理员进行权限分配和管理";
var TransferTeamComfirm = {
	txt0: txt0$1$,
	txt1: txt1$1N,
	txt2: txt2$1D,
	txt3: txt3$1u,
	txt4: txt4$1m,
	txt5: txt5$1e,
	txt6: txt6$13,
	txt7: txt7$V,
	txt8: txt8$T,
	txt9: txt9$M
};

var txt0$1_ = "暂无可选成员";
var txt1$1M = "请选择新的拥有者";
var TransferTeam = {
	txt0: txt0$1_,
	txt1: txt1$1M
};

var shareTitle = "分享";
var ShareingTitle = "正在与他人分享文档";
var toShareTitle = "与他人分享文档（未开启）";
var DocLinkIsExpired = "文档分享链接已过期";
var copyLink$4 = "复制链接";
var copyLinkSuccess = "复制链接成功";
var openLink = "开启分享";
var openExpiredLink = "开启链接";
var openLinkSuccess = "开启分享成功";
var pleaseOpenShare = "开启云⽂档分享，⼀起办公更⾼效";
var noMoreTip = "不再提醒";
var setSuccess = "设置成功";
var wechat = "微信";
var wechatFriend$1 = "指定微信好友";
var guideTitle = "更新实时同步，多人在线编辑";
var setUp = "设置";
var limitedToCompany = "团队管理员已禁止文件分享到企业外";
var limitedToGroup = "团队管理员已禁止文件分享到团队外";
var anyoneRead = "所有人可查看";
var anyoneComment = "所有人可评论";
var anyoneWrite = "所有人可编辑";
var companyRead = "本企业成员可查看";
var companyComment = "本企业成员可评论";
var companyWrite = "本企业成员可编辑";
var anyoneClose = "仅指定⼈可访问";
var anyoneRead1 = "所有人 可查看";
var anyoneComment1 = "所有人 可评论";
var anyoneWrite1 = "所有人 可编辑";
var companyRead1 = "本企业成员 可查看";
var companyComment1 = "本企业成员 可评论";
var companyWrite1 = "本企业成员 可编辑";
var anyoneClose1 = "仅指定⼈ 可访问";
var receiverTitle0 = "文件由";
var receiverTitle1 = "创建，允许 ";
var receiverTitle2 = "创建，仅";
var groupName = "「{0}」";
var groupMemberCanVisit = "成员可访问";
var ShareV2 = {
	shareTitle: shareTitle,
	ShareingTitle: ShareingTitle,
	toShareTitle: toShareTitle,
	DocLinkIsExpired: DocLinkIsExpired,
	copyLink: copyLink$4,
	copyLinkSuccess: copyLinkSuccess,
	openLink: openLink,
	openExpiredLink: openExpiredLink,
	openLinkSuccess: openLinkSuccess,
	pleaseOpenShare: pleaseOpenShare,
	noMoreTip: noMoreTip,
	setSuccess: setSuccess,
	wechat: wechat,
	wechatFriend: wechatFriend$1,
	guideTitle: guideTitle,
	setUp: setUp,
	limitedToCompany: limitedToCompany,
	limitedToGroup: limitedToGroup,
	anyoneRead: anyoneRead,
	anyoneComment: anyoneComment,
	anyoneWrite: anyoneWrite,
	companyRead: companyRead,
	companyComment: companyComment,
	companyWrite: companyWrite,
	anyoneClose: anyoneClose,
	anyoneRead1: anyoneRead1,
	anyoneComment1: anyoneComment1,
	anyoneWrite1: anyoneWrite1,
	companyRead1: companyRead1,
	companyComment1: companyComment1,
	companyWrite1: companyWrite1,
	anyoneClose1: anyoneClose1,
	receiverTitle0: receiverTitle0,
	receiverTitle1: receiverTitle1,
	receiverTitle2: receiverTitle2,
	groupName: groupName,
	groupMemberCanVisit: groupMemberCanVisit
};

var collabortorsCoopTitle = "已加入协作的人";
var collabortorsShareTitle = "已加入分享的人";
var collaboratorsSubTitle = "可以将工作伙伴加入列表，预先为其开通访问权限";
var collaboratorsAdd = "从通讯录添加";
var approvalTitle = "再次开启协作时，以下成员可以直接恢复访问权限";
var noUserRecord = "无访问记录";
var isMeTag = "（我）";
var unloginTxt = "未登录";
var fileCreator$1 = "文档创建者";
var userForbidTitle = "分享提醒";
var shareDisableInMyDoc = "您不是文档创建者，无法关闭协作";
var shareDisableInGroupDoc = "您不是团队成员，无法关闭协作";
var sharePageTitle = "协作";
var secureForbidAnyone = "加密文档不允许直接向全员分享";
var memberText = "团队成员";
var permissionText = "权限";
var allowComment = "可评论";
var settingTitle = "设置禁止下载、水印等选项";
var copyLink$3 = "复制链接";
var linkIsExpired = "链接已过期";
var wechatFriend = "微信好友";
var whoCanOpen = "谁能打开";
var originalGroupPerm = "原有团队权限";
var sendShareLink = "发送分享链接";
var sendCoopLink = "发送协作链接";
var setLinkTimeTxt$1 = "链接有效期";
var unknownErrorTxt$1 = "未知错误，请重试";
var hasOpenCoopTxt = "协作已开启";
var coopDetailTxt = "协作详情";
var shareOpenShareTxt = "分享链接已开启";
var shareDetailTxt = "分享链接详情";
var stopCoopTxt = "停止协作";
var cancelShareTxt = "取消分享";
var stopCoopSuccTxt = "停止协作成功";
var canCelShareSuccTxt = "取消分享成功";
var failTxt = "失败，请重试";
var anyoneTxt = "所有人";
var closeTxt$1 = "指定人";
var companyTxt = "本企业";
var wechatFriendTxt = "微信好友";
var wechatFriendTxt2 = "微信/企微好友";
var linkAdjustTxt = "链接权限已调整，";
var stopCoopTipTxt = "停止协作后，工作伙伴将不能查看你的文档，直到你重新开启。";
var stopShareTipTxt = "不再继续分享此文档？";
var cancelTxt = "取消";
var stopTxt = "停止";
var confirmTxt = "确定";
var coopSwitchNew = "和他人一起查看/编辑";
var openTips = "所有成员都能看到最新的文档内容";
var openCoopTips = "开启协作，获得云文档链接";
var openShareTips = "发送链接，对方始终都能够看到最新的内容";
var applyEditPerm = "申请编辑权限";
var howToAssign = "如何指定？";
var secureFileTips1 = "发送文档链接，对方经你批准后可进入；";
var secureFileTips2 = "发送微信小程序卡片，对方直接进入（不可转发）";
var manageCorpMember = "管理协作者";
var viewCorpMember = "浏览协作者";
var addCorpMember = "添加协作者";
var notAllowInSecureFile = "（不适用于安全文档）";
var allowDisplayCollaborator = "允许协作者查看最近访客";
var selectAll$1 = "全选";
var noPermission$1 = "无权限";
var operateLoading = "正在操作中...";
var changePermSuccess$1 = "权限已设置成功";
var removeSuccess$1 = "已将{0}移除";
var dropdownItem1 = "可编辑";
var dropdownItem2 = "可查看";
var alreadyAdd = "该用户已被添加";
var lookDetail = "查看详情";
var mainShareTitle = "链接";
var mainCoopTitle = "协作";
var blockEditApply$3 = "禁止申请编辑权限";
var blockEditApplyTip$1 = "开启后，加入分享的人将无法申请权限";
var openComment$1 = "允许加入分享的人查看、发表留言";
var openCommentTips = "开启后，他人打开文档可发表留言及查看留言";
var resetLinkText$1 = "文件分享链接已过期";
var resetShareLinkText = "链接已重置";
var forbidCopyText = "禁止查看者下载、打印、另存和复制内容";
var forbidCopyTipText = "开启后，仅具有查看权限的人将无法下载、打印、另存和复制内容";
var ksheetForbid = "禁止查看者导出、打印、另存和复制内容";
var ksheetPopText = "开启后，仅具有查看权限的人将无法导出、打印、另存和复制内容";
var kfpForbid = "禁止查看者导出和另存";
var kfpPopText = "开启后，仅具有查看权限的人将无法导出和另存";
var kdbtForbid = "禁止查看者导出、另存和复制内容";
var kdbtPopText = "开启后，仅具有查看权限的人将无法导出、另存和复制内容";
var kprocessonForbid = "禁止查看者导出和另存";
var kprocessonPopText = "开启后，仅具有查看权限的人将无法导出、另存";
var kimgForbid = "禁止查看者下载和另存";
var kimgPopText = "开启后，仅具有查看权限的人将无法下载、另存";
var ksheetRenameForbid = "禁止添加、删除工作表";
var ksheetRenameForbidPop = "开启后，禁止协作者删除、新建、移动、重命名工作表";
var waterMarkSettingTit$1 = "设置文档水印";
var openWaterMarkStatus$1 = "已开启水印";
var settingTxt$3 = "设置";
var openByOnlineText = "在线编辑";
var openByWpsText = "用 WPS Office 打开";
var sendFileText = "发送";
var sendShareFileText = "发送文件";
var sendPDFText = "导出为PDF";
var sendXlsxText = "导出为xlsx文件";
var sendWordText = "下载为docx文件";
var sendXlsxNewText = "下载为xlsx文件";
var sendPPTText = "下载为pptx文件";
var sendPDFNewText = "下载为pdf文件";
var sendToDeviesText = "发送到我的设备";
var downloadfail = "导出失败，请稍后重试";
var downloadSuccesTxt$1 = "导出成功";
var noPermDownloadTxt$1 = "你没有该文档下载权限";
var SharePermText = "链接权限";
var advancedSettingText = "高级设置";
var expiredText = "已过期";
var errorMsgTxt = "失败！请重试";
var canUpdate = "可编辑";
var canComment = "可评论";
var canView = "可查看";
var multiCompPermsScenesTip = "当前用户权限来源于群组，无法单独移除，可前往“管理协作者-全部”页面中操作";
var multiCompPermsScenesTip2 = "当前用户的权限来源于所在的群组集合";
var permission = "权限";
var personalReadPermission = "查看";
var personalWritePermission = "编辑";
var personalCommentPermission = "查看和评论";
var onlyTxt = "仅";
var secureForbidAnyoneTip = "该文档为加密保护文档：<br/>1.分享权限默认为仅指定人可访问，可在【管理协作者】面板中设置权限<br/>2.在文档内进行授权的成员，可自动获得链接访问权限";
var banShareTxt = "无法确保{0}文件的安全性，已暂停分享该文件。";
var wechatShareDesc = "使用手机微信\"扫一扫\"，发送小程序给好友。";
var wechatShareDesc2 = "使用微信/企业微信「扫一扫」分享给好友/群聊，对方可直接获得文档权限";
var latestVisit = "最近访问";
var all$2 = "全部";
var share = "分享";
var closeShare = "关闭分享";
var watermarkSetting = "水印设置";
var startCoopTxt = "开启协作";
var latestOnline = "最近在线：";
var online$1 = "在线";
var today$1 = "今天 ";
var justNow = "刚刚";
var me$1 = "我";
var unloginCoopTxt = "协作";
var unloginLoginTxt = "登录查看分享详情";
var unloginCopyTxt = "复制链接";
var kdocsTtitleTxt = "金山文档 | WPS云文档";
var copySuccessTxt = "复制成功，任何人可";
var wxWork = "企业微信";
var kemail = "WPS邮箱";
var changeDocOwnershipTxt = "转让文档所有权";
var onlyCreatorOperation = "仅文档所有者可操作";
var chooseContactsTransfer = "选择联系人转让";
var linkTransfer = "通过链接转让";
var onlineFile = "WPS 365在线文档";
var createDesc = "由{0}创建";
var sendToMyWPSText = "发送到我的WPS Office";
var txt_remove_1 = "已将";
var txt_remove_2 = "移除";
var face2faceReadFileTxt = "面对面看文档";
var addFileTxt$1 = "添加文档";
var cancelShareInSelfTips = "「多格式预览示例」取消分享后，其他用户将失去访问权限：";
var cancelShareInGroupTips = "「多格式预览示例」取消分享后，仅团队成员可访问，外部用户将失去访问权限：";
var shareChildFile = "分享子文件";
var shareChildFileTip = "打开后，用户能查看有权限的子文件";
var tipsTxt = "提示";
var openCoopTooltip = "开启后分享";
var anyoneCanWrite = "所有人可编辑";
var anyoneCanRead = "所有人可查看";
var someoneCanRead = "仅指定人可访问";
var sendFile = "发送文件";
var downloadFile = "下载文件";
var send2Wps = "发送到WPS";
var send2Device = "我的设备";
var exportFile = "导出文件";
var exportPic = "导出为图片";
var exportPdf = "导出为PDF";
var exportPicPdf = "导出纯图PDF";
var downloadPermDenied = "你没有该文档的下载权限";
var ShareV3 = {
	collabortorsCoopTitle: collabortorsCoopTitle,
	collabortorsShareTitle: collabortorsShareTitle,
	collaboratorsSubTitle: collaboratorsSubTitle,
	collaboratorsAdd: collaboratorsAdd,
	approvalTitle: approvalTitle,
	noUserRecord: noUserRecord,
	isMeTag: isMeTag,
	unloginTxt: unloginTxt,
	fileCreator: fileCreator$1,
	userForbidTitle: userForbidTitle,
	shareDisableInMyDoc: shareDisableInMyDoc,
	shareDisableInGroupDoc: shareDisableInGroupDoc,
	sharePageTitle: sharePageTitle,
	secureForbidAnyone: secureForbidAnyone,
	memberText: memberText,
	permissionText: permissionText,
	allowComment: allowComment,
	settingTitle: settingTitle,
	copyLink: copyLink$3,
	linkIsExpired: linkIsExpired,
	wechatFriend: wechatFriend,
	whoCanOpen: whoCanOpen,
	originalGroupPerm: originalGroupPerm,
	sendShareLink: sendShareLink,
	sendCoopLink: sendCoopLink,
	setLinkTimeTxt: setLinkTimeTxt$1,
	unknownErrorTxt: unknownErrorTxt$1,
	hasOpenCoopTxt: hasOpenCoopTxt,
	coopDetailTxt: coopDetailTxt,
	shareOpenShareTxt: shareOpenShareTxt,
	shareDetailTxt: shareDetailTxt,
	stopCoopTxt: stopCoopTxt,
	cancelShareTxt: cancelShareTxt,
	stopCoopSuccTxt: stopCoopSuccTxt,
	canCelShareSuccTxt: canCelShareSuccTxt,
	failTxt: failTxt,
	anyoneTxt: anyoneTxt,
	closeTxt: closeTxt$1,
	companyTxt: companyTxt,
	wechatFriendTxt: wechatFriendTxt,
	wechatFriendTxt2: wechatFriendTxt2,
	linkAdjustTxt: linkAdjustTxt,
	stopCoopTipTxt: stopCoopTipTxt,
	stopShareTipTxt: stopShareTipTxt,
	cancelTxt: cancelTxt,
	stopTxt: stopTxt,
	confirmTxt: confirmTxt,
	coopSwitchNew: coopSwitchNew,
	openTips: openTips,
	openCoopTips: openCoopTips,
	openShareTips: openShareTips,
	applyEditPerm: applyEditPerm,
	howToAssign: howToAssign,
	secureFileTips1: secureFileTips1,
	secureFileTips2: secureFileTips2,
	manageCorpMember: manageCorpMember,
	viewCorpMember: viewCorpMember,
	addCorpMember: addCorpMember,
	notAllowInSecureFile: notAllowInSecureFile,
	allowDisplayCollaborator: allowDisplayCollaborator,
	selectAll: selectAll$1,
	noPermission: noPermission$1,
	operateLoading: operateLoading,
	changePermSuccess: changePermSuccess$1,
	removeSuccess: removeSuccess$1,
	dropdownItem1: dropdownItem1,
	dropdownItem2: dropdownItem2,
	alreadyAdd: alreadyAdd,
	lookDetail: lookDetail,
	mainShareTitle: mainShareTitle,
	mainCoopTitle: mainCoopTitle,
	blockEditApply: blockEditApply$3,
	blockEditApplyTip: blockEditApplyTip$1,
	openComment: openComment$1,
	openCommentTips: openCommentTips,
	resetLinkText: resetLinkText$1,
	resetShareLinkText: resetShareLinkText,
	forbidCopyText: forbidCopyText,
	forbidCopyTipText: forbidCopyTipText,
	ksheetForbid: ksheetForbid,
	ksheetPopText: ksheetPopText,
	kfpForbid: kfpForbid,
	kfpPopText: kfpPopText,
	kdbtForbid: kdbtForbid,
	kdbtPopText: kdbtPopText,
	kprocessonForbid: kprocessonForbid,
	kprocessonPopText: kprocessonPopText,
	kimgForbid: kimgForbid,
	kimgPopText: kimgPopText,
	ksheetRenameForbid: ksheetRenameForbid,
	ksheetRenameForbidPop: ksheetRenameForbidPop,
	waterMarkSettingTit: waterMarkSettingTit$1,
	openWaterMarkStatus: openWaterMarkStatus$1,
	settingTxt: settingTxt$3,
	openByOnlineText: openByOnlineText,
	openByWpsText: openByWpsText,
	sendFileText: sendFileText,
	sendShareFileText: sendShareFileText,
	sendPDFText: sendPDFText,
	sendXlsxText: sendXlsxText,
	sendWordText: sendWordText,
	sendXlsxNewText: sendXlsxNewText,
	sendPPTText: sendPPTText,
	sendPDFNewText: sendPDFNewText,
	sendToDeviesText: sendToDeviesText,
	downloadfail: downloadfail,
	downloadSuccesTxt: downloadSuccesTxt$1,
	noPermDownloadTxt: noPermDownloadTxt$1,
	SharePermText: SharePermText,
	advancedSettingText: advancedSettingText,
	expiredText: expiredText,
	errorMsgTxt: errorMsgTxt,
	canUpdate: canUpdate,
	canComment: canComment,
	canView: canView,
	multiCompPermsScenesTip: multiCompPermsScenesTip,
	multiCompPermsScenesTip2: multiCompPermsScenesTip2,
	permission: permission,
	personalReadPermission: personalReadPermission,
	personalWritePermission: personalWritePermission,
	personalCommentPermission: personalCommentPermission,
	onlyTxt: onlyTxt,
	secureForbidAnyoneTip: secureForbidAnyoneTip,
	banShareTxt: banShareTxt,
	wechatShareDesc: wechatShareDesc,
	wechatShareDesc2: wechatShareDesc2,
	latestVisit: latestVisit,
	all: all$2,
	share: share,
	closeShare: closeShare,
	watermarkSetting: watermarkSetting,
	startCoopTxt: startCoopTxt,
	latestOnline: latestOnline,
	online: online$1,
	today: today$1,
	justNow: justNow,
	me: me$1,
	unloginCoopTxt: unloginCoopTxt,
	unloginLoginTxt: unloginLoginTxt,
	unloginCopyTxt: unloginCopyTxt,
	kdocsTtitleTxt: kdocsTtitleTxt,
	copySuccessTxt: copySuccessTxt,
	wxWork: wxWork,
	kemail: kemail,
	changeDocOwnershipTxt: changeDocOwnershipTxt,
	onlyCreatorOperation: onlyCreatorOperation,
	chooseContactsTransfer: chooseContactsTransfer,
	linkTransfer: linkTransfer,
	onlineFile: onlineFile,
	createDesc: createDesc,
	sendToMyWPSText: sendToMyWPSText,
	txt_remove_1: txt_remove_1,
	txt_remove_2: txt_remove_2,
	face2faceReadFileTxt: face2faceReadFileTxt,
	addFileTxt: addFileTxt$1,
	cancelShareInSelfTips: cancelShareInSelfTips,
	cancelShareInGroupTips: cancelShareInGroupTips,
	shareChildFile: shareChildFile,
	shareChildFileTip: shareChildFileTip,
	tipsTxt: tipsTxt,
	openCoopTooltip: openCoopTooltip,
	anyoneCanWrite: anyoneCanWrite,
	anyoneCanRead: anyoneCanRead,
	someoneCanRead: someoneCanRead,
	sendFile: sendFile,
	downloadFile: downloadFile,
	send2Wps: send2Wps,
	send2Device: send2Device,
	exportFile: exportFile,
	exportPic: exportPic,
	exportPdf: exportPdf,
	exportPicPdf: exportPicPdf,
	downloadPermDenied: downloadPermDenied
};

var txt0$1Z = "添加其他共享成员";
var ShareWithContactsEntry = {
	txt0: txt0$1Z
};

var txt0$1Y = "你需要发送验证消息，等待对方通过";
var txt1$1L = "由于验证消息发送频繁，请到";
var txt2$1C = "个人中心";
var txt3$1t = "绑定手机号后重试";
var txt4$1l = "取消";
var txt5$1d = "发送";
var txt6$12 = "我是";
var txt7$U = "发送成功";
var txt8$S = "请输入验证消息";
var SendAddContactInvitation = {
	txt0: txt0$1Y,
	txt1: txt1$1L,
	txt2: txt2$1C,
	txt3: txt3$1t,
	txt4: txt4$1l,
	txt5: txt5$1d,
	txt6: txt6$12,
	txt7: txt7$U,
	txt8: txt8$S
};

var txt0$1X = "你当前账号安全等级过低，请绑定手机号后重新操作";
var txt1$1K = "取消";
var txt2$1B = "立即绑定";
var SecureInfo = {
	txt0: txt0$1X,
	txt1: txt1$1K,
	txt2: txt2$1B
};

var txt0$1W = "待开启";
var txt1$1J = "去邀请";
var txt2$1A = "去上传";
var txt3$1s = "领取成功";
var txt4$1k = "领取失败";
var txt5$1c = "去领取";
var NoviceTaskList = {
	txt0: txt0$1W,
	txt1: txt1$1J,
	txt2: txt2$1A,
	txt3: txt3$1s,
	txt4: txt4$1k,
	txt5: txt5$1c
};

var txt0$1V = "点击免费领取企业空间";
var txt1$1I = "完成任务，可免费领取4G/人的存储空间";
var txt2$1z = "邀请同事";
var txt3$1r = "下次可点击这里邀请同事加入企业";
var txt4$1j = "去邀请";
var txt5$1b = "1/2上传文件";
var txt6$11 = "下次可点击这里上传文档至团队";
var txt7$T = "下一步";
var txt8$R = "2/2分享文件";
var txt9$L = "点击“分享”功能，设置分享权限，创建分享链接，即可分享给同事";
var txt10$H = "去分享";
var txt11$B = "新企业专属权益";
var NoviceGuideReminder = {
	txt0: txt0$1V,
	txt1: txt1$1I,
	txt2: txt2$1z,
	txt3: txt3$1r,
	txt4: txt4$1j,
	txt5: txt5$1b,
	txt6: txt6$11,
	txt7: txt7$T,
	txt8: txt8$R,
	txt9: txt9$L,
	txt10: txt10$H,
	txt11: txt11$B
};

var txt0$1U = "请输入成员姓名";
var txt1$1H = "取消";
var txt2$1y = "确定";
var txt3$1q = "不能包含特殊字符!@#$^*<>?";
var txt4$1i = "不超过30个字符";
var txt5$1a = "重命名成功";
var txt6$10 = "你的操作权限不足";
var ModifyMemberName = {
	txt0: txt0$1U,
	txt1: txt1$1H,
	txt2: txt2$1y,
	txt3: txt3$1q,
	txt4: txt4$1i,
	txt5: txt5$1a,
	txt6: txt6$10
};

var txt0$1T = "还没有同事申请加入企业";
var txt1$1G = "已通过";
var txt2$1x = "已拒绝";
var txt3$1p = "通过";
var txt4$1h = "拒绝";
var txt5$19 = "已验证手机加入";
var txt6$$ = "已验证邮箱加入";
var txt7$S = "已免审加入";
var txt8$Q = "审批失败";
var txt9$K = "前往购买";
var txt10$G = "成员席位已满，无法添加该成员，请增购席位后再审批";
var txt11$A = "成员席位已满，无法添加该成员，您可购买足够席位的套餐再进行审批。";
var MemberApproval = {
	txt0: txt0$1T,
	txt1: txt1$1G,
	txt2: txt2$1x,
	txt3: txt3$1p,
	txt4: txt4$1h,
	txt5: txt5$19,
	txt6: txt6$$,
	txt7: txt7$S,
	txt8: txt8$Q,
	txt9: txt9$K,
	txt10: txt10$G,
	txt11: txt11$A
};

var txt0$1S = "人数已超过限制";
var txt1$1F = "已选择";
var txt2$1w = "个成员 可查看";
var txt3$1o = "已发送邀请，请等待管理员确认";
var txt4$1g = "添加成功";
var txt5$18 = "发送成功";
var txt6$_ = "删除成功";
var txt7$R = "删除联系人失败";
var txt8$P = "，以下";
var txt9$J = "人无法添加：";
var txt10$F = "我知道了";
var txt11$z = "该团队已禁止企业外人员加入文档协作";
var txt12$x = "企业已禁止企业外人员加入文档协作。如需权限，请联系企业管理员";
var txt13$z = "团队所属企业已禁止企业外人员加入文档协作";
var txt14$t = "暂不支持企业外人员加入加密团队";
var txt15$q = "正在添加团队成员，请稍候...";
var groupChat$1 = "群聊";
var InviteContact = {
	txt0: txt0$1S,
	txt1: txt1$1F,
	txt2: txt2$1w,
	txt3: txt3$1o,
	txt4: txt4$1g,
	txt5: txt5$18,
	txt6: txt6$_,
	txt7: txt7$R,
	txt8: txt8$P,
	txt9: txt9$J,
	txt10: txt10$F,
	txt11: txt11$z,
	txt12: txt12$x,
	txt13: txt13$z,
	txt14: txt14$t,
	txt15: txt15$q,
	groupChat: groupChat$1
};

var txt0$1R = "以下用户非本企业成员，是否邀请加入企业？";
var txt1$1E = "是，邀请加入企业";
var txt2$1v = "跳过";
var txt3$1n = "未选中联系人";
var txt4$1f = "一次最多邀请";
var txt5$17 = "人";
var txt6$Z = "添加成功";
var txt7$Q = "等";
var txt8$O = "名成员";
var txt9$I = "加入企业后会自动加入团队";
var InviteBySend = {
	txt0: txt0$1R,
	txt1: txt1$1E,
	txt2: txt2$1v,
	txt3: txt3$1n,
	txt4: txt4$1f,
	txt5: txt5$17,
	txt6: txt6$Z,
	txt7: txt7$Q,
	txt8: txt8$O,
	txt9: txt9$I
};

var txt0$1Q = "请确认取消分享";
var txt1$1D = "取消后，仅";
var txt2$1u = "成员";
var txt3$1m = "你自己";
var txt4$1e = "可访问。以下成员将无法继续访问";
var txt5$16 = "位成员";
var txt6$Y = "成员可访问";
var txt7$P = "取消后，仅你自己可访问";
var txt8$N = "取消";
var txt9$H = "确认";
var cancelShareFileTxt = "取消分享成功";
var DelLink = {
	txt0: txt0$1Q,
	txt1: txt1$1D,
	txt2: txt2$1u,
	txt3: txt3$1m,
	txt4: txt4$1e,
	txt5: txt5$16,
	txt6: txt6$Y,
	txt7: txt7$P,
	txt8: txt8$N,
	txt9: txt9$H,
	cancelShareFileTxt: cancelShareFileTxt
};

var txt0$1P = "请确认移除指定的";
var txt1$1C = "取消";
var txt2$1t = "确定";
var txt3$1l = "个成员";
var DelMember = {
	txt0: txt0$1P,
	txt1: txt1$1C,
	txt2: txt2$1t,
	txt3: txt3$1l
};

var txt0$1O = "允许成员邀请联系人加入团队";
var txt1$1B = "加入时需要管理员确认";
var txt2$1s = "成员加入后仅允许查看";
var txt3$1k = "管理员仍可修改指定成员权限";
var txt4$1d = "邀请链接有效期";
var txt5$15 = "取消共享";
var txt6$X = "取消";
var txt7$O = "确定";
var txt8$M = "天";
var txt9$G = "永久";
var txt10$E = "修改成功";
var FolderShareSetting = {
	txt0: txt0$1O,
	txt1: txt1$1B,
	txt2: txt2$1s,
	txt3: txt3$1k,
	txt4: txt4$1d,
	txt5: txt5$15,
	txt6: txt6$X,
	txt7: txt7$O,
	txt8: txt8$M,
	txt9: txt9$G,
	txt10: txt10$E
};

var txt0$1N = "允许成员邀请联系人加入团队";
var txt1$1A = "加入时需要管理员确认";
var txt2$1r = "允许管理员访问团队所有文件和管理文件权限";
var txt4$1c = "邀请链接/二维码有效期";
var txt5$14 = "取消共享";
var txt6$W = "取消";
var txt7$N = "确定";
var txt8$L = "天";
var txt9$F = "永久";
var txt10$D = "修改成功";
var EntFolderShareSetting = {
	txt0: txt0$1N,
	txt1: txt1$1A,
	txt2: txt2$1r,
	txt4: txt4$1c,
	txt5: txt5$14,
	txt6: txt6$W,
	txt7: txt7$N,
	txt8: txt8$L,
	txt9: txt9$F,
	txt10: txt10$D
};

var txt0$1M = "设为共享";
var txt1$1z = "可邀请指定成员加入共享，共同查看、编辑文件";
var txt2$1q = "取消";
var txt3$1j = "立即共享";
var txt4$1b = "该文件夹中已存在共享文件夹，暂不支持共享。";
var txt5$13 = "确定";
var FolderShareOpen = {
	txt0: txt0$1M,
	txt1: txt1$1z,
	txt2: txt2$1q,
	txt3: txt3$1j,
	txt4: txt4$1b,
	txt5: txt5$13
};

var txt0$1L = "添加成员";
var txt1$1y = "设置";
var txt2$1p = "复制";
var txt3$1i = "请将链接发送给微信/QQ好友，点击即可加入";
var txt4$1a = "团队";
var txt5$12 = "共享";
var txt6$V = "邀请QQ、微信好友加入";
var txt7$M = "从联系人中添加";
var txt8$K = "从企业通讯录添加成员";
var txt9$E = "仅管理员可邀请成员加入";
var txt10$C = "从联系人中选择";
var txt11$y = "从企业通讯录添加成员";
var txt12$w = "已加入的成员";
var txt13$y = "已选择";
var txt14$s = "批量操作";
var txt15$p = "设为 管理员";
var txt16$q = "设为 成员 · 允许编辑";
var txt17$n = "设为 成员 · 仅查看";
var txt18$n = "批量移除";
var txt19$l = "搜索成员";
var txt20$k = "未搜索到匹配的联系人";
var txt21$h = "拥有者";
var txt22$f = "你是共享文件夹拥有者，文件仅占用你的云空间";
var txt23$d = "你是团队拥有者，文件仅占用你的企业云空间";
var txt24$b = "转让共享文件夹";
var txt25$a = "转让团队";
var txt26$a = "拥有者";
var txt27$9 = "移除该成员";
var txt28$9 = "管理员";
var txt29$6 = "成员 · 允许编辑";
var txt30$5 = "成员 · 可查看";
var txt31$5 = "成员";
var txt32$5 = "查看者";
var txt33$4 = "不能再选了";
var txt34$4 = "移除成功";
var txt35$4 = "部分移除失败";
var txt36$4 = "部分修改失败";
var txt37$4 = "修改成功";
var txt38$4 = "（待接受）";
var txt39$4 = "复制成功";
var txt40$4 = "复制失败";
var txt41$4 = "你的浏览器不支持自动复制请按";
var txt42$4 = "复制下面输入框的内容";
var txt43$4 = "(已邀请)";
var txt44$4 = "单次最多选择4000人";
var txt45$4 = "名成员移除失败";
var txt46$4 = "名成员修改失败";
var txt47$4 = "加入时需要管理员确认";
var txt48$4 = "复制链接";
var txt49$4 = "从通讯录选择";
var txt50$4 = "成员加入后 可查看";
var txt51$2 = "成员加入后 可编辑";
var txt52$2 = "取消共享";
var txt53$2 = "3天有效";
var txt54$2 = "永久有效";
var txt55$1 = "修改成功";
var txt56$1 = "转让成功";
var txt57$1 = "对方的团队数量已到达上限，暂不支持转让";
var txt58$1 = "链接已复制，发送至微信邀请好友加入";
var txt59$1 = "链接已复制，发送至QQ邀请好友加入";
var txt60$1 = "搜索已加入的成员";
var txt61$1 = "搜索结果";
var txt62$1 = "单次最多删除100人";
var txt63$1 = "可以增删成员和进行团队管理";
var link_v1_ShareFolder38 = "邀请QQ、微信好友加入";
var link_v1_ShareFolder39 = "请将链接发送给QQ/微信好友，点击即可加入团队";
var link_v1_ShareFolder40 = "使用邀请链接";
var link_v1_ShareFolder41 = "链接发送后，点击即可加入团队";
var shareFolderDialogTitle = "共享文件夹二维码";
var qrcode_invite$1 = "二维码邀请";
var qrcode_scan$1 = "扫描二维码，加入共享文件夹";
var footer_link$1 = "如想拥有更多分享方式，请";
var footer_link_tell_us$1 = "告诉我们";
var FolderShareMain = {
	txt0: txt0$1L,
	txt1: txt1$1y,
	txt2: txt2$1p,
	txt3: txt3$1i,
	txt4: txt4$1a,
	txt5: txt5$12,
	txt6: txt6$V,
	txt7: txt7$M,
	txt8: txt8$K,
	txt9: txt9$E,
	txt10: txt10$C,
	txt11: txt11$y,
	txt12: txt12$w,
	txt13: txt13$y,
	txt14: txt14$s,
	txt15: txt15$p,
	txt16: txt16$q,
	txt17: txt17$n,
	txt18: txt18$n,
	txt19: txt19$l,
	txt20: txt20$k,
	txt21: txt21$h,
	txt22: txt22$f,
	txt23: txt23$d,
	txt24: txt24$b,
	txt25: txt25$a,
	txt26: txt26$a,
	txt27: txt27$9,
	txt28: txt28$9,
	txt29: txt29$6,
	txt30: txt30$5,
	txt31: txt31$5,
	txt32: txt32$5,
	txt33: txt33$4,
	txt34: txt34$4,
	txt35: txt35$4,
	txt36: txt36$4,
	txt37: txt37$4,
	txt38: txt38$4,
	txt39: txt39$4,
	txt40: txt40$4,
	txt41: txt41$4,
	txt42: txt42$4,
	txt43: txt43$4,
	txt44: txt44$4,
	txt45: txt45$4,
	txt46: txt46$4,
	txt47: txt47$4,
	txt48: txt48$4,
	txt49: txt49$4,
	txt50: txt50$4,
	txt51: txt51$2,
	txt52: txt52$2,
	txt53: txt53$2,
	txt54: txt54$2,
	txt55: txt55$1,
	txt56: txt56$1,
	txt57: txt57$1,
	txt58: txt58$1,
	txt59: txt59$1,
	txt60: txt60$1,
	txt61: txt61$1,
	txt62: txt62$1,
	txt63: txt63$1,
	link_v1_ShareFolder38: link_v1_ShareFolder38,
	link_v1_ShareFolder39: link_v1_ShareFolder39,
	link_v1_ShareFolder40: link_v1_ShareFolder40,
	link_v1_ShareFolder41: link_v1_ShareFolder41,
	shareFolderDialogTitle: shareFolderDialogTitle,
	qrcode_invite: qrcode_invite$1,
	qrcode_scan: qrcode_scan$1,
	footer_link: footer_link$1,
	footer_link_tell_us: footer_link_tell_us$1
};

var txt0$1K = "邀请成员加入团队";
var txt1$1x = "设置";
var txt2$1o = "复制";
var txt3$1h = "请将链接发送给微信/QQ好友，点击即可加入";
var txt4$19 = "团队。";
var txt5$11 = "共享。";
var txt6$U = "邀请QQ、微信好友加入";
var txt7$L = "从联系人中添加";
var txt8$J = "从企业通讯录添加成员";
var txt9$D = "仅管理员可邀请成员加入";
var txt10$B = "从联系人中选择";
var txt11$x = "从企业通讯录添加成员";
var txt12$v = "已加入的成员";
var txt13$x = "已选择";
var txt14$r = "批量操作";
var txt15$o = "设为 管理员";
var txt16$p = "设为 成员";
var txt18$m = "批量移除";
var txt19$k = "搜索成员";
var txt20$j = "未搜索到匹配的联系人";
var txt21$g = "拥有者";
var txt22$e = "团队的所有者";
var txt23$c = "团队的所有者";
var txt24$a = "转让共享文件夹";
var txt25$9 = "转让团队";
var txt26$9 = "拥有者";
var txt27$8 = "移除该成员";
var txt28$8 = "管理员";
var txt29$5 = "成员";
var txt30$4 = "成员 · 仅查看";
var txt31$4 = "可以增删成员和设置文件权限";
var txt32$4 = "可以访问团队中有权限的文档";
var txt33$3 = "不能再选了";
var txt34$3 = "移除成功";
var txt35$3 = "部分移除失败";
var txt36$3 = "部分修改失败";
var txt37$3 = "修改成功";
var txt38$3 = "（待接受）";
var txt39$3 = "复制成功";
var txt40$3 = "复制失败";
var txt41$3 = "你的浏览器不支持自动复制请按";
var txt42$3 = "复制下面输入框的内容";
var txt43$3 = "(已邀请)";
var txt44$3 = "单次最多选择4000人";
var txt45$3 = "名成员移除失败";
var txt46$3 = "名成员修改失败";
var txt47$3 = "加入时需要管理员确认";
var txt48$3 = "复制链接";
var txt49$3 = "从通讯录选择";
var txt50$3 = "成员加入后 可查看";
var txt51$1 = "成员加入后 可编辑";
var txt52$1 = "取消共享";
var txt53$1 = "3天有效";
var txt54$1 = "永久有效";
var txt55 = "修改成功";
var txt56 = "转让成功";
var txt57 = "对方的团队数量已到达上限，暂不支持转让";
var txt58 = "链接已复制，发送至微信邀请好友加入";
var txt59 = "链接已复制，发送至QQ邀请好友加入";
var txt60 = "搜索已加入的成员";
var txt61 = "搜索结果";
var txt62 = "单次最多删除100人";
var txt63 = "可以增删成员和进行团队管理";
var txt64 = "使用邀请链接";
var txt65 = "链接发送后，点击即可加入";
var txt66 = "企业内成员";
var txt67 = "从企业通讯录添加";
var txt68 = "企业外部联系人";
var txt69 = "发送链接到工作群邀请同事，同事点击即可申请加入企业团队";
var txt70 = "复制链接并发送给微信/QQ好友，点击即可申请加入";
var txt71 = "为保证数据安全，暂不支持将企业外成员设置为管理员";
var qrcode_invite = "二维码邀请";
var qrcode_scan = "扫描二维码，加入团队";
var footer_link = "如想拥有更多分享方式，请";
var footer_link_tell_us = "告诉我们";
var EntFolderShareMain = {
	txt0: txt0$1K,
	txt1: txt1$1x,
	txt2: txt2$1o,
	txt3: txt3$1h,
	txt4: txt4$19,
	txt5: txt5$11,
	txt6: txt6$U,
	txt7: txt7$L,
	txt8: txt8$J,
	txt9: txt9$D,
	txt10: txt10$B,
	txt11: txt11$x,
	txt12: txt12$v,
	txt13: txt13$x,
	txt14: txt14$r,
	txt15: txt15$o,
	txt16: txt16$p,
	txt18: txt18$m,
	txt19: txt19$k,
	txt20: txt20$j,
	txt21: txt21$g,
	txt22: txt22$e,
	txt23: txt23$c,
	txt24: txt24$a,
	txt25: txt25$9,
	txt26: txt26$9,
	txt27: txt27$8,
	txt28: txt28$8,
	txt29: txt29$5,
	txt30: txt30$4,
	txt31: txt31$4,
	txt32: txt32$4,
	txt33: txt33$3,
	txt34: txt34$3,
	txt35: txt35$3,
	txt36: txt36$3,
	txt37: txt37$3,
	txt38: txt38$3,
	txt39: txt39$3,
	txt40: txt40$3,
	txt41: txt41$3,
	txt42: txt42$3,
	txt43: txt43$3,
	txt44: txt44$3,
	txt45: txt45$3,
	txt46: txt46$3,
	txt47: txt47$3,
	txt48: txt48$3,
	txt49: txt49$3,
	txt50: txt50$3,
	txt51: txt51$1,
	txt52: txt52$1,
	txt53: txt53$1,
	txt54: txt54$1,
	txt55: txt55,
	txt56: txt56,
	txt57: txt57,
	txt58: txt58,
	txt59: txt59,
	txt60: txt60,
	txt61: txt61,
	txt62: txt62,
	txt63: txt63,
	txt64: txt64,
	txt65: txt65,
	txt66: txt66,
	txt67: txt67,
	txt68: txt68,
	txt69: txt69,
	txt70: txt70,
	txt71: txt71,
	qrcode_invite: qrcode_invite,
	qrcode_scan: qrcode_scan,
	footer_link: footer_link,
	footer_link_tell_us: footer_link_tell_us
};

var txt0$1J = "请确认移除指定的";
var txt1$1w = "个成员";
var txt2$1n = "取消";
var txt3$1g = "确定";
var FolderShareDelete = {
	txt0: txt0$1J,
	txt1: txt1$1w,
	txt2: txt2$1n,
	txt3: txt3$1g
};

var txt0$1I = "请确认取消共享";
var txt1$1v = "取消后，仅你自己可访问，其他成员将不能再访问该文件夹";
var txt2$1m = "位成员";
var txt3$1f = "取消";
var txt4$18 = "确定";
var txt5$10 = "文件夹共享已取消";
var txt6$T = "复制";
var txt7$K = "粘贴";
var txt8$I = "删除";
var txt9$C = "移动";
var txt10$A = "取消文件夹共享";
var txt11$w = "正在";
var txt12$u = "请稍候...";
var txt13$w = "文件";
var FolderShareCancel = {
	txt0: txt0$1I,
	txt1: txt1$1v,
	txt2: txt2$1m,
	txt3: txt3$1f,
	txt4: txt4$18,
	txt5: txt5$10,
	txt6: txt6$T,
	txt7: txt7$K,
	txt8: txt8$I,
	txt9: txt9$C,
	txt10: txt10$A,
	txt11: txt11$w,
	txt12: txt12$u,
	txt13: txt13$w
};

var txt0$1H = "反馈";
var txt1$1u = "团队成员";
var txt2$1l = "服务器错误";
var txt3$1e = "设置";
var txt4$17 = "取消共享";
var txt5$$ = "添加成员";
var txt6$S = "团队成员";
var txt7$J = "批量移除";
var FolderShare = {
	txt0: txt0$1H,
	txt1: txt1$1u,
	txt2: txt2$1l,
	txt3: txt3$1e,
	txt4: txt4$17,
	txt5: txt5$$,
	txt6: txt6$S,
	txt7: txt7$J
};

var txt0$1G = "新企业专属权益";
var DialogNoviceTask = {
	txt0: txt0$1G
};

var txt0$1F = "成员审批";
var DialogMemberApproval = {
	txt0: txt0$1F
};

var txt0$1E = "企业成长计划";
var txt1$1t = "企业指数";
var DialogJoinCompPrivilege = {
	txt0: txt0$1E,
	txt1: txt1$1t
};

var txt0$1D = "团队设置";
var txt1$1s = "设置";
var txt2$1k = "批量移除";
var txt3$1d = "转让团队";
var txt4$16 = "安全提醒";
var txt5$_ = "团队成员";
var txt5_beemwork = "团队成员";
var txt6$R = "添加联系人";
var txt7$I = "转让共享文件夹";
var txt8$H = "取消共享";
var txt9$B = "删除联系人";
var txt10$z = "安全验证";
var qrcode_dialog_title$1 = "团队二维码";
var noMemberToSelect = "暂无成员可选";
var some_member_add_failed = "部分人员添加失败";
var DialogFolderShare = {
	txt0: txt0$1D,
	txt1: txt1$1s,
	txt2: txt2$1k,
	txt3: txt3$1d,
	txt4: txt4$16,
	txt5: txt5$_,
	txt5_beemwork: txt5_beemwork,
	txt6: txt6$R,
	txt7: txt7$I,
	txt8: txt8$H,
	txt9: txt9$B,
	txt10: txt10$z,
	qrcode_dialog_title: qrcode_dialog_title$1,
	noMemberToSelect: noMemberToSelect,
	some_member_add_failed: some_member_add_failed
};

var txt0$1C = "邀请同事";
var DialogCompanyInvite = {
	txt0: txt0$1C
};

var txt0$1B = "企业成员";
var txt1$1r = "修改姓名";
var txt2$1j = "设置";
var txt3$1c = "删除成员";
var txt4$15 = "邀请同事";
var txt5$Z = "退出企业";
var txt6$Q = "安全验证";
var DialogAddEntMember = {
	txt0: txt0$1B,
	txt1: txt1$1r,
	txt2: txt2$1j,
	txt3: txt3$1c,
	txt4: txt4$15,
	txt5: txt5$Z,
	txt6: txt6$Q
};

var txt0$1A = "删除后，该成员将退出所有已经加入的团队，无法继续访问企业文档，确定要删除？";
var txt1$1q = "取消";
var txt2$1i = "删除";
var txt3$1b = "删除成功";
var txt4$14 = "你的操作权限不足";
var DeleteEntMember = {
	txt0: txt0$1A,
	txt1: txt1$1q,
	txt2: txt2$1i,
	txt3: txt3$1b,
	txt4: txt4$14
};

var txt0$1z = "允许成员邀请同事加入企业";
var txt1$1p = "成员邀请后，需要通过管理员审批才可以加入企业";
var txt2$1h = "你的操作权限不足";
var CompanyMemberInviteSetting = {
	txt0: txt0$1z,
	txt1: txt1$1p,
	txt2: txt2$1h
};

var txt0$1y = "修改";
var CompanyLogo = {
	txt0: txt0$1y
};

var txt0$1x = "企业成长计划";
var txt1$1o = "企业套餐：";
var txt2$1g = "到期";
var txt3$1a = "企业空间";
var txt4$13 = "邀请同事";
var txt5$Y = "成员审批";
var txt6$P = "企业成员";
var txt7$H = "进入管理后台";
var txt8$G = "已加入";
var txt9$A = "人";
var txt10$y = "这里可管理成员权限，禁止成员在全员团队中随意上传文件。";
var txt11$v = "去设置";
var txt12$t = "有待领取的企业空间、文件上传权益";
var txt13$v = "查看套餐到期后的影响";
var txt14$q = "了解教育增强版";
var txt15$n = "到期后，会自动免费续期一年";
var txt16$o = "企业超管：";
var txt17$m = "企业ID：";
var txt18$l = "升级";
var txt19$j = "续费";
var txt20$i = "企业指数";
var txt21$f = "权益待领取";
var txt22$d = "购买套餐";
var txt23$b = "立即续期";
var txt24$9 = "已使用/用户上限";
var txt25$8 = "增购人数";
var txt26$8 = "升级套餐";
var CompanyHelpHead = {
	txt0: txt0$1x,
	txt1: txt1$1o,
	txt2: txt2$1g,
	txt3: txt3$1a,
	txt4: txt4$13,
	txt5: txt5$Y,
	txt6: txt6$P,
	txt7: txt7$H,
	txt8: txt8$G,
	txt9: txt9$A,
	txt10: txt10$y,
	txt11: txt11$v,
	txt12: txt12$t,
	txt13: txt13$v,
	txt14: txt14$q,
	txt15: txt15$n,
	txt16: txt16$o,
	txt17: txt17$m,
	txt18: txt18$l,
	txt19: txt19$j,
	txt20: txt20$i,
	txt21: txt21$f,
	txt22: txt22$d,
	txt23: txt23$b,
	txt24: txt24$9,
	txt25: txt25$8,
	txt26: txt26$8
};

var txt0$1w = "添加成员";
var txt1$1n = "设置";
var txt2$1f = "邀请同事";
var txt3$19 = "仅管理员可邀请同事加入企业";
var txt4$12 = "已加入的成员";
var txt5$X = "搜索成员";
var txt6$O = "删除";
var txt7$G = "未搜索到匹配的数据";
var txt8$F = "修改姓名";
var txt9$z = "退出企业";
var AddEntMember = {
	txt0: txt0$1w,
	txt1: txt1$1n,
	txt2: txt2$1f,
	txt3: txt3$19,
	txt4: txt4$12,
	txt5: txt5$X,
	txt6: txt6$O,
	txt7: txt7$G,
	txt8: txt8$F,
	txt9: txt9$z
};

var txt0$1v = "获取免登录链接";
var txt1$1m = "开启后，仅具有查看权限的人将无法下载、打印、另存和复制内容";
var txt2$1e = "高级设置";
var txt3$18 = "关闭后，仅具有查看权限的人将无法下载、打印、另存和复制内容";
var ClinkAdvancedSetting = {
	txt0: txt0$1v,
	txt1: txt1$1m,
	txt2: txt2$1e,
	txt3: txt3$18
};

var txt0$1u = "使用团队文档可激活权益";
var txt1$1l = "权益已失效";
var ActivityContent = {
	txt0: txt0$1u,
	txt1: txt1$1l
};

var txt0$1t = "应用中心";
var txt1$1k = "在应用中心里取消应用置顶";
var txt2$1d = "会议";
var txt3$17 = "云上开会，协作无间";
var txt4$11 = "表单";
var txt5$W = "快速创建，高效收集";
var txt6$N = "待办";
var txt7$F = "团队任务协作，多平台同步";
var txt8$E = "日历";
var txt9$y = "高效的日程管理工具";
var txt10$x = "通讯录";
var txt11$u = "添加伙伴，高效团队办公";
var txt12$s = "取消置顶";
var txt13$u = "置顶";
var txt14$p = "最多置顶4个应用，请先取消其他置顶";
var txt15$m = "置顶失败";
var AppCenter = {
	txt0: txt0$1t,
	txt1: txt1$1k,
	txt2: txt2$1d,
	txt3: txt3$17,
	txt4: txt4$11,
	txt5: txt5$W,
	txt6: txt6$N,
	txt7: txt7$F,
	txt8: txt8$E,
	txt9: txt9$y,
	txt10: txt10$x,
	txt11: txt11$u,
	txt12: txt12$s,
	txt13: txt13$u,
	txt14: txt14$p,
	txt15: txt15$m
};

var txt0$1s = "查看所有成员";
var txt1$1j = "所有者";
var txt2$1c = "（我）";
var txt3$16 = "离线";
var txt4$10 = "正在协作的成员";
var txt5$V = "未登录";
var txt6$M = "仅查看";
var txt7$E = "可编辑";
var txt8$D = "我";
var txt9$x = "文档所有者";
var txt10$w = "正在协作，点击头像定位";
var txt11$t = "正在查看，点击头像定位";
var txt10_dbt = "正在协作";
var txt11_dbt = "正在查看";
var txt12$r = "只读权限";
var txt13$t = "申请编辑";
var comment$6 = "可评论";
var commentOnly = "可评论权限";
var AvatarList = {
	txt0: txt0$1s,
	txt1: txt1$1j,
	txt2: txt2$1c,
	txt3: txt3$16,
	txt4: txt4$10,
	txt5: txt5$V,
	txt6: txt6$M,
	txt7: txt7$E,
	txt8: txt8$D,
	txt9: txt9$x,
	txt10: txt10$w,
	txt11: txt11$t,
	txt10_dbt: txt10_dbt,
	txt11_dbt: txt11_dbt,
	txt12: txt12$r,
	txt13: txt13$t,
	comment: comment$6,
	commentOnly: commentOnly
};

var txt0$1r = "请确认关闭文档加密保护";
var txt1$1i = "关闭文档加密保护后，";
var txt2$1b = "已加密的团队文档将会被解密";
var txt3$15 = "，文件被分享后团队外的用户也可查阅";
var txt4$$ = "关闭并解密已保护的文档";
var txt5$U = "取消";
var txt6$L = "关闭保护";
var txt7$D = "关闭成功";
var txt8$C = "关闭失败，请重试";
var txt9$w = "关闭文档加密保护";
var CloseSecure = {
	txt0: txt0$1r,
	txt1: txt1$1i,
	txt2: txt2$1b,
	txt3: txt3$15,
	txt4: txt4$$,
	txt5: txt5$U,
	txt6: txt6$L,
	txt7: txt7$D,
	txt8: txt8$C,
	txt9: txt9$w
};

var txt0$1q = "团队设置";
var txt0_beemwork$1 = "团队设置";
var txt1$1h = "重命名";
var txt2$1a = "权限";
var txt3$14 = "开启文档加密保护";
var txt4$_ = "安全验证";
var txt5$T = "安全提醒";
var txt8$B = "转让团队";
var txt10$v = "团队成员";
var txt10_beemwork$2 = "团队成员";
var txt11$s = "设置";
var txt13$s = "批量移除";
var txt16$n = "添加联系人";
var txt17$l = "添加联系人";
var txt18$k = "分享范围管控";
var DialogTeamSettings = {
	txt0: txt0$1q,
	txt0_beemwork: txt0_beemwork$1,
	txt1: txt1$1h,
	txt2: txt2$1a,
	txt3: txt3$14,
	txt4: txt4$_,
	txt5: txt5$T,
	txt8: txt8$B,
	txt10: txt10$v,
	txt10_beemwork: txt10_beemwork$2,
	txt11: txt11$s,
	txt13: txt13$s,
	txt16: txt16$n,
	txt17: txt17$l,
	txt18: txt18$k
};

var txt0$1p = "设置";
var txt1$1g = "重命名";
var txt2$19 = "权限";
var txt3$13 = "开启文档加密保护";
var txt4$Z = "安全验证";
var txt5$S = "安全提醒";
var txt8$A = "转让团队";
var txt10$u = "团队成员";
var txt11$r = "设置";
var txt13$r = "批量移除";
var txt16$m = "添加联系人";
var txt17$k = "添加联系人";
var txt18$j = "分享范围管控";
var txt19$i = "应用重命名";
var txt20$h = "应用管理";
var txt21$e = "解散团队";
var txt22$c = "提示";
var DialogTeamAppSettings = {
	txt0: txt0$1p,
	txt1: txt1$1g,
	txt2: txt2$19,
	txt3: txt3$13,
	txt4: txt4$Z,
	txt5: txt5$S,
	txt8: txt8$A,
	txt10: txt10$u,
	txt11: txt11$r,
	txt13: txt13$r,
	txt16: txt16$m,
	txt17: txt17$k,
	txt18: txt18$j,
	txt19: txt19$i,
	txt20: txt20$h,
	txt21: txt21$e,
	txt22: txt22$c
};

var txt0$1o = "分享";
var txt1$1f = "免登录访问链接";
var txt2$18 = "取消分享";
var txt3$12 = "添加失败";
var txt4$Y = "二维码";
var batchRemove$1 = "批量移除";
var txt5$R = "创建企业";
var shareMiniCode$2 = "通过小程序发送给微信好友";
var txt6$K = "实名认证";
var banShare = "无法确保{0}文件的安全性，已暂停分享该文件。";
var iSee = "我知道了";
var txt7$C = "已加入分享的人";
var txt8$z = "分享设置";
var txt9$v = "文档水印";
var DialogShareFile = {
	txt0: txt0$1o,
	txt1: txt1$1f,
	txt2: txt2$18,
	txt3: txt3$12,
	txt4: txt4$Y,
	batchRemove: batchRemove$1,
	txt5: txt5$R,
	shareMiniCode: shareMiniCode$2,
	txt6: txt6$K,
	banShare: banShare,
	iSee: iSee,
	txt7: txt7$C,
	txt8: txt8$z,
	txt9: txt9$v
};

var txt0$1n = "插入日程";
var txt1$1e = "输入标题搜索已有日程";
var txt2$17 = "发起";
var txt3$11 = "新建日程";
var txt4$X = "暂无搜索结果";
var txt5$Q = "周一";
var txt6$J = "周二";
var txt7$B = "周三";
var txt8$y = "周四";
var txt9$u = "周五";
var txt10$t = "周六";
var txt11$q = "周日";
var txt12$q = "服务器错误";
var txt13$q = "暂无日程";
var txt14$o = "年";
var txt15$l = "月";
var txt16$l = "日";
var txt17$j = "全天";
var DialogSchedule = {
	txt0: txt0$1n,
	txt1: txt1$1e,
	txt2: txt2$17,
	txt3: txt3$11,
	txt4: txt4$X,
	txt5: txt5$Q,
	txt6: txt6$J,
	txt7: txt7$B,
	txt8: txt8$y,
	txt9: txt9$u,
	txt10: txt10$t,
	txt11: txt11$q,
	txt12: txt12$q,
	txt13: txt13$q,
	txt14: txt14$o,
	txt15: txt15$l,
	txt16: txt16$l,
	txt17: txt17$j
};

var txt0$1m = "设置";
var txt1$1d = "自动备份目录设置";
var DialogBackupSettings = {
	txt0: txt0$1m,
	txt1: txt1$1d
};

var txt0$1l = "自动备份目录:";
var txt1$1c = "我的企业空间";
var txt2$16 = "修改";
var txt3$10 = "已使用";
var txt4$W = "我的文档/我的设备";
var txt5$P = "我的企业文档/自动备份";
var txt6$I = "我的云文档/我的设备";
var BackupSetting = {
	txt0: txt0$1l,
	txt1: txt1$1c,
	txt2: txt2$16,
	txt3: txt3$10,
	txt4: txt4$W,
	txt5: txt5$P,
	txt6: txt6$I
};

var txt0$1k = "确定";
var txt1$1b = "取消";
var BackupSettingSelect = {
	txt0: txt0$1k,
	txt1: txt1$1b
};

var txt0$1j = "我们需要对你的手机号";
var txt1$1a = "进行安全验证";
var txt2$15 = "请输入验证码";
var txt3$$ = "获取验证码";
var txt4$V = "重新获取";
var txt5$O = "取消";
var txt6$H = "确定";
var txt7$A = "请填写验证码";
var SecurePhoneCheck = {
	txt0: txt0$1j,
	txt1: txt1$1a,
	txt2: txt2$15,
	txt3: txt3$$,
	txt4: txt4$V,
	txt5: txt5$O,
	txt6: txt6$H,
	txt7: txt7$A
};

var txt0$1i = "开启文档加密保护后，将团队内600M以下的Office文档转为安全文档格式（不包括历史版本）， 仅此团队成员能访问、编辑";
var txt1$19 = "取消";
var txt2$14 = "开启";
var txt3$_ = "开启成功，初次转换比较耗时请耐心等待";
var txt4$U = "开启失败，请重试";
var SecureTips = {
	txt0: txt0$1i,
	txt1: txt1$19,
	txt2: txt2$14,
	txt3: txt3$_,
	txt4: txt4$U
};

var txt0$1h = "确认解散";
var txt1$18 = "确认退出";
var txt2$13 = "解散后，团队内的文件将无法访问";
var txt3$Z = "退出后，你将无法访问";
var txt4$T = "取消";
var txt5$N = "解散";
var txt6$G = "确定";
var txt7$z = "解散团队";
var txt8$x = "退出团队";
var txt9$t = "解散后：";
var txt10$s = "退出后：";
var txt11$p = "该团队的所有内容将被移到回收站";
var txt12$p = "由你付款采购的会员权益将自动分配到你的个人账号";
var txt13$p = "此操作无法撤销，请谨慎操作。";
var txt14$n = "由你付款采购的会员权益将自动分配到你的个人账号";
var txt15$k = "由管理员采购并分配给你的会员将自动回收";
var txt16$k = "由管理员分配给你的会员将自动回收";
var tipsTitle$2 = "解散后：";
var tips1$2 = "团队成员将无法访问该团队";
var tips2$2 = "所有文件将被移到企业管理后台的「已解散的团队」";
var tips3$2 = "同步删除智能文档库「{0}」";
var reminder = "此操作无法撤销，请谨慎操作";
var TeamDeleteOrExit = {
	txt0: txt0$1h,
	txt1: txt1$18,
	txt2: txt2$13,
	txt3: txt3$Z,
	txt4: txt4$T,
	txt5: txt5$N,
	txt6: txt6$G,
	txt7: txt7$z,
	txt8: txt8$x,
	txt9: txt9$t,
	txt10: txt10$s,
	txt11: txt11$p,
	txt12: txt12$p,
	txt13: txt13$p,
	txt14: txt14$n,
	txt15: txt15$k,
	txt16: txt16$k,
	tipsTitle: tipsTitle$2,
	tips1: tips1$2,
	tips2: tips2$2,
	tips3: tips3$2,
	reminder: reminder
};

var txt0$1g = "取消";
var txt1$17 = "确定";
var txt2$12 = "填写名字";
var TeamRename = {
	txt0: txt0$1g,
	txt1: txt1$17,
	txt2: txt2$12
};

var txt0$1f = "取消";
var txt1$16 = "确定";
var txt2$11 = "填写应用名字";
var success$4 = "修改成功";
var TeamAppRename = {
	txt0: txt0$1f,
	txt1: txt1$16,
	txt2: txt2$11,
	success: success$4
};

var txt0$1e = "团队名";
var txt0_beemwork = "团队名";
var txt1$15 = "修改";
var txt2$10 = "成员管理";
var txt3$Y = "名成员";
var txt4$S = "查看";
var txt5$M = "团队文件权限定义";
var txt6$F = "设置";
var txt7$y = "可管理团队级别的权限，并自定义查看、下载、编辑等";
var txt8$w = "文档加密保护";
var txt9$s = "开启后，团队内 600M 以下 Office 文档将加密保存为 WPS 安全格式，仅团队成员和指定授权的用户可以打开";
var txt10$r = "转让团队";
var txt10_beemwork$1 = "转让团队";
var txt11$o = "解散团队";
var txt11_beemwork = "删除团队";
var txt12$o = "退出团队";
var txt13$o = "解散后，成员将无法访问，所有文件将移入管理后台";
var txt14$m = "退出团队后，你将无法再访问团队";
var txt15$j = "暂无可选成员";
var txt16$j = "仅团队创建者可关闭文档加密保护";
var txt17$i = "团队空间";
var txt18$i = "转让团队后，你将转变为团队成员";
var txt19$h = "文档对外分享范围";
var txt20$g = "可以禁止团队文件分享到企业外/团队外";
var txt21$d = "不限制";
var txt22$b = "仅允许分享给本企业成员";
var txt23$a = "仅允许分享给团队成员";
var txt24$8 = "修改成功";
var txt25$7 = "文档水印";
var txt26$7 = "企业管理员已开启文档显示水印，不支持关闭";
var txt27$7 = "开启后，团队文档查看时会显示水印，水印显示为:";
var txt28$7 = "限免3个团队/企业";
var txt29$4 = "购买企业套餐";
var txt30$3 = "您企业采购的功能服务已超出支持的最大数量，请您联系";
var txt31$3 = "WPS项目经理";
var txt32$3 = "超级管理员";
var txt33$2 = "进行授权升级处理";
var txt34$2 = "升级套餐";
var txt35$2 = "开启团队水印";
var txt36$2 = "设置文档对外分享范围";
var txt37$2 = "开启文档加密保护";
var txt38$2 = "网络异常";
var txt39$2 = "已分享文件管理";
var txt40$2 = "进入";
var txt41$2 = "可以集中管理团队中的已分享文件";
var txt42$2 = "限免查看最近一个月的分享文件";
var txt43$2 = "管理和分配已采购的会员";
var txt44$2 = "分配会员";
var txt45$2 = "企业管理员已禁止分享到企业外";
var txt46$2 = "仅允许分享给本企业及关联组织成员";
var filePermissionForNonEnt = "企业外成员默认文件权限";
var txt47$2 = "自定义";
var txt48$2 = "可以自定义查看,下载,编辑等权限";
var txt49$2 = "定义企业外成员加入团队后，默认获得的文件权限";
var txt50$2 = "当前团队已禁止企业外人员加入文档协作";
var base_info = "基本信息";
var team_safety = "团队安全";
var water_mark_var1 = "企业名";
var water_mark_var2 = "部门名";
var water_mark_var3 = "成员姓名";
var water_mark_var4 = "WPS账号id尾号";
var water_mark_var5 = "手机尾号";
var water_mark_var6 = "IP地址";
var water_mark_var7 = "自定义内容";
var water_mark_var8 = "成员账号";
var water_mark_var9 = "（企业管理员可在后台设定）";
var water_mark_var10 = "文档打开时间";
var water_mark_var11 = "邮箱";
var water_mark_var12 = "工号";
var delete_group_tips = "解散后，该团队的所有内容将被移动到回收站";
var teamMenu = "团队设置";
var docsMenu = "文档设置";
var teamDocTemplate = "团队文档模板";
var tabTeamAI = "AI服务";
var teamApp_errorPage_tips = "页面加载失败，请重新尝试";
var teamApp_errorPage_reload = "重新加载";
var teamApp_moduleNotExist_tips = "页面加载失败，应用不存在";
var no_permission_txt1 = "仅拥有者可用";
var no_permission_txt2 = "仅拥有者与管理员可用";
var success_txt = "修改成功";
var decryption_incomplete_txt = "此团队有文档解密任务未完成，请稍后重试";
var encryption_incomplete_txt = "此团队有文档加密任务未完成，请稍后重试";
var introTip = "点击查看功能介绍";
var secure_desc_owner = "开启后，团队600M 以下的 Office 格式文档自动加密，仅团队成员可访问。（企业管理员设置了团队自动开启文档加密保护）";
var secure_desc_user = "开启后，团队600M 以下的 Office 格式文档自动加密，仅团队成员可访问。";
var creator_can_manage = "允许文件创建者管理自己创建的文件";
var creator_can_manage_tips = "开启后，文件的创建者可以删除、移动和管理文件的权限（不包括文件夹）";
var shareRange_status_reclaiming = "正在回收权限，回收完成之前，已授权的用户仍能访问文件";
var shareRange_status_done = "权限回收已完成";
var shareRange_selectButton_title = "提示";
var shareRange_selectButton_content = "权限回收任务未完成，无法变更文档分享范围";
var no_transfer_to_nonEntMember = "不支持将团队转让给企业外人员";
var set_success = "设置成功";
var set_failed = "设置失败";
var forbid_FileSecure_CoopGroup = "暂不支持非本企业成员加入团队后开启文档加密保护";
var companyJustAssoc = "仅允许分享给本企业及关联组织成员";
var companyJustOutContact = "仅允许分享给本企业及外部联系人";
var companyJustAssocAndOutContact = "仅允许分享给本企业、关联组织及外部联系人";
var groupChat = "群聊";
var teamAI = {
	switchLabel: "团队文档智能问答",
	switchDesc: "团队成员可通过对话形式获取团队内的文档信息。",
	processingTitle: "数据处理中...{percentage}%",
	processingDesc: "后台正在处理数据，当前团队文件数较多，大约需要几小时",
	errorTips: "操作失败",
	inforIconContent: "目前支持的格式有：doc/docx、xls/xlsx、ppt/pptx、pdf、txt、智能文档",
	processingBtnDesc: "AI 正在后台解析文档，执行其他操作不影响解析过程...",
	processingBtnDesc1: "正在重新解析{N}篇文档，执行其他操作不影响解析过程",
	closeBtnText: "关闭问答",
	openBtnText: "已开启",
	processingBtnText: "开启中",
	openNow: "立即开启",
	closeDialog: {
		title: "关闭智能问答?",
		content: "关闭后，将无法以对话形式获取团队内的文档信息，且下次开启该功能时需重新对团队文档进行解析。",
		confirmBtn: "关闭智能问答",
		cancelBtn: "取消"
	},
	forbidTips: {
		indexGroup: "全员团队暂不支持开启智能问答",
		secureGroup: "加密团队暂不支持开启智能问答",
		noPermission: "仅管理员可用，请联系团队管理员（{name}）操作"
	}
};
var publishWikiMenu = "知识视图设置";
var publishWikiDialog = {
	title: "为团队文档开启知识视图",
	subtitle: "开启后，可通过目录树的形式更清晰地组织团队内的文档，提高文档阅读效率",
	scopeOption: "可见范围",
	closeWikiTxt: "需关闭视图后才能重新修改发布范围",
	managerCloseGroupWikiTxt: "企业管理员已限制团队文档开启知识视图",
	secureGroupUnSupportWiki: "加密团队不支持企业公开",
	reviewingEntGroupWikiTooltip: "企业管理员审批中，审批通过后可见范围自动变为「企业内公开」",
	inTeamScopeReviewingEntGroupWikiTooltip: "当前可见范围为「团队成员可见」，企业管理员审批通过后自动变为「企业内公开」",
	scopeItem1Txt1: "团队成员可见",
	scopeItem1Txt2: "免审批，跟随本团队权限",
	scopeItem2Txt1: "企业内公开",
	scopeItem2Txt2: "需企业管理员审批，非本团队成员仅查看",
	coverOption: "封面",
	descOption: "简介",
	descPlaceholder: "简单描述知识的内容、相关领域等信息",
	reviewResultNotice: "审核结果将以消息方式通知",
	cancelReview: "取消审批",
	closeWiki: "关闭知识视图",
	saveUpdate: "保存修改",
	reviewing: "审批中",
	confirmOpen: "立即开启",
	openSuccess: "开启成功",
	updateSuccess: "修改成功",
	applyReviewSuccess: "申请已发送，审批结果将由「消息」通知",
	closeWikiSuccess: "已关闭知识视图",
	closeWikiFail: "关闭知识视图失败，请稍后重试",
	recallApplyReviewSuccess: "已撤回审批申请",
	enterGroupWiki: "进入知识视图"
};
var publishWikiCover = {
	locationUpload: "本地上传",
	uploadFail: "上传失败",
	customCover: "自定义封面",
	uploaLargerError: "目前暂不支持超过5M的图片上传",
	uploadMaxLarger: "图片最大为5M",
	uploadFileTypeError: "文件格式不对，仅支持jpg、jpeg、png格式",
	uploadImg: "上传图片",
	suggestUploadSize: "建议尺寸为508*320px，仅支持 JPG / JPEG / PNG 格式",
	cancelTxt: "取消",
	confirmTxt: "确定"
};
var unPublishWikiDialog = {
	title1: "关闭知识视图？",
	title2: "关闭知识视图？",
	txt1: "关闭后，该团队文档将不再支持目录树视图",
	txt2: "企业管理员正在审批你的「企业内公开」申请，关闭知识视图会撤回申请信息",
	cancelBtn: "再想想",
	confirmBtn1: "关闭知识视图",
	confirmBtn2: "关闭知识视图"
};
var pulishWikiReasonDialog = {
	title: "申请开启",
	placeholderTxt: "向企业管理员简要说明设置为企业公开的理由",
	cancelBtn: "取消",
	confirmBtn: "发送申请"
};
var publishWikiAlertDialog = {
	title: "修改可见范围？",
	content: "企业管理员正在审批你的「企业内公开」申请，修改可见范围将撤回申请",
	cancelBtn: "再想想",
	confirmBtn: "修改"
};
var TeamSettings = {
	txt0: txt0$1e,
	txt0_beemwork: txt0_beemwork,
	txt1: txt1$15,
	txt2: txt2$10,
	txt3: txt3$Y,
	txt4: txt4$S,
	txt5: txt5$M,
	txt6: txt6$F,
	txt7: txt7$y,
	txt8: txt8$w,
	txt9: txt9$s,
	txt10: txt10$r,
	txt10_beemwork: txt10_beemwork$1,
	txt11: txt11$o,
	txt11_beemwork: txt11_beemwork,
	txt12: txt12$o,
	txt13: txt13$o,
	txt14: txt14$m,
	txt15: txt15$j,
	txt16: txt16$j,
	txt17: txt17$i,
	txt18: txt18$i,
	txt19: txt19$h,
	txt20: txt20$g,
	txt21: txt21$d,
	txt22: txt22$b,
	txt23: txt23$a,
	txt24: txt24$8,
	txt25: txt25$7,
	txt26: txt26$7,
	txt27: txt27$7,
	txt28: txt28$7,
	txt29: txt29$4,
	txt30: txt30$3,
	txt31: txt31$3,
	txt32: txt32$3,
	txt33: txt33$2,
	txt34: txt34$2,
	txt35: txt35$2,
	txt36: txt36$2,
	txt37: txt37$2,
	txt38: txt38$2,
	txt39: txt39$2,
	txt40: txt40$2,
	txt41: txt41$2,
	txt42: txt42$2,
	txt43: txt43$2,
	txt44: txt44$2,
	txt45: txt45$2,
	txt46: txt46$2,
	filePermissionForNonEnt: filePermissionForNonEnt,
	txt47: txt47$2,
	txt48: txt48$2,
	txt49: txt49$2,
	txt50: txt50$2,
	base_info: base_info,
	team_safety: team_safety,
	water_mark_var1: water_mark_var1,
	water_mark_var2: water_mark_var2,
	water_mark_var3: water_mark_var3,
	water_mark_var4: water_mark_var4,
	water_mark_var5: water_mark_var5,
	water_mark_var6: water_mark_var6,
	water_mark_var7: water_mark_var7,
	water_mark_var8: water_mark_var8,
	water_mark_var9: water_mark_var9,
	water_mark_var10: water_mark_var10,
	water_mark_var11: water_mark_var11,
	water_mark_var12: water_mark_var12,
	delete_group_tips: delete_group_tips,
	teamMenu: teamMenu,
	docsMenu: docsMenu,
	teamDocTemplate: teamDocTemplate,
	tabTeamAI: tabTeamAI,
	teamApp_errorPage_tips: teamApp_errorPage_tips,
	teamApp_errorPage_reload: teamApp_errorPage_reload,
	teamApp_moduleNotExist_tips: teamApp_moduleNotExist_tips,
	no_permission_txt1: no_permission_txt1,
	no_permission_txt2: no_permission_txt2,
	success_txt: success_txt,
	decryption_incomplete_txt: decryption_incomplete_txt,
	encryption_incomplete_txt: encryption_incomplete_txt,
	introTip: introTip,
	secure_desc_owner: secure_desc_owner,
	secure_desc_user: secure_desc_user,
	creator_can_manage: creator_can_manage,
	creator_can_manage_tips: creator_can_manage_tips,
	shareRange_status_reclaiming: shareRange_status_reclaiming,
	shareRange_status_done: shareRange_status_done,
	shareRange_selectButton_title: shareRange_selectButton_title,
	shareRange_selectButton_content: shareRange_selectButton_content,
	no_transfer_to_nonEntMember: no_transfer_to_nonEntMember,
	set_success: set_success,
	set_failed: set_failed,
	forbid_FileSecure_CoopGroup: forbid_FileSecure_CoopGroup,
	companyJustAssoc: companyJustAssoc,
	companyJustOutContact: companyJustOutContact,
	companyJustAssocAndOutContact: companyJustAssocAndOutContact,
	groupChat: groupChat,
	teamAI: teamAI,
	publishWikiMenu: publishWikiMenu,
	publishWikiDialog: publishWikiDialog,
	publishWikiCover: publishWikiCover,
	unPublishWikiDialog: unPublishWikiDialog,
	pulishWikiReasonDialog: pulishWikiReasonDialog,
	publishWikiAlertDialog: publishWikiAlertDialog
};

var openSuccess = "已开启应用";
var closeSuccess = "已关闭应用";
var check = "查看";
var openFail = "开启失败，请重试";
var closeFail = "关闭失败，请重试";
var openedApp = "已开启应用";
var allApp = "全部应用";
var open = "开启";
var close$1 = "关闭";
var setting$1 = "设置";
var permissionsOpenTips = "仅拥有者与管理员有权限开启";
var permissionsRenameTips = "仅拥有者与管理员有权限重命名";
var permissionsCloseTips = "仅拥有者与管理员有权限关闭";
var permissionsCloseDocsTips = "文档应用暂不支持关闭";
var createApp = "新建应用";
var createAppDesc = "更贴合业务的管理应用";
var permissionsCreateTips = "仅拥有者与管理员有权限构建";
var TeamAppManage = {
	openSuccess: openSuccess,
	closeSuccess: closeSuccess,
	check: check,
	openFail: openFail,
	closeFail: closeFail,
	openedApp: openedApp,
	allApp: allApp,
	open: open,
	close: close$1,
	setting: setting$1,
	permissionsOpenTips: permissionsOpenTips,
	permissionsRenameTips: permissionsRenameTips,
	permissionsCloseTips: permissionsCloseTips,
	permissionsCloseDocsTips: permissionsCloseDocsTips,
	createApp: createApp,
	createAppDesc: createAppDesc,
	permissionsCreateTips: permissionsCreateTips
};

var txt0$1d = "请确认将文件夹";
var txt1$14 = "转让给";
var txt2$$ = "转让后，你将成为文件夹的编辑权限成员";
var txt3$X = "你可以在";
var txt4$R = "我收到的";
var txt5$L = "中找到文件夹";
var txt6$E = "取消";
var txt7$x = "确定";
var preview_MoreMenus_transferfile_aftertransfer2 = "转让后，";
var preview_MoreMenus_transferfile_aftertransfer3 = "将收到消息通知";
var preview_MoreMenus_transferfile_other = "对方";
var preview_MoreMenus_transferfile_choseowner = "选择联系人";
var preview_MoreMenus_Tem_NetWork_Error = "网络异常，请稍后再试";
var TransferConfirm = {
	txt0: txt0$1d,
	txt1: txt1$14,
	txt2: txt2$$,
	txt3: txt3$X,
	txt4: txt4$R,
	txt5: txt5$L,
	txt6: txt6$E,
	txt7: txt7$x,
	preview_MoreMenus_transferfile_aftertransfer2: preview_MoreMenus_transferfile_aftertransfer2,
	preview_MoreMenus_transferfile_aftertransfer3: preview_MoreMenus_transferfile_aftertransfer3,
	preview_MoreMenus_transferfile_other: preview_MoreMenus_transferfile_other,
	preview_MoreMenus_transferfile_choseowner: preview_MoreMenus_transferfile_choseowner,
	preview_MoreMenus_Tem_NetWork_Error: preview_MoreMenus_Tem_NetWork_Error
};

var txt0$1c = "暂无可选成员";
var txt1$13 = "请选择新的拥有者";
var TransferMembers = {
	txt0: txt0$1c,
	txt1: txt1$13
};

var txt0$1b = "绑定手机后可转让共享文件夹，并提高账号安全性";
var txt1$12 = "取消";
var txt2$_ = "确定";
var TransferTips = {
	txt0: txt0$1b,
	txt1: txt1$12,
	txt2: txt2$_
};

var txt0$1a = "分别发送给:";
var txt1$11 = "等";
var txt2$Z = "人";
var txt3$W = "给联系人留言";
var txt4$Q = "取消";
var txt5$K = "发送";
var txt6$D = "请输入100字以内留言";
var ContactLeaveMessage = {
	txt0: txt0$1a,
	txt1: txt1$11,
	txt2: txt2$Z,
	txt3: txt3$W,
	txt4: txt4$Q,
	txt5: txt5$K,
	txt6: txt6$D
};

var helper = "我是小助手";
var message$1 = "消息";
var usageHelp = "使用帮助";
var helpAndAdvise = "帮助与反馈";
var moreSkill = "更多技巧";
var bilibili = "视频教程";
var bilibiliTips = "进入金山文档bilibili官方账号，学习使用技巧";
var advise = "意见反馈";
var cancelSuspend = "取消悬浮";
var fixSuspend = "固定悬浮";
var corpHelper = "企业助手";
var title$n = "小助手";
var wpsDocumentEmbedTitle = "企业小助手";
var emptyTitle = "找不到想要的，试试这样搜";
var filter$1 = "筛选";
var cellPicture = "单元格图片";
var sort = "排序";
var freezeFirstLine = "冻结首行";
var moreUserHelp = "更多使用帮助 >";
var expend = "开启全文评论";
var noExpend = "关闭全文评论";
var position = "定位到全文评论";
var showComment1 = "开启全文评论，交流想法更流畅";
var showComment2 = "发表全文评论，交流想法更流畅";
var openComment = "开启后，加入分享的人可查看、发表全文评论";
var closeTitle = "关闭全文评论";
var closeText = "关闭后，他人将无法发表及查看全文评论";
var cancel$5 = "取消";
var submit$2 = "确定";
var fold = "收起全文评论";
var unfold = "展开全文评论";
var springVersionUpdateDetail = "新视觉更新详情";
var webSpringBubble = "协作模式新视觉全面升级，";
var wpsWebSpringBubble = "金山文档新视觉全面升级，";
var springBubbleKnowMore = "了解详情";
var versionUpdateLog = "版本更新说明";
var shortcutKey = "快捷键";
var shortcutWarn = "数据表/应用中不支持「快捷键面板」";
var functionIntro = "功能介绍";
var recommendQs = "问智能客服";
var searchWant = "搜索想要的功能";
var FloatBox = {
	helper: helper,
	message: message$1,
	usageHelp: usageHelp,
	helpAndAdvise: helpAndAdvise,
	moreSkill: moreSkill,
	bilibili: bilibili,
	bilibiliTips: bilibiliTips,
	advise: advise,
	cancelSuspend: cancelSuspend,
	fixSuspend: fixSuspend,
	corpHelper: corpHelper,
	title: title$n,
	wpsDocumentEmbedTitle: wpsDocumentEmbedTitle,
	emptyTitle: emptyTitle,
	filter: filter$1,
	cellPicture: cellPicture,
	sort: sort,
	freezeFirstLine: freezeFirstLine,
	moreUserHelp: moreUserHelp,
	expend: expend,
	noExpend: noExpend,
	position: position,
	showComment1: showComment1,
	showComment2: showComment2,
	openComment: openComment,
	closeTitle: closeTitle,
	closeText: closeText,
	cancel: cancel$5,
	submit: submit$2,
	fold: fold,
	unfold: unfold,
	springVersionUpdateDetail: springVersionUpdateDetail,
	webSpringBubble: webSpringBubble,
	wpsWebSpringBubble: wpsWebSpringBubble,
	springBubbleKnowMore: springBubbleKnowMore,
	versionUpdateLog: versionUpdateLog,
	shortcutKey: shortcutKey,
	shortcutWarn: shortcutWarn,
	functionIntro: functionIntro,
	recommendQs: recommendQs,
	searchWant: searchWant
};

var txt0$19 = "加载超时";
var txt1$10 = "请确认是否允许第三方cookies";
var txt2$Y = "重试";
var txt3$V = "加载失败";
var txt4$P = "前往完整应用";
var txt5$J = "关闭应用";
var AppsSidebar = {
	txt0: txt0$19,
	txt1: txt1$10,
	txt2: txt2$Y,
	txt3: txt3$V,
	txt4: txt4$P,
	txt5: txt5$J
};

var inviteAdd$1 = "使用链接添加";
var inviteRoad = "邀请QQ、微信等好友";
var copyLink$2 = "复制链接";
var memberSelect = "选择成员";
var deleteContact = "删除联系人";
var inviteSucceedMessage = "邀请发送成功";
var deleteContactMessage = "删除成功";
var MContactSelector = {
	inviteAdd: inviteAdd$1,
	inviteRoad: inviteRoad,
	copyLink: copyLink$2,
	memberSelect: memberSelect,
	deleteContact: deleteContact,
	inviteSucceedMessage: inviteSucceedMessage,
	deleteContactMessage: deleteContactMessage
};

var txt0$18 = "搜索";
var txt1$$ = "搜索结果";
var txt2$X = "目录为空";
var txt3$U = "没有更多文档";
var txt4$O = "确定";
var txt5$I = "你的权限已被作者收回";
var txt6$C = "你没有该文件的操作权限";
var txt7$w = "我的设备";
var txt8$v = "请先完成实名认证";
var txt9$r = "私密文件夹";
var txt10$q = "最近";
var txt11$n = "星标";
var txt12$n = "我的文档";
var txt13$n = "我收到的";
var AppFinder = {
	txt0: txt0$18,
	txt1: txt1$$,
	txt2: txt2$X,
	txt3: txt3$U,
	txt4: txt4$O,
	txt5: txt5$I,
	txt6: txt6$C,
	txt7: txt7$w,
	txt8: txt8$v,
	txt9: txt9$r,
	txt10: txt10$q,
	txt11: txt11$n,
	txt12: txt12$n,
	txt13: txt13$n
};

var txt0$17 = "请输入文件夹密码";
var txt1$_ = "请输入密码";
var txt2$W = "请填写密码";
var txt3$T = "密码不正确";
var txt4$N = "忘记密码";
var txt5$H = "取消";
var txt6$B = "确定";
var txt7$v = "密码不正确，你今天还可以尝试";
var txt8$u = "次";
var txt9$q = "密码输入错误达到上限，请明天再试";
var UnLockSecretFolder = {
	txt0: txt0$17,
	txt1: txt1$_,
	txt2: txt2$W,
	txt3: txt3$T,
	txt4: txt4$N,
	txt5: txt5$H,
	txt6: txt6$B,
	txt7: txt7$v,
	txt8: txt8$u,
	txt9: txt9$q
};

var txt0$16 = "已选";
var txt1$Z = "项";
var txt2$V = "另存至";
var txt3$S = "解锁私密文件夹";
var txt4$M = "另存";
var txt5$G = "成功";
var txt6$A = "失败";
var txt7$u = "设备目录暂不支持批量";
var txt8$t = "正在另存文件，请稍后";
var txt9$p = "查看";
var txt10$p = "不支持另存至子文件夹，请重新选择";
var txt11$m = "文件已禁止下载/另存";
var txt12$m = "等待下载/另存中，请稍后重试";
var txt13$m = "你没有该文件的另存权限";
var FilesSaveAs = {
	txt0: txt0$16,
	txt1: txt1$Z,
	txt2: txt2$V,
	txt3: txt3$S,
	txt4: txt4$M,
	txt5: txt5$G,
	txt6: txt6$A,
	txt7: txt7$u,
	txt8: txt8$t,
	txt9: txt9$p,
	txt10: txt10$p,
	txt11: txt11$m,
	txt12: txt12$m,
	txt13: txt13$m
};

var txt0$15 = "企业团队空间容量已满，请调整团队空间设置";
var txt1$Y = "企业团队空间容量已满，请通知超级管理员";
var txt2$U = "调整空间";
var txt3$R = "我的企业文档空间容量已满，请调整空间设置";
var txt4$L = "我的企业文档空间容量已满，请通知超级管理员";
var txt5$F = "取消";
var txt6$z = "管理后台";
var CorpTeamSpaceFull = {
	txt0: txt0$15,
	txt1: txt1$Y,
	txt2: txt2$U,
	txt3: txt3$R,
	txt4: txt4$L,
	txt5: txt5$F,
	txt6: txt6$z
};

var help = "更新后将在团队内原文件夹中添加最新的文件，且不会覆盖文件数据";
var success$3 = "团队更新成功";
var error$2 = {
	"40000105": "空间已满，团队更新失败",
	"40000201": "更新失败，请重新再次更新"
};
var GroupTemplateUpdateInfo = {
	help: help,
	success: success$3,
	error: error$2
};

var txt0$14 = "我知道了";
var TeamGuide = {
	txt0: txt0$14
};

var txt0$13 = "团队设置";
var txt1$X = "重命名";
var txt8$s = "转让团队";
var txt10$o = "团队成员";
var txt10_beemwork = "团队成员";
var txt11$l = "设置";
var txt13$l = "批量移除";
var txt16$i = "添加联系人";
var txt17$h = "添加联系人";
var txt18$h = "解散团队";
var txt19$g = "删除联系人";
var txt20$f = "取消共享";
var qrcode_dialog_title = "团队二维码";
var DialogTeamFolderSettings = {
	txt0: txt0$13,
	txt1: txt1$X,
	txt8: txt8$s,
	txt10: txt10$o,
	txt10_beemwork: txt10_beemwork,
	txt11: txt11$l,
	txt13: txt13$l,
	txt16: txt16$i,
	txt17: txt17$h,
	txt18: txt18$h,
	txt19: txt19$g,
	txt20: txt20$f,
	qrcode_dialog_title: qrcode_dialog_title
};

var txt0$12 = "团队名";
var txt1$W = "修改";
var txt2$T = "成员管理";
var txt3$Q = "名成员";
var txt4$K = "查看";
var txt10$n = "转让团队";
var txt12$l = "退出团队";
var txt14$l = "退出团队后，你将无法再访问团队";
var txt18$g = "转让团队后，你将转变为团队成员";
var txt19$f = "解散团队";
var txt20$e = "解散后，团队文件将转为仅你可见，其他成员无法访问";
var TeamFolderSettings = {
	txt0: txt0$12,
	txt1: txt1$W,
	txt2: txt2$T,
	txt3: txt3$Q,
	txt4: txt4$K,
	txt10: txt10$n,
	txt12: txt12$l,
	txt14: txt14$l,
	txt18: txt18$g,
	txt19: txt19$f,
	txt20: txt20$e
};

var txt0$11 = "取消";
var txt1$V = "退出企业";
var txt2$S = "重新检测";
var txt3$P = "退出企业条件检测中:";
var txt4$J = "符合退出企业条件：";
var txt5$E = "不符合退出企业条件：";
var txt6$y = "你不是团队的拥有者";
var txt7$t = "查看详情";
var txt8$r = "账号已绑定手机号码";
var txt9$o = "立即绑定";
var txt16$h = "你仍是团队的拥有者";
var txt17$g = "账号未绑定手机号码";
var txt10$m = "后，将产生以下影响：";
var txt11$k = "确定";
var txt12$k = "不可再访问企业团队，不可再查看企业文档";
var txt13$k = "因加入企业获得的会员权益将被回收";
var txt14$k = "退出操作无法撤回，重新加入企业需联系企业管理员";
var txt15$i = "你仍是以下团队的拥有者，请转让或解散团队后重新检测";
var txt18$f = "当前账号归属";
var txt19$e = "不支持主动退出企业";
var LeaveCompany = {
	txt0: txt0$11,
	txt1: txt1$V,
	txt2: txt2$S,
	txt3: txt3$P,
	txt4: txt4$J,
	txt5: txt5$E,
	txt6: txt6$y,
	txt7: txt7$t,
	txt8: txt8$r,
	txt9: txt9$o,
	txt16: txt16$h,
	txt17: txt17$g,
	txt10: txt10$m,
	txt11: txt11$k,
	txt12: txt12$k,
	txt13: txt13$k,
	txt14: txt14$k,
	txt15: txt15$i,
	txt18: txt18$f,
	txt19: txt19$e
};

var txt0$10 = "我们需要对你的手机号";
var txt1$U = "进行安全验证";
var txt2$R = "请输入验证码";
var txt3$O = "发送验证码";
var txt4$I = "重新获取";
var txt5$D = "取消";
var txt6$x = "确定";
var txt7$s = "请填写验证码";
var txt8$q = "退出企业成功";
var txt9$n = "短信验证码错误";
var LeaveCompanyPhoneCheck = {
	txt0: txt0$10,
	txt1: txt1$U,
	txt2: txt2$R,
	txt3: txt3$O,
	txt4: txt4$I,
	txt5: txt5$D,
	txt6: txt6$x,
	txt7: txt7$s,
	txt8: txt8$q,
	txt9: txt9$n
};

var txt0$$ = "文字水印";
var txt1$T = "适用于个人品牌曝光宣传";
var txt3$N = "访客水印";
var txt4$H = "适用于追溯访客截图分享文档内容";
var txt5$C = "效果预览";
var txt6$w = "透明度";
var txt7$r = "对自己隐藏水印";
var txt8$p = "取消";
var txt9$m = "确认";
var txt11$j = "点击输入文案，默认显示作者名称";
var txt12$j = "水印预览";
var txt13$j = "设置成功";
var txt14$j = "文字水印已开启";
var txt15$h = "文字水印已关闭";
var txt16$g = "访客水印已开启";
var txt17$f = "访客水印已关闭";
var txt18$e = "访客水印文案";
var txt19$d = "水印加载失败，请重新设置";
var txt20$d = "他人另存后，水印保留且不可更改";
var txt21$c = "水印由源创建者设置，另存后无法更改";
var txt22$a = "请先允许查看者另存";
var txt23$9 = "请先打开文字水印";
var WaterMarkSetting = {
	txt0: txt0$$,
	txt1: txt1$T,
	txt3: txt3$N,
	txt4: txt4$H,
	txt5: txt5$C,
	txt6: txt6$w,
	txt7: txt7$r,
	txt8: txt8$p,
	txt9: txt9$m,
	txt11: txt11$j,
	txt12: txt12$j,
	txt13: txt13$j,
	txt14: txt14$j,
	txt15: txt15$h,
	txt16: txt16$g,
	txt17: txt17$f,
	txt18: txt18$e,
	txt19: txt19$d,
	txt20: txt20$d,
	txt21: txt21$c,
	txt22: txt22$a,
	txt23: txt23$9
};

var label0 = "请输入收集标题";
var label1 = "设置对方需要提交的信息";
var label2 = "创建提交者文件夹";
var label3 = "设置收集截止时间";
var label4 = "接收到的文件将自动保存在：";
var placeholder = "如个人资料、xxx报名表等";
var desc$3 = "收到的文件将按照对方信息自动命名：{0}.doc";
var descEmpty = "未设置提交信息，收到的文件将按原名上传";
var button$1 = "开始收集";
var text0 = "开启后，将根据提交者填写的信息，创建对应文件夹并保存";
var text1$3 = "示例：姓名+手机";
var text2$2 = "默认收集长期有效";
var titleError = "请填写收集标题";
var error$1 = {
	"10001": "已有成员使用该文件夹发起收集"
};
var FileCollection = {
	label0: label0,
	label1: label1,
	label2: label2,
	label3: label3,
	label4: label4,
	placeholder: placeholder,
	desc: desc$3,
	descEmpty: descEmpty,
	button: button$1,
	text0: text0,
	text1: text1$3,
	text2: text2$2,
	titleError: titleError,
	error: error$1
};

var title$m = "文件夹「{0}」已创建";
var subTitle$1 = "复制并转发以下链接，开始收集文件";
var button = "复制链接";
var copySuccess$1 = "复制成功";
var copyError$1 = "复制失败";
var FileCollectionLink = {
	title: title$m,
	subTitle: subTitle$1,
	button: button,
	copySuccess: copySuccess$1,
	copyError: copyError$1
};

var dialog0 = {
	title: "文件收集",
	content0: "已发起文件收集，可前往「文件收集管理」进行查看",
	content1: "已使用该文件夹发起收集，请重新选择",
	button0: "取消",
	button1: "确认",
	button2: "前往文件收集管理"
};
var dialog1 = {
	title: "新建收集文件"
};
var dialog2 = {
	title: "邀请填写"
};
var DialogFileCollection = {
	dialog0: dialog0,
	dialog1: dialog1,
	dialog2: dialog2
};

var txt0$_ = "取消";
var txt1$S = "确认";
var txt2$Q = "确认禁止「企业外的人」访问该团队的文件？";
var txt3$M = "确认禁止「团队外的人」访问该团队的文件？";
var company = "本企业";
var group = "团队";
var companyAsso = "本企业及关联组织";
var tips = "团队可能存在已分享出去的文件，你希望如何处理：";
var recall = "回收权限，移除范围外用户的权限";
var retain = "保留权限，不处理已分享出去的文件";
var retainDesc = "(如需按文件回收权限，可到<span class=\"link\">【已分享文件管理】</span>手动回收)";
var ShareRangeTips = {
	txt0: txt0$_,
	txt1: txt1$S,
	txt2: txt2$Q,
	txt3: txt3$M,
	company: company,
	group: group,
	companyAsso: companyAsso,
	tips: tips,
	recall: recall,
	retain: retain,
	retainDesc: retainDesc
};

var txt0$Z = "团队创建用途";
var txt1$R = "企业管理员开启了创建团队需审批";
var txt2$P = "请简述团队用途，以便审批人审核（50字内）";
var txt3$L = "审批人";
var txt4$G = "多名审批人时，其中一名审批人同意即可创建团队成功";
var txt5$B = "取消";
var txt6$v = "确定";
var GroupApply = {
	txt0: txt0$Z,
	txt1: txt1$R,
	txt2: txt2$P,
	txt3: txt3$L,
	txt4: txt4$G,
	txt5: txt5$B,
	txt6: txt6$v
};

var txt0$Y = "申请中的团队";
var txt1$Q = "暂无申请中的团队";
var txt2$O = "团队名称";
var txt3$K = "申请时间";
var txt4$F = "状态";
var txt5$A = "审批人";
var txt6$u = "操作";
var txt7$q = "撤销";
var txt8$o = "详情";
var txt9$l = "删除";
var txt10$l = "操作成功";
var txt11$i = "删除失败";
var txt12$i = "申请不通过详情";
var txt13$i = "团队用途";
var txt14$i = "团队成员";
var txt15$g = "已邀请";
var txt16$f = "审批意见";
var txt17$e = "审批时间";
var txt18$d = "确定";
var txt19$c = "撤销申请记录";
var txt20$c = "的申请记录";
var txt21$b = "取消";
var txt22$9 = "确定撤销";
var txt23$8 = "待审批";
var txt24$7 = "已通过";
var txt25$6 = "不通过";
var txt26$6 = "删除";
var txt27$6 = "已处理";
var txt28$6 = "团队名";
var GroupApplyList = {
	txt0: txt0$Y,
	txt1: txt1$Q,
	txt2: txt2$O,
	txt3: txt3$K,
	txt4: txt4$F,
	txt5: txt5$A,
	txt6: txt6$u,
	txt7: txt7$q,
	txt8: txt8$o,
	txt9: txt9$l,
	txt10: txt10$l,
	txt11: txt11$i,
	txt12: txt12$i,
	txt13: txt13$i,
	txt14: txt14$i,
	txt15: txt15$g,
	txt16: txt16$f,
	txt17: txt17$e,
	txt18: txt18$d,
	txt19: txt19$c,
	txt20: txt20$c,
	txt21: txt21$b,
	txt22: txt22$9,
	txt23: txt23$8,
	txt24: txt24$7,
	txt25: txt25$6,
	txt26: txt26$6,
	txt27: txt27$6,
	txt28: txt28$6
};

var txt0$X = "你的申请待审核";
var txt1$P = "可复制链接发给审批人审批";
var txt2$N = "复制审批链接";
var txt3$J = "查看申请中的团队";
var txt4$E = "复制成功";
var txt5$z = "复制失败";
var GroupApplySuccess = {
	txt0: txt0$X,
	txt1: txt1$P,
	txt2: txt2$N,
	txt3: txt3$J,
	txt4: txt4$E,
	txt5: txt5$z
};

var txt0$W = "新建团队申请";
var DialogUpToCorpTeam = {
	txt0: txt0$W
};

var txt0$V = "新建团队申请";
var DialogGroupApply = {
	txt0: txt0$V
};

var txt0$U = "输入成员名称，添加授权";
var txt1$O = "以下成员未加入团队，需添加为团队成员再授权";
var txt2$M = "从成员列表中选择";
var txt3$I = "拥有文档的所有操作权限";
var txt4$D = "添加并授权";
var txt5$y = "添加";
var txt6$t = "自定义";
var txt7$p = "可自定义更多团队级别的权限";
var txt8$n = "移除";
var txt9$k = "权限名称";
var txt10$k = "删除权限";
var txt11$h = "团队文件权限定义";
var txt13$h = "子文件(夹)修改确认";
var txt14$h = "{icon} 该文件(夹)已开启链接分享，点击 [ {share} ] 可修改";
var txt15$f = "可分享给团队外的人";
var txt16$e = "自定义组名称";
var txt17$d = "删除分组";
var txt18$c = "自定义组管理";
var txt19$b = "该文件(夹)已开启对外分享，点击";
var txt20$b = "可查看分享权限";
var txt21$a = "查看";
var txt22$8 = "下载";
var txt23$7 = "上传";
var txt24$6 = "编辑";
var txt25$5 = "分享";
var txt26$5 = "评论";
var txt27$5 = "删除";
var txt28$5 = "团队拥有者";
var txt29$3 = "团队管理员";
var txt30$2 = "设置成功，已同步更新该文件夹下所有文件(夹)的权限";
var txt31$2 = "子文件(夹)修改确认";
var txt32$2 = "添加用户权限成功";
var txt33$1 = "添加到团队成功";
var txt34$1 = "设置成功";
var txt35$1 = "重置为默认权限";
var txt36$1 = "拥有文件(夹)所有权限";
var txt37$1 = "团队文件权限将更新为以下权限，请确认是否重置？";
var txt38$1 = "文件(夹)权限和父文件夹权限保持同步，更新为以下权限，请确认是否重置？";
var txt39$1 = "无默认授权数据";
var txt40$1 = "重置";
var txt41$1 = "取消";
var txt42$1 = "授权列表";
var txt43$1 = "重置成功";
var txt44$1 = "仅查看";
var txt45$1 = "可查看";
var txt46$1 = "可编辑";
var txt47$1 = "权限设置";
var txt48$1 = "没有权限，请联系管理员";
var txt49$1 = "不能修改/移除自己的权限";
var txt50$1 = "复制内容";
var txt51 = "打印";
var txt52 = "拥有文件(夹)所有权限";
var txt53 = "下载/另存";
var txt54 = "可以修改文件(夹)权限";
var customizeGroupShareTip = "{icon} 自定义组名称 [ {share} ] 删除分组";
var entJoinByLinkDialogTitle = "通过链接加入的人";
var countOfJoined$1 = "已有 {0} 人加入";
var searchContacts = "输入用户名、群组或部门";
var contacts = "通讯录";
var teamOwner = "团队拥有者";
var admin = "管理员";
var fileCreator = "文件创建者";
var teamWhichOwnsFile = "文档所属团队";
var assignPermissionDirectly = "直接指定添加";
var shareContentForExtendedPermission = "父目录已开启链接分享，权限为 [ {permission} ]";
var anyonePermission = "任何人{0}";
var memberPermission = "本企业成员{0}";
var onlyAssignedPermission = "仅指定人{0}";
var checkoutDetail = "查看已加入的人";
var manageable$1 = "可管理";
var membersUnauthorized = "企业管理员已禁止分享到企业外，以下 {0} 人无法添加：";
var addPersonError = "{0}, 以下 {1} 人无法添加：";
var gotIt = "我知道了";
var assignPermission$1 = "指定授权";
var unassigned = "未设置";
var etc = "等";
var addOutsideTip = "请先把用户添加到团队内";
var canNotShareToOutside = "暂不支持添加团队外成员或群组";
var addFail = "添加失败";
var hasSelect = "已选择";
var batchOperation = "批量操作";
var batchDel = "批量移除";
var setting = "设为 ";
var sharePeopleGroup = "分享给用户和群组";
var batchSelectMax = "单次最多选择或排除{0}人";
var myGroup = "群聊";
var uniquePerm = "当前文件独有权限";
var requestShareOutside = "申请外发";
var DialogEnterFilePerSetting = {
	txt0: txt0$U,
	txt1: txt1$O,
	txt2: txt2$M,
	txt3: txt3$I,
	txt4: txt4$D,
	txt5: txt5$y,
	txt6: txt6$t,
	txt7: txt7$p,
	txt8: txt8$n,
	txt9: txt9$k,
	txt10: txt10$k,
	txt11: txt11$h,
	txt13: txt13$h,
	txt14: txt14$h,
	txt15: txt15$f,
	txt16: txt16$e,
	txt17: txt17$d,
	txt18: txt18$c,
	txt19: txt19$b,
	txt20: txt20$b,
	txt21: txt21$a,
	txt22: txt22$8,
	txt23: txt23$7,
	txt24: txt24$6,
	txt25: txt25$5,
	txt26: txt26$5,
	txt27: txt27$5,
	txt28: txt28$5,
	txt29: txt29$3,
	txt30: txt30$2,
	txt31: txt31$2,
	txt32: txt32$2,
	txt33: txt33$1,
	txt34: txt34$1,
	txt35: txt35$1,
	txt36: txt36$1,
	txt37: txt37$1,
	txt38: txt38$1,
	txt39: txt39$1,
	txt40: txt40$1,
	txt41: txt41$1,
	txt42: txt42$1,
	txt43: txt43$1,
	txt44: txt44$1,
	txt45: txt45$1,
	txt46: txt46$1,
	txt47: txt47$1,
	txt48: txt48$1,
	txt49: txt49$1,
	txt50: txt50$1,
	txt51: txt51,
	txt52: txt52,
	txt53: txt53,
	txt54: txt54,
	customizeGroupShareTip: customizeGroupShareTip,
	entJoinByLinkDialogTitle: entJoinByLinkDialogTitle,
	countOfJoined: countOfJoined$1,
	searchContacts: searchContacts,
	contacts: contacts,
	teamOwner: teamOwner,
	admin: admin,
	fileCreator: fileCreator,
	teamWhichOwnsFile: teamWhichOwnsFile,
	assignPermissionDirectly: assignPermissionDirectly,
	shareContentForExtendedPermission: shareContentForExtendedPermission,
	anyonePermission: anyonePermission,
	memberPermission: memberPermission,
	onlyAssignedPermission: onlyAssignedPermission,
	checkoutDetail: checkoutDetail,
	manageable: manageable$1,
	membersUnauthorized: membersUnauthorized,
	addPersonError: addPersonError,
	gotIt: gotIt,
	assignPermission: assignPermission$1,
	unassigned: unassigned,
	etc: etc,
	addOutsideTip: addOutsideTip,
	canNotShareToOutside: canNotShareToOutside,
	addFail: addFail,
	hasSelect: hasSelect,
	batchOperation: batchOperation,
	batchDel: batchDel,
	setting: setting,
	sharePeopleGroup: sharePeopleGroup,
	batchSelectMax: batchSelectMax,
	myGroup: myGroup,
	uniquePerm: uniquePerm,
	requestShareOutside: requestShareOutside
};

var txt0$T = "权限名称";
var txt1$N = "查看";
var txt2$L = "下载/另存";
var txt3$H = "上传";
var txt4$C = "评论";
var txt5$x = "新建/上传/重命名";
var txt6$s = "分享";
var txt7$o = "移动/删除";
var txt8$m = "添加权限";
var txt9$j = "取消";
var txt10$j = "确定";
var txt11$g = "删除成功";
var txt12$h = "创建权限名成功";
var txt13$g = "最多只能自定义";
var txt14$g = "个权限组合";
var txt15$e = "修改成功";
var txt16$d = "仅查看";
var txt17$c = "可查看";
var txt18$b = "可编辑";
var txt19$a = "的操作权限还没有定义";
var txt20$a = "和";
var txt21$9 = "权限重复";
var txt22$7 = "权限设置";
var txt23$6 = "拥有该权限点，可以修改文件（夹）的权限";
var txt24$5 = "复制内容";
var txt25$4 = "打印";
var txt26$4 = "编辑";
var txt27$4 = "可评论";
var txt28$4 = "可管理";
var txt29$2 = "拥有该权限点，可以分享团队内文件（夹）";
var hasPerm = "拥有该权限点";
var shareGroupFile = "分享团队内文件（夹）";
var groupUser = "团队内用户";
var outGroupUser = "团队外用户";
var detail = "详情";
var CustomizeFilePerSetting = {
	txt0: txt0$T,
	txt1: txt1$N,
	txt2: txt2$L,
	txt3: txt3$H,
	txt4: txt4$C,
	txt5: txt5$x,
	txt6: txt6$s,
	txt7: txt7$o,
	txt8: txt8$m,
	txt9: txt9$j,
	txt10: txt10$j,
	txt11: txt11$g,
	txt12: txt12$h,
	txt13: txt13$g,
	txt14: txt14$g,
	txt15: txt15$e,
	txt16: txt16$d,
	txt17: txt17$c,
	txt18: txt18$b,
	txt19: txt19$a,
	txt20: txt20$a,
	txt21: txt21$9,
	txt22: txt22$7,
	txt23: txt23$6,
	txt24: txt24$5,
	txt25: txt25$4,
	txt26: txt26$4,
	txt27: txt27$4,
	txt28: txt28$4,
	txt29: txt29$2,
	hasPerm: hasPerm,
	shareGroupFile: shareGroupFile,
	groupUser: groupUser,
	outGroupUser: outGroupUser,
	detail: detail
};

var txt0$S = "团队文件权限定义";
var DialogCustomizeFilePerSetting = {
	txt0: txt0$S
};

var txt0$R = "权限名称";
var DialogCreateCustomizePermission = {
	txt0: txt0$R
};

var txt0$Q = "删除【";
var txt1$M = "取消";
var txt2$K = "确定";
var txt3$G = "操作成功";
var txt4$B = "操作失败";
var txt5$w = "你的操作权限不足";
var txt6$r = "】后，已经授予【";
var txt7$n = "】权限的成员替换成下面哪个权限？";
var txt8$l = "位成员";
var txt9$i = "移除";
var DeleteCustomizePermission = {
	txt0: txt0$Q,
	txt1: txt1$M,
	txt2: txt2$K,
	txt3: txt3$G,
	txt4: txt4$B,
	txt5: txt5$w,
	txt6: txt6$r,
	txt7: txt7$n,
	txt8: txt8$l,
	txt9: txt9$i
};

var txt0$P = "请输入权限名称，如仅编辑、可删除";
var txt1$L = "取消";
var txt2$J = "确定";
var txt3$F = "权限名称不能重名";
var txt4$A = "权限名称不能超过8个字符";
var txt5$v = "权限名称不能为空";
var noManage = "暂不支持该名称";
var CreateCustomizePermission = {
	txt0: txt0$P,
	txt1: txt1$L,
	txt2: txt2$J,
	txt3: txt3$F,
	txt4: txt4$A,
	txt5: txt5$v,
	noManage: noManage
};

var txt0$O = "请输入自定义组名称，如管理组";
var txt1$K = "取消";
var txt2$I = "确定";
var txt3$E = "组名称不能重名";
var txt4$z = "组名称不能超过30个字符";
var txt5$u = "组名称不能为空";
var txt6$q = "你确定要删除";
var txt7$m = "删除后，文件权限会移除该组的授权";
var txt8$k = "删除";
var txt9$h = "新建自定义组";
var txt10$i = "重命名";
var txt11$f = "删除分组";
var txt12$g = "成员列表";
var txt13$f = "添加成员";
var txt14$f = "暂无数据";
var txt15$d = "暂无成员";
var txt16$c = "自定义组名称";
var txt17$b = "自定义组重命名";
var txt18$a = "添加成功！";
var txt19$9 = "添加失败！";
var txt20$9 = "名字不能包含非法字符和特殊符号/:*?\"<>|%&";
var txt21$8 = "重命名成功！";
var txt22$6 = "重命名失败，自定义组数量超限";
var txt23$5 = "重命名失败！";
var txt24$4 = "创建成功！";
var txt25$3 = "创建失败，自定义组数量超限";
var txt26$3 = "创建失败！";
var txt27$3 = "删除成功";
var txt28$3 = "删除失败";
var validateErr = "单次添加成员不能超过50个";
var CustomizeGroup = {
	txt0: txt0$O,
	txt1: txt1$K,
	txt2: txt2$I,
	txt3: txt3$E,
	txt4: txt4$z,
	txt5: txt5$u,
	txt6: txt6$q,
	txt7: txt7$m,
	txt8: txt8$k,
	txt9: txt9$h,
	txt10: txt10$i,
	txt11: txt11$f,
	txt12: txt12$g,
	txt13: txt13$f,
	txt14: txt14$f,
	txt15: txt15$d,
	txt16: txt16$c,
	txt17: txt17$b,
	txt18: txt18$a,
	txt19: txt19$9,
	txt20: txt20$9,
	txt21: txt21$8,
	txt22: txt22$6,
	txt23: txt23$5,
	txt24: txt24$4,
	txt25: txt25$3,
	txt26: txt26$3,
	txt27: txt27$3,
	txt28: txt28$3,
	validateErr: validateErr
};

var txt0$N = "保存为企业模板";
var txt1$J = "重命名";
var txt2$H = "选择使用范围";
var txt3$D = "取消";
var txt4$y = "确定";
var txt5$t = "保存成功";
var txt6$p = "保存失败";
var txt7$l = "查看";
var txt8$j = "1. 仅可选择你是管理员的团队；";
var txt9$g = "2. 选定团队后，仅当前团队成员可使用该模板；";
var txt10$h = "所属企业";
var txt11$e = "已添加使用成员";
var txt12$f = "从通讯录选择";
var txt13$e = "删除";
var txt14$e = "仅我自己";
var txt15$c = "本企业所有人员";
var txt16$b = "选择指定人可使用";
var txt17$a = "共享成功";
var txt18$9 = "共享失败";
var CompanyTemplateSaving = {
	txt0: txt0$N,
	txt1: txt1$J,
	txt2: txt2$H,
	txt3: txt3$D,
	txt4: txt4$y,
	txt5: txt5$t,
	txt6: txt6$p,
	txt7: txt7$l,
	txt8: txt8$j,
	txt9: txt9$g,
	txt10: txt10$h,
	txt11: txt11$e,
	txt12: txt12$f,
	txt13: txt13$e,
	txt14: txt14$e,
	txt15: txt15$c,
	txt16: txt16$b,
	txt17: txt17$a,
	txt18: txt18$9
};

var txt0$M = "企业模板设置";
var txt1$I = "如何使用企业模板？";
var txt2$G = "本地上传";
var txt3$C = "更新";
var txt4$x = "重命名";
var txt5$s = "删除";
var txt6$o = "选择文件";
var txt7$k = "云文档上传";
var txt8$i = "上传工作模板后，可在「企业模板」中直接新建";
var txt9$f = "关闭面板将取消上传";
var txt10$g = "查看详情";
var txt11$d = "返回";
var txt12$e = "获取模板列表失败";
var txt13$d = "我的工作模板设置";
var txt14$d = "非法文件类型，禁止上传";
var txt15$b = "上传工作模板后，仅本团队成员可新建使用";
var txt16$a = "暂无权限操作，请联系企业管理员开启";
var txt17$9 = "文件已停止分享";
var txt18$8 = "更新成功";
var txt19$8 = "上传工作模板后，团队成员可新建使用";
var txt20$8 = "返回模板列表";
var txt21$7 = "上传文件";
var allUploadSuccess = "已完成上传";
var allUploadFailed = "无法上传，请重试";
var uploadCompleteFailed_first = "上传完成 （失败";
var uploadCompleteFailed_second = "份）";
var uploading = "正在上传";
var CompanyTemplateSetting = {
	txt0: txt0$M,
	txt1: txt1$I,
	txt2: txt2$G,
	txt3: txt3$C,
	txt4: txt4$x,
	txt5: txt5$s,
	txt6: txt6$o,
	txt7: txt7$k,
	txt8: txt8$i,
	txt9: txt9$f,
	txt10: txt10$g,
	txt11: txt11$d,
	txt12: txt12$e,
	txt13: txt13$d,
	txt14: txt14$d,
	txt15: txt15$b,
	txt16: txt16$a,
	txt17: txt17$9,
	txt18: txt18$8,
	txt19: txt19$8,
	txt20: txt20$8,
	txt21: txt21$7,
	allUploadSuccess: allUploadSuccess,
	allUploadFailed: allUploadFailed,
	uploadCompleteFailed_first: uploadCompleteFailed_first,
	uploadCompleteFailed_second: uploadCompleteFailed_second,
	uploading: uploading
};

var txt0$L = "重命名";
var txt1$H = "取消";
var txt2$F = "确定";
var txt3$B = "成功";
var txt4$w = "模板名字不能包含非法字符和特殊符号\\/:*?\"<>|";
var txt5$r = "模板名字不能超过240个字符";
var txt6$n = "请输入文件名";
var CompanyTemplateRename = {
	txt0: txt0$L,
	txt1: txt1$H,
	txt2: txt2$F,
	txt3: txt3$B,
	txt4: txt4$w,
	txt5: txt5$r,
	txt6: txt6$n
};

var txt0$K = "不能选择非本企业的文件";
var CompanyTemplateUpload = {
	txt0: txt0$K
};

var txt0$J = "等待上传";
var txt1$G = "上传中...";
var txt2$E = "上传成功";
var txt3$A = "上传失败";
var txt4$v = "取消";
var txt5$q = "已取消";
var CompanyTemplateUploadDetail = {
	txt0: txt0$J,
	txt1: txt1$G,
	txt2: txt2$E,
	txt3: txt3$A,
	txt4: txt4$v,
	txt5: txt5$q
};

var txt0$I = "删除";
var txt1$F = "确认删除后，在企业模板中无法查看，且无法恢复";
var txt2$D = "删除";
var txt3$z = "取消";
var txt4$u = "删除成功";
var txt5$p = "删除失败";
var CompanyTemplateDelete = {
	txt0: txt0$I,
	txt1: txt1$F,
	txt2: txt2$D,
	txt3: txt3$z,
	txt4: txt4$u,
	txt5: txt5$p
};

var error = {
	"0": "未知错误",
	"40000001": "企业空间不足，请联系管理员扩容",
	"40010003": "暂无权限操作，请重新选择",
	"40010004": "团队不存在",
	"40010005": "文件不存在",
	"40010006": "你的操作权限不足，请联系团队管理员开启",
	"40010100": "该企业模板不存在，请重新选择",
	"40010102": "该文件名已存在",
	"40010103": "操作不成功，请修改内容后重试",
	"40010104": "文件已停止分享",
	"40010300": "暂无权限操作，请联系企业管理员开启",
	"40010301": "你的操作权限不足，请联系团队管理员开启",
	"40010400": "操作频繁，请稍后再试",
	"40010502": "单个文件限制100M",
	"40020009": "企业禁止当前IP对该文件(夹)进行此操作",
	"40020010": "企业禁止当前IP保存文件到「{0}」",
	"40020011": "当前IP只允许文件保存到企业空间",
	corpSpaceFullError: "空间不足，上传失败",
	networkError: "网络错误，请稍后重试",
	permissionDenied: "暂无权限操作，请联系企业管理员开启",
	groupNormalSpacesFull: "团队空间不足，请联系管理员扩容",
	CorpSpaceFull: "企业空间不足，请联系管理员扩容"
};
var CompanyTemplate = {
	error: error
};

var txt0$H = "下载二维码";
var txt1$E = "二维码分享";
var txt2$C = "长按保存二维码";
var txt3$y = "请升级至最新版本后长按保存二维码";
var miniCodeShare = "微信小程序分享";
var scan = "手机扫一扫，查看文件";
var contextmenuSave = "右键下载二维码";
var rightClickSave = "右键点击保存二维码";
var enterprise$1 = "企业";
var wechatScan = "使用手机微信\"扫一扫\"，分享文档给好友。";
var dingtalkScan = "使用手机钉钉\"扫一扫\"，发送文档给好友";
var qqScan = "使用手机QQ\"扫一扫\"，发送文档给好友";
var wxqyScan = "使用企业微信\"扫一扫\"，分享文档给同事。";
var scanGuide = "扫码一键发送小程序";
var saveQrCode = "保存二维码发送给好友或发布至朋友圈，朋友可以扫码查看";
var qrCodeTips = "保存二维码发送给好友或发布至朋友圈，朋友可以扫码查看";
var QrCode = {
	txt0: txt0$H,
	txt1: txt1$E,
	txt2: txt2$C,
	txt3: txt3$y,
	miniCodeShare: miniCodeShare,
	scan: scan,
	contextmenuSave: contextmenuSave,
	rightClickSave: rightClickSave,
	enterprise: enterprise$1,
	wechatScan: wechatScan,
	dingtalkScan: dingtalkScan,
	qqScan: qqScan,
	wxqyScan: wxqyScan,
	scanGuide: scanGuide,
	saveQrCode: saveQrCode,
	qrCodeTips: qrCodeTips
};

var write$6 = "可编辑";
var comment$5 = "可评论";
var read$7 = "可查看";
var shareTips = "仅我分享的微信好友/群";
var copyTipsTxt = "手机不在身边？";
var copyHandleTxt = "复制链接";
var copySuccessText = "复制成功";
var receiveMessage = "接收文件消息通知";
var followOfficial = "关注微信公众号";
var receiveNotification = "不错过重要信息通知";
var receiveFileMsg = "接收文件通知";
var MiniCode = {
	write: write$6,
	comment: comment$5,
	read: read$7,
	shareTips: shareTips,
	copyTipsTxt: copyTipsTxt,
	copyHandleTxt: copyHandleTxt,
	copySuccessText: copySuccessText,
	receiveMessage: receiveMessage,
	followOfficial: followOfficial,
	receiveNotification: receiveNotification,
	receiveFileMsg: receiveFileMsg
};

var txt0$G = "推荐";
var TeamFileRecommend = {
	txt0: txt0$G
};

var txt0$F = "创建文件失败";
var txt1$D = "创建文件成功";
var txt2$B = "上一章";
var txt3$x = "下一章";
var txt4$t = "教学指南";
var txt5$o = "获取状态失败";
var txt6$m = "保存状态失败";
var txt7$j = "网络错误，请稍后再试";
var TeamFileTop = {
	txt0: txt0$F,
	txt1: txt1$D,
	txt2: txt2$B,
	txt3: txt3$x,
	txt4: txt4$t,
	txt5: txt5$o,
	txt6: txt6$m,
	txt7: txt7$j
};

var txt0$E = "设置";
var txt1$C = "团队设置";
var txt2$A = "管理";
var txt3$w = "已分享文件";
var txt4$s = "基本信息";
var txt5$n = "测试使用";
var DialogEntTeamFuncManage = {
	txt0: txt0$E,
	txt1: txt1$C,
	txt2: txt2$A,
	txt3: txt3$w,
	txt4: txt4$s,
	txt5: txt5$n
};

var txt0$D = "搜索文件名、分享创建人";
var txt1$B = "全选";
var txt2$z = "筛选";
var txt3$v = "已选";
var txt4$r = "个";
var txt5$m = "分享链接";
var txt6$l = "创建者：";
var txt7$i = "链接地址：";
var txt8$h = "链接权限：";
var txt9$e = "有效期：";
var txt10$f = "访问人数：";
var txt11$c = "下载人数：";
var txt12$d = "免登录访问";
var txt13$c = "修改链接权限";
var txt14$c = "修改有效期";
var txt15$a = "关闭免登录";
var txt16$9 = "取消分享";
var txt17$8 = "未搜索到包含\"";
var txt18$7 = "\"的文件";
var txt19$7 = "搜索超时";
var txt20$7 = "请重试";
var txt21$6 = "请确认取消分享指定的";
var txt22$5 = "个文件（夹）";
var txt23$4 = "请确认关闭指定";
var txt24$3 = "个文件（夹）的免登录访问";
var txt25$2 = "取消";
var txt26$2 = "确认";
var txt27$2 = "未查询到相关文件";
var txt28$2 = "操作成功";
var txt29$1 = "永久有效";
var txt30$1 = "30天有效";
var txt31$1 = "7天有效";
var txt32$1 = "天后过期";
var txt33 = "今日过期";
var txt34 = "当前套餐仅支持";
var txt35 = "天";
var txt36 = "如需";
var txt37 = "升级套餐后可";
var txt38 = "进行授权升级处理";
var txt39 = "由";
var txt40 = "设为";
var txt41 = "开启免登录";
var txt42 = "最近";
var txt43 = "更早的文件";
var txt44 = "请联系";
var txt45 = "已过期";
var txt46 = "有效";
var txt47 = "分享管理";
var txt48 = "或";
var txt49 = "查看本企业已分享的文件列表";
var txt50 = "查看>>";
var closed = "已关闭";
var noLogin = "免登录";
var update = "去升级";
var updateServices = "升级套餐";
var view = "查看";
var search$1 = "搜索";
var download = "下载";
var today = "今天";
var yesterday = "昨天";
var shareTimeByDesc = "新分享优先";
var shareTimeByAsc = "旧分享优先";
var anyone$1 = "任何人";
var theCompany = "本企业成员";
var theSomeone = "指定人";
var theSomeone2 = "仅指定用户可访问";
var read$6 = "可查看";
var write$5 = "可编辑";
var companyAdmin = "企业管理员";
var superAdmin = "超级管理员";
var wpsPD = "WPS项目经理";
var closeNoLogin = "免登录已关闭";
var viewShareDetail = "查看详情";
var applyOrderAdmin = "申请成为订单管理员";
var EntShareManage = {
	txt0: txt0$D,
	txt1: txt1$B,
	txt2: txt2$z,
	txt3: txt3$v,
	txt4: txt4$r,
	txt5: txt5$m,
	txt6: txt6$l,
	txt7: txt7$i,
	txt8: txt8$h,
	txt9: txt9$e,
	txt10: txt10$f,
	txt11: txt11$c,
	txt12: txt12$d,
	txt13: txt13$c,
	txt14: txt14$c,
	txt15: txt15$a,
	txt16: txt16$9,
	txt17: txt17$8,
	txt18: txt18$7,
	txt19: txt19$7,
	txt20: txt20$7,
	txt21: txt21$6,
	txt22: txt22$5,
	txt23: txt23$4,
	txt24: txt24$3,
	txt25: txt25$2,
	txt26: txt26$2,
	txt27: txt27$2,
	txt28: txt28$2,
	txt29: txt29$1,
	txt30: txt30$1,
	txt31: txt31$1,
	txt32: txt32$1,
	txt33: txt33,
	txt34: txt34,
	txt35: txt35,
	txt36: txt36,
	txt37: txt37,
	txt38: txt38,
	txt39: txt39,
	txt40: txt40,
	txt41: txt41,
	txt42: txt42,
	txt43: txt43,
	txt44: txt44,
	txt45: txt45,
	txt46: txt46,
	txt47: txt47,
	txt48: txt48,
	txt49: txt49,
	txt50: txt50,
	closed: closed,
	noLogin: noLogin,
	update: update,
	updateServices: updateServices,
	view: view,
	search: search$1,
	download: download,
	today: today,
	yesterday: yesterday,
	shareTimeByDesc: shareTimeByDesc,
	shareTimeByAsc: shareTimeByAsc,
	anyone: anyone$1,
	theCompany: theCompany,
	theSomeone: theSomeone,
	theSomeone2: theSomeone2,
	read: read$6,
	write: write$5,
	companyAdmin: companyAdmin,
	superAdmin: superAdmin,
	wpsPD: wpsPD,
	closeNoLogin: closeNoLogin,
	viewShareDetail: viewShareDetail,
	applyOrderAdmin: applyOrderAdmin
};

var txt0$C = "文件类型";
var txt1$A = "成员";
var txt2$y = "状态";
var txt3$u = "搜索";
var txt4$q = "重置";
var txt5$l = "全部";
var txt6$k = "文件夹";
var txt7$h = "文档";
var txt8$g = "表格";
var txt9$d = "演示";
var txt10$e = "PDF";
var txt11$b = "表单";
var txt12$c = "图片";
var txt13$b = "便签";
var txt14$b = "流程图";
var txt15$9 = "思维导图";
var txt16$8 = "团队成员";
var txt17$7 = "非团队成员 ";
var txt18$6 = "选择成员";
var txt19$6 = "文件创建者";
var txt20$6 = "分享创建者";
var txt21$5 = "分享已过期";
var txt22$4 = "分享未过期";
var txt23$3 = "不限";
var EntFileFilter = {
	txt0: txt0$C,
	txt1: txt1$A,
	txt2: txt2$y,
	txt3: txt3$u,
	txt4: txt4$q,
	txt5: txt5$l,
	txt6: txt6$k,
	txt7: txt7$h,
	txt8: txt8$g,
	txt9: txt9$d,
	txt10: txt10$e,
	txt11: txt11$b,
	txt12: txt12$c,
	txt13: txt13$b,
	txt14: txt14$b,
	txt15: txt15$9,
	txt16: txt16$8,
	txt17: txt17$7,
	txt18: txt18$6,
	txt19: txt19$6,
	txt20: txt20$6,
	txt21: txt21$5,
	txt22: txt22$4,
	txt23: txt23$3
};

var text1$2 = "已移除「{0}」的访问权限，为避免非企业成员查看，建议将分享链接修改为";
var submit$1 = "立即修改";
var modify = "分享范围修改提醒";
var nextTime = "下次再说";
var onlyRead = "仅本企业成员可查看";
var onlyWrite = "仅本企业成员可编辑";
var modifySuccess = "修改分享范围成功";
var modifyFailed = "修改分享范围失败";
var ModifyShareScope = {
	text1: text1$2,
	submit: submit$1,
	modify: modify,
	nextTime: nextTime,
	onlyRead: onlyRead,
	onlyWrite: onlyWrite,
	modifySuccess: modifySuccess,
	modifyFailed: modifyFailed
};

var offline = "移除访问权限";
var invite$1 = "邀请加入企业";
var offlineFailed = "移除失败";
var offlineSuccess = "移除成功";
var notCompanyMember = "非企业成员";
var inviteSuccess = "邀请已发送";
var inviteFailed = "邀请失败";
var inviteError = "仅管理员可邀请同事加入企业";
var CompanyMemberInfoCard = {
	offline: offline,
	invite: invite$1,
	offlineFailed: offlineFailed,
	offlineSuccess: offlineSuccess,
	notCompanyMember: notCompanyMember,
	inviteSuccess: inviteSuccess,
	inviteFailed: inviteFailed,
	inviteError: inviteError
};

var txt1$z = "购买";
var txt2$x = "最大可支持";
var txt3$t = "个团队";
var txt4$p = "可支持不限数量的团队";
var txt5$k = "联系企业超级管理员";
var txt6$j = "当前套餐是";
var txt7$g = "每个企业仅支持";
var txt8$f = "个团队";
var txt9$c = "任意套餐均可享受对应套餐内所有权益";
var txt10$d = "开启团队水印";
var txt11$a = "设置文档对外分享范围";
var txt12$b = "申请成为\"订单管理员\"";
var txt13$a = "也可以申请成为";
var txt14$a = "\"订单管理员\"";
var txt15$8 = "进行购买";
var txt16$7 = "升级";
var txt17$6 = "立即申请>";
var txt18$5 = "您可以联系企业超级管理员(";
var txt19$5 = ")购买企业套餐，";
var txt20$5 = "我知道了";
var txt21$4 = "不支持";
var UpgradePrivilege = {
	txt1: txt1$z,
	txt2: txt2$x,
	txt3: txt3$t,
	txt4: txt4$p,
	txt5: txt5$k,
	txt6: txt6$j,
	txt7: txt7$g,
	txt8: txt8$f,
	txt9: txt9$c,
	txt10: txt10$d,
	txt11: txt11$a,
	txt12: txt12$b,
	txt13: txt13$a,
	txt14: txt14$a,
	txt15: txt15$8,
	txt16: txt16$7,
	txt17: txt17$6,
	txt18: txt18$5,
	txt19: txt19$5,
	txt20: txt20$5,
	txt21: txt21$4
};

var txt0$B = "取消";
var txt1$y = "确定";
var txt2$w = "发送验证码";
var txt3$s = "短信发送失败";
var txt4$o = "短信已发送";
var txt5$j = "请输入";
var txt6$i = "，仅限输入汉字、字母、数字";
var txt7$f = "，最长8位";
var txt8$e = "，11位数字";
var txt9$b = "请输入验证码";
var txt10$c = "验证码不正确";
var txt11$9 = "企业名称";
var txt12$a = "您的姓名";
var txt13$9 = "您的手机号";
var txt14$9 = "验证码";
var txt15$7 = "完成";
var txt16$6 = "您的操作未授权";
var txt17$5 = "加入企业数量超过限制";
var txt18$4 = "您的操作频率过快，请稍后重试";
var txt19$4 = "该手机验证码次数过多，请明天再试";
var txt20$4 = "操作不成功，请修改内容后重试";
var txt21$3 = "该电话号码可创建企业数量已达上限";
var txt22$3 = "验证码不正确";
var txt23$2 = "的团队";
var txt24$2 = "，4~30位";
var txt25$1 = "，不能包含特殊符号\\/:*?\"<>|";
var txt26$1 = "感谢您选择WPS+云办公服务。以下主要是介绍您及/或您所代表的组织与金山办公达成的有关注册、订阅、使用本服务的法律协议。";
var txt27$1 = "请你阅读";
var txt28$1 = "，点击“同意”，即视为同意该协议内容，并接受我们的服务。";
var txt29 = "我已阅读并同意";
var txt30 = "同意服务协议";
var txt31 = "《WPS+云办公服务使用协议》";
var txt32 = "企业名称重复";
var CompanyRegister = {
	txt0: txt0$B,
	txt1: txt1$y,
	txt2: txt2$w,
	txt3: txt3$s,
	txt4: txt4$o,
	txt5: txt5$j,
	txt6: txt6$i,
	txt7: txt7$f,
	txt8: txt8$e,
	txt9: txt9$b,
	txt10: txt10$c,
	txt11: txt11$9,
	txt12: txt12$a,
	txt13: txt13$9,
	txt14: txt14$9,
	txt15: txt15$7,
	txt16: txt16$6,
	txt17: txt17$5,
	txt18: txt18$4,
	txt19: txt19$4,
	txt20: txt20$4,
	txt21: txt21$3,
	txt22: txt22$3,
	txt23: txt23$2,
	txt24: txt24$2,
	txt25: txt25$1,
	txt26: txt26$1,
	txt27: txt27$1,
	txt28: txt28$1,
	txt29: txt29,
	txt30: txt30,
	txt31: txt31,
	txt32: txt32
};

var txt0$A = "创建企业成功";
var txt1$x = "已将该文件复制到企业内";
var txt2$v = "同事点击链接，即可加入企业并查看文件";
var txt3$r = "进入企业";
var txt4$n = "复制文件分享链接";
var txt5$i = "企业内可查看";
var txt6$h = "企业内可编辑";
var txt7$e = "复制成功";
var txt8$d = "复制失败";
var CompanyRegisterSuccess = {
	txt0: txt0$A,
	txt1: txt1$x,
	txt2: txt2$v,
	txt3: txt3$r,
	txt4: txt4$n,
	txt5: txt5$i,
	txt6: txt6$h,
	txt7: txt7$e,
	txt8: txt8$d
};

var txt0$z = "了解企业指数";
var txt1$w = "（较昨日 ";
var txt2$u = " 分）";
var txt3$q = "用户活跃";
var txt4$m = "团队活跃";
var txt5$h = "文档活跃";
var txt6$g = "协同办公";
var txt7$d = "组织管理";
var txt8$c = "分";
var txt9$a = "同行企业（";
var txt10$b = "当前企业（";
var EnterpriseIndexRadar = {
	txt0: txt0$z,
	txt1: txt1$w,
	txt2: txt2$u,
	txt3: txt3$q,
	txt4: txt4$m,
	txt5: txt5$h,
	txt6: txt6$g,
	txt7: txt7$d,
	txt8: txt8$c,
	txt9: txt9$a,
	txt10: txt10$b
};

var txt0$y = "企业指数";
var DialogEnterpriseIndexRadar = {
	txt0: txt0$y
};

var enableFullComment = "显示留言";
var enableFullCommentTip = "允许加入分享的人查看和发表留言";
var blockEditApply$2 = "禁止申请编辑权限";
var blockEditApplyDesc = "适用于公开发布的文档";
var resetLinkText = "重置分享链接";
var openFullComment = "开启留言";
var waterMarkSettingTit = "设置文档水印";
var openWaterMarkStatus = "已开启水印";
var fileWaterMark = "文档水印";
var transferFileOwner = "转让文档所有权";
var MShareFileMore = {
	enableFullComment: enableFullComment,
	enableFullCommentTip: enableFullCommentTip,
	blockEditApply: blockEditApply$2,
	blockEditApplyDesc: blockEditApplyDesc,
	resetLinkText: resetLinkText,
	openFullComment: openFullComment,
	waterMarkSettingTit: waterMarkSettingTit,
	openWaterMarkStatus: openWaterMarkStatus,
	fileWaterMark: fileWaterMark,
	transferFileOwner: transferFileOwner
};

var txt0$x = "访客需通过密码访问";
var txt1$v = "（ 密码：";
var txt2$t = "重置密码";
var txt3$p = " ）";
var txt4$l = "复制链接和密码";
var LinkChkCodePerm = {
	txt0: txt0$x,
	txt1: txt1$v,
	txt2: txt2$t,
	txt3: txt3$p,
	txt4: txt4$l
};

var txt0$w = "【测试】共享文件夹";
var txt1$u = "关闭后，当前团队内的文件打开不再默认进入多人编辑";
var txt2$s = "设置后，当前团队内的文件打开默认进入多人编辑";
var title$l = "所有文档以多人编辑方式打开";
var subTitle = "开启后，团队内的Office文档将默认以多人编辑方式打开";
var confirm = "确认";
var cancel$4 = "取消";
var close = "关闭";
var setup = "设置";
var success$2 = "成功";
var fail = "失败";
var tryAgain = "请稍后再试";
var EntMultiEditConfirm = {
	txt0: txt0$w,
	txt1: txt1$u,
	txt2: txt2$s,
	title: title$l,
	subTitle: subTitle,
	confirm: confirm,
	cancel: cancel$4,
	close: close,
	setup: setup,
	success: success$2,
	fail: fail,
	tryAgain: tryAgain
};

var title$k = "编辑文件";
var txt0$v = "文件由他人分享，仅支持查看";
var txt1$t = "了解详情";
var txt2$r = "申请编辑权限";
var txt3$o = "多人协作";
var txt4$k = "一个文档多人协作，编辑内容实时更新";
var txt5$g = "另存文件并编辑";
var txt6$f = "将分享的文件另存，编辑后发送回对方";
var txt7$c = "取消";
var txt8$b = "确定";
var txt9$9 = "你没有另存权限，作者禁止文档另存";
var txt10$a = "另存失败，请稍后重试";
var txt11$8 = "暂不支持企业账号";
var txt12$9 = "获取文件权限失败，请重试";
var txt13$8 = "申请失败，对方未绑定公众号";
var txt14$8 = "团队空间已满";
var txt15$6 = "空间已满";
var txt16$5 = "当前文件";
var txt17$4 = "向";
var txt18$3 = "申请权限";
var txt19$3 = "失败";
var txt20$3 = "你可以";
var SubText = "文件由他人分享，仅支持";
var SubTextRead = "仅可查看";
var SubTextComment = "可查看和评论";
var optionComment = "申请评论权限";
var optionCommentSubText = "只能查看和评论，不能编辑文件";
var applyPermission$1 = "申请权限";
var needCertification = "为保护文件数据安全，验证手机后\n可开启编辑";
var shareFile = "的文件，";
var shareFileAll = "的文件，";
var blockEditApply$1 = "作者已设置禁止申请编辑权限";
var SaveAndEdit = {
	title: title$k,
	txt0: txt0$v,
	txt1: txt1$t,
	txt2: txt2$r,
	txt3: txt3$o,
	txt4: txt4$k,
	txt5: txt5$g,
	txt6: txt6$f,
	txt7: txt7$c,
	txt8: txt8$b,
	txt9: txt9$9,
	txt10: txt10$a,
	txt11: txt11$8,
	txt12: txt12$9,
	txt13: txt13$8,
	txt14: txt14$8,
	txt15: txt15$6,
	txt16: txt16$5,
	txt17: txt17$4,
	txt18: txt18$3,
	txt19: txt19$3,
	txt20: txt20$3,
	SubText: SubText,
	SubTextRead: SubTextRead,
	SubTextComment: SubTextComment,
	optionComment: optionComment,
	optionCommentSubText: optionCommentSubText,
	applyPermission: applyPermission$1,
	needCertification: needCertification,
	shareFile: shareFile,
	shareFileAll: shareFileAll,
	blockEditApply: blockEditApply$1
};

var title$j = "申请编辑权限";
var txt0$u = "已通知对方";
var txt1$s = "微信扫一扫关注金山文档公众号";
var txt2$q = "申请通过后第一时间收到通知";
var txt3$n = "对方同意后，可在";
var txt4$j = "金山文档小程序";
var txt5$f = "「我」-「消息」-「办公与协作」查看通知";
var txt6$e = "请关注";
var txt7$b = "金山文档";
var txt8$a = "公众号，申请通过后第一时间收到通知";
var txt9$8 = "关注金山文档公众号，及时收到申请结果";
var txt10$9 = "长按保存二维码";
var txt11$7 = "并在微信中识别二维码完成关注";
var txt12$8 = "申请通过后将收到消息通知";
var txt13$7 = "刷新";
var txt14$7 = "已通知";
var txt15$5 = "已通知对方";
var txt16$4 = "对方通过后，你会在金山文档公众号收到消息";
var txt17$3 = "复制审批链接给对方";
var txt18$2 = "请关注「金山文档」公众号";
var txt19$2 = "申请通过后第一时间收到通知";
var txt20$2 = "长按识别二维码关注";
var txt21$2 = "截屏使用微信扫一扫关注";
var txt22$2 = "或复制并搜索公众号「金山文档」";
var txt23$1 = "微信扫一扫，关注「金山文档」公众号";
var txt24$1 = "申请通过后第一时间收到通知";
var creatorCustomEditSettings = "创作者已自定义申请编辑方式";
var applyPermission = "申请权限";
var applyAfterTxt = "申请通过后将收到消息通知";
var copy = "复制";
var copyLink$1 = "复制链接";
var refreshPage = "刷新页面";
var refreshSuc = "刷新成功";
var comment$4 = "评论";
var read$5 = "访问";
var write$4 = "编辑";
var kdocsName = "金山文档";
var copyLinkSuc = "复制链接成功";
var copySuc = "复制成功";
var showDialog = "前往关注";
var followTips1 = "关注";
var followTips2 = "「金山文档」公众号";
var followTips3 = "及时收到申请结果";
var ApplyPermission = {
	title: title$j,
	txt0: txt0$u,
	txt1: txt1$s,
	txt2: txt2$q,
	txt3: txt3$n,
	txt4: txt4$j,
	txt5: txt5$f,
	txt6: txt6$e,
	txt7: txt7$b,
	txt8: txt8$a,
	txt9: txt9$8,
	txt10: txt10$9,
	txt11: txt11$7,
	txt12: txt12$8,
	txt13: txt13$7,
	txt14: txt14$7,
	txt15: txt15$5,
	txt16: txt16$4,
	txt17: txt17$3,
	txt18: txt18$2,
	txt19: txt19$2,
	txt20: txt20$2,
	txt21: txt21$2,
	txt22: txt22$2,
	txt23: txt23$1,
	txt24: txt24$1,
	creatorCustomEditSettings: creatorCustomEditSettings,
	applyPermission: applyPermission,
	applyAfterTxt: applyAfterTxt,
	copy: copy,
	copyLink: copyLink$1,
	refreshPage: refreshPage,
	refreshSuc: refreshSuc,
	comment: comment$4,
	read: read$5,
	write: write$4,
	kdocsName: kdocsName,
	copyLinkSuc: copyLinkSuc,
	copySuc: copySuc,
	showDialog: showDialog,
	followTips1: followTips1,
	followTips2: followTips2,
	followTips3: followTips3
};

var requestError = "请求异常，请稍后再试";
var copy_success = "复制成功";
var copy_fail = "复制失败";
var process = {
	txt1: "权限审批中",
	txt2: "“订单管理员”正在审批中，暂不能进行购买/续费，你可复制链接给",
	txt3: "审批，或发送审批消息进行提醒",
	txt4: "发送审批消息",
	txt5: "复制链接",
	txt6: "发送成功",
	txt7: "发送次数过于频繁，请稍后再试"
};
var applySuccess = {
	txt1: "申请已提交",
	txt2: "可复制链接发给",
	txt3: "提醒审批",
	txt4: "复制链接"
};
var OrderAdminApplyment = {
	requestError: requestError,
	copy_success: copy_success,
	copy_fail: copy_fail,
	process: process,
	applySuccess: applySuccess
};

var next$1 = "下一步";
var FlashPopover = {
	next: next$1
};

var txt0$t = "领取成功";
var txt1$r = "重复领取";
var txt2$p = "当前企业已购买套餐权益，无法领取任务奖励";
var txt3$m = "操作频繁，请稍后重试";
var txt4$i = "企业新手任务";
var NewbieTask = {
	txt0: txt0$t,
	txt1: txt1$r,
	txt2: txt2$p,
	txt3: txt3$m,
	txt4: txt4$i
};

var txt0$s = "请填写团队名称";
var txt1$q = "你可能想创建的团队";
var txt2$o = "创建";
var txt3$l = "名字不能包含非法字符和特殊符号/\\;:*?\"<>|%&";
var txt4$h = "创建团队失败";
var txt5$e = "创建团队成功";
var CreateGroupTask = {
	txt0: txt0$s,
	txt1: txt1$q,
	txt2: txt2$o,
	txt3: txt3$l,
	txt4: txt4$h,
	txt5: txt5$e
};

var title$i = "邀请成员";
var txt0$r = "分享链接，邀请更多成员加入企业进行协作与共享";
var txt1$p = "扫码发送邀请给同事";
var txt2$n = "复制链接，邀请同事";
var txt3$k = "获取邀请信息失败";
var txt4$g = "复制链接成功";
var txt5$d = "复制失败";
var txt6$d = "邀请你加入【";
var txt7$a = "】 ，一起文档协作";
var no_invite_link_tip = "温馨提示：当前无法获取加入企业邀请链接，请联系企业管理员操作";
var InviteTask = {
	title: title$i,
	txt0: txt0$r,
	txt1: txt1$p,
	txt2: txt2$n,
	txt3: txt3$k,
	txt4: txt4$g,
	txt5: txt5$d,
	txt6: txt6$d,
	txt7: txt7$a,
	no_invite_link_tip: no_invite_link_tip
};

var txt0$q = "我有工作文档";
var txt1$o = "从个人文档上传";
var txt2$m = "本地上传";
var txt3$j = "文档在同事手中";
var txt4$f = "扫码发送邀请给同事";
var txt5$c = "复制链接，邀请上传";
var txt6$c = "获取邀请信息失败";
var txt7$9 = "复制成功";
var txt8$9 = "复制失败";
var txt9$7 = "获取路径失败";
var txt10$8 = "获取团队id失败";
var txt11$6 = "选择移动存储路径";
var txt12$7 = "选择需要移动的文件（夹）";
var UploadFileTask = {
	txt0: txt0$q,
	txt1: txt1$o,
	txt2: txt2$m,
	txt3: txt3$j,
	txt4: txt4$f,
	txt5: txt5$c,
	txt6: txt6$c,
	txt7: txt7$9,
	txt8: txt8$9,
	txt9: txt9$7,
	txt10: txt10$8,
	txt11: txt11$6,
	txt12: txt12$7
};

var txt0$p = "请勾选模板";
var txt1$n = "领取成功";
var txt2$l = "领取失败";
var txt3$i = "已选{0}/{1}";
var DialogGetTemplates = {
	txt0: txt0$p,
	txt1: txt1$n,
	txt2: txt2$l,
	txt3: txt3$i
};

var txt0$o = "注意";
var txt1$m = "复制链接";
var txt2$k = "我知道了";
var txt3$h = "无法确保该类型文件的安全性，请注意设备安全，如仍要下载";
var txt4$e = "，请复制下载链接后访问。";
var txt5$b = "复制链接";
var txt6$b = "我知道了";
var txt7$8 = "复制成功";
var txt8$8 = "复制失败";
var txt9$6 = "你的浏览器不支持自动复制请按 {0} + c 复制下面输入框的内容";
var txt10$7 = "文件下载";
var KRiskyDownloadTips = {
	txt0: txt0$o,
	txt1: txt1$m,
	txt2: txt2$k,
	txt3: txt3$h,
	txt4: txt4$e,
	txt5: txt5$b,
	txt6: txt6$b,
	txt7: txt7$8,
	txt8: txt8$8,
	txt9: txt9$6,
	txt10: txt10$7
};

var next = "下一步";
var end = "知道了";
var StepGuidePopover = {
	next: next,
	end: end
};

var title$h = "标签";
var create_title = "新建标签";
var constant_FAVOR = "常用";
var empty$2 = "暂无标签";
var empty_tips = "添加标签后，可在「首页-标签」查看和管理";
var help_tips = "已添加标签的文件将展示在「首页-标签」";
var remove_tips = "确定要删除标签？删除后不影响文件，仅删除对应的标签标记";
var file_list_empty_1 = "添加标签的文件将展示在这里";
var file_list_empty_2 = "可在文件右键菜单中选择“添加标签”";
var rename = "重命名";
var favor_label = "「常用」作为标签展示";
var network_error = "网络异常";
var errors_invalidObjPerm = "您的操作权限不足";
var emoji_history_title = "最近使用";
var emoji_article = "物品";
var emoji_recreation = "娱乐活动";
var emoji_culture = "文化";
var emoji_people = "人物";
var emoji_animal = "动物";
var emoji_food = "食物";
var emoji_nature = "自然";
var emoji_facilities = "设施";
var emoji_symbol = "其他符号";
var file_label_pending = "待处理";
var file_label_quick_assess = "快速访问";
var FileLabel = {
	title: title$h,
	create_title: create_title,
	constant_FAVOR: constant_FAVOR,
	empty: empty$2,
	empty_tips: empty_tips,
	help_tips: help_tips,
	remove_tips: remove_tips,
	file_list_empty_1: file_list_empty_1,
	file_list_empty_2: file_list_empty_2,
	rename: rename,
	"delete": "删除标签",
	favor_label: favor_label,
	network_error: network_error,
	errors_invalidObjPerm: errors_invalidObjPerm,
	emoji_history_title: emoji_history_title,
	emoji_article: emoji_article,
	emoji_recreation: emoji_recreation,
	emoji_culture: emoji_culture,
	emoji_people: emoji_people,
	emoji_animal: emoji_animal,
	emoji_food: emoji_food,
	emoji_nature: emoji_nature,
	emoji_facilities: emoji_facilities,
	emoji_symbol: emoji_symbol,
	file_label_pending: file_label_pending,
	file_label_quick_assess: file_label_quick_assess
};

var mobileTitle = "金山文档";
var mentioned = "提及我";
var mention = "我提及";
var done = "已完成";
var markFinish = "已标记为完成";
var removeMark = "已移除完成标记";
var undo = "撤销";
var undoFinished = "已撤销";
var markFail = "标记失败，请重试";
var removeMarkFail = "移除标记失败，请重试";
var listLoadError = "列表加载失败，请重试";
var refresh = "刷新";
var refresh2 = "立即刷新";
var from = "来自";
var at = "提及";
var loading$2 = "正在加载";
var noMore = "没有更多了";
var loadError = "加载失败";
var allMarkTip = "全部标记为完成";
var emptyTip01 = "提及记录已全部完成";
var emptyTip02 = "暂时没有新的提及";
var emptyTip03 = "没有提及他人的记录";
var emptyTip04 = "文档里输入 “@” 可以提及他人";
var emptyTip05 = "中";
var emptyTip06 = "标记完成的将显示在这里";
var emptyTip07 = "已完成的提及纪录将显示在这里";
var me = "我";
var InBox = {
	mobileTitle: mobileTitle,
	mentioned: mentioned,
	mention: mention,
	done: done,
	markFinish: markFinish,
	removeMark: removeMark,
	undo: undo,
	undoFinished: undoFinished,
	markFail: markFail,
	removeMarkFail: removeMarkFail,
	listLoadError: listLoadError,
	refresh: refresh,
	refresh2: refresh2,
	from: from,
	at: at,
	loading: loading$2,
	noMore: noMore,
	loadError: loadError,
	allMarkTip: allMarkTip,
	emptyTip01: emptyTip01,
	emptyTip02: emptyTip02,
	emptyTip03: emptyTip03,
	emptyTip04: emptyTip04,
	emptyTip05: emptyTip05,
	emptyTip06: emptyTip06,
	emptyTip07: emptyTip07,
	me: me
};

var txt0$n = "您可以通过「分享」邀请好友一起编辑文档，实时更新保存";
var txt1$l = "我知道了";
var ShareTips = {
	txt0: txt0$n,
	txt1: txt1$l
};

var txt0$m = "团队可见标签";
var txt1$k = "管理标签";
var txt2$j = "标签已存在";
var txt3$g = "删除标签";
var txt4$d = "选择、搜索或新建标签";
var txt5$a = "标签文字过长";
var txt6$a = "保存";
var txt7$7 = "当前文件没有添加团队标签";
var txt8$7 = "没有可选择的标签";
var txt9$5 = "没有匹配到标签，可按回车键新建";
var txt10$6 = "显示所有标签";
var txt11$5 = "添加失败";
var txt12$6 = "搜索标签";
var txt13$6 = "标签名过长";
var txt14$6 = "标签名不能为空";
var txt15$4 = "删除";
var txt16$3 = "取消";
var txt17$2 = "没有搜索结果";
var txt18$1 = "请确认删除【{0}】？删除后，该标签将从所有文件中移除。";
var txt19$1 = "检查到有未保存的内容, 确定放弃吗？";
var txt20$1 = "提示";
var txt21$1 = "确定";
var txt22$1 = "重命名";
var GroupLabelManager = {
	txt0: txt0$m,
	txt1: txt1$k,
	txt2: txt2$j,
	txt3: txt3$g,
	txt4: txt4$d,
	txt5: txt5$a,
	txt6: txt6$a,
	txt7: txt7$7,
	txt8: txt8$7,
	txt9: txt9$5,
	txt10: txt10$6,
	txt11: txt11$5,
	txt12: txt12$6,
	txt13: txt13$6,
	txt14: txt14$6,
	txt15: txt15$4,
	txt16: txt16$3,
	txt17: txt17$2,
	txt18: txt18$1,
	txt19: txt19$1,
	txt20: txt20$1,
	txt21: txt21$1,
	txt22: txt22$1
};

var title$g = "购买企业套餐";
var buyPkg = "购买套餐";
var sample = "功能使用示例";
var groupAuth = {
	txt1: "按用户组授权",
	txt2: "按用户组授权权益还有",
	txt3: "天到期，到期后将不能使用按自定义/部门授权",
	txt4: "去"
};
var customRight = {
	txt1: "设置文件权限自定义",
	txt2: "文件权限自定义权益还有",
	txt3: "天到期，到期后将不能应用团队文档自定义权限",
	txt4: "，去"
};
var Privilege = {
	title: title$g,
	buyPkg: buyPkg,
	sample: sample,
	groupAuth: groupAuth,
	customRight: customRight,
	"private": {
	txt1: "您企业采购的功能服务已超出支持的最大数量，请您联系",
	txt2: "WPS项目经理",
	txt3: "超级管理员",
	txt4: "进行授权升级处理",
	txt5: "升级套餐"
}
};

var setDocPermTxt = "设置文档访问权限";
var setFullTextCommentxt = "设置全文评论";
var transformFileOwnerTxt = "转让文档所有权";
var blockEditApply = "禁止申请编辑权限";
var blockEditApplyTip = "开启后，加入分享的人将无法申请权限";
var ShareFileAdvanceSettings = {
	setDocPermTxt: setDocPermTxt,
	setFullTextCommentxt: setFullTextCommentxt,
	transformFileOwnerTxt: transformFileOwnerTxt,
	blockEditApply: blockEditApply,
	blockEditApplyTip: blockEditApplyTip
};

var title$f = "权益过期通知";
var tipPrefix = "您订阅的【{0}】已过期";
var tipText = "，如有使用以下功能，其管理防护效果将于";
var tipDays = "{0}日后失效";
var feature1$2 = "团队设置，含加密保护，水印，分享范围管控等";
var feature2$2 = "全局设置，含移动管控，水印，分享范围管控，IP访问限制等";
var feature3$2 = "后台管理，含自定义角色，分级管理，空间分配，通讯录可见性，通讯录同步，创建团队需审批等";
var tipEnd = "为更好保障企业文档数据安全，请及时{0}。";
var kfService = "需要企业专属服务？";
var kfBtn = "点击联系";
var buynew = "购买";
var renew = "续费";
var notnow = "暂不";
var now = "立即";
var confirmText$1 = "确定暂不{0}，放弃付费套餐的管理防护功能权益？";
var confirmDanger = "确定后，您有{0}日的缓冲期可继续完成";
var confirmDangerSuffix = "，否则可能面临以下风险：";
var confirmDanger1 = "企业文件的加密保护/水印/分享范围管控/IP访问控制等安全设置将失效，核心文档容易遭员工外泄；";
var confirmDanger2 = "企业文件的移动管控等安全设置将失效，数字资产有机会被转移；";
var confirmDanger3 = "后台自定义管理角色的管理员将无法访问后台对应的菜单，管理效率难以提升；";
var confirmEnd = "我已知悉以上潜在风险，并确定暂不";
var workTime = "工作时间 9:00-18:00";
var ok$2 = "确定";
var cancel$3 = "取消";
var operateFail = "操作失败";
var OutDateService = {
	title: title$f,
	tipPrefix: tipPrefix,
	tipText: tipText,
	tipDays: tipDays,
	feature1: feature1$2,
	feature2: feature2$2,
	feature3: feature3$2,
	tipEnd: tipEnd,
	kfService: kfService,
	kfBtn: kfBtn,
	buynew: buynew,
	renew: renew,
	notnow: notnow,
	now: now,
	confirmText: confirmText$1,
	confirmDanger: confirmDanger,
	confirmDangerSuffix: confirmDangerSuffix,
	confirmDanger1: confirmDanger1,
	confirmDanger2: confirmDanger2,
	confirmDanger3: confirmDanger3,
	confirmEnd: confirmEnd,
	workTime: workTime,
	ok: ok$2,
	cancel: cancel$3,
	operateFail: operateFail
};

var title$e = "提示";
var contentIntro1 = "文档创建自";
var contentIntro2 = "，支持以下云端特性：";
var contentTip1 = "海量存储云端图片";
var contentTip2 = "跟踪数据修改记录";
var contentTip3 = "在云端文档间引用数据";
var recommendWpsOpen = "要继续在 WPS Office 中打开？";
var exportAs = "导出";
var exportSuccess$1 = "导出成功";
var exportFail = "导出失败";
var networkError$1 = "网络异常";
var exportProcessing = "文件导出中，请稍候...";
var DialogWPSGuide = {
	title: title$e,
	contentIntro1: contentIntro1,
	contentIntro2: contentIntro2,
	contentTip1: contentTip1,
	contentTip2: contentTip2,
	contentTip3: contentTip3,
	recommendWpsOpen: recommendWpsOpen,
	exportAs: exportAs,
	exportSuccess: exportSuccess$1,
	exportFail: exportFail,
	networkError: networkError$1,
	exportProcessing: exportProcessing
};

var smsValid = "使用短信验证码验证";
var wxValid = "使用微信扫码验证";
var bindPhoneTitle = "验证手机号";
var qrcodeShowTip = "微信扫码快速验证";
var finishedTip1 = "扫码完成，请在手机上操作";
var finishedTip2 = "重新扫码，请";
var finishedTip3 = "返回";
var successTip1 = "验证成功";
var QrCodeBind = {
	smsValid: smsValid,
	wxValid: wxValid,
	bindPhoneTitle: bindPhoneTitle,
	qrcodeShowTip: qrcodeShowTip,
	finishedTip1: finishedTip1,
	finishedTip2: finishedTip2,
	finishedTip3: finishedTip3,
	successTip1: successTip1
};

var copy_title$1 = "金山文档 | WPS云文档";
var apply_perm = "需要向你申请权限";
var copy_txt$1 = "链接已复制";
var file_txt = "文档权限";
var anyone_txt = "所有人";
var someone_txt = "指定分享的人";
var just_txt = "仅";
var member_txt = "成员";
var only_self = "仅自己";
var securetip_head = "该文档为加密保护文档：";
var securetip_txt1 = "分享权限控制为指定分享的人";
var securetip_txt2 = "在文档内进行授权的成员，可自动获得链接访问权限";
var perm_read = "可查看";
var perm_comment = "可评论";
var perm_write = "可编辑";
var added_members = "已加入分享的人";
var await_txt = "等";
var total_txt = "共";
var person_txt = "人";
var no_member = "无";
var share_setting = "分享设置";
var share_setting_perm = "设置下载、打印、另存等权限";
var share_ksheet_setting_perm = "设置导出、打印、另存等权限";
var share_otl_setting_perm = "设置导出、另存等权限";
var share_dbt_setting_perm = "设置导出、另存、复制内容等权限";
var share_other_setting_perm = "设置有效期等";
var has_setting_txt = "已设置";
var count_txt = "项";
var no_modify_txt = "不修改";
var modify_txt = "修改";
var cancel_txt = "取消";
var primay_txt = "确定";
var open_txt = "开启";
var modify_change_txt = "是否修改权限为所有人可";
var coop_txt = "编辑";
var nocoop_txt = "查看";
var question_mark = "？";
var expire_change_txt = "分享链接已过期，是否开启分享？";
var no_modify_copy_txt = "链接已复制，指定分享的人需要向你申请权限";
var no_modify_apply_txt = "指定分享的人需要向你申请权限";
var copy_success_edit = "链接已复制，权限已更改为所有人可";
var open_success_edit = "已开启分享，权限已更改为所有人可";
var group_txt_left = "仅「";
var group_txt_right = "」成员可访问";
var del_txt = "已加入分享的人将被停止访问";
var perm_change_success = "权限变更成功";
var only_self_txt = "仅你可访问";
var open_link_success = "开启链接成功";
var switch_link_perm = "正在切换权限，请稍后";
var share_link_expire = "分享链接已过期";
var personal_share_link_copy = "复制链接";
var PersonalCoopHasPerm = {
	copy_title: copy_title$1,
	apply_perm: apply_perm,
	copy_txt: copy_txt$1,
	file_txt: file_txt,
	anyone_txt: anyone_txt,
	someone_txt: someone_txt,
	just_txt: just_txt,
	member_txt: member_txt,
	only_self: only_self,
	securetip_head: securetip_head,
	securetip_txt1: securetip_txt1,
	securetip_txt2: securetip_txt2,
	perm_read: perm_read,
	perm_comment: perm_comment,
	perm_write: perm_write,
	added_members: added_members,
	await_txt: await_txt,
	total_txt: total_txt,
	person_txt: person_txt,
	no_member: no_member,
	share_setting: share_setting,
	share_setting_perm: share_setting_perm,
	share_ksheet_setting_perm: share_ksheet_setting_perm,
	share_otl_setting_perm: share_otl_setting_perm,
	share_dbt_setting_perm: share_dbt_setting_perm,
	share_other_setting_perm: share_other_setting_perm,
	has_setting_txt: has_setting_txt,
	count_txt: count_txt,
	no_modify_txt: no_modify_txt,
	modify_txt: modify_txt,
	cancel_txt: cancel_txt,
	primay_txt: primay_txt,
	open_txt: open_txt,
	modify_change_txt: modify_change_txt,
	coop_txt: coop_txt,
	nocoop_txt: nocoop_txt,
	question_mark: question_mark,
	expire_change_txt: expire_change_txt,
	no_modify_copy_txt: no_modify_copy_txt,
	no_modify_apply_txt: no_modify_apply_txt,
	copy_success_edit: copy_success_edit,
	open_success_edit: open_success_edit,
	group_txt_left: group_txt_left,
	group_txt_right: group_txt_right,
	del_txt: del_txt,
	perm_change_success: perm_change_success,
	only_self_txt: only_self_txt,
	open_link_success: open_link_success,
	switch_link_perm: switch_link_perm,
	share_link_expire: share_link_expire,
	personal_share_link_copy: personal_share_link_copy
};

var copy_title = "金山文档 | WPS云文档";
var can_read_txt = "可访问";
var copy_txt = "链接已复制";
var fname_txt = "文件名";
var encrypter_txt = "加密者";
var creator_txt = "所有者";
var file_perm_txt = "文件权限";
var no_share_link_txt = "文档未开启分享";
var no_share_link_txt2 = "该文档未开启分享";
var i_know_txt = "我知道了";
var PersonalCoopNoPerm = {
	copy_title: copy_title,
	can_read_txt: can_read_txt,
	copy_txt: copy_txt,
	fname_txt: fname_txt,
	encrypter_txt: encrypter_txt,
	creator_txt: creator_txt,
	file_perm_txt: file_perm_txt,
	no_share_link_txt: no_share_link_txt,
	no_share_link_txt2: no_share_link_txt2,
	i_know_txt: i_know_txt
};

var txt0$l = "分享";
var shareMiniCode$1 = "通过小程序发送给微信好友";
var txt4$c = "二维码";
var txt2$i = "取消分享";
var perm_setting$1 = "权限设置";
var DialogPersonalShareFile = {
	txt0: txt0$l,
	shareMiniCode: shareMiniCode$1,
	txt4: txt4$c,
	txt2: txt2$i,
	perm_setting: perm_setting$1
};

var share_to_txt = "分享到";
var wechat_friend_txt = "指定微信好友";
var wechat_txt = "微信";
var qrcode_txt = "二维码";
var copylink_txt = "复制链接";
var changeToOpenShareSucTip = "链接权限已调整为";
var dingtalk = "钉钉";
var wework = "企业微信";
var qq_title = "扫码发送给QQ好友";
var dingtalk_title = "扫码发送给钉钉好友";
var miniShare_title = "通过小程序分享给{0}微信好友";
var enterprise = "企业";
var ShareFileChannels = {
	share_to_txt: share_to_txt,
	wechat_friend_txt: wechat_friend_txt,
	wechat_txt: wechat_txt,
	qrcode_txt: qrcode_txt,
	copylink_txt: copylink_txt,
	changeToOpenShareSucTip: changeToOpenShareSucTip,
	dingtalk: dingtalk,
	wework: wework,
	qq_title: qq_title,
	dingtalk_title: dingtalk_title,
	miniShare_title: miniShare_title,
	enterprise: enterprise
};

var txt0$k = "设置公文属性";
var EntSetPubDocAttr = {
	txt0: txt0$k
};

var txt0$j = "以下文件复制移动失败";
var txt1$j = "与我共享";
var txt2$h = "我收到的文件";
var txt3$f = "我的文档";
var txt4$b = "私人空间";
var txt5$9 = "我的云文档";
var txt6$9 = "其他";
var txt7$6 = "个人团队";
var txt8$6 = "企业团队";
var txt9$4 = "共享文件夹";
var txt10$5 = "我的文档";
var CopyMoveFailList = {
	txt0: txt0$j,
	txt1: txt1$j,
	txt2: txt2$h,
	txt3: txt3$f,
	txt4: txt4$b,
	txt5: txt5$9,
	txt6: txt6$9,
	txt7: txt7$6,
	txt8: txt8$6,
	txt9: txt9$4,
	txt10: txt10$5
};

var txt0$i = "从其他账号导入";
var txt1$i = "当前设备已登录以下账号，可从以下账号选择";
var txt2$g = "选择";
var txt3$e = "登录已失效";
var txt4$a = "该企业禁止将该文件转移到企业外";
var MultiAccountSelectList = {
	txt0: txt0$i,
	txt1: txt1$i,
	txt2: txt2$g,
	txt3: txt3$e,
	txt4: txt4$a
};

var txt0$h = "移动文件";
var txt1$h = "移动后";
var txt2$f = "将不再保留这些文件";
var txt3$d = "确定移动";
var txt4$9 = "从";
var txt5$8 = "中导入";
var txt6$8 = "取消";
var tip$1 = "移动后，{info}，可能也无法从企业账号移出，确定移动？";
var subTip = "我已经了解移动文件所带来的影响，并确认移动";
var personalAccount = "个人账号";
var MultiAccountFileImport = {
	txt0: txt0$h,
	txt1: txt1$h,
	txt2: txt2$f,
	txt3: txt3$d,
	txt4: txt4$9,
	txt5: txt5$8,
	txt6: txt6$8,
	tip: tip$1,
	subTip: subTip,
	personalAccount: personalAccount
};

var txt0$g = "确定";
var txt1$g = "取消";
var txt2$e = "暂不支持创建到该位置";
var txt3$c = "快捷方式已添加至";
var txt4$8 = "添加快捷方式到";
var txt5$7 = "原文件(夹)不存在";
var txt6$7 = "是";
var txt7$5 = "否";
var txt8$5 = "添加快捷方式成功";
var txt9$3 = "查看";
var txt10$4 = "已添加快捷方式到";
var txt11$4 = "是否允许成员";
var txt12$5 = "文档";
var txt13$5 = "编辑";
var txt14$5 = "查看";
var CreateShortcut = {
	txt0: txt0$g,
	txt1: txt1$g,
	txt2: txt2$e,
	txt3: txt3$c,
	txt4: txt4$8,
	txt5: txt5$7,
	txt6: txt6$7,
	txt7: txt7$5,
	txt8: txt8$5,
	txt9: txt9$3,
	txt10: txt10$4,
	txt11: txt11$4,
	txt12: txt12$5,
	txt13: txt13$5,
	txt14: txt14$5
};

var yun_views_Avatar0 = "点击进入消息中心";
var yun_views_Avatar1 = "小程序";
var yun_views_Avatar2 = "把文档装进小程序";
var yun_views_Avatar3 = "微信扫码体验";
var yun_views_Avatar4 = "个人中心";
var yun_views_Avatar5 = "我的云服务";
var yun_views_Avatar6 = "已使用：";
var yun_views_Avatar7 = "创建企业";
var yun_views_Avatar8 = "启用通讯录，享高效团队协作";
var yun_views_Avatar9 = "管理后台";
var yun_views_Avatar10 = "意见反馈";
var yun_views_Avatar11 = "退出账号";
var yun_views_Avatar12 = "升级";
var yun_views_Avatar13 = "续费";
var yun_views_Avatar14 = "企业成员";
var yun_views_Avatar15 = "加载失败";
var yun_views_Avatar16 = "空间不足 ";
var yun_views_Avatar17 = "注册用户";
var yun_views_Avatar18 = "进入官网";
var yun_views_Avatar19 = "切换环境";
var yun_views_Avatar20 = "个人中心";
var yun_views_Avatar21 = "语言";
var yun_views_Avatar_clean = "清理";
var yun_views_Avatar_join_member = "开通会员";
var yun_views_Avatar_renew_member = "续费会员";
var yun_views_Avatar_check_privilege = "查看特权";
var yun_views_Avatar_open_member = "开通超级会员享130+项会员特权";
var yun_views_Avatar_join_yun_time = "已使用云服务{day}天";
var yun_views_Avatar_account_manage = "账号管理";
var yun_views_Avatar_account = "账号：";
var yun_views_Avatar_account_id = "账号ID：";
var yun_views_Avatar_score = "安全评分：";
var yun_views_Avatar_place_ownership = "IP属地：";
var yun_views_Avatar_yun_space = "云空间";
var yun_views_Avatar_expired_time = "{type}到期：{year}-{month}-{day}";
var yun_views_Avatar_expired_text = "(即将过期)";
var yun_views_Avatar_supervip = "超级会员";
var yun_views_Avatar_wpsvip = "会员";
var yun_views_Avatar_dockervip = "稻壳会员";
var yun_views_Avatar_has = "你已拥有";
var yun_views_Avatar_expire_has = "续费尊享";
var yun_views_Avatar_and = "和";
var yun_views_Avatar_supervip_privilege = "130+项超级会员特权";
var yun_views_Avatar_wpsvip_privilege = "80+项会员特权";
var yun_views_Avatar_dockervip_privilege = "50+项模板特权";
var yun_views_Avatar_upperlimit = "满";
var yun_views_Avatar_account_id_copySuccess = "复制成功";
var yun_views_Avatar_account_id_copyError = "复制失败";
var yun_views_Avatar_account_expire_date = "已于{expiredate}失效";
var yun_views_Avatar_account_expire_date1 = "已于{expiredate}到期";
var yun_views_Avatar_account_expire_date2 = "{expiredate}到期";
var yun_views_Avatar_account_expire_text = "已过期";
var yun_views_Avatar_supervip_default = "你有一笔待支付的超级会员订单";
var yun_views_Avatar_wpsvip_default = "你有一笔待支付的会员订单";
var yun_views_Avatar_dockervip_default = "你有一笔待支付的稻壳会员订单";
var yun_views_Avatar_vipPro_default = "你有一笔待支付的新超级会员订单";
var yun_views_Avatar_vipProPlus_default = "你有一笔待支付的超级会员Pro订单";
var yun_views_Avatar_anyvip_default = "你有一笔待支付的订单";
var yun_views_Avatar_pay_default = "去支付";
var yun_views_Avatar_company_base = "企业基础版";
var yun_views_Avatar_company_partner = "{name}（{time}到期）";
var yun_views_Avatar_compapy_space_buy = "购买套餐";
var yun_views_Avatar_company_space_rebuy = "立即续费";
var yun_views_Avatar_company_space_addbuy = "增购人数";
var yun_views_Avatar_company_space = "企业空间";
var yun_views_Avatar_lougout_title = "退出登录";
var yun_views_Avatar_accountsList_protect = "入口升级维护中";
var yun_views_Avatar_accountsList_idnex0 = "账号切换";
var yun_views_Avatar_accountsList_idnex1 = "切换账号";
var yun_views_Avatar_accountsList_idnex2 = "账号不可用";
var yun_views_Avatar_accountsList_idnex3 = "新建企业账号";
var yun_views_Avatar_accountsList_idnex5 = "账号密码已过期，您可以尝试";
var yun_views_Avatar_accountsList_idnex6 = " 修改密码 ";
var yun_views_Avatar_accountsList_idnex7 = "后重新登录";
var yun_views_Avatar_accountsList_idnex8 = "退出登录";
var yun_views_Avatar_accountsList_idnex9 = "登录其他账号";
var yun_views_Avatar_accountsList_idnex10 = "切换失败，";
var yun_views_Avatar_accountsList_idnex11 = "当前设备暂未支持「登录其他账号」";
var yun_views_Avatar_accountsList_idnex12 = "未验证";
var yun_views_Avatar_accountsList_idnex13 = "当前已登录账号数量已达上限";
var yun_views_Avatar_accountsList_createCompany_desc = "沉淀企业数字资产";
var yun_views_Avatar_accountsList_mail_list = "添加伙伴，高效办公";
var yun_views_Avatar_company_package = "企业套餐";
var yun_views_Avatar_company_expireTtime = "到期";
var yun_views_Avatar_company_expireTtime_tips = "到期后，会自动免费续费一年";
var yun_views_Avatar_company_toVerify = "去认证";
var yun_views_Avatar_company_verifiyTip_default = "企业加V认证，避免企业名称被抢注";
var yun_views_Avatar_company_isVerify = "已认证";
var yun_views_Avatar_company_unVerify = "未认证";
var yun_views_Avatar_company_buy1 = "购买套餐";
var yun_views_Avatar_company_buy2 = "增购人数";
var yun_views_Avatar_company_buy3 = "立即续费";
var yun_views_Avatar_Header = "金山文档";
var yun_views_Avatar_Header5 = "个人文档";
var yun_views_Avatar_ToWelcome0 = "进入官网";
var yun_views_Avatar_ToWelcome1 = "已复制金山文档官网链接，前往浏览器打开链接即可进入";
var yun_views_Avatar_ToWelcome2 = "我知道了";
var yun_views_Avatar_expansion = "扩容";
var yun_views_Avatar_enter = "进入";
var yun_views_Avatar_To_view = "去查看";
var AvatarPanel = {
	yun_views_Avatar0: yun_views_Avatar0,
	yun_views_Avatar1: yun_views_Avatar1,
	yun_views_Avatar2: yun_views_Avatar2,
	yun_views_Avatar3: yun_views_Avatar3,
	yun_views_Avatar4: yun_views_Avatar4,
	yun_views_Avatar5: yun_views_Avatar5,
	yun_views_Avatar6: yun_views_Avatar6,
	yun_views_Avatar7: yun_views_Avatar7,
	yun_views_Avatar8: yun_views_Avatar8,
	yun_views_Avatar9: yun_views_Avatar9,
	yun_views_Avatar10: yun_views_Avatar10,
	yun_views_Avatar11: yun_views_Avatar11,
	yun_views_Avatar12: yun_views_Avatar12,
	yun_views_Avatar13: yun_views_Avatar13,
	yun_views_Avatar14: yun_views_Avatar14,
	yun_views_Avatar15: yun_views_Avatar15,
	yun_views_Avatar16: yun_views_Avatar16,
	yun_views_Avatar17: yun_views_Avatar17,
	yun_views_Avatar18: yun_views_Avatar18,
	yun_views_Avatar19: yun_views_Avatar19,
	yun_views_Avatar20: yun_views_Avatar20,
	yun_views_Avatar21: yun_views_Avatar21,
	yun_views_Avatar_clean: yun_views_Avatar_clean,
	yun_views_Avatar_join_member: yun_views_Avatar_join_member,
	yun_views_Avatar_renew_member: yun_views_Avatar_renew_member,
	yun_views_Avatar_check_privilege: yun_views_Avatar_check_privilege,
	yun_views_Avatar_open_member: yun_views_Avatar_open_member,
	yun_views_Avatar_join_yun_time: yun_views_Avatar_join_yun_time,
	yun_views_Avatar_account_manage: yun_views_Avatar_account_manage,
	yun_views_Avatar_account: yun_views_Avatar_account,
	yun_views_Avatar_account_id: yun_views_Avatar_account_id,
	yun_views_Avatar_score: yun_views_Avatar_score,
	yun_views_Avatar_place_ownership: yun_views_Avatar_place_ownership,
	yun_views_Avatar_yun_space: yun_views_Avatar_yun_space,
	yun_views_Avatar_expired_time: yun_views_Avatar_expired_time,
	yun_views_Avatar_expired_text: yun_views_Avatar_expired_text,
	yun_views_Avatar_supervip: yun_views_Avatar_supervip,
	yun_views_Avatar_wpsvip: yun_views_Avatar_wpsvip,
	yun_views_Avatar_dockervip: yun_views_Avatar_dockervip,
	yun_views_Avatar_has: yun_views_Avatar_has,
	yun_views_Avatar_expire_has: yun_views_Avatar_expire_has,
	yun_views_Avatar_and: yun_views_Avatar_and,
	yun_views_Avatar_supervip_privilege: yun_views_Avatar_supervip_privilege,
	yun_views_Avatar_wpsvip_privilege: yun_views_Avatar_wpsvip_privilege,
	yun_views_Avatar_dockervip_privilege: yun_views_Avatar_dockervip_privilege,
	yun_views_Avatar_upperlimit: yun_views_Avatar_upperlimit,
	yun_views_Avatar_account_id_copySuccess: yun_views_Avatar_account_id_copySuccess,
	yun_views_Avatar_account_id_copyError: yun_views_Avatar_account_id_copyError,
	yun_views_Avatar_account_expire_date: yun_views_Avatar_account_expire_date,
	yun_views_Avatar_account_expire_date1: yun_views_Avatar_account_expire_date1,
	yun_views_Avatar_account_expire_date2: yun_views_Avatar_account_expire_date2,
	yun_views_Avatar_account_expire_text: yun_views_Avatar_account_expire_text,
	yun_views_Avatar_supervip_default: yun_views_Avatar_supervip_default,
	yun_views_Avatar_wpsvip_default: yun_views_Avatar_wpsvip_default,
	yun_views_Avatar_dockervip_default: yun_views_Avatar_dockervip_default,
	yun_views_Avatar_vipPro_default: yun_views_Avatar_vipPro_default,
	yun_views_Avatar_vipProPlus_default: yun_views_Avatar_vipProPlus_default,
	yun_views_Avatar_anyvip_default: yun_views_Avatar_anyvip_default,
	yun_views_Avatar_pay_default: yun_views_Avatar_pay_default,
	yun_views_Avatar_company_base: yun_views_Avatar_company_base,
	yun_views_Avatar_company_partner: yun_views_Avatar_company_partner,
	yun_views_Avatar_compapy_space_buy: yun_views_Avatar_compapy_space_buy,
	yun_views_Avatar_company_space_rebuy: yun_views_Avatar_company_space_rebuy,
	yun_views_Avatar_company_space_addbuy: yun_views_Avatar_company_space_addbuy,
	yun_views_Avatar_company_space: yun_views_Avatar_company_space,
	yun_views_Avatar_lougout_title: yun_views_Avatar_lougout_title,
	yun_views_Avatar_accountsList_protect: yun_views_Avatar_accountsList_protect,
	yun_views_Avatar_accountsList_idnex0: yun_views_Avatar_accountsList_idnex0,
	yun_views_Avatar_accountsList_idnex1: yun_views_Avatar_accountsList_idnex1,
	yun_views_Avatar_accountsList_idnex2: yun_views_Avatar_accountsList_idnex2,
	yun_views_Avatar_accountsList_idnex3: yun_views_Avatar_accountsList_idnex3,
	yun_views_Avatar_accountsList_idnex5: yun_views_Avatar_accountsList_idnex5,
	yun_views_Avatar_accountsList_idnex6: yun_views_Avatar_accountsList_idnex6,
	yun_views_Avatar_accountsList_idnex7: yun_views_Avatar_accountsList_idnex7,
	yun_views_Avatar_accountsList_idnex8: yun_views_Avatar_accountsList_idnex8,
	yun_views_Avatar_accountsList_idnex9: yun_views_Avatar_accountsList_idnex9,
	yun_views_Avatar_accountsList_idnex10: yun_views_Avatar_accountsList_idnex10,
	yun_views_Avatar_accountsList_idnex11: yun_views_Avatar_accountsList_idnex11,
	yun_views_Avatar_accountsList_idnex12: yun_views_Avatar_accountsList_idnex12,
	yun_views_Avatar_accountsList_idnex13: yun_views_Avatar_accountsList_idnex13,
	yun_views_Avatar_accountsList_createCompany_desc: yun_views_Avatar_accountsList_createCompany_desc,
	yun_views_Avatar_accountsList_mail_list: yun_views_Avatar_accountsList_mail_list,
	yun_views_Avatar_company_package: yun_views_Avatar_company_package,
	yun_views_Avatar_company_expireTtime: yun_views_Avatar_company_expireTtime,
	yun_views_Avatar_company_expireTtime_tips: yun_views_Avatar_company_expireTtime_tips,
	yun_views_Avatar_company_toVerify: yun_views_Avatar_company_toVerify,
	yun_views_Avatar_company_verifiyTip_default: yun_views_Avatar_company_verifiyTip_default,
	yun_views_Avatar_company_isVerify: yun_views_Avatar_company_isVerify,
	yun_views_Avatar_company_unVerify: yun_views_Avatar_company_unVerify,
	yun_views_Avatar_company_buy1: yun_views_Avatar_company_buy1,
	yun_views_Avatar_company_buy2: yun_views_Avatar_company_buy2,
	yun_views_Avatar_company_buy3: yun_views_Avatar_company_buy3,
	yun_views_Avatar_Header: yun_views_Avatar_Header,
	yun_views_Avatar_Header5: yun_views_Avatar_Header5,
	yun_views_Avatar_ToWelcome0: yun_views_Avatar_ToWelcome0,
	yun_views_Avatar_ToWelcome1: yun_views_Avatar_ToWelcome1,
	yun_views_Avatar_ToWelcome2: yun_views_Avatar_ToWelcome2,
	yun_views_Avatar_expansion: yun_views_Avatar_expansion,
	yun_views_Avatar_enter: yun_views_Avatar_enter,
	yun_views_Avatar_To_view: yun_views_Avatar_To_view
};

var countOfJoined = "已加入的人 ({0})";
var quickAction = "快捷操作";
var removeMemberOutsideCompany = "移除企业外成员";
var removeAll = "移除所有人";
var searchMember = "搜索用户";
var assignPermission = "指定授权";
var memberInsideCompany = "本企业成员";
var memberOutsideCompany = "企业外成员";
var justAgo = "刚刚加入";
var joinHoursAgo = "{0} 小时前加入";
var joinDaysAgo = "{0} 天前加入";
var remove = "移除";
var confirmAssignPermission = "确认授予「{0}」【{1}】的权限？";
var confirmAssignPermissionRemark = "授权后，用户将进入上层页面的授权列表";
var confirmUpdateSubfilePermission = "子文件（夹）修改确认";
var updateSubfileSuccessMsg = "设置成功，已同步更新该文件夹下所有文件(夹)的权限";
var selected$1 = "已选择({0})";
var batchRemove = "批量移除";
var EntJoinByLink = {
	countOfJoined: countOfJoined,
	quickAction: quickAction,
	removeMemberOutsideCompany: removeMemberOutsideCompany,
	removeAll: removeAll,
	searchMember: searchMember,
	assignPermission: assignPermission,
	memberInsideCompany: memberInsideCompany,
	memberOutsideCompany: memberOutsideCompany,
	justAgo: justAgo,
	joinHoursAgo: joinHoursAgo,
	joinDaysAgo: joinDaysAgo,
	remove: remove,
	confirmAssignPermission: confirmAssignPermission,
	confirmAssignPermissionRemark: confirmAssignPermissionRemark,
	confirmUpdateSubfilePermission: confirmUpdateSubfilePermission,
	updateSubfileSuccessMsg: updateSubfileSuccessMsg,
	selected: selected$1,
	batchRemove: batchRemove
};

var morning = "上午";
var afternoon = "下午";
var Message = {
	morning: morning,
	afternoon: afternoon
};

var dialogTitle1 = "管理团队版本标记";
var dialogTitle2 = "设置版本标记";
var dialogTex1 = "仅团队成员可标记版本";
var dialogTex2 = "最多同时标记20个文件";
var txt0$f = "搜索";
var txt6$6 = "服务器异常";
var txt12$4 = "不能创建空标签";
var txt13$4 = "暂无标签";
var txt14$4 = "标签保存成功";
var txt15$3 = "标签保存失败";
var txt16$2 = "标签删除成功";
var txt17$1 = "标签删除失败";
var txt100 = "当前版本";
var txt101 = "选择、搜索或新建标签";
var txt102 = "团队版本标记";
var txt103 = "管理";
var txt104 = "取消";
var txt105 = "确认";
var txt106 = "服务器异常";
var txt107 = "搜索结果";
var txt111 = "添加标记";
var txt112 = "不能创建空标签";
var txt113 = "没有匹配到标签，可按回车新建";
var txt114 = "没有可选择的标签";
var txt115 = "提示";
var txt116 = "该版本标记下已有文档历史版本，确认修改该标记？修改后历史版本的对应标记文案将被修改";
var txt117 = "该版本标记下已有文档历史版本，确认删除该标记？删除后历史版本的对应标记将被删除";
var txt118 = "删除";
var txt119 = "修改";
var txt120 = "暂不";
var txt121 = "保存成功";
var txt122 = "个文档当前版本已有标签，批量标记失败";
var netError = "服务器或网络异常";
var permissionDefault = "权限不足，请联系管理员";
var HistoryVersionLabelManager = {
	dialogTitle1: dialogTitle1,
	dialogTitle2: dialogTitle2,
	dialogTex1: dialogTex1,
	dialogTex2: dialogTex2,
	txt0: txt0$f,
	txt6: txt6$6,
	txt12: txt12$4,
	txt13: txt13$4,
	txt14: txt14$4,
	txt15: txt15$3,
	txt16: txt16$2,
	txt17: txt17$1,
	txt100: txt100,
	txt101: txt101,
	txt102: txt102,
	txt103: txt103,
	txt104: txt104,
	txt105: txt105,
	txt106: txt106,
	txt107: txt107,
	txt111: txt111,
	txt112: txt112,
	txt113: txt113,
	txt114: txt114,
	txt115: txt115,
	txt116: txt116,
	txt117: txt117,
	txt118: txt118,
	txt119: txt119,
	txt120: txt120,
	txt121: txt121,
	txt122: txt122,
	netError: netError,
	permissionDefault: permissionDefault
};

var txt0$e = "暂无列表";
var txt1$f = "版本标记";
var txt2$d = "无删除权限，请联系管理员";
var txtDelMark = "删除标记";
var txtPreview = "预览";
var txtSave = "版本另存为";
var txtDelSuccess = "删除成功";
var txtDelError = "删除失败";
var txtConfirmTitle = "提示";
var txtNoSupport = "暂不支持该类型预览，请另存为或下载查看";
var noCreatePremission = "无新增权限，请联系管理员";
var VersionTagsList = {
	txt0: txt0$e,
	txt1: txt1$f,
	txt2: txt2$d,
	txtDelMark: txtDelMark,
	txtPreview: txtPreview,
	txtSave: txtSave,
	txtDelSuccess: txtDelSuccess,
	txtDelError: txtDelError,
	txtConfirmTitle: txtConfirmTitle,
	txtNoSupport: txtNoSupport,
	noCreatePremission: noCreatePremission
};

var inviteAdd = "邀请新成员，分配会员权益";
var inviteBtn = "复制邀请链接";
var inviteText1 = "邀请你加入";
var inviteText2 = "加入后可申请使用WPS会员特权";
var allocationBtn = "分配WPS会员特权";
var copySuccess = "复制成功";
var copyError = "复制失败";
var noticeTitle = "已分配WPS会员，通知同事进入企业生效";
var noticeLink = "{0}赠送你一个WPS会员，进入企业后生效\nhttps://www.kdocs.cn/latest";
var noticeCopyBtn = "复制链接通知成员";
var noticeTip = "可继续邀请企业成员，回到团队顶部入口或“管理后台-增值中心-权益分配”进行分配。";
var applyError = "分配失败";
var DialogVipAllocation = {
	inviteAdd: inviteAdd,
	inviteBtn: inviteBtn,
	inviteText1: inviteText1,
	inviteText2: inviteText2,
	allocationBtn: allocationBtn,
	copySuccess: copySuccess,
	copyError: copyError,
	noticeTitle: noticeTitle,
	noticeLink: noticeLink,
	noticeCopyBtn: noticeCopyBtn,
	noticeTip: noticeTip,
	applyError: applyError
};

var tips1$1 = "提示";
var tips2$1 = "已添加快捷方式到";
var tips3$1 = "是否允许成员";
var tips4$1 = "文档";
var tips5$1 = "取消";
var tips6$1 = "允许";
var read$4 = "查看";
var write$3 = "编辑";
var comment$3 = "评论";
var failShare = "没有分享权限";
var AddTeam = {
	tips1: tips1$1,
	tips2: tips2$1,
	tips3: tips3$1,
	tips4: tips4$1,
	tips5: tips5$1,
	tips6: tips6$1,
	read: read$4,
	write: write$3,
	comment: comment$3,
	failShare: failShare
};

var settingTxt$2 = "设置";
var minicodeTxt = "通过小程序发送给好友";
var qrcodeTxt = "二维码";
var qqScanTxt = "扫码发送给QQ好友";
var shareTxt$1 = "分享";
var settingMenuTxt = "分享设置";
var collsMenuTxt = "成员管理";
var delShareTxt = "取消分享";
var addContactTxt = "添加指定人";
var link404Txt = "你访问的链接不存在或者已移除";
var serverErrTxt = "服务器错误";
var linkTimeTxt = "链接有效期";
var setLinkTimeTxt = "设置文档访问有效期";
var advanceSettingTxt = "高级设置";
var resetLinkTxt = "重置分享链接";
var selectAllTxt = "全选";
var linkExpiredTxt = "文档分享链接已过期，请重新选择有效期。";
var waterSettingTxt = "文档水印";
var feedbackTxt = "反馈";
var addedMemberTxt = "已加入分享的用户";
var delSuccessTxt = "已取消分享，仅你自己可见";
var bindPhoneTxt = "验证手机号";
var userForbiddenTitle = "分享提醒";
var newShareV2 = {
	settingTxt: settingTxt$2,
	minicodeTxt: minicodeTxt,
	qrcodeTxt: qrcodeTxt,
	qqScanTxt: qqScanTxt,
	shareTxt: shareTxt$1,
	settingMenuTxt: settingMenuTxt,
	collsMenuTxt: collsMenuTxt,
	delShareTxt: delShareTxt,
	addContactTxt: addContactTxt,
	link404Txt: link404Txt,
	serverErrTxt: serverErrTxt,
	linkTimeTxt: linkTimeTxt,
	setLinkTimeTxt: setLinkTimeTxt,
	advanceSettingTxt: advanceSettingTxt,
	resetLinkTxt: resetLinkTxt,
	selectAllTxt: selectAllTxt,
	linkExpiredTxt: linkExpiredTxt,
	waterSettingTxt: waterSettingTxt,
	feedbackTxt: feedbackTxt,
	addedMemberTxt: addedMemberTxt,
	delSuccessTxt: delSuccessTxt,
	bindPhoneTxt: bindPhoneTxt,
	userForbiddenTitle: userForbiddenTitle
};

var title$d = "模板上传";
var finishTip$1 = "已全部上传完毕";
var closeTip$1 = "关闭当前弹窗，将取消正在上传的文件";
var scopeName$1 = "选择使用范围";
var scopeTip1$1 = "1. 仅可选择你是管理员的团队；";
var scopeTip2$1 = "2. 选定团队后，仅当前团队成员可使用该模板；";
var contactList$1 = "已添加使用成员";
var contactListBtn$1 = "从通讯录选择";
var contactListBtnNew$1 = "通讯录";
var self$1 = "仅我自己";
var all$1 = "本企业所有人员";
var part$1 = "选择指定人可使用";
var templateList$1 = "模板内容";
var cloudUpload$1 = "云文档上传";
var localUpload$1 = "本地上传";
var ok$1 = "确定";
var fileTypeError$1 = "非法文件类型，禁止上传";
var cancel$2 = "取消";
var canceled$1 = "已取消";
var success$1 = "上传成功";
var failed$1 = "上传失败";
var templateEmpty$1 = "上传模板文件即可使用";
var selectFileTips1$1 = "已选择";
var selectFileTips2$1 = "份文件，请确认是否上传为模板";
var uploadingTips$1 = "模板文件正在上传";
var uploadFinishTips$1 = "模板文件已上传完毕";
var uploadButtonText$1 = "立即上传";
var templateEmptyTips$1 = "暂无文件";
var uploadBtn$1 = "选择文件";
var addFileBtn$1 = "添加文件";
var authText$1 = "模板权限";
var allNew$1 = "本企业所有人";
var partNew$1 = "本企业指定人";
var uploadingTitle$1 = "上传中";
var uploadFinishTitle$1 = "上传完成";
var uploadingBtnText$1 = "正在上传";
var failedSpaceLimit$1 = "空间不足，上传失败";
var DialogCompanyTemplateUpload = {
	title: title$d,
	finishTip: finishTip$1,
	closeTip: closeTip$1,
	scopeName: scopeName$1,
	scopeTip1: scopeTip1$1,
	scopeTip2: scopeTip2$1,
	contactList: contactList$1,
	contactListBtn: contactListBtn$1,
	contactListBtnNew: contactListBtnNew$1,
	self: self$1,
	all: all$1,
	part: part$1,
	templateList: templateList$1,
	cloudUpload: cloudUpload$1,
	localUpload: localUpload$1,
	ok: ok$1,
	fileTypeError: fileTypeError$1,
	"delete": "删除",
	cancel: cancel$2,
	canceled: canceled$1,
	success: success$1,
	failed: failed$1,
	templateEmpty: templateEmpty$1,
	selectFileTips1: selectFileTips1$1,
	selectFileTips2: selectFileTips2$1,
	uploadingTips: uploadingTips$1,
	uploadFinishTips: uploadFinishTips$1,
	uploadButtonText: uploadButtonText$1,
	templateEmptyTips: templateEmptyTips$1,
	uploadBtn: uploadBtn$1,
	addFileBtn: addFileBtn$1,
	authText: authText$1,
	allNew: allNew$1,
	partNew: partNew$1,
	uploadingTitle: uploadingTitle$1,
	uploadFinishTitle: uploadFinishTitle$1,
	uploadingBtnText: uploadingBtnText$1,
	failedSpaceLimit: failedSpaceLimit$1
};

var title$c = "编辑模板";
var finishTip = "已全部上传完毕";
var closeTip = "关闭当前弹窗，将取消正在上传的文件";
var scopeName = "选择使用范围";
var scopeTip1 = "1. 仅可选择你是管理员的团队；";
var scopeTip2 = "2. 选定团队后，仅当前团队成员可使用该模板；";
var contactList = "已添加使用成员";
var contactListBtn = "从通讯录选择";
var contactListBtnNew = "通讯录";
var self = "仅我自己";
var all = "本企业所有人员";
var part = "选择指定人可使用";
var templateList = "模板内容";
var cloudUpload = "云文档上传";
var localUpload = "本地上传";
var ok = "确定";
var fileTypeError = "非法文件类型，禁止上传";
var cancel$1 = "取消";
var canceled = "已取消";
var success = "上传成功";
var failed = "上传失败";
var templateEmpty = "上传模板文件即可使用";
var selectFileTips1 = "已选择";
var selectFileTips2 = "份文件，请确认是否上传为模板";
var uploadingTips = "模板文件正在上传";
var uploadFinishTips = "模板文件已上传完毕";
var uploadButtonText = "立即上传";
var templateEmptyTips = "暂无文件";
var uploadBtn = "选择文件";
var addFileBtn = "添加文件";
var authText = "模板权限";
var allNew = "本企业所有人";
var partNew = "本企业指定人";
var uploadingTitle = "上传中";
var uploadFinishTitle = "上传完成";
var uploadingBtnText = "正在上传";
var failedSpaceLimit = "空间不足，上传失败";
var updateTemplate = "更新模板";
var templateName = "工作模板名称";
var templateNameEmpty = "模板名称不能为空";
var memberEmpty = "模板权限不能为空";
var editSuccess = "编辑成功";
var editError = "编辑失败";
var team$1 = "团队";
var fileTypeNotPatch = "请更新对应的文件类型";
var useScope = "使用范围";
var DialogCompanyTemplateEdit = {
	title: title$c,
	finishTip: finishTip,
	closeTip: closeTip,
	scopeName: scopeName,
	scopeTip1: scopeTip1,
	scopeTip2: scopeTip2,
	contactList: contactList,
	contactListBtn: contactListBtn,
	contactListBtnNew: contactListBtnNew,
	self: self,
	all: all,
	part: part,
	templateList: templateList,
	cloudUpload: cloudUpload,
	localUpload: localUpload,
	ok: ok,
	fileTypeError: fileTypeError,
	"delete": "删除",
	cancel: cancel$1,
	canceled: canceled,
	success: success,
	failed: failed,
	templateEmpty: templateEmpty,
	selectFileTips1: selectFileTips1,
	selectFileTips2: selectFileTips2,
	uploadingTips: uploadingTips,
	uploadFinishTips: uploadFinishTips,
	uploadButtonText: uploadButtonText,
	templateEmptyTips: templateEmptyTips,
	uploadBtn: uploadBtn,
	addFileBtn: addFileBtn,
	authText: authText,
	allNew: allNew,
	partNew: partNew,
	uploadingTitle: uploadingTitle,
	uploadFinishTitle: uploadFinishTitle,
	uploadingBtnText: uploadingBtnText,
	failedSpaceLimit: failedSpaceLimit,
	updateTemplate: updateTemplate,
	templateName: templateName,
	templateNameEmpty: templateNameEmpty,
	memberEmpty: memberEmpty,
	editSuccess: editSuccess,
	editError: editError,
	team: team$1,
	fileTypeNotPatch: fileTypeNotPatch,
	useScope: useScope
};

var title$b = "快捷提取链接插件";
var mulGet = "批量导出链接";
var logoText = "文档批量管理器";
var mulSettingShare = "批量设置分享权限";
var linkStyle = "链接样式预览";
var permTitle1 = "文档标题";
var permTitle2 = "分享权限";
var linkTitle1 = "链接+标题";
var linkTitle2 = "纯链接";
var linkTitle3 = "超链接";
var chagne = "修改";
var exportSuccess = "文档导出成功";
var saveAs = "保存至：";
var docCollect = "文档合集";
var exportAsDoc = "导出为文档";
var exportAsExcel = "导出为表格";
var copyTip = "文件权限提示";
var copyDesc = "复制的链接中有未公开分享文档，他人将无法查看，是否继续复制？";
var copyLink = "复制链接";
var changeDoc = "修改文档权限";
var onlyMeText = "仅我可见";
var choosed = "已选中";
var tiao = "文档";
var collecting = "导出中";
var linkCollect = "导出中";
var allSuccess = "全部导出成功";
var collectFail = "导出失败，";
var chooseDoc = "已选条目：";
var gewendang = "个文档";
var noPermText = "无权限操作";
var settingTxt$1 = "设置中...";
var settingTip1 = "设置完成，有";
var settingTip2 = "个文档修改失败，可重试";
var settingTip3 = "设置完成，全部文档修改成功";
var settingTip4 = "个文档高级设置失败，可重试";
var shareRange = "分享范围";
var shareRange1 = "任何人 可查看";
var shareRange2 = "任何人 可评论";
var shareRange3 = "任何人 可编辑";
var shareRangeCompanyRead = "本企业成员 可查看";
var shareRangeCompanyWrite = "本企业成员 可编辑";
var shareRangeCompanyComment = "本企业成员 可评论";
var shareRangeDesignatedPerson = "仅指定人 可见";
var settingSheet = "禁止添加、删除工作表";
var textTooltip = "仅支持对企业文档操作";
var txtDesignatedPerson = "批量设置暂不支持仅指定人可见";
var day30 = "30天";
var day7 = "7天";
var errorTip2 = "链接无法导出";
var errorTip3 = "链接导出失败";
var errorTip4 = "服务异常，请重试";
var exportTip = "导出提示";
var app = "应用";
var myCompanyDoc = "我的企业文档";
var forbidPermTxt = "禁止查看者下载、打印、导出、另存和复制内容";
var canSeeTxt = "可见";
var shareCompanyForbid = "团队管理员已禁止文档分享企业外";
var sharegroupForbid = "团队管理员已禁止文档分享团队外";
var shareGroupForbid2 = "部分企业文档不支持分享团队外";
var shareCompanyForbid2 = "部分企业文档不支持设置公开权限";
var feedbackText = "问题反馈";
var showFolder = "展示文件夹信息";
var QuickCollect = {
	title: title$b,
	mulGet: mulGet,
	logoText: logoText,
	mulSettingShare: mulSettingShare,
	linkStyle: linkStyle,
	permTitle1: permTitle1,
	permTitle2: permTitle2,
	linkTitle1: linkTitle1,
	linkTitle2: linkTitle2,
	linkTitle3: linkTitle3,
	"export": "导出",
	chagne: chagne,
	exportSuccess: exportSuccess,
	saveAs: saveAs,
	docCollect: docCollect,
	exportAsDoc: exportAsDoc,
	exportAsExcel: exportAsExcel,
	copyTip: copyTip,
	copyDesc: copyDesc,
	copyLink: copyLink,
	changeDoc: changeDoc,
	onlyMeText: onlyMeText,
	choosed: choosed,
	tiao: tiao,
	collecting: collecting,
	linkCollect: linkCollect,
	allSuccess: allSuccess,
	collectFail: collectFail,
	chooseDoc: chooseDoc,
	gewendang: gewendang,
	noPermText: noPermText,
	settingTxt: settingTxt$1,
	settingTip1: settingTip1,
	settingTip2: settingTip2,
	settingTip3: settingTip3,
	settingTip4: settingTip4,
	shareRange: shareRange,
	shareRange1: shareRange1,
	shareRange2: shareRange2,
	shareRange3: shareRange3,
	shareRangeCompanyRead: shareRangeCompanyRead,
	shareRangeCompanyWrite: shareRangeCompanyWrite,
	shareRangeCompanyComment: shareRangeCompanyComment,
	shareRangeDesignatedPerson: shareRangeDesignatedPerson,
	settingSheet: settingSheet,
	textTooltip: textTooltip,
	txtDesignatedPerson: txtDesignatedPerson,
	day30: day30,
	day7: day7,
	errorTip2: errorTip2,
	errorTip3: errorTip3,
	errorTip4: errorTip4,
	exportTip: exportTip,
	app: app,
	myCompanyDoc: myCompanyDoc,
	forbidPermTxt: forbidPermTxt,
	canSeeTxt: canSeeTxt,
	shareCompanyForbid: shareCompanyForbid,
	sharegroupForbid: sharegroupForbid,
	shareGroupForbid2: shareGroupForbid2,
	shareCompanyForbid2: shareCompanyForbid2,
	feedbackText: feedbackText,
	showFolder: showFolder
};

var title$a = "无法导出文档链接";
var desc$2 = "超出以下任一限制无法导出链接，请重新选择：";
var imgAlt = "提示";
var QuickCollectLimited = {
	title: title$a,
	desc: desc$2,
	imgAlt: imgAlt
};

var moresetting_title = "高级设置";
var moresetting_noshare_tip = "当前文档未开启分享，无法设置开关";
var moresetting_linkdownloadperm_desc = "适用于禁止查看者复用的文档";
var moresetting_publishfile_desc = "适用于公开发布的文档";
var moresetting_linkrenameperm_desc = "适用于多人填写的信息收集表";
var moresetting_watermarksetting_desc = "设置文档水印";
var moresetting_watermarkopen_desc = "已开启水印";
var moresetting_downloadperm_tit = "禁止查看者下载、打印、另存和复制内容";
var moresetting_downloadperm_subtit = "适用于禁止查看者复用的文档";
var moresetting_downloadperm_pop_tip = "开启后，仅具有查看权限的人将无法下载、打印、另存和复制内容";
var moresetting_downloadperm_ksheetForbid = "禁止查看者导出、打印、另存和复制内容";
var moresetting_downloadperm_ksheetPopText = "开启后，仅具有查看权限的人将无法导出、打印、另存和复制内容";
var moresetting_downloadperm_kdbtForbid = "禁止查看者导出、另存和复制内容";
var moresetting_downloadperm_kfpPopText = "开启后，仅具有查看权限的人将无法导出和另存";
var moresetting_downloadperm_kfpForbid = "禁止查看者导出和另存";
var moresetting_downloadperm_kdbtPopText = "开启后，仅具有查看权限的人将无法导出、另存和复制内容";
var moresetting_downloadperm_kprocessonForbid = "禁止查看者导出和另存";
var moresetting_downloadperm_kprocessonPopText = "开启后，仅具有查看权限的人将无法导出、另存";
var moresetting_downloadperm_kimgForbid = "禁止查看者下载和另存";
var moresetting_downloadperm_kimgPopText = "开启后，仅具有查看权限的人将无法下载、另存";
var moresetting_downloadperm_noshare_right = "当前文档未开启分享，暂无法设置开关";
var moresetting_linkrenameperm_ksheetRenameForbid = "禁止添加、删除工作表";
var moresetting_linkrenameperm_ksheetRenameForbidPop = "开启后，禁止协作者删除、新建、移动、重命名工作表";
var moresetting_linkrenameperm_permissionDenied = "您的操作权限不足";
var moresetting_linkrenameperm_noNetwork = "网络故障，请稍后重试";
var moresetting_linkrenameperm_serverError = "服务器故障，请稍后重试";
var moresetting_linkrenameperm_error = "操作失败，请稍后重试";
var moresetting_fullcomment_openComment = "允许加入分享的人查看、发表留言";
var moresetting_fullcomment_openCommentTips = "开启后，他人打开文档可发表留言及查看留言";
var moresetting_blockeditApplyswitch_blockEditApply = "禁止申请编辑权限";
var moresetting_blockeditApplyswitch_blockEditApplyTip = "开启后，加入分享的人将无法申请权限";
var moresetting_share_to_woa_error = "仅创建者允许开启水印";
var DialogAdvancedSetting = {
	moresetting_title: moresetting_title,
	moresetting_noshare_tip: moresetting_noshare_tip,
	moresetting_linkdownloadperm_desc: moresetting_linkdownloadperm_desc,
	moresetting_publishfile_desc: moresetting_publishfile_desc,
	moresetting_linkrenameperm_desc: moresetting_linkrenameperm_desc,
	moresetting_watermarksetting_desc: moresetting_watermarksetting_desc,
	moresetting_watermarkopen_desc: moresetting_watermarkopen_desc,
	moresetting_downloadperm_tit: moresetting_downloadperm_tit,
	moresetting_downloadperm_subtit: moresetting_downloadperm_subtit,
	moresetting_downloadperm_pop_tip: moresetting_downloadperm_pop_tip,
	moresetting_downloadperm_ksheetForbid: moresetting_downloadperm_ksheetForbid,
	moresetting_downloadperm_ksheetPopText: moresetting_downloadperm_ksheetPopText,
	moresetting_downloadperm_kdbtForbid: moresetting_downloadperm_kdbtForbid,
	moresetting_downloadperm_kfpPopText: moresetting_downloadperm_kfpPopText,
	moresetting_downloadperm_kfpForbid: moresetting_downloadperm_kfpForbid,
	moresetting_downloadperm_kdbtPopText: moresetting_downloadperm_kdbtPopText,
	moresetting_downloadperm_kprocessonForbid: moresetting_downloadperm_kprocessonForbid,
	moresetting_downloadperm_kprocessonPopText: moresetting_downloadperm_kprocessonPopText,
	moresetting_downloadperm_kimgForbid: moresetting_downloadperm_kimgForbid,
	moresetting_downloadperm_kimgPopText: moresetting_downloadperm_kimgPopText,
	moresetting_downloadperm_noshare_right: moresetting_downloadperm_noshare_right,
	moresetting_linkrenameperm_ksheetRenameForbid: moresetting_linkrenameperm_ksheetRenameForbid,
	moresetting_linkrenameperm_ksheetRenameForbidPop: moresetting_linkrenameperm_ksheetRenameForbidPop,
	moresetting_linkrenameperm_permissionDenied: moresetting_linkrenameperm_permissionDenied,
	moresetting_linkrenameperm_noNetwork: moresetting_linkrenameperm_noNetwork,
	moresetting_linkrenameperm_serverError: moresetting_linkrenameperm_serverError,
	moresetting_linkrenameperm_error: moresetting_linkrenameperm_error,
	moresetting_fullcomment_openComment: moresetting_fullcomment_openComment,
	moresetting_fullcomment_openCommentTips: moresetting_fullcomment_openCommentTips,
	moresetting_blockeditApplyswitch_blockEditApply: moresetting_blockeditApplyswitch_blockEditApply,
	moresetting_blockeditApplyswitch_blockEditApplyTip: moresetting_blockeditApplyswitch_blockEditApplyTip,
	moresetting_share_to_woa_error: moresetting_share_to_woa_error
};

var title$9 = "提示";
var txt1$e = "不再接收此文档的编辑申请";
var txt2$c = "任何人均可申请编辑";
var txt3$b = "修改设置";
var DialogGoToAdvancedSetting = {
	title: title$9,
	txt1: txt1$e,
	txt2: txt2$c,
	txt3: txt3$b
};

var txt0$d = "创建";
var txt1$d = "创建失败";
var txt2$b = "请输入20字以内团队名";
var txt3$a = "推荐";
var ShareCreateTeam = {
	txt0: txt0$d,
	txt1: txt1$d,
	txt2: txt2$b,
	txt3: txt3$a
};

var title$8 = "自定义有效期为超级会员功能";
var tips_1 = "灵活设置分享有效期，精确到指定日期时分";
var tips_2 = "超过有效期即禁用分享，隐私保护更安全";
var vipButton = "立即升级";
var PCCustomShareDateDialog = {
	title: title$8,
	tips_1: tips_1,
	tips_2: tips_2,
	vipButton: vipButton
};

var txt01 = "体验「协作空间」";
var txt02 = "进入协作空间";
var txt03 = "以文件夹以外的形态，探索更好的团队协作方式";
var txt04 = "*功能尚在早期尝试阶段，仅对公司内部同事开放使用";
var txt05 = "体验「协作空间」";
var txt06 = "暂不体验";
var txt07 = "升级失败";
var txt08 = "当前团队暂未开启协作空间";
var txt09 = "暂时无法访问当前团队的协作空间。";
var txt10$3 = "您可通知团队拥有者和管理员开启空间。";
var txt11$3 = "发送通知";
var txt12$3 = "前往官网，了解更多";
var txt13$3 = "已发送通知";
var txt14$3 = "发送失败，请重试";
var TeamSpace = {
	txt01: txt01,
	txt02: txt02,
	txt03: txt03,
	txt04: txt04,
	txt05: txt05,
	txt06: txt06,
	txt07: txt07,
	txt08: txt08,
	txt09: txt09,
	txt10: txt10$3,
	txt11: txt11$3,
	txt12: txt12$3,
	txt13: txt13$3,
	txt14: txt14$3
};

var showAdInfo = "展示企业认证信息";
var popTxt = "开启后，文档将对加入分享的人展示企业认证信息";
var ShowAuthenticationInfo = {
	showAdInfo: showAdInfo,
	popTxt: popTxt
};

var corpMarkTxt = "展示企业认证信息";
var corpMarkTipTxt = "开启后，文档将对外展示本企业认证信息";
var corpMarkSwitch = {
	corpMarkTxt: corpMarkTxt,
	corpMarkTipTxt: corpMarkTipTxt
};

var txt0$c = "分享";
var shareMiniCode = "通过小程序发送给微信好友";
var txt4$7 = "二维码";
var txt2$a = "取消分享";
var perm_setting = "权限设置";
var DialogShareCooperate = {
	txt0: txt0$c,
	shareMiniCode: shareMiniCode,
	txt4: txt4$7,
	txt2: txt2$a,
	perm_setting: perm_setting
};

var txt1$c = "请确认移除选中的{0}个人";
var txt2$9 = "取消";
var txt3$9 = "确认";
var txt4$6 = "移除成功";
var txt5$6 = "移除失败";
var MultiManageConfirm = {
	txt1: txt1$c,
	txt2: txt2$9,
	txt3: txt3$9,
	txt4: txt4$6,
	txt5: txt5$6
};

var surveyTitle = "小调查";
var content = "你愿意推荐朋友或同事使用 ";
var contentEnd = " 吗？";
var thxFeedback = "感谢你的反馈";
var improve = "你认为哪些方面可以改进？";
var submit = "提交";
var submitFeedback = "提交反馈";
var submitSuccess = "提交成功";
var submitInfo = "我们将为你提供更专业，更优质的服务体验";
var certainlyNot = "肯定不会";
var veryWillingTo = "非常愿意";
var Nps = {
	surveyTitle: surveyTitle,
	content: content,
	contentEnd: contentEnd,
	thxFeedback: thxFeedback,
	improve: improve,
	submit: submit,
	submitFeedback: submitFeedback,
	submitSuccess: submitSuccess,
	submitInfo: submitInfo,
	certainlyNot: certainlyNot,
	veryWillingTo: veryWillingTo
};

var dialog_approve_open_coop_title = "请重新开启协作";
var dialog_approve_coop_members = "协作人";
var read$3 = "仅查看";
var comment$2 = "可评论";
var write$2 = "可编辑";
var loading$1 = "请稍等";
var common_txt1 = "已重新开启协作";
var common_txt2 = "开启失败";
var common_txt3 = "加载失败";
var mobile_txt1 = "请重新开启协作";
var mobile_txt2 = "协作已关闭";
var mobile_txt3 = "请重新开启以便新成员访问";
var mobile_txt4 = "开启协作";
var mobile_txt5 = "协作成员";
var mobile_txt6 = "新申请加入";
var mobile_txt7 = "已加入的协作者";
var mobile_txt8 = "查看或修改成员列表";
var mobile_txt9 = "将恢复访问";
var pc_txt1 = "请重新开启协作";
var pc_txt2 = "协作已关闭，请重新开启以便新成员访问";
var pc_txt3 = "开启协作";
var pc_txt4 = "协作成员";
var pc_txt5 = "新申请加入";
var pc_txt6 = "已加入的协作者";
var pc_txt7 = "查看或修改成员列表";
var pc_txt8 = "将一同恢复访问";
var pc_txt9 = "当关闭协作时，已加入的协作者会被暂停访问，直到重新开启协作";
var ApproveOpenCoop = {
	dialog_approve_open_coop_title: dialog_approve_open_coop_title,
	dialog_approve_coop_members: dialog_approve_coop_members,
	read: read$3,
	comment: comment$2,
	write: write$2,
	loading: loading$1,
	common_txt1: common_txt1,
	common_txt2: common_txt2,
	common_txt3: common_txt3,
	mobile_txt1: mobile_txt1,
	mobile_txt2: mobile_txt2,
	mobile_txt3: mobile_txt3,
	mobile_txt4: mobile_txt4,
	mobile_txt5: mobile_txt5,
	mobile_txt6: mobile_txt6,
	mobile_txt7: mobile_txt7,
	mobile_txt8: mobile_txt8,
	mobile_txt9: mobile_txt9,
	pc_txt1: pc_txt1,
	pc_txt2: pc_txt2,
	pc_txt3: pc_txt3,
	pc_txt4: pc_txt4,
	pc_txt5: pc_txt5,
	pc_txt6: pc_txt6,
	pc_txt7: pc_txt7,
	pc_txt8: pc_txt8,
	pc_txt9: pc_txt9
};

var hasCoopLinkTxt = "协作已开启";
var hasShareLinkTxt = "分享链接已开启";
var noPermCoopLinkTxt = "协作详情";
var noPermShareLinkTxt = "分享链接详情";
var openTxt = "已开启";
var closeTxt = "未开启";
var coopTxt = "协作";
var shareTxt = "链接分享";
var settingTxt = "设置";
var sendCoopLinkTxt = "发送协作链接";
var sendShareLinkTxt = "发送分享链接";
var openCoopTxt = "开启协作";
var openShareTxt = "开启分享链接";
var applyShareTxt = "请先向管理员申请「分享」权限";
var unknownErrorTxt = "未知错误，请重试";
var sendTxt = "发送";
var sendImgTxt = "导出为图片";
var sendPDFTxt = "导出为PDF";
var sendXLSXTxt = "导出为xlsx文件";
var sendFileTxt = "发送文件";
var downloadSuccesTxt = "导出成功";
var noPermDownloadTxt = "你没有该文档下载权限";
var ShareCooperate = {
	hasCoopLinkTxt: hasCoopLinkTxt,
	hasShareLinkTxt: hasShareLinkTxt,
	noPermCoopLinkTxt: noPermCoopLinkTxt,
	noPermShareLinkTxt: noPermShareLinkTxt,
	openTxt: openTxt,
	closeTxt: closeTxt,
	coopTxt: coopTxt,
	shareTxt: shareTxt,
	settingTxt: settingTxt,
	sendCoopLinkTxt: sendCoopLinkTxt,
	sendShareLinkTxt: sendShareLinkTxt,
	openCoopTxt: openCoopTxt,
	openShareTxt: openShareTxt,
	applyShareTxt: applyShareTxt,
	unknownErrorTxt: unknownErrorTxt,
	sendTxt: sendTxt,
	sendImgTxt: sendImgTxt,
	sendPDFTxt: sendPDFTxt,
	sendXLSXTxt: sendXLSXTxt,
	sendFileTxt: sendFileTxt,
	downloadSuccesTxt: downloadSuccesTxt,
	noPermDownloadTxt: noPermDownloadTxt
};

var dialog_logout_title = "退出登录";
var dialog_logout_text1 = "服务正在升级，您可以通过以下方式选择登录其他账号使用金山文档：";
var dialog_logout_text2 = "方法1：清除浏览器缓存后刷新当前页面";
var dialog_logout_text3 = "方法2：打开新的无痕窗口，重新访问金山文档";
var i_know = "我知道了";
var LogoutFail = {
	dialog_logout_title: dialog_logout_title,
	dialog_logout_text1: dialog_logout_text1,
	dialog_logout_text2: dialog_logout_text2,
	dialog_logout_text3: dialog_logout_text3,
	i_know: i_know
};

var dialogTitle = "金山文档";
var dialogContent = "授权金山文档使用真实姓名、学号等信息，用于团队内协作展示。";
var dialogCheckboxLabel = "今日不再展示";
var dialogConfirmText = "去授权";
var TeamAuth = {
	dialogTitle: dialogTitle,
	dialogContent: dialogContent,
	dialogCheckboxLabel: dialogCheckboxLabel,
	dialogConfirmText: dialogConfirmText
};

var invite = {
	txt0: "邀请已发送",
	txt1: "成员接受后即可加入企业",
	txt2: "发送链接给同事，同事点击即可申请加入企业",
	txt3: "扫码发送邀请给同事",
	txt4: "复制链接",
	txt5: "我的联系人",
	txt6: "取消",
	txt7: "确定",
	txt8: "复制失败",
	txt9: "复制成功",
	txt10: "设置",
	txt11: "允许成员邀请同事加入企业"
};
var approve = {
	txt0: "还没有同事申请加入企业",
	txt1: "已通过",
	txt2: "已拒绝",
	txt3: "通过",
	txt4: "拒绝",
	txt5: "已验证手机加入",
	txt6: "已验证邮箱加入",
	txt7: "已免审加入",
	txt8: "审批失败",
	txt9: "前往购买",
	txt10: "成员席位已满，无法添加该成员，请增购席位后再审批",
	txt11: "成员席位已满，无法添加该成员，您可购买足够席位的套餐再进行审批。",
	txt12: "待审批成员"
};
var dialog$2 = {
	title: "办理员工入职"
};
var CompanyAdminInviteApprove = {
	invite: invite,
	approve: approve,
	dialog: dialog$2
};

var dialog$1 = {
	title: "办理员工离职"
};
var desc$1 = "管理员可一键交接已离职员工下的数据：【我的企业文档】、团队文档、未来日程、以及安全文档。";
var dimission = {
	txt0: "已离职员工",
	txt1: "离职",
	txt2: "无数据",
	txt3: "更多请前往{0}处理",
	txt4: "管理后台",
	handover_status: {
		wait: "去交接",
		part_complete: "继续交接",
		complete: "交接记录",
		no_require: "无需交接",
		handovering: "交接中"
	}
};
var CompanyAdminDismission = {
	dialog: dialog$1,
	desc: desc$1,
	dimission: dimission
};

var noPermission = "没有权限";
var dialog = {
	title: "企业文档安全设置"
};
var shareOutside = {
	title: "禁止全部企业文档分享到企业外"
};
var fileOutside = {
	title: "禁止全部企业文档转移到企业外"
};
var showWatermark = {
	title: "显示企业文档水印",
	setting: "水印设置"
};
var CompanyAdminDocSettings = {
	noPermission: noPermission,
	dialog: dialog,
	shareOutside: shareOutside,
	fileOutside: fileOutside,
	showWatermark: showWatermark
};

var txt0$b = "团队协作，高效办公";
var txt1$b = "在这里与你的同事一起，高效在线协作，彻底告别本地文件找不到、版本杂、协作烦";
var OperationBanner = {
	txt0: txt0$b,
	txt1: txt1$b
};

var txt0$a = "正在协作，点击头像定位";
var txt1$a = "正在查看，点击头像定位";
var txt2$8 = "只读权限";
var txt3$8 = "申请编辑";
var txt4$5 = "可评论权限";
var txt5$5 = "正在协作";
var txt6$5 = "正在查看";
var mine = "（我）";
var read$2 = "可查看";
var comment$1 = "可评论";
var write$1 = "可编辑";
var notLogin = "未登录";
var creator = "文档创建者";
var encrytUser = "加密者";
var owner$1 = "文档所有者";
var changePermSuccess = "权限已设置成功";
var removeSuccess = "已将「{0}」移除";
var anyWrite = "任何人可编辑";
var anyComment = "任何人可评论";
var anyRead = "任何人可查看";
var CollaboratorItem = {
	txt0: txt0$a,
	txt1: txt1$a,
	txt2: txt2$8,
	txt3: txt3$8,
	txt4: txt4$5,
	txt5: txt5$5,
	txt6: txt6$5,
	mine: mine,
	read: read$2,
	comment: comment$1,
	write: write$1,
	notLogin: notLogin,
	creator: creator,
	encrytUser: encrytUser,
	owner: owner$1,
	changePermSuccess: changePermSuccess,
	removeSuccess: removeSuccess,
	anyWrite: anyWrite,
	anyComment: anyComment,
	anyRead: anyRead
};

var txt0$9 = "邀请已发送";
var txt1$9 = "邀请失败";
var txt2$7 = "最近与你协作过文档";
var txt3$7 = "TA是您的联系人";
var txt4$4 = "已复制链接，可发送给同事申请加入";
var txt5$4 = "复制失败";
var txt6$4 = "邀请成员加入";
var txt7$4 = "发送邀请消息";
var txt8$4 = "复制链接，邀请成员";
var DialogCollaborationInviteMembers = {
	txt0: txt0$9,
	txt1: txt1$9,
	txt2: txt2$7,
	txt3: txt3$7,
	txt4: txt4$4,
	txt5: txt5$4,
	txt6: txt6$4,
	txt7: txt7$4,
	txt8: txt8$4
};

var txt1$8 = "设置";
var DialogEntFolderShareSetting = {
	txt1: txt1$8
};

var cropTeamDes = "共享文件夹升级为企业团队，会产生以下影响：";
var cropTeamDes1 = "升级操作不可逆，共享文件夹所有资料将移入企业";
var cropTeamDes2 = "升级完成后，共享文件夹成员将同步加入至企业团队";
var cropTeamDes3 = "会员权益依然保留在当前个人账号";
var createCropErrText = "创建企业失败";
var getRewardErr = "权益发送失败";
var noSupport = "企业成员席位不足，请购买成员席位后尝试升级！";
var equityWarn1 = "为提升企业使用体验，我们将在你";
var equityWarn2 = "开始升级后";
var equityWarn3 = "赠送企业以下权益：";
var equityName1 = "企业空间";
var equityName2 = "成员席位";
var equityUnitLabel = "有效期：";
var equityUnitPeople = "人";
var equityUnitDay = "天";
var equityBtn = "开始升级";
var equityBtn1 = "我知道了";
var equityBtn2 = "暂不使用";
var equityTitle = "企业成员席位不足";
var equityTitle1 = "升级权益限免赠送";
var DialogShareFolderUPToCorpTeam = {
	cropTeamDes: cropTeamDes,
	cropTeamDes1: cropTeamDes1,
	cropTeamDes2: cropTeamDes2,
	cropTeamDes3: cropTeamDes3,
	createCropErrText: createCropErrText,
	getRewardErr: getRewardErr,
	noSupport: noSupport,
	equityWarn1: equityWarn1,
	equityWarn2: equityWarn2,
	equityWarn3: equityWarn3,
	equityName1: equityName1,
	equityName2: equityName2,
	equityUnitLabel: equityUnitLabel,
	equityUnitPeople: equityUnitPeople,
	equityUnitDay: equityUnitDay,
	equityBtn: equityBtn,
	equityBtn1: equityBtn1,
	equityBtn2: equityBtn2,
	equityTitle: equityTitle,
	equityTitle1: equityTitle1
};

var fileName = "文件名";
var size = "大小";
var extract = "解压";
var cancel = "取消";
var extractTo = "解压文件至";
var extracting = "正在解压文件，请稍后... {progress}%";
var extractSuccess = "解压文件完毕";
var extractFail = "解压失败";
var extractRetry = "刷新重试";
var extractFailTips = "当前文件无法解压";
var empty$1 = "没有内容";
var emptyTips = "文件夹中没有内容哦～";
var notSupport = "压缩包中暂不支持预览此格式文件";
var loadingText$1 = "正在解压中";
var networkError = "网络异常，请稍后重试";
var ArchivePreview = {
	fileName: fileName,
	size: size,
	extract: extract,
	cancel: cancel,
	extractTo: extractTo,
	extracting: extracting,
	extractSuccess: extractSuccess,
	extractFail: extractFail,
	extractRetry: extractRetry,
	extractFailTips: extractFailTips,
	empty: empty$1,
	emptyTips: emptyTips,
	notSupport: notSupport,
	loadingText: loadingText$1,
	networkError: networkError
};

var title$7 = "创建共享文件夹";
var desc = "可邀请成员加入，共同查看、编辑文件。所有修改，将同步到共享文件夹";
var defaultShareFolderName = "新建共享文件夹";
var defaultPlaceholder = "请输入共享文件夹名";
var cancelText = "取消";
var confirmText = "立即创建";
var toastSuccess = "创建成功";
var toastDefaultError = "共享文件夹创建失败";
var toastErrorMissingName = "请输入共享文件夹名称";
var toastErrorInvalidChars = "文件夹名不能包含特殊字符： /\\;:*?\"<>|%&,";
var toastErrorNameTooLong = "文件名不能超过240个字符";
var multiAccountSwitchDialogName = "切换到企业（团队）账号后使用团队高级共享";
var multiAccountSwitchDialogDesc = "创建新的企业开启高级共享";
var multiAccountSwitchDialogBtn = "点此新建企业";
var DialogCreateShareFolder = {
	title: title$7,
	desc: desc,
	defaultShareFolderName: defaultShareFolderName,
	defaultPlaceholder: defaultPlaceholder,
	cancelText: cancelText,
	confirmText: confirmText,
	toastSuccess: toastSuccess,
	toastDefaultError: toastDefaultError,
	toastErrorMissingName: toastErrorMissingName,
	toastErrorInvalidChars: toastErrorInvalidChars,
	toastErrorNameTooLong: toastErrorNameTooLong,
	multiAccountSwitchDialogName: multiAccountSwitchDialogName,
	multiAccountSwitchDialogDesc: multiAccountSwitchDialogDesc,
	multiAccountSwitchDialogBtn: multiAccountSwitchDialogBtn
};

var title$6 = "已切换为企业账号";
var tip = "当前企业暂不支持新建团队，请联系管理员开启。";
var btnText$2 = "确定";
var DialogCreateTeamDenied = {
	title: title$6,
	tip: tip,
	btnText: btnText$2
};

var title$5 = "创建团队开启高效协作";
var description = "团队资料统一管理，轻松高效多端办公，文档安全更有保障";
var feature1$1 = "大容量团队云空间";
var feature2$1 = "多人同时协作";
var feature3$1 = "权限管控防泄漏";
var tipsTitle$1 = "使用团队的流程：";
var tip1$2 = "团队仅限企业账号使用，创建团队时需要先创建企业";
var noMoreReminderText$1 = "不再提醒";
var btnText$1 = "立即创建";
var DialogCreateTeamGuidance = {
	title: title$5,
	description: description,
	feature1: feature1$1,
	feature2: feature2$1,
	feature3: feature3$1,
	tipsTitle: tipsTitle$1,
	tip1: tip1$2,
	noMoreReminderText: noMoreReminderText$1,
	btnText: btnText$1
};

var title1 = "创建团队";
var title2 = "新建团队成功";
var text1$1 = "团队名称";
var text2$1 = "请填写团队名称（2-100字）";
var text3 = "分享链接邀请成员加入团队";
var text4 = "你可以将其他账号的文件导入企业团队中";
var text5 = "导入其他账号文件";
var text6 = "如何开展企业团队在线协作？点击";
var text7 = "查看介绍";
var btnText1$1 = "确定";
var createErrorTip$1 = "创建团队失败";
var emptyTip = "请输入团队名称";
var copyText1 = "复制链接";
var copyText2 = "复制成功";
var copyText3 = "复制失败";
var DialogCreateTeamSimply = {
	title1: title1,
	title2: title2,
	text1: text1$1,
	text2: text2$1,
	text3: text3,
	text4: text4,
	text5: text5,
	text6: text6,
	text7: text7,
	btnText1: btnText1$1,
	createErrorTip: createErrorTip$1,
	emptyTip: emptyTip,
	copyText1: copyText1,
	copyText2: copyText2,
	copyText3: copyText3
};

var title$4 = "团队全新升级";
var feature1 = "存储空间更充足";
var feature2 = "资料共享更便捷";
var feature3 = "权限设置更丰富";
var featureDesc1 = "邀请3人可享10TB企业存储空间";
var featureDesc2 = "跨部门数据共享，云端实时共享资料";
var featureDesc3 = "灵活设置编辑/查看权限，多场景管控";
var tipsTitle = "本次升级，对你具体的影响：";
var tip1$1 = "后续新建团队时，需使用企业账号";
var noMoreReminderText = "不再提醒";
var btnText = "我知道了";
var DialogCreateTeamUpgradeAnnouncement = {
	title: title$4,
	feature1: feature1,
	feature2: feature2,
	feature3: feature3,
	featureDesc1: featureDesc1,
	featureDesc2: featureDesc2,
	featureDesc3: featureDesc3,
	tipsTitle: tipsTitle,
	tip1: tip1$1,
	noMoreReminderText: noMoreReminderText,
	btnText: btnText
};

var title$3 = "导入完成！";
var desc1 = "本次共计导入";
var desc2 = "个文件/文件夹。";
var text = "分享链接邀请更多成员加入协作";
var DialogCreateTeamImportDataSuccessfully = {
	title: title$3,
	desc1: desc1,
	desc2: desc2,
	text: text
};

var title$2 = "新建团队需使用企业账号，请先切换账号";
var tip1 = "可切换以下企业账号来新建团队：";
var tip2 = "以下账号需登录后才可选择：";
var btnText1 = "切换为该企业账号";
var btnText2 = "登录该企业账号";
var text1 = "想创建新的企业？";
var text2 = "点击这里";
var switchErrorTip$1 = "账号切换失败";
var MultiAccountSwitch = {
	title: title$2,
	tip1: tip1,
	tip2: tip2,
	btnText1: btnText1,
	btnText2: btnText2,
	text1: text1,
	text2: text2,
	switchErrorTip: switchErrorTip$1
};

var createErrorTip = "创建企业失败，请重试";
var switchErrorTip = "账号切换失败";
var CreateEnterprise = {
	createErrorTip: createErrorTip,
	switchErrorTip: switchErrorTip
};

var txt1$7 = "将开启文档协作，并向所选用户发送协作邀请";
var txt2$6 = "取消";
var txt3$6 = "开启协作";
var title$1 = "继续";
var EntSearchAddCollaConfrm = {
	txt1: txt1$7,
	txt2: txt2$6,
	txt3: txt3$6,
	title: title$1
};

var txt0$8 = "合作";
var CooperateTagIcon = {
	txt0: txt0$8
};

var txt0$7 = "合作";
var txt1$6 = "团队归属方";
var txt2$5 = "合作方";
var txt3$5 = "加载中...";
var PartnerInformationPanel = {
	txt0: txt0$7,
	txt1: txt1$6,
	txt2: txt2$5,
	txt3: txt3$5
};

var txt0$6 = "企业公开";
var txt1$5 = "管理员已将本团队开启了企业内知识视图，对所有企业成员可见";
var txt3$4 = "公开范围";
var PublicInformationPanel = {
	txt0: txt0$6,
	txt1: txt1$5,
	txt3: txt3$4
};

var externalFailListTitle = "受企业安全策略限制，该成员暂时不支持加入团队。以下{0}人添加失败：";
var associationFailListTitle = "成员不在关联组织的共享范围内。以下{0}人添加失败：";
var txt0$5 = "关闭";
var AddMemberFailedTips = {
	externalFailListTitle: externalFailListTitle,
	associationFailListTitle: associationFailListTitle,
	txt0: txt0$5
};

var dialog_title = "转让文档所有权";
var receive_title = "文档接收";
var common_error = "加载失败";
var step1 = "转让对象，通过链接接受邀请";
var step2 = "所有者，确认转让文档所有权";
var step3 = "转让完成";
var tips1 = "查看";
var tips2 = "转让流程：";
var tips3 = "重置邀请链接";
var tips4 = "复制转让邀请链接";
var tips5 = "转让链接已失效";
var tips6 = "等待转让对象接受邀请，邀请链接24小时内有效";
var tips7 = "已成功转让文档给";
var tips8 = "确认转让";
var tips9 = "接收转让邀请";
var tips10 = "转让文档给你";
var tips11 = "申请接收文件";
var tips12 = "【金山文档】";
var tips13 = "复制成功，发送给好友接收";
var tips14 = "复制失败";
var tips15 = "重置成功，可重新邀请好友";
var tips16 = "重置失败";
var tips17 = "转让成功";
var tips18 = "已成为被转让对象，请等待所有者确认";
var tips19 = "已移除";
var tips20 = "复制审批链接";
var tips21 = "复制成功，发送给好友审批";
var tips22 = "未知错误";
var tips23 = "刷新";
var tips24 = "转让失败";
var tips25 = "接收失败";
var tips26 = "删除失败";
var TransferFileApprove = {
	dialog_title: dialog_title,
	receive_title: receive_title,
	common_error: common_error,
	step1: step1,
	step2: step2,
	step3: step3,
	tips1: tips1,
	tips2: tips2,
	tips3: tips3,
	tips4: tips4,
	tips5: tips5,
	tips6: tips6,
	tips7: tips7,
	tips8: tips8,
	tips9: tips9,
	tips10: tips10,
	tips11: tips11,
	tips12: tips12,
	tips13: tips13,
	tips14: tips14,
	tips15: tips15,
	tips16: tips16,
	tips17: tips17,
	tips18: tips18,
	tips19: tips19,
	tips20: tips20,
	tips21: tips21,
	tips22: tips22,
	tips23: tips23,
	tips24: tips24,
	tips25: tips25,
	tips26: tips26
};

var txt0$4 = "网页转文档";
var txt1$4 = "保存成功";
var txt2$4 = "保存失败";
var DialogConvertPage = {
	txt0: txt0$4,
	txt1: txt1$4,
	txt2: txt2$4
};

var txt0$3 = "输入网页链接，将链接内容一键保存为金山文档";
var txt1$3 = "立即保存";
var txt2$3 = "请先输入链接";
var txt3$3 = "链接不符合规范，请重新输入";
var txt4$3 = "暂不支持收藏此类链接";
var txt5$3 = "打开";
var txt6$3 = "保存中...";
var txt7$3 = "链接格式错误";
var txt8$3 = "保存失败，该链接不支持转换";
var txt9$2 = "网络异常，请稍后重试";
var txt10$2 = "服务异常，请稍后重试";
var txt11$2 = "链接已保存为文档";
var txt12$2 = "保存失败，云空间已满";
var txt13$2 = "清理空间";
var txt14$2 = "重试";
var txt15$2 = "文档已保存至：";
var txt16$1 = "保存成功";
var txt17 = "保存失败";
var txt18 = "返回";
var txt19 = "打开文档";
var txt20 = "取消";
var txt21 = "抱歉，该链接暂不支持转换";
var txt22 = "链接不符合规范，请重新输入";
var txt23 = "我知道了";
var txt24 = "云空间已满，请清理空间后重试";
var txt25 = "自动保存中，完成后提醒你";
var txt26 = "保存中";
var txt27 = "输入网页链接，将链接内容一键保存为PDF";
var txt28 = "该链接不支持转为PDF";
var ConvertPage = {
	txt0: txt0$3,
	txt1: txt1$3,
	txt2: txt2$3,
	txt3: txt3$3,
	txt4: txt4$3,
	txt5: txt5$3,
	txt6: txt6$3,
	txt7: txt7$3,
	txt8: txt8$3,
	txt9: txt9$2,
	txt10: txt10$2,
	txt11: txt11$2,
	txt12: txt12$2,
	txt13: txt13$2,
	txt14: txt14$2,
	txt15: txt15$2,
	txt16: txt16$1,
	txt17: txt17,
	txt18: txt18,
	txt19: txt19,
	txt20: txt20,
	txt21: txt21,
	txt22: txt22,
	txt23: txt23,
	txt24: txt24,
	txt25: txt25,
	txt26: txt26,
	txt27: txt27,
	txt28: txt28
};

var txt0$2 = "邀请已发送";
var txt1$2 = "邀请失败";
var txt2$2 = "最近与你协作过文档";
var txt3$2 = "TA是您的联系人";
var txt4$2 = "已复制链接，可发送给同事申请加入";
var txt5$2 = "复制失败";
var txt6$2 = "邀请成员加入";
var txt7$2 = "发送邀请消息";
var txt8$2 = "复制链接，邀请成员";
var DialogNewEnterpriseGuidance = {
	txt0: txt0$2,
	txt1: txt1$2,
	txt2: txt2$2,
	txt3: txt3$2,
	txt4: txt4$2,
	txt5: txt5$2,
	txt6: txt6$2,
	txt7: txt7$2,
	txt8: txt8$2
};

var checkAll = "全选";
var sendNotice = "发送通知";
var dialogInstructions = "说明：通知消息将针对成员的个人账号发送";
var loadingText = "加载中...";
var noticeMsg = "已向成员的个人账号发送通知消息";
var initError = "网络错误，请稍后再试";
var empty = "企业使用情况较好，当前已无未使用的成员";
var sendingText = "发送中...";
var notSuperAdmin = "当前账号无权限邀请成员，请联系企业管理员。";
var subtitle = "查看成员将会接收到的提醒信息";
var popoverTip = "* 该通知仅针对成员的个人账号发送";
var popoverTitle = "成员会接收以下提醒内容：";
var NotifyUnusedMembers = {
	checkAll: checkAll,
	sendNotice: sendNotice,
	dialogInstructions: dialogInstructions,
	loadingText: loadingText,
	noticeMsg: noticeMsg,
	initError: initError,
	empty: empty,
	sendingText: sendingText,
	notSuperAdmin: notSuperAdmin,
	subtitle: subtitle,
	popoverTip: popoverTip,
	popoverTitle: popoverTitle
};

var read$1 = "查看";
var MessageBubble = {
	read: read$1
};

var addFaceFileDesc = "是否将此文档添加至现有的「面对面看文档」？";
var addFileTxt = "添加";
var createNewFaceText = "发起新的面对面";
var addFaceFilePermDesc = "该文档限定了访问者，「面对面」成员可能无法查看，建议调整权限后重试。";
var still = "仍然";
var launch = "发起";
var tipsText = "提示";
var endFaceByNewFaceDesc = "发起新的「面对面看文档」会结束当前的面对面，是否确定结束？";
var exitFaceByNewFaceDesc = "发起新的「面对面看文档」会退出当前的面对面，是否确定退出？";
var endTxt = "确定结束";
var exitTxt = "确定退出";
var addSuccessTxt = "添加成功";
var endCurFaceTxt = "结束当前「面对面文档」";
var exitCurFaceTxt = "退出当前「面对面文档」";
var ShareV3Face = {
	addFaceFileDesc: addFaceFileDesc,
	addFileTxt: addFileTxt,
	createNewFaceText: createNewFaceText,
	addFaceFilePermDesc: addFaceFilePermDesc,
	still: still,
	launch: launch,
	tipsText: tipsText,
	endFaceByNewFaceDesc: endFaceByNewFaceDesc,
	exitFaceByNewFaceDesc: exitFaceByNewFaceDesc,
	endTxt: endTxt,
	exitTxt: exitTxt,
	addSuccessTxt: addSuccessTxt,
	endCurFaceTxt: endCurFaceTxt,
	exitCurFaceTxt: exitCurFaceTxt
};

var rewardReceived = "领取奖励";
var rewardView = "前往查看";
var rewardSuccess = "权益领取成功，可前往管理后台查看。";
var rewardAlreadyReceived = "您已领取过该权益，请前往管理后台查看";
var rewardFailed = "领取失败";
var TaskPanelReward = {
	rewardReceived: rewardReceived,
	rewardView: rewardView,
	rewardSuccess: rewardSuccess,
	rewardAlreadyReceived: rewardAlreadyReceived,
	rewardFailed: rewardFailed
};

var rewardClaim = "点此领取>";
var growthPlan = "成长计划>";
var benefitCenter = "管理后台>";
var TaskPanel = {
	rewardClaim: rewardClaim,
	growthPlan: growthPlan,
	benefitCenter: benefitCenter
};

var txt0$1 = "链接邀请";
var txt1$1 = "二维码邀请";
var txt2$1 = "输入邀请链接即可加入{0}";
var txt3$1 = "复制邀请链接";
var txt4$1 = "扫码{0}二维码即可加入{0}";
var txt5$1 = "下载二维码";
var txt6$1 = "复制二维码";
var txt7$1 = "复制成功";
var txt8$1 = "复制失败";
var txt9$1 = "邀请你一起在「{0}」进行文档协作";
var txt10$1 = "{0}邀请您加入";
var txt11$1 = "扫一扫上方二维码，加入{0}";
var txt12$1 = "有效期：";
var txt13$1 = "业务协同，远程会议，高效办公";
var txt14$1 = "企业";
var txt15$1 = "永久";
var txt16 = "邀请二维码";
var CompanyInvitePanel = {
	txt0: txt0$1,
	txt1: txt1$1,
	txt2: txt2$1,
	txt3: txt3$1,
	txt4: txt4$1,
	txt5: txt5$1,
	txt6: txt6$1,
	txt7: txt7$1,
	txt8: txt8$1,
	txt9: txt9$1,
	txt10: txt10$1,
	txt11: txt11$1,
	txt12: txt12$1,
	txt13: txt13$1,
	txt14: txt14$1,
	txt15: txt15$1,
	txt16: txt16
};

var txt0 = "下载客户端";
var txt1 = "本地办公";
var txt2 = "在线办公";
var txt3 = "一站式办公平台";
var txt4 = "金山文档｜WPS云文档";
var txt5 = "微信小程序";
var txt6 = "网页收藏插件";
var txt7 = "立即下载";
var txt8 = "传统Office";
var txt9 = "移动端";
var txt10 = "在线协作办公";
var txt11 = "AI智能办公";
var txt12 = "手机扫码下载";
var txt13 = "手机扫码使用";
var txt14 = "纯在线办公";
var txt15 = "复制下载客户端链接";
var DownloadClientPanel = {
	txt0: txt0,
	txt1: txt1,
	txt2: txt2,
	txt3: txt3,
	txt4: txt4,
	txt5: txt5,
	txt6: txt6,
	txt7: txt7,
	txt8: txt8,
	txt9: txt9,
	txt10: txt10,
	txt11: txt11,
	txt12: txt12,
	txt13: txt13,
	txt14: txt14,
	txt15: txt15
};

var removeSuggestion = "建议";
var message = "已移除 {0} 的访问权限，为避免其再次进入，建议修改文档链接设置。";
var current = "当前";
var suggest = "建议";
var anyone = "所有人";
var someone = "指定人";
var read = "仅查看";
var write = "可编辑";
var comment = "可查看和评论";
var btn_cancel = "下次再说";
var btn_submit = "立即修改";
var many_users = "{0}，{1} 等{2}人";
var RemoveSuggestion = {
	removeSuggestion: removeSuggestion,
	message: message,
	current: current,
	suggest: suggest,
	anyone: anyone,
	someone: someone,
	read: read,
	write: write,
	comment: comment,
	btn_cancel: btn_cancel,
	btn_submit: btn_submit,
	many_users: many_users
};

var scanCodeTiptxt0 = "打开手机微信“扫一扫”，";
var scanCodeTiptxt1 = "向好友发送私密邀请";
var onlyCreatorTip = "只有你分享的微信好友/群成员可访问，转发无效";
var scopOfApplicationTip = "适用于公司微信群、付费私域群、私人客户服务等场景";
var privicyInvite = "私密链接";
var privicyWaterMark = "私密水印";
var AddCollaboratorPrivateInvitation = {
	scanCodeTiptxt0: scanCodeTiptxt0,
	scanCodeTiptxt1: scanCodeTiptxt1,
	onlyCreatorTip: onlyCreatorTip,
	scopOfApplicationTip: scopOfApplicationTip,
	privicyInvite: privicyInvite,
	privicyWaterMark: privicyWaterMark
};

var title = "管理协作者";
var inviteFriends = "邀请好友一起协作";
var batchManagement = "批量管理";
var searchPlaceholder = "搜索协作者";
var filter = "筛选";
var batchLabel = "调整为";
var selected = "已选择";
var selectAll = "全选";
var search = "搜索";
var noResult = "无{0}结果";
var online = "在线";
var team = "团队/组织";
var joined = "已加入";
var notjoin = "未加入";
var visitorRights = "访客权限";
var blocked = "已阻止";
var accessBlocked = "未授权";
var notJoined = "还未加入";
var removeCollaborator = "取消授权";
var removeBlock = "清除记录";
var loading = "加载中...";
var transferOwnerDisableForSecret = "加密文档暂不支持转让";
var modifiedSuccessfully = "修改成功";
var changeFail = "修改失败";
var removePartFail = "部分移除失败";
var removeFail = "移除失败";
var canNotChangeGroupMemberPerm = "暂不支持调整团队中的单个成员权限";
var multiRemoveSuccess = "移除成功";
var transferSuccess = "转让成功";
var manageable = "可管理";
var owner = "文档所有者";
var settingSuccess = "设置成功";
var clear = "清除";
var myContact = "我的联系人";
var addCorp = "添加协作";
var unAuthorized = "未授权";
var lookUserSetting = "查看成员授权";
var noCollabortorsCoop = "没有好友加入协作";
var retry = "重试";
var pleaseRetry = "加载失败，请重试";
var afterNotify = "稍后将通知此人";
var limitCount = "最多支持选择200名协作者";
var searchResult = "搜索结果";
var filterResult = "筛选结果";
var isExitNoPerm = "已存在未授权用户，请重新选择";
var oldNotJoinedDataTip = "2023年6月30日起未访问文档视为未加入";
var CollaboratorsV2 = {
	title: title,
	inviteFriends: inviteFriends,
	batchManagement: batchManagement,
	searchPlaceholder: searchPlaceholder,
	filter: filter,
	batchLabel: batchLabel,
	selected: selected,
	selectAll: selectAll,
	search: search,
	noResult: noResult,
	online: online,
	team: team,
	joined: joined,
	notjoin: notjoin,
	visitorRights: visitorRights,
	blocked: blocked,
	accessBlocked: accessBlocked,
	notJoined: notJoined,
	removeCollaborator: removeCollaborator,
	removeBlock: removeBlock,
	loading: loading,
	transferOwnerDisableForSecret: transferOwnerDisableForSecret,
	modifiedSuccessfully: modifiedSuccessfully,
	changeFail: changeFail,
	removePartFail: removePartFail,
	removeFail: removeFail,
	canNotChangeGroupMemberPerm: canNotChangeGroupMemberPerm,
	multiRemoveSuccess: multiRemoveSuccess,
	transferSuccess: transferSuccess,
	manageable: manageable,
	owner: owner,
	settingSuccess: settingSuccess,
	clear: clear,
	myContact: myContact,
	addCorp: addCorp,
	unAuthorized: unAuthorized,
	lookUserSetting: lookUserSetting,
	noCollabortorsCoop: noCollabortorsCoop,
	retry: retry,
	pleaseRetry: pleaseRetry,
	afterNotify: afterNotify,
	limitCount: limitCount,
	searchResult: searchResult,
	filterResult: filterResult,
	isExitNoPerm: isExitNoPerm,
	oldNotJoinedDataTip: oldNotJoinedDataTip
};

var popperTitle = "知识视图";
var SharedWiki = {
	popperTitle: popperTitle
};

var login = {
  logic: {
    AvatarPanel: AvatarPanel,
    AInewfileRecommend: AInewfileRecommend,
    AiProtocol: AiProtocol,
    CreateGroupTask: CreateGroupTask,
    InviteTask: InviteTask,
    UploadFileTask: UploadFileTask,
    QrCode: QrCode,
    BackupSettingSelect: BackupSettingSelect,
    BackupSetting: BackupSetting,
    DialogBackupSettings: DialogBackupSettings,
    FloatBox: FloatBox,
    AddRecommendContact: AddRecommendContact,
    AddressBook: AddressBook,
    AppDownload: AppDownload,
    AppealIllegalFile: AppealIllegalFile,
    AddToCoop: AddToCoop,
    AppFinder: AppFinder,
    ClinkCoopBox: ClinkCoopBox,
    ClinkPerm: ClinkPerm,
    ClinkSettingBox: ClinkSettingBox,
    ClinkTime: ClinkTime,
    CompanyGuidePanel: CompanyGuidePanel,
    CompanyAdminInviteApprove: CompanyAdminInviteApprove,
    CompanyAdminDismission: CompanyAdminDismission,
    CompanyAdminDocSettings: CompanyAdminDocSettings,
    ContactInvitationPanel: ContactInvitationPanel,
    CoopMember: CoopMember,
    CoopMemberList: CoopMemberList,
    CoopMemberSearch: CoopMemberSearch,
    CoopMemberSearcher: CoopMemberSearcher,
    CopyEditLink: CopyEditLink,
    CopyLink: CopyLink,
    CorpSpaceFull: CorpSpaceFull,
    CreateTeam: CreateTeam,
    DocInfo: DocInfo,
    DeleteContact: DeleteContact,
    DialogCorpSpaceFull: DialogCorpSpaceFull,
    DialogCreateTeam: DialogCreateTeam,
    DialogEntCardsGuide: DialogEntCardsGuide,
    DialogEntDemo: DialogEntDemo,
    DialogEntGetCooper: DialogEntGetCooper,
    DialogEntGuide: DialogEntGuide,
    DialogLinkJumpTip: DialogLinkJumpTip,
    DialogModifyFilePermission: DialogModifyFilePermission,
    DialogModifyFilePerSetting: DialogModifyFilePerSetting,
    Ent2019nCovGuide: Ent2019nCovGuide,
    EntCardsGuide: EntCardsGuide,
    EntCardsGuideVideo: EntCardsGuideVideo,
    EntGetCooper: EntGetCooper,
    EntRemoteWorkGuide: EntRemoteWorkGuide,
    EntTeamtopDemo: EntTeamtopDemo,
    EntSharePanel: EntSharePanel,
    EditLabel: EditLabel,
    FileCopy: FileCopy,
    FileDownload: FileDownload,
    FileMove: FileMove,
    FileInfo: FileInfo,
    SecureTeamConfirm: SecureTeamConfirm,
    ShareV2: ShareV2,
    ShareV3: ShareV3,
    FinishCompPrivilege: FinishCompPrivilege,
    GroupTemplateGuide: GroupTemplateGuide,
    GroupTplVideo: GroupTplVideo,
    GuideReminder: GuideReminder,
    GuideSingleTip: GuideSingleTip,
    GuideStepTips: GuideStepTips,
    ImportPersonalFolder: ImportPersonalFolder,
    DialogImportFromSpecail: DialogImportFromSpecail,
    ImportFromSpecailTips: ImportFromSpecailTips,
    ImportFromSpecail: ImportFromSpecail,
    ImportPersonalFolderPlus: ImportPersonalFolderPlus,
    InviteColleague: InviteColleague,
    JoinCompPrivilege: JoinCompPrivilege,
    LinkCoopBox: LinkCoopBox,
    LinkDownloadPerm: LinkDownloadPerm,
    LinkRenamePerm: LinkRenamePerm,
    LinkSettingBox: LinkSettingBox,
    LinkTime: LinkTime,
    LinkToCoop: LinkToCoop,
    MemberSelectorPlus: MemberSelectorPlus,
    ModifyFilePermission: ModifyFilePermission,
    ModifyFilePerSetting: ModifyFilePerSetting,
    ModifyPermission: ModifyPermission,
    ModifyPermissionInfoSub: ModifyPermissionInfoSub,
    ModifyPermissionInfoTip: ModifyPermissionInfoTip,
    OpenShare: OpenShare,
    OpenClient: OpenClient,
    PublishFile: PublishFile,
    Report: Report,
    RequestShareOutside: RequestShareOutside,
    DriveRegisterVip: DriveRegisterVip,
    SendVerfiyMessage: SendVerfiyMessage,
    SlideHelper: SlideHelper,
    TeamSceneSelector: TeamSceneSelector,
    TeamSceneVideo: TeamSceneVideo,
    TeamTopAreaNotice: TeamTopAreaNotice,
    TeamTagPanel: TeamTagPanel,
    Upload: Upload,
    UpToCorpTeam: UpToCorpTeam,
    UpToPersonalTeam: UpToPersonalTeam,
    UpToPersonalTeamGuide: UpToPersonalTeamGuide,
    UpToPersonalTeamSelect: UpToPersonalTeamSelect,
    DialogUpToPersonalTeam: DialogUpToPersonalTeam,
    CompanyHelpContent: CompanyHelpContent,
    TransferTeamMembers: TransferTeamMembers,
    TransferTeamComfirm: TransferTeamComfirm,
    TransferTeam: TransferTeam,
    ShareWithContactsEntry: ShareWithContactsEntry,
    SendAddContactInvitation: SendAddContactInvitation,
    SecureInfo: SecureInfo,
    NoviceTaskList: NoviceTaskList,
    NoviceGuideReminder: NoviceGuideReminder,
    ModifyMemberName: ModifyMemberName,
    MemberApproval: MemberApproval,
    InviteContact: InviteContact,
    InviteBySend: InviteBySend,
    DelLink: DelLink,
    DelMember: DelMember,
    FolderShareSetting: FolderShareSetting,
    EntFolderShareSetting: EntFolderShareSetting,
    FolderShareOpen: FolderShareOpen,
    FolderShareMain: FolderShareMain,
    EntFolderShareMain: EntFolderShareMain,
    FolderShareDelete: FolderShareDelete,
    FolderShareCancel: FolderShareCancel,
    FolderShare: FolderShare,
    DialogNoviceTask: DialogNoviceTask,
    DialogMemberApproval: DialogMemberApproval,
    DialogJoinCompPrivilege: DialogJoinCompPrivilege,
    DialogFolderShare: DialogFolderShare,
    DialogCompanyInvite: DialogCompanyInvite,
    DialogAddEntMember: DialogAddEntMember,
    DeleteEntMember: DeleteEntMember,
    CompanyMemberInviteSetting: CompanyMemberInviteSetting,
    CompanyLogo: CompanyLogo,
    CompanyHelpHead: CompanyHelpHead,
    AddEntMember: AddEntMember,
    ClinkAdvancedSetting: ClinkAdvancedSetting,
    ActivityContent: ActivityContent,
    AppCenter: AppCenter,
    AvatarList: AvatarList,
    CloseSecure: CloseSecure,
    DialogTeamSettings: DialogTeamSettings,
    DialogTeamAppSettings: DialogTeamAppSettings,
    DialogShareFile: DialogShareFile,
    DialogSchedule: DialogSchedule,
    SecurePhoneCheck: SecurePhoneCheck,
    SecureTips: SecureTips,
    TeamDeleteOrExit: TeamDeleteOrExit,
    TeamRename: TeamRename,
    TeamAppRename: TeamAppRename,
    TeamSettings: TeamSettings,
    TeamAppManage: TeamAppManage,
    TransferConfirm: TransferConfirm,
    TransferMembers: TransferMembers,
    TransferTips: TransferTips,
    ContactLeaveMessage: ContactLeaveMessage,
    AppsSidebar: AppsSidebar,
    MContactSelector: MContactSelector,
    UnLockSecretFolder: UnLockSecretFolder,
    FilesSaveAs: FilesSaveAs,
    CorpTeamSpaceFull: CorpTeamSpaceFull,
    GroupTemplateUpdateInfo: GroupTemplateUpdateInfo,
    TeamGuide: TeamGuide,
    DialogTeamFolderSettings: DialogTeamFolderSettings,
    TeamFolderSettings: TeamFolderSettings,
    LeaveCompany: LeaveCompany,
    LeaveCompanyPhoneCheck: LeaveCompanyPhoneCheck,
    WaterMarkSetting: WaterMarkSetting,
    FileCollection: FileCollection,
    FileCollectionLink: FileCollectionLink,
    DialogFileCollection: DialogFileCollection,
    ShareRangeTips: ShareRangeTips,
    GroupApply: GroupApply,
    GroupApplyList: GroupApplyList,
    GroupApplySuccess: GroupApplySuccess,
    DialogUpToCorpTeam: DialogUpToCorpTeam,
    DialogGroupApply: DialogGroupApply,
    DialogEnterFilePerSetting: DialogEnterFilePerSetting,
    CreateCustomizePermission: CreateCustomizePermission,
    CustomizeGroup: CustomizeGroup,
    DeleteCustomizePermission: DeleteCustomizePermission,
    DialogCreateCustomizePermission: DialogCreateCustomizePermission,
    DialogCustomizeFilePerSetting: DialogCustomizeFilePerSetting,
    CustomizeFilePerSetting: CustomizeFilePerSetting,
    CompanyTemplateSaving: CompanyTemplateSaving,
    CompanyTemplateSetting: CompanyTemplateSetting,
    CompanyTemplateRename: CompanyTemplateRename,
    CompanyTemplateUpload: CompanyTemplateUpload,
    CompanyTemplateUploadDetail: CompanyTemplateUploadDetail,
    CompanyTemplateDelete: CompanyTemplateDelete,
    CompanyTemplate: CompanyTemplate,
    TeamFileRecommend: TeamFileRecommend,
    TeamFileTop: TeamFileTop,
    ModifyShareScope: ModifyShareScope,
    CompanyMemberInfoCard: CompanyMemberInfoCard,
    DialogEntTeamFuncManage: DialogEntTeamFuncManage,
    EntShareManage: EntShareManage,
    EntFileFilter: EntFileFilter,
    UpgradePrivilege: UpgradePrivilege,
    CompanyRegister: CompanyRegister,
    CompanyRegisterSuccess: CompanyRegisterSuccess,
    EnterpriseIndexRadar: EnterpriseIndexRadar,
    DialogEnterpriseIndexRadar: DialogEnterpriseIndexRadar,
    LinkChkCodePerm: LinkChkCodePerm,
    MShareFileMore: MShareFileMore,
    TransferOwnerConfirm: TransferOwnerConfirm,
    EntMultiEditConfirm: EntMultiEditConfirm,
    SaveAndEdit: SaveAndEdit,
    ApplyPermission: ApplyPermission,
    OrderAdminApplyment: OrderAdminApplyment,
    FlashPopover: FlashPopover,
    NewbieTask: NewbieTask,
    DialogGetTemplates: DialogGetTemplates,
    KRiskyDownloadTips: KRiskyDownloadTips,
    StepGuidePopover: StepGuidePopover,
    FileLabel: FileLabel,
    Privilege: Privilege,
    InBox: InBox,
    ShareTips: ShareTips,
    GroupLabelManager: GroupLabelManager,
    ShareFileAdvanceSettings: ShareFileAdvanceSettings,
    OutDateService: OutDateService,
    DialogWPSGuide: DialogWPSGuide,
    QrCodeBind: QrCodeBind,
    PersonalCoopHasPerm: PersonalCoopHasPerm,
    PersonalCoopNoPerm: PersonalCoopNoPerm,
    DialogPersonalShareFile: DialogPersonalShareFile,
    ShareFileChannels: ShareFileChannels,
    EntSetPubDocAttr: EntSetPubDocAttr,
    CopyMoveFailList: CopyMoveFailList,
    MultiAccountSelectList: MultiAccountSelectList,
    MultiAccountFileImport: MultiAccountFileImport,
    CreateShortcut: CreateShortcut,
    EntJoinByLink: EntJoinByLink,
    Message: Message,
    HistoryVersionLabelManager: HistoryVersionLabelManager,
    VersionTagsList: VersionTagsList,
    DialogVipAllocation: DialogVipAllocation,
    AddTeam: AddTeam,
    MiniCode: MiniCode,
    newShareV2: newShareV2,
    DialogCompanyTemplateUpload: DialogCompanyTemplateUpload,
    DialogCompanyTemplateEdit: DialogCompanyTemplateEdit,
    QuickCollect: QuickCollect,
    QuickCollectLimited: QuickCollectLimited,
    DialogAdvancedSetting: DialogAdvancedSetting,
    DialogGoToAdvancedSetting: DialogGoToAdvancedSetting,
    ShareCreateTeam: ShareCreateTeam,
    PCCustomShareDateDialog: PCCustomShareDateDialog,
    TeamSpace: TeamSpace,
    ShowAuthenticationInfo: ShowAuthenticationInfo,
    corpMarkSwitch: corpMarkSwitch,
    DialogShareCooperate: DialogShareCooperate,
    MultiManageConfirm: MultiManageConfirm,
    Nps: Nps,
    ApproveOpenCoop: ApproveOpenCoop,
    ShareCooperate: ShareCooperate,
    LogoutFail: LogoutFail,
    TeamAuth: TeamAuth,
    OperationBanner: OperationBanner,
    CollaboratorItem: CollaboratorItem,
    DialogCollaborationInviteMembers: DialogCollaborationInviteMembers,
    DialogEntFolderShareSetting: DialogEntFolderShareSetting,
    DialogShareFolderUPToCorpTeam: DialogShareFolderUPToCorpTeam,
    ArchivePreview: ArchivePreview,
    DialogCreateTeamDenied: DialogCreateTeamDenied,
    DialogCreateTeamGuidance: DialogCreateTeamGuidance,
    DialogCreateTeamSimply: DialogCreateTeamSimply,
    DialogCreateTeamUpgradeAnnouncement: DialogCreateTeamUpgradeAnnouncement,
    DialogCreateTeamImportDataSuccessfully: DialogCreateTeamImportDataSuccessfully,
    MultiAccountSwitch: MultiAccountSwitch,
    CreateEnterprise: CreateEnterprise,
    EntSearchAddCollaConfrm: EntSearchAddCollaConfrm,
    CooperateTagIcon: CooperateTagIcon,
    PartnerInformationPanel: PartnerInformationPanel,
    PublicInformationPanel: PublicInformationPanel,
    AddMemberFailedTips: AddMemberFailedTips,
    TransferFileApprove: TransferFileApprove,
    DialogConvertPage: DialogConvertPage,
    ConvertPage: ConvertPage,
    NotifyUnusedMembers: NotifyUnusedMembers,
    MessageBubble: MessageBubble,
    ShareV3Face: ShareV3Face,
    DownloadClientPanel: DownloadClientPanel,
    DialogNewEnterpriseGuidance: DialogNewEnterpriseGuidance,
    DialogCreateShareFolder: DialogCreateShareFolder,
    TaskPanelReward: TaskPanelReward,
    TaskPanel: TaskPanel,
    CompanyInvitePanel: CompanyInvitePanel,
    RemoveSuggestion: RemoveSuggestion,
    AddCollaboratorPrivateInvitation: AddCollaboratorPrivateInvitation,
    CollaboratorsV2: CollaboratorsV2,
    SharedWiki: SharedWiki
  }
};

var mLogic = {
	MDownloadSingle: {
		txt0: "点击右上角的 “…” 按钮",
		txt1: "使用 Safari",
		txt2: "打开",
		txt3: "文件导出中，请稍候...",
		txt4: "导出成功",
		txt5: "导出失败"
	},
	MShareFileMember: {
		txt0: "当前团队",
		txt1: "人可编辑",
		txt2: "人可查看，其中",
		txt3: "人可查看",
		txt4: "添加协作成员",
		txt5: "创建者",
		txt6: "可查看",
		txt7: "可编辑",
		txt8: "文件创建者",
		txt9: "通过链接加入",
		txt10: "直接指定添加",
		txt11: "可编辑",
		txt12: "可查看",
		txt13: "移除",
		txt14: "取消",
		txt15: "我",
		txt16: "文档加密者",
		txt17: "邀请成员",
		canComment: "可评论",
		addedShareMember: "已加入分享的人",
		addedCollaborator: "添加协作者"
	},
	MShareFileSearch: {
		searchPlaceholder: "搜索",
		error: "未知错误",
		emptyTxt: "未搜索到匹配的联系人",
		groupMemberTxt: "团队成员",
		confirmTxt: "确认"
	},
	MShareFileMore: {
		txt0: "当前链接",
		txt1: "重置链接",
		txt2: "取消分享",
		txt3: "链接重置成功",
		txt4: "请确认取消分享",
		txt5: "所有人",
		txt6: "仅编辑者",
		txt7: "仅自己",
		downloadPermText: "禁止查看者下载、打印、另存和复制内容",
		KsheetDownloadPermText: "禁止查看者导出、打印、另存和复制内容",
		canDownloadPermText: "可以下载、打印、另存和复制内容的人",
		KsheetCanDownloadPermText: "可以者导出、打印、另存和复制内容的人",
		ksheetDownloadPermText: "禁止查看者导出、打印、另存和复制内容",
		dbtDownloadPermText: "禁止查看者另存和复制内容",
		fpDownloadPermText: "禁止查看者导出和另存",
		processonDownloadPermText: "禁止查看者导出和另存",
		imgDownloadPermText: "禁止查看者下载和另存",
		kdbtPermText: "禁止查看者导出、另存和复制内容",
		accessConditionTxt: "访问文档需填写信息",
		accessConditionSubTxt: "适用于收发资料时收集访问者信息",
		copySuccessTxt: "复制链接成功",
		closeFullComment: "关闭留言",
		closeFullCommentMsg: "关闭后，他人打开文件将无法发表和查看留言"
	},
	MShareFileOpenShare: {
		txt0: "链接权限",
		txt1: "链接有效期",
		txt2: "永久有效",
		txt3: "有效",
		txt4: "复制链接",
		txt5: "关闭免登录链接",
		txt6: "金山文档 | WPS云文档",
		txt7: "任何人可查看",
		txt8: "任何人可编辑",
		txt9: "本企业成员可查看",
		txt10: "本企业成员可编辑",
		txt11: "仅指定人可查看/编辑",
		txt12: "仅指定人可查看",
		txt13: "复制成功",
		txt14: "复制失败",
		txt15: "你的浏览器不支持自动复制请按",
		txt16: "复制下面输入框的内容",
		txt17: "分享功能升级维护中",
		txt18: "免登录链接已关闭"
	},
	MShareFilePermission: {
		txt0: "公开分享",
		txt1: "任何人可查看",
		txt2: "任何人可编辑",
		txt3: "指定范围分享",
		txt4: "本企业成员可查看",
		txt5: "本企业成员可编辑",
		txt6: "仅指定人可查看/编辑",
		txt7: "仅指定人可查看",
		txt8: "添加协作者",
		txt9: "取消",
		txt10: "确定",
		txt11: "修改成功",
		anyoneComment: "任何人可评论",
		companyComment: "本企业成员可评论",
		someoneWrite: "仅指定人可查看/评论/编辑"
	},
	MShareFileTime: {
		txt0: "链接失效后，好友将无法通过链接加入文档协作",
		txt1: "7天有效",
		txt2: "30天有效",
		txt3: "永久有效",
		txt4: "取消",
		txt5: "确定",
		txt6: "链接有效期设置成功"
	},
	MUpdateVersion: {
		upgradeToNewest: "该版本不支持该功能，请升级至最新版本",
		upgradeTips: "更新提示",
		cancelUpgrade: "取消",
		downloadSoon: "立即下载",
		isLoadding: "正在获取最新版本信息...",
		isLatest: "当前已是最新版本",
		error: "获取版本更新信息失败，请重试",
		stopped: "当前版本已停止支持，请升级到最新版本",
		willStop: "当前版本将于{year}年{month}月{day}日停止支持，请升级到最新版本"
	},
	MClipboardModal: {
		title: "打开剪贴板链接",
		open: "立即打开",
		errOpen: "我知道了",
		errFname: "链接识别失败",
		expired: "文件链接已过期"
	},
	MShareFileBindOfficeAccount: {
		title: "分享在线文档到公众号推文",
		content: "你可以在微信公众号发布文章时，直接在文章中插入金山文档小程序卡片，分享当前文档",
		helpText: "查看详细帮助文档",
		bindText: "绑定信息",
		pathText: "小程序路径：",
		copyMessageText: "一键复制绑定信息",
		currentText: "当前权限为",
		changeText: "是否将权限修改为",
		cancelText: "取消",
		confirmText: "确定",
		copySuccessText: "复制成功",
		copyErrorText: "复制失败",
		anyone_read: "任何人可查看",
		anyone_comment: "任何人可评论",
		anyone_write: "任何人可编辑",
		company_read: "本企业成员可查看",
		company_comment: "本企业成员可评论",
		company_write: "本企业成员可编辑",
		close: "仅指定人可查看/编辑",
		close_comment: "仅指定人可查看/评论/编辑",
		close_read: "仅指定人可查看"
	},
	MAccessCondition: {
		infoTitle: "必填信息",
		infoTxt: "姓名、手机号",
		recordTxt: "访问记录",
		countTxt: "人已填写"
	},
	MAccessCreator: {
		titleTxt: "访问者查看文档前将需填写以下内容",
		subTitleTxt: "以下设置仅对该文件生效",
		creatorTxt: "访问者界面示意"
	},
	MRecord: {
		dataTxt: "访问数据",
		todayTxt: "今日",
		downloadLeftTxt: "导出访问记录（",
		downloadRightTxt: "人已填写）",
		readCountTxt: "查看次数",
		readMemberTxt: "查看人数",
		editTxt: "编辑人数"
	},
	FileAccessInfo: {
		accessTxt: "去填写",
		fileAccessTxt: "要求查看文件前，填写姓名、手机号",
		nameTxt: "姓名",
		phoneTxt: "手机号",
		placeholderNameTxt: "请填写姓名",
		placeholderPhoneTxt: "请填写手机号",
		clearTxt: "清除",
		submitTxt: "查看文件",
		warnTxt: "请正确填写姓名和手机号",
		unkownMsg: "未知错误",
		warnTipTxt: "信息并非金山文档官方收集，请核实文档创建者",
		warnTipTxt2: "身份，防止信息泄露",
		inviteTxt: "邀请你",
		inviteTopTxt: "填写姓名、手机号，以便后续联系",
		inviteSubTxt: "如不方便提供，可以选择退出文档查阅",
		extDocTxt: "退出文档",
		writeAndReadTxt: "填写并查看"
	},
	MNewShare: {
		cancel: "取消",
		application: "应用",
		batchTitle: "批量操作",
		permTitle: "权限",
		dialogTitle: "建议",
		txt6: "已移除",
		txt7: "的访问权限，为避免其再次进入，建议修改文档链接设置",
		txt8: "当前：",
		txt9: "建议：",
		txt10: "下次再说",
		txt11: "立即修改",
		txt_remove: "移出协作",
		txt_remove_1: "已将",
		txt_remove_2: "移除",
		txt_noData: "无访问记录",
		txt_operate: "正在操作中...",
		txt_success: "权限已设置成功",
		addMemberFromAddressBook: "从通讯录添加",
		noPrivilegeTips: "权益不足，请联系企业超级管理员",
		tab_latest: "最近访问",
		tab_all: "全部",
		batchRemove: "批量删除",
		batchAction: "批量操作",
		selectAll: "全选",
		pageTtitleShareMember: "协作者",
		pageTitleJoinByLink: "通过链接加入的人",
		emptyListTips: "暂无数据",
		changePerm: "修改权限",
		anyone_close_read: "指定人可查看",
		can_write: "可编辑",
		can_read: "可查看",
		unlogin: "未登录",
		subtitle_online: "在线",
		subtitle_today: "今天",
		subtitle_just: "刚刚",
		subtitle_last: "最近在线",
		no_perm: "无权限",
		menu_remove: "移出协作",
		batch_remove: "移出",
		remove_success: "移出成功",
		delete_success: "删除成功",
		remove_some_success: "部分移出失败",
		remove_failed: "移出失败",
		set_permission_success: "设置成功",
		modify_success: "修改成功",
		remove_success_batch: "批量移出成功",
		multi_dialog_tips: "提示",
		multi_dialog_content: "当前用户的权限来源与所在的群组集合",
		multi_dialog_know: "我知道了"
	}
};
var mLogic$1 = {
	mLogic: mLogic
};

var request = {
	drive: {
		txt0: "等",
		txt1: "名成员",
		txt2: "添加失败",
		txt3: "共享成员人数已达上限"
	}
};
var request$1 = {
	request: request
};

var utils = {
	errors: {
		txt0: "你的3个免费团队数量已用完，升级会员即可拥有创建50个团队和100G 云空间特权。",
		txt1: "团队名至少2个汉字或4个字母",
		txt2: "团队名不能包含下列字符： \\/;:*?\"<>|%&",
		txt3: "团队名不能超过100个字符",
		txt4: "账号已退出，请重新登录",
		txt5: "提交的参数无效",
		txt6: "服务器忙请稍后再试",
		txt7: "服务器错误",
		txt8: "账号未授权",
		txt9: "账号已过期",
		txt10: "你的操作权限不足",
		txt11: "域名已存在",
		txt12: "公司不存在",
		txt13: "公司名无效",
		txt14: "公司名太长",
		txt15: "用户已存在",
		txt16: "部门非空",
		txt17: "团队已存在此成员",
		txt18: "团队人数已达上限",
		txt19: "请输入一个正确的邮箱/手机号",
		txt21: "团队已不存在",
		txt22: "团队链接已不存在",
		txt23: "不能添加企业账号",
		txt24: "用户不存在",
		txt25: "文件名不能超过100个字符",
		txt26: "存在同名文件",
		txt27: "文件(夹)不存在",
		txt28: "你已不是该团队成员",
		txt29: "名字不能包含非法字符和特殊符号\\/:*?\"<>|",
		txt30: "名字不能包含非法字符和特殊符号： \\/;:*?\"<>|%&",
		txt31: "文件名不能为空",
		txt32: "普通成员只能移动自己的文件",
		txt33: "文件移动位置不变",
		txt34: "链接已存在",
		txt35: "链接不存在或已被重置",
		txt36: "私密文件夹特权已过期",
		txt37: "权限校验失败，请刷新重试",
		txt38: "没有当前目录的操作权限,请联系管理员",
		txt39: "没有当前目录的新建权限",
		txt40: "请保留邮箱或手机其中一种登录方式",
		txt41: "你的操作频率过快，请稍后重试",
		txt42: "该手机申请验证码次数已超上限，请明天再试",
		txt43: "手机格式不正确",
		txt44: "该手机已绑定其它账号",
		txt45: "请输入正确格式的邮箱",
		txt46: "该邮箱已绑定其它账号，请换一个",
		txt47: "验证码错误",
		txt48: "该邮箱已绑定其它账号，请换一个",
		txt49: "无法解绑，至少要有一个邮箱或手机账号，请先绑定邮箱再解绑手机",
		txt50: "验证码错误",
		txt51: "密码为8-16位，大小写字母、数字或符号3种组合",
		txt52: "你已绑定了手机",
		txt53: "该手机已绑定其它账号",
		txt54: "验证码不能为空",
		txt55: "验证码不正确,请重新输入",
		txt56: "验证码不正确,请重新输入",
		txt57: "你已绑定了邮箱",
		txt58: "邮箱不存在",
		txt59: "不合法的操作",
		txt60: "不能包含字符!@#$^*<>?",
		txt61: "密码错误",
		txt62: "打开文件失败，轻地址密码已变更。",
		txt63: "评论内容超过了255个字符",
		txt64: "分享失败",
		txt65: "评论不能超过255个字",
		txt66: "移动文件失败",
		txt67: "链接已关闭",
		txt68: "文件不存在",
		txt69: "内部错误",
		txt70: "文件内容读取错误",
		txt71: "文件夹层级过多，请重新选择",
		txt72: "下载失败，所选文件格式不支持下载",
		txt73: "下载失败，不支持下载空文件夹",
		txt74: "你未选中任何实体文件，请确认文件是否存在",
		txt75: "没有文件搜索功能权限",
		txt76: "不支持复制到子文件夹，请重新选择",
		txt77: "不支持复制带有子文件夹的目录，请重新选择",
		txt78: "不支持复制带有子文件夹的目录，请重新选择",
		txt79: "文件批量操作任务失败",
		txt80: "不支持操作5000个以上的文件，请重新选择",
		txt81: "文件批量操作任务不存在",
		txt82: "正在执行文件操作，请稍候重试",
		txt83: "名字太长",
		txt84: "无效ssid",
		txt85: "用户已经签约",
		txt86: "不可导入同一账号的数据",
		txt87: "验证结果已过期",
		txt88: "验证码不正确，请重新输入",
		txt89: "参数缺失ssid",
		txt90: "ssid参数错误",
		txt91: "获取被合并账号用户信息失败",
		txt92: "报告合并完成失败",
		txt93: "不能合并不同公司的账号",
		txt94: "此公司的用户不能合并账号",
		txt95: "获取用户授权的安全文档失败",
		txt96: "无法获取登录用户的信息",
		txt97: "验证信息与所绑定的账号不一致",
		txt98: "绑定时间过短",
		txt99: "该协作已被解散",
		txt100: "超过团队数量限制",
		txt101: "你已不是该协作组成员",
		txt102: "操作不成功，请修改内容后重试",
		txt103: "操作不成功，请修改团队名后重试",
		txt104: "网络异常",
		txt105: "未知错误",
		txt106: "应用名不可超过256个字符",
		txt107: "名字不能包含非法字符和特殊符号\\/:*?\"<>|"
	},
	link: {
		txt0: "仅指定人",
		txt1: "仅指定人",
		txt2: "本企业成员",
		txt3: "本企业成员",
		txt4: "仅共享成员",
		txt5: "仅下方指定人",
		txt6: "仅下方指定人",
		txt7: "本企业成员",
		txt8: "本企业成员",
		txt9: "仅共享成员",
		txt10: "仅自己",
		txt11: "打开链接的人",
		txt12: "仅你自己 可访问",
		txt13: "仅指定人 可访问",
		txt14: "本企业成员",
		txt15: "本企业成员",
		txt17: "任何人",
		txt18: "打开链接的人",
		txt19: "文件分享链接已过期，仅指定人可访问",
		txt20: "可查看/编辑",
		txt21: "可查看",
		txt22: "可查看",
		txt23: "可编辑",
		txt24: "可查看",
		txt25: "可编辑",
		txt26: "可查看/编辑",
		txt27: "取消",
		txt28: "分享",
		txt29: "共享",
		txt30: "重置链接",
		txt31: "可查看",
		txt32: "分享链接已失效",
		txt33: "我的联系人",
		comment: "可评论",
		someoneAllPerm: "可查看/评论/编辑",
		anyone: "所有人",
		can_View: "可查看",
		can_comment: "可评论",
		can_edit: "可编辑",
		anyone_can_view: "所有人可查看",
		anyone_can_comment: "所有人可评论",
		anyone_can_edit: "所有人可编辑",
		specify_shared_person: "指定分享的人",
		specify_shared_person_share: "指定人",
		company_can_read: "本企业成员可查看",
		company_can_comment: "本企业成员可评论",
		company_can_write: "本企业成员可编辑"
	}
};
var utils$1 = {
	utils: utils
};

var config = {
	constants: {
		TEAM_ROLES: {
			admin: "管理员",
			member: "成员 · 允许编辑",
			read_member: "成员 · 仅查看"
		},
		COMPANY_ROLES: {
			"1": "企业拥有者",
			"2": "企业管理员",
			"3": "成员"
		}
	}
};
var configConstants = {
	config: config
};

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var zhCN = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, basic$1), combine$1), miCombine), login), mLogic$1), request$1), utils$1), configConstants);

export { zhCN as default };
